export const countryDetails=[
  {
    id: "2589581",
    Name: "Algeria",
    States: [
      {
        id: "2508226",
        Name: "Wilaya de Aïn Defla",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2507899",
        Name: "Wilaya de Aïn Temouchent",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2505569",
        Name: "Wilaya de Batna",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2505325",
        Name: "Wilaya de Bejaïa",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2503822",
        Name: "Wilaya de Biskra",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2503765",
        Name: "Wilaya de Blida",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2503699",
        Name: "Wilaya de Bordj Bou Arréridj",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2502951",
        Name: "Wilaya de Bouira",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2502638",
        Name: "Wilaya de Boumerdes",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2505525",
        Name: "Wilaya de Béchar",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2501296",
        Name: "Wilaya de Chlef",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2501147",
        Name: "Wilaya de Constantine",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2500013",
        Name: "Wilaya de Djelfa",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2496045",
        Name: "Wilaya de Ghardaïa",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2495659",
        Name: "Wilaya de Guelma",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2492910",
        Name: "Wilaya de Jijel",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2491887",
        Name: "Wilaya de Khenchela",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2491188",
        Name: "Wilaya de Laghouat",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2490095",
        Name: "Wilaya de Mascara",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2487449",
        Name: "Wilaya de Mila",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2487130",
        Name: "Wilaya de Mostaganem",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2488831",
        Name: "Wilaya de Médéa",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2486682",
        Name: "Wilaya de M’Sila",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2486512",
        Name: "Wilaya de Naama",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2485794",
        Name: "Wilaya de Ouargla",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2483666",
        Name: "Wilaya de Relizane",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2482557",
        Name: "Wilaya de Saïda",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2481001",
        Name: "Wilaya de Sidi Bel Abbès",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2479532",
        Name: "Wilaya de Skikda",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2479213",
        Name: "Wilaya de Souk Ahras",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2481696",
        Name: "Wilaya de Sétif",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2478217",
        Name: "Wilaya de Tamanghasset",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2476893",
        Name: "Wilaya de Tiaret",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2476302",
        Name: "Wilaya de Tindouf",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2476027",
        Name: "Wilaya de Tipaza",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2475858",
        Name: "Wilaya de Tissemsilt",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2475741",
        Name: "Wilaya de Tizi Ouzou",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2475683",
        Name: "Wilaya de Tlemcen",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2477457",
        Name: "Wilaya de Tébessa",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2508807",
        Name: "Wilaya d’ Adrar",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2507475",
        Name: "Wilaya d’ Alger",
        
        FCode: "ADM1",
        CountryCode: "DZ",
      },
      {
        id: "2506994",
        Name: "Wilaya d’ Annaba",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2498541",
        Name: "Wilaya d’ El Bayadh",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2497406",
        Name: "Wilaya d’ El Oued",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2497322",
        Name: "Wilaya d’ El Tarf",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2493455",
        Name: "Wilaya d’ Illizi",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2485920",
        Name: "Wilaya d’ Oran",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      },
      {
        id: "2484618",
        Name: "Wilaya d’ Oum el Bouaghi",
        
        FCode: "ADM1",
        CountryCode: "DZ"
      }
    ],
  },
  {
    id: "3351879",
    Name: "Angola",
    States: [
      {
        id: "2243598",
        Name: "Bengo Province",
        
        FCode: "ADM1",
        CountryCode: "AO"
      },
      {
        id: "2241660",
        Name: "Cuanza Norte Province",
        
        FCode: "ADM1",
        CountryCode: "AO"
      },
      {
        id: "3349096",
        Name: "Cunene Province",
        
        FCode: "ADM1",
        CountryCode: "AO"
      },
      {
        id: "3348303",
        Name: "Huila Province",
        
        FCode: "ADM1",
        CountryCode: "AO"
      },
      {
        id: "2240444",
        Name: "Luanda Province",
        
        FCode: "ADM1",
        CountryCode: "AO"
      },
      {
        id: "145702",
        Name: "Lunda Norte Province",
        
        FCode: "ADM1",
        CountryCode: "AO"
      },
      {
        id: "2239858",
        Name: "Malanje Province",
        
        FCode: "ADM1",
        CountryCode: "AO"
      },
      {
        id: "3347016",
        Name: "Namibe Province",
        
        FCode: "ADM1",
        CountryCode: "AO"
      },
      {
        id: "145701",
        Name: "Província da Lunda Sul",
        
        FCode: "ADM1",
        CountryCode: "AO"
      },
      {
        id: "3351660",
        Name: "Província de Benguela",
        
        FCode: "ADM1",
        CountryCode: "AO"
      },
      {
        id: "2243266",
        Name: "Província de Cabinda",
        
        FCode: "ADM1",
        CountryCode: "AO"
      },
      {
        id: "3351640",
        Name: "Província do Bié",
        
        FCode: "ADM1",
        CountryCode: "AO"
      },
      {
        id: "876337",
        Name: "Província do Cuando Cubango",
        
        FCode: "ADM1",
        CountryCode: "AO"
      },
      {
        id: "3348310",
        Name: "Província do Huambo",
        
        FCode: "ADM1",
        CountryCode: "AO"
      },
      {
        id: "3349234",
        Name: "Província do Kwanza Sul",
        
        FCode: "ADM1",
        CountryCode: "AO"
      },
      {
        id: "875996",
        Name: "Província do Moxico",
        
        FCode: "ADM1",
        CountryCode: "AO"
      },
      {
        id: "2236566",
        Name: "Província do Uíge",
        
        FCode: "ADM1",
        CountryCode: "AO"
      },
      {
        id: "2236355",
        Name: "Província do Zaire",
        
        FCode: "ADM1",
        CountryCode: "AO"
      }
    ],
  },
  {
    id: "2395170",
    Name: "Benin",
    States: [
      {
        id: "2597274",
        Name: "Département de la Donga",
        
        FCode: "ADM1",
        CountryCode: "BJ"
      },
      {
        id: "2597271",
        Name: "Département de l’ Alibori",
        
        FCode: "ADM1",
        CountryCode: "BJ"
      },
      {
        id: "2395524",
        Name: "Département de l’ Atakora",
        
        FCode: "ADM1",
        CountryCode: "BJ"
      },
      {
        id: "2395504",
        Name: "Département de l’ Atlantique",
        
        FCode: "ADM1",
        CountryCode: "BJ"
      },
      {
        id: "2392325",
        Name: "Département de l’ Ouémé",
        
        FCode: "ADM1",
        CountryCode: "BJ"
      },
      {
        id: "2394992",
        Name: "Département du Borgou",
        
        FCode: "ADM1",
        CountryCode: "BJ"
      },
      {
        id: "2597272",
        Name: "Département du Collines",
        
        FCode: "ADM1",
        CountryCode: "BJ"
      },
      {
        id: "2597273",
        Name: "Département du Kouffo",
        
        FCode: "ADM1",
        CountryCode: "BJ"
      },
      {
        id: "2597275",
        Name: "Département du Littoral",
        
        FCode: "ADM1",
        CountryCode: "BJ"
      },
      {
        id: "2392716",
        Name: "Département du Mono",
        
        FCode: "ADM1",
        CountryCode: "BJ"
      },
      {
        id: "2597277",
        Name: "Département du Plateau",
        
        FCode: "ADM1",
        CountryCode: "BJ"
      },
      {
        id: "2390719",
        Name: "Département du Zou",
        
        FCode: "ADM1",
        CountryCode: "BJ"
      }
    ],
  },
  {
    id: "933860",
    Name: "Botswana",
    States: [
      {
        id: "933851",
        Name: "Central District",
        
        FCode: "ADM1",
        CountryCode: "BW"
      },
      {
        id: "933758",
        Name: "Ghanzi District",
        
        FCode: "ADM1",
        CountryCode: "BW"
      },
      {
        id: "933657",
        Name: "Kgalagadi District",
        
        FCode: "ADM1",
        CountryCode: "BW"
      },
      {
        id: "933654",
        Name: "Kgatleng District",
        
        FCode: "ADM1",
        CountryCode: "BW"
      },
      {
        id: "933562",
        Name: "Kweneng District",
        
        FCode: "ADM1",
        CountryCode: "BW"
      },
      {
        id: "933210",
        Name: "North East District",
        
        FCode: "ADM1",
        CountryCode: "BW"
      },
      {
        id: "933230",
        Name: "North West District",
        
        FCode: "ADM1",
        CountryCode: "BW"
      },
      {
        id: "933044",
        Name: "South East District",
        
        FCode: "ADM1",
        CountryCode: "BW"
      },
      {
        id: "933043",
        Name: "Southern District",
        
        FCode: "ADM1",
        CountryCode: "BW"
      }
    ],
  },
  {
    id: "2361809",
    Name: "Burkina Faso",
    States: [
      {
        id: "6930701",
        Name: "Boucle du Mouhoun",
        
        FCode: "ADM1",
        CountryCode: "BF"
      },
      {
        id: "6930703",
        Name: "Cascades",
        
        FCode: "ADM1",
        CountryCode: "BF"
      },
      {
        id: "6930704",
        Name: "Centre",
        
        FCode: "ADM1",
        CountryCode: "BF"
      },
      {
        id: "6930705",
        Name: "Centre-Est",
        
        FCode: "ADM1",
        CountryCode: "BF"
      },
      {
        id: "6930706",
        Name: "Centre-Nord",
        
        FCode: "ADM1",
        CountryCode: "BF"
      },
      {
        id: "6930707",
        Name: "Centre-Ouest",
        
        FCode: "ADM1",
        CountryCode: "BF"
      },
      {
        id: "6930708",
        Name: "Centre-Sud",
        
        FCode: "ADM1",
        CountryCode: "BF"
      },
      {
        id: "6930709",
        Name: "Est",
        
        FCode: "ADM1",
        CountryCode: "BF"
      },
      {
        id: "6930710",
        Name: "Hauts-Bassins",
        
        FCode: "ADM1",
        CountryCode: "BF"
      },
      {
        id: "6930711",
        Name: "Nord",
        
        FCode: "ADM1",
        CountryCode: "BF"
      },
      {
        id: "6930712",
        Name: "Plateau-Central",
        
        FCode: "ADM1",
        CountryCode: "BF"
      },
      {
        id: "6930713",
        Name: "Sahel",
        
        FCode: "ADM1",
        CountryCode: "BF"
      },
      {
        id: "6930714",
        Name: "Sud-Ouest",
        
        FCode: "ADM1",
        CountryCode: "BF"
      }
    ],
  },
  {
    id: "433561",
    Name: "Burundi",
    States: [
      {
        id: "7303939",
        Name: "Bujumbura Mairie",
        
        FCode: "ADM1",
        CountryCode: "BI"
      },
      {
        id: "7303940",
        Name: "Bujumbura Rural",
        
        FCode: "ADM1",
        CountryCode: "BI"
      },
      {
        id: "434386",
        Name: "Province de Mwaro",
        
        FCode: "ADM1",
        CountryCode: "BI"
      },
      {
        id: "428514",
        Name: "iProvense ya Bubanza",
        
        FCode: "ADM1",
        CountryCode: "BI"
      },
      {
        id: "423327",
        Name: "iProvense ya Bururi",
        
        FCode: "ADM1",
        CountryCode: "BI"
      },
      {
        id: "427700",
        Name: "iProvense ya Cankuzo",
        
        FCode: "ADM1",
        CountryCode: "BI"
      },
      {
        id: "430020",
        Name: "iProvense ya Cibitoke",
        
        FCode: "ADM1",
        CountryCode: "BI"
      },
      {
        id: "426271",
        Name: "iProvense ya Gitega",
        
        FCode: "ADM1",
        CountryCode: "BI"
      },
      {
        id: "428218",
        Name: "iProvense ya Karuzi",
        
        FCode: "ADM1",
        CountryCode: "BI"
      },
      {
        id: "430951",
        Name: "iProvense ya Kayanza",
        
        FCode: "ADM1",
        CountryCode: "BI"
      },
      {
        id: "432455",
        Name: "iProvense ya Kirundo",
        
        FCode: "ADM1",
        CountryCode: "BI"
      },
      {
        id: "422233",
        Name: "iProvense ya Makamba",
        
        FCode: "ADM1",
        CountryCode: "BI"
      },
      {
        id: "425550",
        Name: "iProvense ya Muramvya",
        
        FCode: "ADM1",
        CountryCode: "BI"
      },
      {
        id: "431747",
        Name: "iProvense ya Muyinga",
        
        FCode: "ADM1",
        CountryCode: "BI"
      },
      {
        id: "430567",
        Name: "iProvense ya Ngozi",
        
        FCode: "ADM1",
        CountryCode: "BI"
      },
      {
        id: "434147",
        Name: "iProvense ya Rutana",
        
        FCode: "ADM1",
        CountryCode: "BI"
      },
      {
        id: "426699",
        Name: "iProvense ya Ruyigi",
        
        FCode: "ADM1",
        CountryCode: "BI"
      }
    ],
  },
  {
    id: "2233387",
    Name: "Cameroon",
    States: [
      {
        id: "2236015",
        Name: "Adamaoua Province",
        
        FCode: "ADM1",
        CountryCode: "CM",
      },
      {
        id: "2233376",
        Name: "Centre Region",
        
        FCode: "ADM1",
        CountryCode: "CM",
      },
      {
        id: "2231835",
        Name: "East Province",
        
        FCode: "ADM1",
        CountryCode: "CM",
      },
      {
        id: "2231755",
        Name: "Far North Province",
        
        FCode: "ADM1",
        CountryCode: "CM",
      },
      {
        id: "2229336",
        Name: "Littoral Province",
        
        FCode: "ADM1",
        CountryCode: "CM",
      },
      {
        id: "2223603",
        Name: "North Province",
        
        FCode: "ADM1",
        CountryCode: "CM",
      },
      {
        id: "2223602",
        Name: "North-West Region",
        
        FCode: "ADM1",
        CountryCode: "CM",
      },
      {
        id: "2221789",
        Name: "South Province",
        
        FCode: "ADM1",
        CountryCode: "CM",
      },
      {
        id: "2221788",
        Name: "South-West Province",
        
        FCode: "ADM1",
        CountryCode: "CM",
      },
      {
        id: "2222934",
        Name: "West Province",
        
        FCode: "ADM1",
        CountryCode: "CM",
      }
    ],
  },
  {
    id: "3374766",
    Name: "Cape Verde",
    States: [
      {
        id: "3374855",
        Name: "Concelho da Boa Vista",
        
        FCode: "ADM1",
        CountryCode: "CV"
      },
      {
        id: "3374832",
        Name: "Concelho da Brava",
        
        FCode: "ADM1",
        CountryCode: "CV"
      },
      {
        id: "3374332",
        Name: "Concelho da Praia",
        
        FCode: "ADM1",
        CountryCode: "CV"
      },
      {
        id: "7602869",
        Name: "Concelho da Ribeira Brava",
        
        FCode: "ADM1",
        CountryCode: "CV"
      },
      {
        id: "3374274",
        Name: "Concelho da Ribeira Grande",
        
        FCode: "ADM1",
        CountryCode: "CV"
      },
      {
        id: "7603281",
        Name: "Concelho de Ribeira Grande de Santiago",
        
        FCode: "ADM1",
        CountryCode: "CV"
      },
      {
        id: "3374226",
        Name: "Concelho de Santa Catarina",
        
        FCode: "ADM1",
        CountryCode: "CV"
      },
      {
        id: "7602870",
        Name: "Concelho de Santa Catarina do Fogo",
        
        FCode: "ADM1",
        CountryCode: "CV"
      },
      {
        id: "3411925",
        Name: "Concelho de Santa Cruz",
        
        FCode: "ADM1",
        CountryCode: "CV"
      },
      {
        id: "3411926",
        Name: "Concelho de São Domingos",
        
        FCode: "ADM1",
        CountryCode: "CV"
      },
      {
        id: "7602873",
        Name: "Concelho de São Lourenço dos Orgãos",
        
        FCode: "ADM1",
        CountryCode: "CV"
      },
      {
        id: "3411928",
        Name: "Concelho de São Miguel",
        
        FCode: "ADM1",
        CountryCode: "CV"
      },
      {
        id: "7602871",
        Name: "Concelho de São Salvador do Mundo",
        
        FCode: "ADM1",
        CountryCode: "CV"
      },
      {
        id: "3374198",
        Name: "Concelho de São Vicente",
        
        FCode: "ADM1",
        CountryCode: "CV"
      },
      {
        id: "3374487",
        Name: "Concelho do Maio",
        
        FCode: "ADM1",
        CountryCode: "CV"
      },
      {
        id: "3374391",
        Name: "Concelho do Paul",
        
        FCode: "ADM1",
        CountryCode: "CV"
      },
      {
        id: "7602868",
        Name: "Concelho do Porto Novo",
        
        FCode: "ADM1",
        CountryCode: "CV"
      },
      {
        id: "3374249",
        Name: "Concelho do Sal",
        
        FCode: "ADM1",
        CountryCode: "CV"
      },
      {
        id: "3411927",
        Name: "Concelho do São Filipe",
        
        FCode: "ADM1",
        CountryCode: "CV"
      },
      {
        id: "3374161",
        Name: "Concelho do Tarrafal",
        
        FCode: "ADM1",
        CountryCode: "CV"
      },
      {
        id: "7602872",
        Name: "Concelho do Tarrafal de São Nicolau",
        
        FCode: "ADM1",
        CountryCode: "CV"
      },
      {
        id: "3411924",
        Name: "Concelho dos Mosteiros",
        
        FCode: "ADM1",
        CountryCode: "CV"
      }
    ],
  },
  {
    id: "239880",
    Name: "Central African Republic",
    States: [
      {
        id: "2596686",
        Name: "Commune de Bangui",
        
        FCode: "ADM1",
        CountryCode: "CF"
      },
      {
        id: "240591",
        Name: "Préfecture de la Bamingui-Bangoran",
        
        FCode: "ADM1",
        CountryCode: "CF"
      },
      {
        id: "240396",
        Name: "Préfecture de la Basse-Kotto",
        
        FCode: "ADM1",
        CountryCode: "CF"
      },
      {
        id: "238640",
        Name: "Préfecture de la Haute-Kotto",
        
        FCode: "ADM1",
        CountryCode: "CF"
      },
      {
        id: "2385836",
        Name: "Préfecture de la Kémo",
        
        FCode: "ADM1",
        CountryCode: "CF"
      },
      {
        id: "2385105",
        Name: "Préfecture de la Lobaye",
        
        FCode: "ADM1",
        CountryCode: "CF"
      },
      {
        id: "2386161",
        Name: "Préfecture de la Mambéré-Kadéï",
        
        FCode: "ADM1",
        CountryCode: "CF"
      },
      {
        id: "2386243",
        Name: "Préfecture de la Nana-Grébizi",
        
        FCode: "ADM1",
        CountryCode: "CF"
      },
      {
        id: "2384205",
        Name: "Préfecture de la Nana-Mambéré",
        
        FCode: "ADM1",
        CountryCode: "CF"
      },
      {
        id: "236887",
        Name: "Préfecture de la Ouaka",
        
        FCode: "ADM1",
        CountryCode: "CF"
      },
      {
        id: "2383204",
        Name: "Préfecture de la Sangha-Mbaéré",
        
        FCode: "ADM1",
        CountryCode: "CF"
      },
      {
        id: "236178",
        Name: "Préfecture de la Vakaga",
        
        FCode: "ADM1",
        CountryCode: "CF"
      },
      {
        id: "2383765",
        Name: "Préfecture de l’ Ombella-Mpoko",
        
        FCode: "ADM1",
        CountryCode: "CF"
      },
      {
        id: "2383653",
        Name: "Préfecture de l’ Ouham",
        
        FCode: "ADM1",
        CountryCode: "CF"
      },
      {
        id: "2383650",
        Name: "Préfecture de l’ Ouham-Pendé",
        
        FCode: "ADM1",
        CountryCode: "CF"
      },
      {
        id: "238639",
        Name: "Préfecture du Haut-Mbomou",
        
        FCode: "ADM1",
        CountryCode: "CF"
      },
      {
        id: "237556",
        Name: "Préfecture du Mbomou",
        
        FCode: "ADM1",
        CountryCode: "CF"
      }
    ],
  },
  {
    id: "2434508",
    Name: "Chad",
    States: [
      {
        id: "7603256",
        Name: "Ennedi",
        
        FCode: "ADM1",
        CountryCode: "TD"
      },
      {
        id: "7603254",
        Name: "Région de la Ville de N'Djaména",
        
        FCode: "ADM1",
        CountryCode: "TD"
      },
      {
        id: "7603255",
        Name: "Région du Barh el Gazel",
        
        FCode: "ADM1",
        CountryCode: "TD"
      },
      {
        id: "2435899",
        Name: "Région du Batha",
        
        FCode: "ADM1",
        CountryCode: "TD"
      },
      {
        id: "7602866",
        Name: "Région du Borkou",
        
        FCode: "ADM1",
        CountryCode: "TD"
      },
      {
        id: "2434478",
        Name: "Région du Chari-Baguirmi",
        
        FCode: "ADM1",
        CountryCode: "TD"
      },
      {
        id: "2431555",
        Name: "Région du Guéra",
        
        FCode: "ADM1",
        CountryCode: "TD"
      },
      {
        id: "7603251",
        Name: "Région du Hadjer-Lamis",
        
        FCode: "ADM1",
        CountryCode: "TD"
      },
      {
        id: "2430873",
        Name: "Région du Kanem",
        
        FCode: "ADM1",
        CountryCode: "TD"
      },
      {
        id: "2429323",
        Name: "Région du Lac",
        
        FCode: "ADM1",
        CountryCode: "TD"
      },
      {
        id: "2429060",
        Name: "Région du Logone Occidental",
        
        FCode: "ADM1",
        CountryCode: "TD"
      },
      {
        id: "2429058",
        Name: "Région du Logone Oriental",
        
        FCode: "ADM1",
        CountryCode: "TD"
      },
      {
        id: "7603252",
        Name: "Région du Mandoul",
        
        FCode: "ADM1",
        CountryCode: "TD"
      },
      {
        id: "2428132",
        Name: "Région du Mayo-Kébbi Est",
        
        FCode: "ADM1",
        CountryCode: "TD"
      },
      {
        id: "7603253",
        Name: "Région du Mayo-Kébbi Ouest",
        
        FCode: "ADM1",
        CountryCode: "TD"
      },
      {
        id: "2427315",
        Name: "Région du Moyen-Chari",
        
        FCode: "ADM1",
        CountryCode: "TD"
      },
      {
        id: "242246",
        Name: "Région du Ouaddaï",
        
        FCode: "ADM1",
        CountryCode: "TD"
      },
      {
        id: "242048",
        Name: "Région du Salamat",
        
        FCode: "ADM1",
        CountryCode: "TD"
      },
      {
        id: "7603257",
        Name: "Région du Sila",
        
        FCode: "ADM1",
        CountryCode: "TD"
      },
      {
        id: "2425287",
        Name: "Région du Tandjilé",
        
        FCode: "ADM1",
        CountryCode: "TD"
      },
      {
        id: "7603258",
        Name: "Région du Tibesti",
        
        FCode: "ADM1",
        CountryCode: "TD"
      },
      {
        id: "244877",
        Name: "Région du Wadi Fira",
        
        FCode: "ADM1",
        CountryCode: "TD"
      }
    ],
  },
  {
    id: "921929",
    Name: "Comoros",
    States: [
      {
        id: "921780",
        Name: "Mwali",
        
        FCode: "ADM1",
        CountryCode: "KM"
      },
      {
        id: "922001",
        Name: "Ndzuwani",
        
        FCode: "ADM1",
        CountryCode: "KM"
      },
      {
        id: "921882",
        Name: "Île Autonome de Grande Comore",
        
        FCode: "ADM1",
        CountryCode: "KM"
      }
    ],
  },
  {
    id: "203312",
    Name: "Congo",
    States: [
      {
        id: "216139",
        Name: "Province Orientale",
        
        FCode: "ADM1",
        CountryCode: "CD"
      },
      {
        id: "2317396",
        Name: "Province de Bandundu",
        
        FCode: "ADM1",
        CountryCode: "CD"
      },
      {
        id: "216661",
        Name: "Province de l’ Équateur",
        
        FCode: "ADM1",
        CountryCode: "CD"
      },
      {
        id: "2317277",
        Name: "Province du Bas-Congo",
        
        FCode: "ADM1",
        CountryCode: "CD"
      },
      {
        id: "214139",
        Name: "Province du Kasaï-Occidental",
        
        FCode: "ADM1",
        CountryCode: "CD"
      },
      {
        id: "214138",
        Name: "Province du Kasaï-Oriental",
        
        FCode: "ADM1",
        CountryCode: "CD"
      },
      {
        id: "205703",
        Name: "Province du Katanga",
        
        FCode: "ADM1",
        CountryCode: "CD"
      },
      {
        id: "209610",
        Name: "Province du Maniema",
        
        FCode: "ADM1",
        CountryCode: "CD"
      },
      {
        id: "206938",
        Name: "Province du Nord-Kivu",
        
        FCode: "ADM1",
        CountryCode: "CD"
      },
      {
        id: "205413",
        Name: "Province du Sud-Kivu",
        
        FCode: "ADM1",
        CountryCode: "CD"
      },
      {
        id: "2314300",
        Name: "Ville de Kinshasa",
        
        FCode: "ADM1",
        CountryCode: "CD"
      }
    ],
  },
  {
    id: "223816",
    Name: "Djibouti",
    States: [
      {
        id: "223889",
        Name: "Région de Dikhil",
        
        FCode: "ADM1",
        CountryCode: "DJ"
      },
      {
        id: "220781",
        Name: "Région de Tadjourah",
        
        FCode: "ADM1",
        CountryCode: "DJ"
      },
      {
        id: "225282",
        Name: "Région d’ Ali Sabieh",
        
        FCode: "ADM1",
        CountryCode: "DJ"
      },
      {
        id: "449265",
        Name: "Région d’ Arta",
        
        FCode: "ADM1",
        CountryCode: "DJ"
      },
      {
        id: "221525",
        Name: "Région d’ Obock",
        
        FCode: "ADM1",
        CountryCode: "DJ"
      },
      {
        id: "223818",
        Name: "Ville de Djibouti",
        
        FCode: "ADM1",
        CountryCode: "DJ"
      }
    ],
  },
  {
    id: "357994",
    Name: "Egypt",
    States: [
      {
        id: "361059",
        Name: "Alexandria",
        
        FCode: "ADM1",
        CountryCode: "EG",
      },
      {
        id: "360016",
        Name: "Eastern Province",
        
        FCode: "ADM1",
        CountryCode: "EG",
      },
      {
        id: "359787",
        Name: "Muḩāfaz̧at Aswān",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "359781",
        Name: "Muḩāfaz̧at Asyūţ",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "359171",
        Name: "Muḩāfaz̧at Banī Suwayf",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "358617",
        Name: "Muḩāfaz̧at Būr Sa‘īd",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "358044",
        Name: "Muḩāfaz̧at Dumyāţ",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "355182",
        Name: "Muḩāfaz̧at Janūb Sīnā’",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "354500",
        Name: "Muḩāfaz̧at Kafr ash Shaykh",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "352603",
        Name: "Muḩāfaz̧at Maţrūḩ",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "350546",
        Name: "Muḩāfaz̧at Qinā",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "349401",
        Name: "Muḩāfaz̧at Shamāl Sīnā’",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "347794",
        Name: "Muḩāfaz̧at Sūhāj",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "361849",
        Name: "Muḩāfaz̧at ad Daqahlīyah",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "361468",
        Name: "Muḩāfaz̧at al Baḩr al Aḩmar",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "361370",
        Name: "Muḩāfaz̧at al Buḩayrah",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "361323",
        Name: "Muḩāfaz̧at al Fayyūm",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "361294",
        Name: "Muḩāfaz̧at al Gharbīyah",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "361056",
        Name: "Muḩāfaz̧at al Ismā‘īlīyah",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "360997",
        Name: "Muḩāfaz̧at al Jīzah",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "360688",
        Name: "Muḩāfaz̧at al Minyā",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "360689",
        Name: "Muḩāfaz̧at al Minūfīyah",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "360621",
        Name: "Muḩāfaz̧at al Qalyūbīyah",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "360631",
        Name: "Muḩāfaz̧at al Qāhirah",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "7603259",
        Name: "Muḩāfaz̧at al Uqşur",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "360483",
        Name: "Muḩāfaz̧at al Wādī al Jadīd",
        
        FCode: "ADM1",
        CountryCode: "EG"
      },
      {
        id: "359797",
        Name: "Muḩāfaz̧at as Suways",
        
        FCode: "ADM1",
        CountryCode: "EG"
      }
    ],
  },
  {
    id: "2309096",
    Name: "Equatorial Guinea",
    States: [
      {
        id: "2310307",
        Name: "Provincia de Annobón",
        
        FCode: "ADM1",
        CountryCode: "GQ"
      },
      {
        id: "2566978",
        Name: "Provincia de Bioko Norte",
        
        FCode: "ADM1",
        CountryCode: "GQ"
      },
      {
        id: "2566979",
        Name: "Provincia de Bioko Sur",
        
        FCode: "ADM1",
        CountryCode: "GQ"
      },
      {
        id: "2566980",
        Name: "Provincia de Centro Sur",
        
        FCode: "ADM1",
        CountryCode: "GQ"
      },
      {
        id: "2566981",
        Name: "Provincia de Kié-Ntem",
        
        FCode: "ADM1",
        CountryCode: "GQ"
      },
      {
        id: "2566982",
        Name: "Provincia de Litoral",
        
        FCode: "ADM1",
        CountryCode: "GQ"
      },
      {
        id: "2566983",
        Name: "Provincia de Wele-Nzas",
        
        FCode: "ADM1",
        CountryCode: "GQ"
      }
    ],
  },
  {
    id: "338010",
    Name: "Eritrea",
    States: [
      {
        id: "448498",
        Name: "Zoba Debub",
        
        FCode: "ADM1",
        CountryCode: "ER"
      },
      {
        id: "448499",
        Name: "Zoba Debubawī K’eyih Bahrī",
        
        FCode: "ADM1",
        CountryCode: "ER"
      },
      {
        id: "448500",
        Name: "Zoba Gash-Barka",
        
        FCode: "ADM1",
        CountryCode: "ER"
      },
      {
        id: "448501",
        Name: "Zoba Ma’ākel",
        
        FCode: "ADM1",
        CountryCode: "ER"
      },
      {
        id: "448502",
        Name: "Zoba Semēnawī K’eyih Bahrī",
        
        FCode: "ADM1",
        CountryCode: "ER"
      },
      {
        id: "448497",
        Name: "Zoba Ānseba",
        
        FCode: "ADM1",
        CountryCode: "ER"
      }
    ],
  },
  {
    id: "337996",
    Name: "Ethiopia",
    States: [
      {
        id: "444181",
        Name: "Beneshangual Gumz Regional State",
        
        FCode: "ADM1",
        CountryCode: "ET",
      },
      {
        id: "444182",
        Name: "Dire Dawa Region",
        
        FCode: "ADM1",
        CountryCode: "ET",
      },
      {
        id: "444183",
        Name: "Gambela",
        
        FCode: "ADM1",
        CountryCode: "ET",
      },
      {
        id: "444185",
        Name: "Oromia Regional State",
        
        FCode: "ADM1",
        CountryCode: "ET",
      },
      {
        id: "444188",
        Name: "SSNPR",
        
        FCode: "ADM1",
        CountryCode: "ET",
      },
      {
        id: "444179",
        Name: "The State of Afar",
        
        FCode: "ADM1",
        CountryCode: "ET",
      },
      {
        id: "444180",
        Name: "The State of Amhara",
        
        FCode: "ADM1",
        CountryCode: "ET",
      },
      {
        id: "444184",
        Name: "The State of Harari People",
        
        FCode: "ADM1",
        CountryCode: "ET",
      },
      {
        id: "444186",
        Name: "The State of Somalia",
        
        FCode: "ADM1",
        CountryCode: "ET",
      },
      {
        id: "444187",
        Name: "The State of Tigray",
        
        FCode: "ADM1",
        CountryCode: "ET",
      },
      {
        id: "444178",
        Name: "Ādīs Ābeba Āstedader",
        
        FCode: "ADM1",
        CountryCode: "ET"
      }
    ],
  },
  {
    id: "2400553",
    Name: "Gabon",
    States: [
      {
        id: "2397466",
        Name: "Province de la Ngounié",
        
        FCode: "ADM1",
        CountryCode: "GA"
      },
      {
        id: "2397141",
        Name: "Province de la Nyanga",
        
        FCode: "ADM1",
        CountryCode: "GA"
      },
      {
        id: "2400682",
        Name: "Province de l’ Estuaire",
        
        FCode: "ADM1",
        CountryCode: "GA"
      },
      {
        id: "2396926",
        Name: "Province de l’ Ogooué-Ivindo",
        
        FCode: "ADM1",
        CountryCode: "GA"
      },
      {
        id: "2396925",
        Name: "Province de l’ Ogooué-Lolo",
        
        FCode: "ADM1",
        CountryCode: "GA"
      },
      {
        id: "2396924",
        Name: "Province de l’ Ogooué-Maritime",
        
        FCode: "ADM1",
        CountryCode: "GA"
      },
      {
        id: "2400454",
        Name: "Province du Haut-Ogooué",
        
        FCode: "ADM1",
        CountryCode: "GA"
      },
      {
        id: "2397842",
        Name: "Province du Moyen-Ogooué",
        
        FCode: "ADM1",
        CountryCode: "GA"
      },
      {
        id: "2396076",
        Name: "Province du Woleu-Ntem",
        
        FCode: "ADM1",
        CountryCode: "GA"
      }
    ],
  },
  {
    id: "2413451",
    Name: "Gambia",
    States: [
      {
        id: "2412707",
        Name: "Central River Division",
        
        FCode: "ADM1",
        CountryCode: "GM"
      },
      {
        id: "2413875",
        Name: "City of Banjul",
        
        FCode: "ADM1",
        CountryCode: "GM"
      },
      {
        id: "2412716",
        Name: "Lower River Division",
        
        FCode: "ADM1",
        CountryCode: "GM"
      },
      {
        id: "2412353",
        Name: "North Bank Division",
        
        FCode: "ADM1",
        CountryCode: "GM"
      },
      {
        id: "2411711",
        Name: "Upper River",
        
        FCode: "ADM1",
        CountryCode: "GM",
      },
      {
        id: "2411683",
        Name: "Western Division",
        
        FCode: "ADM1",
        CountryCode: "GM"
      }
    ],
  },
  {
    id: "2300660",
    Name: "Ghana",
    States: [
      {
        id: "2304116",
        Name: "Ashanti Region",
        
        FCode: "ADM1",
        CountryCode: "GH"
      },
      {
        id: "2302547",
        Name: "Brong-Ahafo",
        
        FCode: "ADM1",
        CountryCode: "GH",
      },
      {
        id: "2302353",
        Name: "Central Region",
        
        FCode: "ADM1",
        CountryCode: "GH"
      },
      {
        id: "2301360",
        Name: "Eastern Region",
        
        FCode: "ADM1",
        CountryCode: "GH"
      },
      {
        id: "2300569",
        Name: "Greater Accra Region",
        
        FCode: "ADM1",
        CountryCode: "GH"
      },
      {
        id: "2297169",
        Name: "Northern Region",
        
        FCode: "ADM1",
        CountryCode: "GH"
      },
      {
        id: "2294291",
        Name: "Upper East Region",
        
        FCode: "ADM1",
        CountryCode: "GH"
      },
      {
        id: "2294286",
        Name: "Upper West Region",
        
        FCode: "ADM1",
        CountryCode: "GH"
      },
      {
        id: "2294234",
        Name: "Volta Region",
        
        FCode: "ADM1",
        CountryCode: "GH"
      },
      {
        id: "2294076",
        Name: "Western Region",
        
        FCode: "ADM1",
        CountryCode: "GH"
      }
    ],
  },
  {
    id: "2420477",
    Name: "Guinea",
    States: [
      {
        id: "2422464",
        Name: "Capitale d’État-Zone Spéciale de Conakry",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2423124",
        Name: "Préfecture de Beyla",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2422967",
        Name: "Préfecture de Boffa",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2422923",
        Name: "Préfecture de Boké",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2595299",
        Name: "Préfecture de Coyah",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2422441",
        Name: "Préfecture de Dabola",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2422377",
        Name: "Préfecture de Dalaba",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2421902",
        Name: "Préfecture de Dinguiraye",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2421533",
        Name: "Préfecture de Dubréka",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2421272",
        Name: "Préfecture de Faranah",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2420983",
        Name: "Préfecture de Forécariah",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2420883",
        Name: "Préfecture de Fria",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2420825",
        Name: "Préfecture de Gaoual",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2420561",
        Name: "Préfecture de Guékédou",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2419991",
        Name: "Préfecture de Kankan",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2419531",
        Name: "Préfecture de Kindia",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2419470",
        Name: "Préfecture de Kissidougou",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2595302",
        Name: "Préfecture de Koubia",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2418595",
        Name: "Préfecture de Koundara",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2418435",
        Name: "Préfecture de Kouroussa",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2419618",
        Name: "Préfecture de Kérouané",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2418360",
        Name: "Préfecture de Labé",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2595304",
        Name: "Préfecture de Lola",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2595303",
        Name: "Préfecture de Lélouma",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2417987",
        Name: "Préfecture de Macenta",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2417885",
        Name: "Préfecture de Mali",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2417831",
        Name: "Préfecture de Mamou",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2595305",
        Name: "Préfecture de Mandiana",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2416968",
        Name: "Préfecture de Nzérékoré",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2416440",
        Name: "Préfecture de Pita",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2415702",
        Name: "Préfecture de Siguiri",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2414544",
        Name: "Préfecture de Tougué",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2414925",
        Name: "Préfecture de Télimélé",
        
        FCode: "ADM1",
        CountryCode: "GN"
      },
      {
        id: "2414077",
        Name: "Préfecture de Yomou",
        
        FCode: "ADM1",
        CountryCode: "GN"
      }
    ],
  },
  {
    id: "2372248",
    Name: "Guinea-Bissau",
    States: [
      {
        id: "2375255",
        Name: "Bafatá",
        
        FCode: "ADM1",
        CountryCode: "GW"
      },
      {
        id: "2374820",
        Name: "Biombo",
        
        FCode: "ADM1",
        CountryCode: "GW"
      },
      {
        id: "2374776",
        Name: "Bissau Autonomous Region",
        
        FCode: "ADM1",
        CountryCode: "GW",
      },
      {
        id: "2374689",
        Name: "Bolama and Bijagos",
        
        FCode: "ADM1",
        CountryCode: "GW",
      },
      {
        id: "2374312",
        Name: "Cacheu",
        
        FCode: "ADM1",
        CountryCode: "GW"
      },
      {
        id: "2372533",
        Name: "Gabú",
        
        FCode: "ADM1",
        CountryCode: "GW"
      },
      {
        id: "2371071",
        Name: "Oio",
        
        FCode: "ADM1",
        CountryCode: "GW"
      },
      {
        id: "2370360",
        Name: "Quinara",
        
        FCode: "ADM1",
        CountryCode: "GW"
      },
      {
        id: "2368955",
        Name: "Tombali",
        
        FCode: "ADM1",
        CountryCode: "GW"
      }
    ],
  },
  {
    id: "2287781",
    Name: "Ivory Coast",
    States: [
      {
        id: "2597332",
        Name: "Région de la Marahoué",
        
        FCode: "ADM1",
        CountryCode: "CI"
      },
      {
        id: "2597321",
        Name: "Région de la Vallée du Bandama",
        
        FCode: "ADM1",
        CountryCode: "CI"
      },
      {
        id: "2597318",
        Name: "Région de l’ Agnéby",
        
        FCode: "ADM1",
        CountryCode: "CI"
      },
      {
        id: "2597323",
        Name: "Région des Dix-Huit Montagnes",
        
        FCode: "ADM1",
        CountryCode: "CI"
      },
      {
        id: "2597324",
        Name: "Région des Lacs",
        
        FCode: "ADM1",
        CountryCode: "CI"
      },
      {
        id: "2597316",
        Name: "Région des Lagunes",
        
        FCode: "ADM1",
        CountryCode: "CI"
      },
      {
        id: "2597320",
        Name: "Région des Savanes",
        
        FCode: "ADM1",
        CountryCode: "CI"
      },
      {
        id: "2597334",
        Name: "Région du Bafing",
        
        FCode: "ADM1",
        CountryCode: "CI"
      },
      {
        id: "2597326",
        Name: "Région du Bas-Sassandra",
        
        FCode: "ADM1",
        CountryCode: "CI"
      },
      {
        id: "2597328",
        Name: "Région du Denguélé",
        
        FCode: "ADM1",
        CountryCode: "CI"
      },
      {
        id: "2597330",
        Name: "Région du Fromager",
        
        FCode: "ADM1",
        CountryCode: "CI"
      },
      {
        id: "2597319",
        Name: "Région du Haut-Sassandra",
        
        FCode: "ADM1",
        CountryCode: "CI"
      },
      {
        id: "2597333",
        Name: "Région du Moyen-Cavally",
        
        FCode: "ADM1",
        CountryCode: "CI"
      },
      {
        id: "2597322",
        Name: "Région du Moyen-Comoé",
        
        FCode: "ADM1",
        CountryCode: "CI"
      },
      {
        id: "2597331",
        Name: "Région du N’zi-Comoé",
        
        FCode: "ADM1",
        CountryCode: "CI"
      },
      {
        id: "2597329",
        Name: "Région du Sud-Bandama",
        
        FCode: "ADM1",
        CountryCode: "CI"
      },
      {
        id: "2597317",
        Name: "Région du Sud-Comoé",
        
        FCode: "ADM1",
        CountryCode: "CI"
      },
      {
        id: "2597327",
        Name: "Région du Worodougou",
        
        FCode: "ADM1",
        CountryCode: "CI"
      },
      {
        id: "2597325",
        Name: "Région du Zanzan",
        
        FCode: "ADM1",
        CountryCode: "CI"
      }
    ],
  },
  {
    id: "192950",
    Name: "Kenya",
    States: [
      {
        id: "400742",
        Name: "Central Province",
        
        FCode: "ADM1",
        CountryCode: "KE"
      },
      {
        id: "400740",
        Name: "Coast Province",
        
        FCode: "ADM1",
        CountryCode: "KE"
      },
      {
        id: "400741",
        Name: "Eastern",
        
        FCode: "ADM1",
        CountryCode: "KE",
      },
      {
        id: "184742",
        Name: "Nairobi Province",
        
        FCode: "ADM1",
        CountryCode: "KE"
      },
      {
        id: "400745",
        Name: "North Eastern Province",
        
        FCode: "ADM1",
        CountryCode: "KE"
      },
      {
        id: "182763",
        Name: "Nyanza Province",
        
        FCode: "ADM1",
        CountryCode: "KE"
      },
      {
        id: "400744",
        Name: "Rift Valley Province",
        
        FCode: "ADM1",
        CountryCode: "KE"
      },
      {
        id: "400743",
        Name: "Western Province",
        
        FCode: "ADM1",
        CountryCode: "KE"
      }
    ],
  },
  {
    id: "932692",
    Name: "Lesotho",
    States: [
      {
        id: "932932",
        Name: "Berea",
        
        FCode: "ADM1",
        CountryCode: "LS",
      },
      {
        id: "932888",
        Name: "Butha-Buthe",
        
        FCode: "ADM1",
        CountryCode: "LS",
      },
      {
        id: "932700",
        Name: "Leribe",
        
        FCode: "ADM1",
        CountryCode: "LS",
      },
      {
        id: "932615",
        Name: "Mafeteng District",
        
        FCode: "ADM1",
        CountryCode: "LS"
      },
      {
        id: "932506",
        Name: "Maseru District",
        
        FCode: "ADM1",
        CountryCode: "LS"
      },
      {
        id: "932439",
        Name: "Mohale’s Hoek District",
        
        FCode: "ADM1",
        CountryCode: "LS"
      },
      {
        id: "932418",
        Name: "Mokhotlong District",
        
        FCode: "ADM1",
        CountryCode: "LS"
      },
      {
        id: "932219",
        Name: "Qacha’s Nek District",
        
        FCode: "ADM1",
        CountryCode: "LS"
      },
      {
        id: "932184",
        Name: "Quthing",
        
        FCode: "ADM1",
        CountryCode: "LS",
      },
      {
        id: "932011",
        Name: "Thaba-Tseka",
        
        FCode: "ADM1",
        CountryCode: "LS",
      }
    ],
  },
  {
    id: "2275384",
    Name: "Liberia",
    States: [
      {
        id: "2278324",
        Name: "Bomi County",
        
        FCode: "ADM1",
        CountryCode: "LR"
      },
      {
        id: "2278292",
        Name: "Bong County",
        
        FCode: "ADM1",
        CountryCode: "LR"
      },
      {
        id: "2593119",
        Name: "Gbarpolu County",
        
        FCode: "ADM1",
        CountryCode: "LR"
      },
      {
        id: "2276630",
        Name: "Grand Bassa County",
        
        FCode: "ADM1",
        CountryCode: "LR"
      },
      {
        id: "2276627",
        Name: "Grand Cape Mount County",
        
        FCode: "ADM1",
        CountryCode: "LR"
      },
      {
        id: "2276622",
        Name: "Grand Gedeh County",
        
        FCode: "ADM1",
        CountryCode: "LR"
      },
      {
        id: "2588490",
        Name: "Grand Kru County",
        
        FCode: "ADM1",
        CountryCode: "LR"
      },
      {
        id: "2275344",
        Name: "Lofa County",
        
        FCode: "ADM1",
        CountryCode: "LR"
      },
      {
        id: "2588491",
        Name: "Margibi County",
        
        FCode: "ADM1",
        CountryCode: "LR"
      },
      {
        id: "2275099",
        Name: "Maryland County",
        
        FCode: "ADM1",
        CountryCode: "LR"
      },
      {
        id: "2274890",
        Name: "Montserrado County",
        
        FCode: "ADM1",
        CountryCode: "LR"
      },
      {
        id: "2274688",
        Name: "Nimba County",
        
        FCode: "ADM1",
        CountryCode: "LR"
      },
      {
        id: "2588492",
        Name: "River Cess County",
        
        FCode: "ADM1",
        CountryCode: "LR"
      },
      {
        id: "2593120",
        Name: "River Gee County",
        
        FCode: "ADM1",
        CountryCode: "LR"
      },
      {
        id: "2273898",
        Name: "Sinoe County",
        
        FCode: "ADM1",
        CountryCode: "LR"
      }
    ],
  },
  {
    id: "2215636",
    Name: "Libya",
    States: [
      {
        id: "88318",
        Name: "Sha‘bīyat Banghāzī",
        
        FCode: "ADM1",
        CountryCode: "LY"
      },
      {
        id: "87204",
        Name: "Sha‘bīyat Darnah",
        
        FCode: "ADM1",
        CountryCode: "LY"
      },
      {
        id: "2217350",
        Name: "Sha‘bīyat Ghāt",
        
        FCode: "ADM1",
        CountryCode: "LY"
      },
      {
        id: "2214845",
        Name: "Sha‘bīyat Mişrātah",
        
        FCode: "ADM1",
        CountryCode: "LY"
      },
      {
        id: "2214602",
        Name: "Sha‘bīyat Murzuq",
        
        FCode: "ADM1",
        CountryCode: "LY"
      },
      {
        id: "2214432",
        Name: "Sha‘bīyat Nālūt",
        
        FCode: "ADM1",
        CountryCode: "LY"
      },
      {
        id: "2212774",
        Name: "Sha‘bīyat Sabhā",
        
        FCode: "ADM1",
        CountryCode: "LY"
      },
      {
        id: "2210553",
        Name: "Sha‘bīyat Surt",
        
        FCode: "ADM1",
        CountryCode: "LY"
      },
      {
        id: "7602693",
        Name: "Sha‘bīyat Wādī al Ḩayāt",
        
        FCode: "ADM1",
        CountryCode: "LY"
      },
      {
        id: "2219413",
        Name: "Sha‘bīyat Wādī ash Shāţi’",
        
        FCode: "ADM1",
        CountryCode: "LY"
      },
      {
        id: "7602688",
        Name: "Sha‘bīyat al Buţnān",
        
        FCode: "ADM1",
        CountryCode: "LY"
      },
      {
        id: "443289",
        Name: "Sha‘bīyat al Jabal al Akhḑar",
        
        FCode: "ADM1",
        CountryCode: "LY"
      },
      {
        id: "7602689",
        Name: "Sha‘bīyat al Jabal al Gharbī",
        
        FCode: "ADM1",
        CountryCode: "LY"
      },
      {
        id: "7602690",
        Name: "Sha‘bīyat al Jafārah",
        
        FCode: "ADM1",
        CountryCode: "LY"
      },
      {
        id: "2219944",
        Name: "Sha‘bīyat al Jufrah",
        
        FCode: "ADM1",
        CountryCode: "LY"
      },
      {
        id: "88932",
        Name: "Sha‘bīyat al Kufrah",
        
        FCode: "ADM1",
        CountryCode: "LY"
      },
      {
        id: "88904",
        Name: "Sha‘bīyat al Marj",
        
        FCode: "ADM1",
        CountryCode: "LY"
      },
      {
        id: "7602691",
        Name: "Sha‘bīyat al Marqab",
        
        FCode: "ADM1",
        CountryCode: "LY"
      },
      {
        id: "7602692",
        Name: "Sha‘bīyat al Wāḩāt",
        
        FCode: "ADM1",
        CountryCode: "LY"
      },
      {
        id: "2593778",
        Name: "Sha‘bīyat an Nuqāţ al Khams",
        
        FCode: "ADM1",
        CountryCode: "LY"
      },
      {
        id: "2218972",
        Name: "Sha‘bīyat az Zāwiyah",
        
        FCode: "ADM1",
        CountryCode: "LY"
      },
      {
        id: "2210245",
        Name: "Sha‘bīyat Ţarābulus",
        
        FCode: "ADM1",
        CountryCode: "LY",
      }
    ],

  },
  {
    id: "1062947",
    Name: "Madagascar",
    States: [
      {
        id: "7670851",
        Name: "Alaotra-Mangoro",
        
        FCode: "ADM1",
        CountryCode: "MG"
      },
      {
        id: "7670904",
        Name: "Amoron'i Mania",
        
        FCode: "ADM1",
        CountryCode: "MG"
      },
      {
        id: "7670856",
        Name: "Analamanga",
        
        FCode: "ADM1",
        CountryCode: "MG"
      },
      {
        id: "7670848",
        Name: "Analanjirofo",
        
        FCode: "ADM1",
        CountryCode: "MG"
      },
      {
        id: "7670911",
        Name: "Androy",
        
        FCode: "ADM1",
        CountryCode: "MG"
      },
      {
        id: "7670910",
        Name: "Anosy",
        
        FCode: "ADM1",
        CountryCode: "MG"
      },
      {
        id: "7670850",
        Name: "Betsiboka",
        
        FCode: "ADM1",
        CountryCode: "MG"
      },
      {
        id: "7670849",
        Name: "Boeny",
        
        FCode: "ADM1",
        CountryCode: "MG"
      },
      {
        id: "7670853",
        Name: "Bongolava",
        
        FCode: "ADM1",
        CountryCode: "MG"
      },
      {
        id: "7670842",
        Name: "Diana",
        
        FCode: "ADM1",
        CountryCode: "MG"
      },
      {
        id: "7670857",
        Name: "East",
        
        FCode: "ADM1",
        CountryCode: "MG",
      },
      {
        id: "7670907",
        Name: "Ihorombe",
        
        FCode: "ADM1",
        CountryCode: "MG"
      },
      {
        id: "7670855",
        Name: "Itasy",
        
        FCode: "ADM1",
        CountryCode: "MG"
      },
      {
        id: "7670852",
        Name: "Melaky",
        
        FCode: "ADM1",
        CountryCode: "MG"
      },
      {
        id: "7670902",
        Name: "Menabe",
        
        FCode: "ADM1",
        CountryCode: "MG"
      },
      {
        id: "7670846",
        Name: "Sava",
        
        FCode: "ADM1",
        CountryCode: "MG"
      },
      {
        id: "7670847",
        Name: "Sofia",
        
        FCode: "ADM1",
        CountryCode: "MG"
      },
      {
        id: "7670908",
        Name: "South-East",
        
        FCode: "ADM1",
        CountryCode: "MG",
      },
      {
        id: "7670913",
        Name: "South-West",
        
        FCode: "ADM1",
        CountryCode: "MG",
      },
      {
        id: "7670905",
        Name: "Upper Matsiatra",
        
        FCode: "ADM1",
        CountryCode: "MG",
      },
      {
        id: "7670854",
        Name: "Vakinankaratra",
        
        FCode: "ADM1",
        CountryCode: "MG"
      },
      {
        id: "7670906",
        Name: "Vatovavy-Fitovinany",
        
        FCode: "ADM1",
        CountryCode: "MG"
      }
    ],
  },
  {
    id: "927384",
    Name: "Malawi",
    States: [
      {
        id: "931597",
        Name: "Central Region",
        
        FCode: "ADM1",
        CountryCode: "MW"
      },
      {
        id: "924591",
        Name: "Northern Region",
        
        FCode: "ADM1",
        CountryCode: "MW"
      },
      {
        id: "923817",
        Name: "Southern Region",
        
        FCode: "ADM1",
        CountryCode: "MW"
      }
    ],
  },
  {
    id: "2453866",
    Name: "Mali",
    States: [
      {
        id: "2460594",
        Name: "District de Bamako",
        
        FCode: "ADM1",
        CountryCode: "ML"
      },
      {
        id: "2457161",
        Name: "Région de Gao",
        
        FCode: "ADM1",
        CountryCode: "ML"
      },
      {
        id: "2455517",
        Name: "Région de Kayes",
        
        FCode: "ADM1",
        CountryCode: "ML"
      },
      {
        id: "2597449",
        Name: "Région de Kidal",
        
        FCode: "ADM1",
        CountryCode: "ML"
      },
      {
        id: "2454532",
        Name: "Région de Koulikoro",
        
        FCode: "ADM1",
        CountryCode: "ML"
      },
      {
        id: "2453347",
        Name: "Région de Mopti",
        
        FCode: "ADM1",
        CountryCode: "ML"
      },
      {
        id: "2451184",
        Name: "Région de Sikasso",
        
        FCode: "ADM1",
        CountryCode: "ML"
      },
      {
        id: "2451477",
        Name: "Région de Ségou",
        
        FCode: "ADM1",
        CountryCode: "ML"
      },
      {
        id: "2449066",
        Name: "Région de Tombouctou",
        
        FCode: "ADM1",
        CountryCode: "ML"
      }
    ],
  },
  {
    id: "2378080",
    Name: "Mauritania",
    States: [
      {
        id: "2377449",
        Name: "District de Nouakchott",
        
        FCode: "ADM1",
        CountryCode: "MR"
      },
      {
        id: "2380426",
        Name: "Wilaya de Dakhlet Nouadhibou",
        
        FCode: "ADM1",
        CountryCode: "MR"
      },
      {
        id: "2381972",
        Name: "Wilaya de l'Adrar",
        
        FCode: "ADM1",
        CountryCode: "MR"
      },
      {
        id: "2381344",
        Name: "Wilaya de l'Assaba",
        
        FCode: "ADM1",
        CountryCode: "MR"
      },
      {
        id: "2378903",
        Name: "Wilaya de l'Inchiri",
        
        FCode: "ADM1",
        CountryCode: "MR"
      },
      {
        id: "2380635",
        Name: "Wilaya du Brakna",
        
        FCode: "ADM1",
        CountryCode: "MR"
      },
      {
        id: "2379384",
        Name: "Wilaya du Gorgol",
        
        FCode: "ADM1",
        CountryCode: "MR"
      },
      {
        id: "2379216",
        Name: "Wilaya du Guidimaka",
        
        FCode: "ADM1",
        CountryCode: "MR"
      },
      {
        id: "2379025",
        Name: "Wilaya du Hodh ech Chargui",
        
        FCode: "ADM1",
        CountryCode: "MR"
      },
      {
        id: "2379024",
        Name: "Wilaya du Hodh el Gharbi",
        
        FCode: "ADM1",
        CountryCode: "MR"
      },
      {
        id: "2376551",
        Name: "Wilaya du Tagant",
        
        FCode: "ADM1",
        CountryCode: "MR"
      },
      {
        id: "2375989",
        Name: "Wilaya du Tiris Zemmour",
        
        FCode: "ADM1",
        CountryCode: "MR"
      },
      {
        id: "2375742",
        Name: "Wilaya du Trarza",
        
        FCode: "ADM1",
        CountryCode: "MR"
      }
    ],
  },
  {
    id: "934292",
    Name: "Mauritius",
    States: [
      {
        id: "448254",
        Name: "Agalega Islands",
        
        FCode: "ADM1",
        CountryCode: "MU"
      },
      {
        id: "934718",
        Name: "Black River District",
        
        FCode: "ADM1",
        CountryCode: "MU"
      },
      {
        id: "1106583",
        Name: "Cargados Carajos",
        
        FCode: "ADM1",
        CountryCode: "MU",
      },
      {
        id: "934522",
        Name: "Flacq District",
        
        FCode: "ADM1",
        CountryCode: "MU"
      },
      {
        id: "934466",
        Name: "Grand Port District",
        
        FCode: "ADM1",
        CountryCode: "MU"
      },
      {
        id: "934275",
        Name: "Moka District",
        
        FCode: "ADM1",
        CountryCode: "MU"
      },
      {
        id: "934212",
        Name: "Pamplemousses District",
        
        FCode: "ADM1",
        CountryCode: "MU"
      },
      {
        id: "934166",
        Name: "Plaines Wilhems District",
        
        FCode: "ADM1",
        CountryCode: "MU"
      },
      {
        id: "934153",
        Name: "Port Louis District",
        
        FCode: "ADM1",
        CountryCode: "MU"
      },
      {
        id: "934090",
        Name: "Rivière du Rempart District",
        
        FCode: "ADM1",
        CountryCode: "MU"
      },
      {
        id: "1547449",
        Name: "Rodrigues",
        
        FCode: "ADM1",
        CountryCode: "MU"
      },
      {
        id: "934017",
        Name: "Savanne District",
        
        FCode: "ADM1",
        CountryCode: "MU"
      }
    ],
  },
  {
    id: "1024031",
    Name: "Mayotte",
    States: [
      {
        id: "7521421",
        Name: "Acoua",
        
        FCode: "ADM1",
        CountryCode: "YT"
      },
      {
        id: "7521422",
        Name: "Bandraboua",
        
        FCode: "ADM1",
        CountryCode: "YT"
      },
      {
        id: "7521423",
        Name: "Bandrele",
        
        FCode: "ADM1",
        CountryCode: "YT"
      },
      {
        id: "7521424",
        Name: "Bouéni",
        
        FCode: "ADM1",
        CountryCode: "YT"
      },
      {
        id: "7521425",
        Name: "Chiconi",
        
        FCode: "ADM1",
        CountryCode: "YT"
      },
      {
        id: "7521426",
        Name: "Chirongui",
        
        FCode: "ADM1",
        CountryCode: "YT"
      },
      {
        id: "7521427",
        Name: "Dembeni",
        
        FCode: "ADM1",
        CountryCode: "YT"
      },
      {
        id: "7521428",
        Name: "Dzaoudzi",
        
        FCode: "ADM1",
        CountryCode: "YT"
      },
      {
        id: "7521429",
        Name: "Kani-Kéli",
        
        FCode: "ADM1",
        CountryCode: "YT"
      },
      {
        id: "7521430",
        Name: "Koungou",
        
        FCode: "ADM1",
        CountryCode: "YT"
      },
      {
        id: "7521433",
        Name: "M'Tsangamouji",
        
        FCode: "ADM1",
        CountryCode: "YT"
      },
      {
        id: "7521431",
        Name: "Mamoudzou",
        
        FCode: "ADM1",
        CountryCode: "YT"
      },
      {
        id: "7521432",
        Name: "Mtsamboro",
        
        FCode: "ADM1",
        CountryCode: "YT"
      },
      {
        id: "7521434",
        Name: "Ouangani",
        
        FCode: "ADM1",
        CountryCode: "YT"
      },
      {
        id: "7521435",
        Name: "Pamandzi",
        
        FCode: "ADM1",
        CountryCode: "YT"
      },
      {
        id: "7521436",
        Name: "Sada",
        
        FCode: "ADM1",
        CountryCode: "YT"
      },
      {
        id: "7521437",
        Name: "Tsingoni",
        
        FCode: "ADM1",
        CountryCode: "YT"
      }
    ],
  },
  {
    id: "2542007",
    Name: "Morocco",
    States: [
      {
        id: "6545402",
        Name: "Laâyoune-Boujdour-Sakia El Hamra",
        
        FCode: "ADM1",
        CountryCode: "MA"
      },
      {
        id: "7627603",
        Name: "Oued ed Dahab-Lagouira",
        
        FCode: "ADM1",
        CountryCode: "MA"
      },
      {
        id: "2597548",
        Name: "Région de Chaouia-Ouardigha",
        
        FCode: "ADM1",
        CountryCode: "MA"
      },
      {
        id: "2597549",
        Name: "Région de Doukkala-Abda",
        
        FCode: "ADM1",
        CountryCode: "MA"
      },
      {
        id: "2548882",
        Name: "Région de Fès-Boulemane",
        
        FCode: "ADM1",
        CountryCode: "MA"
      },
      {
        id: "2597550",
        Name: "Région de Gharb-Chrarda-Beni Hssen",
        
        FCode: "ADM1",
        CountryCode: "MA"
      },
      {
        id: "2597551",
        Name: "Région de Guelmim-Es Smara",
        
        FCode: "ADM1",
        CountryCode: "MA"
      },
      {
        id: "2542995",
        Name: "Région de Marrakech-Tensift-Al Haouz",
        
        FCode: "ADM1",
        CountryCode: "MA",
      },
      {
        id: "2542710",
        Name: "Région de Meknès-Tafilalet",
        
        FCode: "ADM1",
        CountryCode: "MA"
      },
      {
        id: "2538470",
        Name: "Région de Rabat-Salé-Zemmour-Zaër",
        
        FCode: "ADM1",
        CountryCode: "MA"
      },
      {
        id: "2597554",
        Name: "Région de Souss-Massa-Drâa",
        
        FCode: "ADM1",
        CountryCode: "MA"
      },
      {
        id: "2597555",
        Name: "Région de Tadla-Azilal",
        
        FCode: "ADM1",
        CountryCode: "MA"
      },
      {
        id: "2597556",
        Name: "Région de Tanger-Tétouan",
        
        FCode: "ADM1",
        CountryCode: "MA"
      },
      {
        id: "2597557",
        Name: "Région de Taza-Al Hoceima-Taounate",
        
        FCode: "ADM1",
        CountryCode: "MA"
      },
      {
        id: "2597553",
        Name: "Région de l’ Oriental",
        
        FCode: "ADM1",
        CountryCode: "MA"
      },
      {
        id: "2553603",
        Name: "Région du Grand Casablanca",
        
        FCode: "ADM1",
        CountryCode: "MA",
      }
    ],
  },
  {
    id: "1036973",
    Name: "Mozambique",
    States: [
      {
        id: "1105845",
        Name: "Cidade de Maputo",
        
        FCode: "ADM1",
        CountryCode: "MZ"
      },
      {
        id: "1040649",
        Name: "Maputo",
        
        FCode: "ADM1",
        CountryCode: "MZ",
      },
      {
        id: "1026010",
        Name: "Province of Tete",
        
        FCode: "ADM1",
        CountryCode: "MZ",
      },
      {
        id: "1051823",
        Name: "Província de Cabo Delgado",
        
        FCode: "ADM1",
        CountryCode: "MZ"
      },
      {
        id: "1046058",
        Name: "Província de Gaza",
        
        FCode: "ADM1",
        CountryCode: "MZ"
      },
      {
        id: "1045110",
        Name: "Província de Inhambane",
        
        FCode: "ADM1",
        CountryCode: "MZ"
      },
      {
        id: "1040947",
        Name: "Província de Manica",
        
        FCode: "ADM1",
        CountryCode: "MZ"
      },
      {
        id: "1033354",
        Name: "Província de Nampula",
        
        FCode: "ADM1",
        CountryCode: "MZ"
      },
      {
        id: "1030006",
        Name: "Província de Niassa",
        
        FCode: "ADM1",
        CountryCode: "MZ"
      },
      {
        id: "1026804",
        Name: "Província de Sofala",
        
        FCode: "ADM1",
        CountryCode: "MZ"
      },
      {
        id: "1024312",
        Name: "Província de Zambézia",
        
        FCode: "ADM1",
        CountryCode: "MZ"
      }
    ],
  },
  {
    id: "3355338",
    Name: "Namibia",
    States: [
      {
        id: "1090052",
        Name: "Caprivi",
        
        FCode: "ADM1",
        CountryCode: "NA"
      },
      {
        id: "3371199",
        Name: "Erongo",
        
        FCode: "ADM1",
        CountryCode: "NA"
      },
      {
        id: "3371200",
        Name: "Hardap",
        
        FCode: "ADM1",
        CountryCode: "NA"
      },
      {
        id: "3371201",
        Name: "Karas",
        
        FCode: "ADM1",
        CountryCode: "NA"
      },
      {
        id: "3352137",
        Name: "Khomas",
        
        FCode: "ADM1",
        CountryCode: "NA"
      },
      {
        id: "3371202",
        Name: "Kunene",
        
        FCode: "ADM1",
        CountryCode: "NA"
      },
      {
        id: "3371203",
        Name: "Ohangwena",
        
        FCode: "ADM1",
        CountryCode: "NA"
      },
      {
        id: "3371204",
        Name: "Okavango",
        
        FCode: "ADM1",
        CountryCode: "NA"
      },
      {
        id: "3371205",
        Name: "Omaheke",
        
        FCode: "ADM1",
        CountryCode: "NA"
      },
      {
        id: "3371206",
        Name: "Omusati",
        
        FCode: "ADM1",
        CountryCode: "NA"
      },
      {
        id: "3371207",
        Name: "Oshana",
        
        FCode: "ADM1",
        CountryCode: "NA"
      },
      {
        id: "3371208",
        Name: "Oshikoto",
        
        FCode: "ADM1",
        CountryCode: "NA"
      },
      {
        id: "3371209",
        Name: "Otjozondjupa",
        
        FCode: "ADM1",
        CountryCode: "NA"
      }
    ],
  },
  {
    id: "2440476",
    Name: "Niger",
    States: [
      {
        id: "2448083",
        Name: "Agadez",
        
        FCode: "ADM1",
        CountryCode: "NE"
      },
      {
        id: "2445702",
        Name: "Diffa",
        
        FCode: "ADM1",
        CountryCode: "NE"
      },
      {
        id: "2445486",
        Name: "Dosso",
        
        FCode: "ADM1",
        CountryCode: "NE"
      },
      {
        id: "2441289",
        Name: "Maradi",
        
        FCode: "ADM1",
        CountryCode: "NE"
      },
      {
        id: "2595294",
        Name: "Niamey",
        
        FCode: "ADM1",
        CountryCode: "NE"
      },
      {
        id: "2439374",
        Name: "Tahoua",
        
        FCode: "ADM1",
        CountryCode: "NE"
      },
      {
        id: "2595293",
        Name: "Tillabéri",
        
        FCode: "ADM1",
        CountryCode: "NE"
      },
      {
        id: "2437797",
        Name: "Zinder",
        
        FCode: "ADM1",
        CountryCode: "NE"
      }
    ],
  },
  {
    id: "2328926",
    Name: "Nigeria",
    States: [
      {
        id: "2565340",
        Name: "Abia State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2352776",
        Name: "Abuja Federal Capital Territory",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2565342",
        Name: "Adamawa State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2350813",
        Name: "Akwa Ibom State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2347468",
        Name: "Bauchi",
        
        FCode: "ADM1",
        CountryCode: "NG",
      },
      {
        id: "2595344",
        Name: "Bayelsa State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2347266",
        Name: "Benue State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2346794",
        Name: "Borno State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2345891",
        Name: "Cross River State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2565341",
        Name: "Delta State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2595345",
        Name: "Ebonyi State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2565343",
        Name: "Edo",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2595346",
        Name: "Ekiti State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2565344",
        Name: "Enugu State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2595347",
        Name: "Gombe State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2337542",
        Name: "Imo State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2565345",
        Name: "Jigawa State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2335722",
        Name: "Kaduna State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2335196",
        Name: "Kano State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2334797",
        Name: "Katsina State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2597363",
        Name: "Kebbi State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2597364",
        Name: "Kogi State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2332785",
        Name: "Kwara State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2332453",
        Name: "Lagos",
        
        FCode: "ADM1",
        CountryCode: "NG",
      },
      {
        id: "2595348",
        Name: "Nassarawa State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2328925",
        Name: "Niger State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2327546",
        Name: "Ogun State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2326168",
        Name: "Ondo State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2597365",
        Name: "Osun State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2325190",
        Name: "Oyo State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2324828",
        Name: "Plateau State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2324433",
        Name: "Rivers State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2322907",
        Name: "Sokoto State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2597366",
        Name: "Taraba State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2349961",
        Name: "Udi State",
        
        FCode: "ADM1",
        CountryCode: "NG",
      },
      {
        id: "2597367",
        Name: "Yobe State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      },
      {
        id: "2595349",
        Name: "Zamfara State",
        
        FCode: "ADM1",
        CountryCode: "NG"
      }
    ],
  },
  {
    id: "2260494",
    Name: "Republic of the Congo",
    States: [
      {
        id: "2572183",
        Name: "Commune de Brazzaville",
        
        FCode: "ADM1",
        CountryCode: "CG"
      },
      {
        id: "7280295",
        Name: "Pointe-Noire",
        
        FCode: "ADM1",
        CountryCode: "CG"
      },
      {
        id: "2260668",
        Name: "Région de la Bouenza",
        
        FCode: "ADM1",
        CountryCode: "CG"
      },
      {
        id: "2260487",
        Name: "Région de la Cuvette",
        
        FCode: "ADM1",
        CountryCode: "CG"
      },
      {
        id: "2593118",
        Name: "Région de la Cuvette-Ouest",
        
        FCode: "ADM1",
        CountryCode: "CG"
      },
      {
        id: "2258431",
        Name: "Région de la Likouala",
        
        FCode: "ADM1",
        CountryCode: "CG"
      },
      {
        id: "2258534",
        Name: "Région de la Lékoumou",
        
        FCode: "ADM1",
        CountryCode: "CG"
      },
      {
        id: "2255329",
        Name: "Région de la Sangha",
        
        FCode: "ADM1",
        CountryCode: "CG"
      },
      {
        id: "2255422",
        Name: "Région des Plateaux",
        
        FCode: "ADM1",
        CountryCode: "CG"
      },
      {
        id: "2258738",
        Name: "Région du Kouilou",
        
        FCode: "ADM1",
        CountryCode: "CG"
      },
      {
        id: "2256175",
        Name: "Région du Niari",
        
        FCode: "ADM1",
        CountryCode: "CG"
      },
      {
        id: "2255404",
        Name: "Région du Pool",
        
        FCode: "ADM1",
        CountryCode: "CG"
      }
    ],
  },
  {
    id: "49518",
    Name: "Rwanda",
    States: [
      {
        id: "6413337",
        Name: "Eastern Province",
        
        FCode: "ADM1",
        CountryCode: "RW",
      },
      {
        id: "6413338",
        Name: "Kigali City",
        
        FCode: "ADM1",
        CountryCode: "RW",
      },
      {
        id: "6413339",
        Name: "Northern Province",
        
        FCode: "ADM1",
        CountryCode: "RW",
      },
      {
        id: "6413341",
        Name: "Southern Province",
        
        FCode: "ADM1",
        CountryCode: "RW",
      },
      {
        id: "6413340",
        Name: "Western Province",
        
        FCode: "ADM1",
        CountryCode: "RW",
      }
    ],
  },
  {
    id: "3370751",
    Name: "Saint Helena",
    States: [
      {
        id: "2411430",
        Name: "Ascension",
        
        FCode: "ADM1",
        CountryCode: "SH"
      },
      {
        id: "6930057",
        Name: "Saint Helena",
        
        FCode: "ADM1",
        CountryCode: "SH"
      },
      {
        id: "3370684",
        Name: "Tristan da Cunha",
        
        FCode: "ADM1",
        CountryCode: "SH"
      }
    ],
  },
  {
    id: "2245662",
    Name: "Senegal",
    States: [
      {
        id: "2249781",
        Name: "Kolda",
        
        FCode: "ADM1",
        CountryCode: "SN",
      },
      {
        id: "2253350",
        Name: "Région de Dakar",
        
        FCode: "ADM1",
        CountryCode: "SN"
      },
      {
        id: "2252308",
        Name: "Région de Diourbel",
        
        FCode: "ADM1",
        CountryCode: "SN"
      },
      {
        id: "2251910",
        Name: "Région de Fatick",
        
        FCode: "ADM1",
        CountryCode: "SN"
      },
      {
        id: "7303935",
        Name: "Région de Kaffrine",
        
        FCode: "ADM1",
        CountryCode: "SN"
      },
      {
        id: "2250804",
        Name: "Région de Kaolack",
        
        FCode: "ADM1",
        CountryCode: "SN"
      },
      {
        id: "7303936",
        Name: "Région de Kédougou",
        
        FCode: "ADM1",
        CountryCode: "SN"
      },
      {
        id: "2249221",
        Name: "Région de Louga",
        
        FCode: "ADM1",
        CountryCode: "SN"
      },
      {
        id: "2248753",
        Name: "Région de Matam",
        
        FCode: "ADM1",
        CountryCode: "SN"
      },
      {
        id: "2246451",
        Name: "Région de Saint-Louis",
        
        FCode: "ADM1",
        CountryCode: "SN"
      },
      {
        id: "7303937",
        Name: "Région de Sédhiou",
        
        FCode: "ADM1",
        CountryCode: "SN"
      },
      {
        id: "2244990",
        Name: "Région de Tambacounda",
        
        FCode: "ADM1",
        CountryCode: "SN"
      },
      {
        id: "2244800",
        Name: "Région de Thiès",
        
        FCode: "ADM1",
        CountryCode: "SN"
      },
      {
        id: "2243939",
        Name: "Région de Ziguinchor",
        
        FCode: "ADM1",
        CountryCode: "SN"
      }
    ],
  },
  {
    id: "241170",
    Name: "Seychelles",
    States: [
      {
        id: "241449",
        Name: "Anse Boileau",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "241447",
        Name: "Anse Etoile",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "241444",
        Name: "Anse Royale",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "241450",
        Name: "Anse aux Pins",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "448410",
        Name: "Au Cap",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "241439",
        Name: "Baie Lazare",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "241438",
        Name: "Baie Sainte Anne",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "241428",
        Name: "Beau Vallon",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "241426",
        Name: "Bel Air",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "241424",
        Name: "Bel Ombre",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "241396",
        Name: "Cascade",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "241302",
        Name: "English River",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "241336",
        Name: "Glacis",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "241330",
        Name: "Grand Anse Mahe",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "241331",
        Name: "Grand Anse Praslin",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "241311",
        Name: "Inner Islands",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "448408",
        Name: "Les Mamelles",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "241252",
        Name: "Mont Buxton",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "241251",
        Name: "Mont Fleuri",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "241224",
        Name: "Plaisance",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "241221",
        Name: "Pointe Larue",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "241215",
        Name: "Port Glaud",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "448409",
        Name: "Roche Caiman",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "241181",
        Name: "Saint Louis",
        
        FCode: "ADM1",
        CountryCode: "SC"
      },
      {
        id: "241151",
        Name: "Takamaka",
        
        FCode: "ADM1",
        CountryCode: "SC"
      }
    ],
  },
  {
    id: "2403846",
    Name: "Sierra Leone",
    States: [
      {
        id: "2409543",
        Name: "Eastern Province",
        
        FCode: "ADM1",
        CountryCode: "SL",
      },
      {
        id: "2404798",
        Name: "Northern Province",
        
        FCode: "ADM1",
        CountryCode: "SL",
      },
      {
        id: "2403745",
        Name: "Southern Province",
        
        FCode: "ADM1",
        CountryCode: "SL",
      },
      {
        id: "2403068",
        Name: "Western Area",
        
        FCode: "ADM1",
        CountryCode: "SL",
      }
    ],
  },
  {
    id: "51537",
    Name: "Somalia",
    States: [
      {
        id: "6268943",
        Name: "Gobolka Awdal",
        
        FCode: "ADM1",
        CountryCode: "SO"
      },
      {
        id: "64982",
        Name: "Gobolka Bakool",
        
        FCode: "ADM1",
        CountryCode: "SO"
      },
      {
        id: "64833",
        Name: "Gobolka Banaadir",
        
        FCode: "ADM1",
        CountryCode: "SO"
      },
      {
        id: "64661",
        Name: "Gobolka Bari",
        
        FCode: "ADM1",
        CountryCode: "SO"
      },
      {
        id: "64538",
        Name: "Gobolka Bay",
        
        FCode: "ADM1",
        CountryCode: "SO"
      },
      {
        id: "59362",
        Name: "Gobolka Galguduud",
        
        FCode: "ADM1",
        CountryCode: "SO"
      },
      {
        id: "58802",
        Name: "Gobolka Gedo",
        
        FCode: "ADM1",
        CountryCode: "SO"
      },
      {
        id: "57060",
        Name: "Gobolka Hiiraan",
        
        FCode: "ADM1",
        CountryCode: "SO"
      },
      {
        id: "53707",
        Name: "Gobolka Mudug",
        
        FCode: "ADM1",
        CountryCode: "SO"
      },
      {
        id: "53477",
        Name: "Gobolka Nugaal",
        
        FCode: "ADM1",
        CountryCode: "SO"
      },
      {
        id: "52187",
        Name: "Gobolka Sanaag",
        
        FCode: "ADM1",
        CountryCode: "SO"
      },
      {
        id: "51966",
        Name: "Gobolka Shabeellaha Hoose",
        
        FCode: "ADM1",
        CountryCode: "SO"
      },
      {
        id: "6268947",
        Name: "Gobolka Sool",
        
        FCode: "ADM1",
        CountryCode: "SO"
      },
      {
        id: "51230",
        Name: "Gobolka Togdheer",
        
        FCode: "ADM1",
        CountryCode: "SO"
      },
      {
        id: "50360",
        Name: "Gobolka Woqooyi Galbeed",
        
        FCode: "ADM1",
        CountryCode: "SO"
      },
      {
        id: "56083",
        Name: "Lower Juba",
        
        FCode: "ADM1",
        CountryCode: "SO",
      },
      {
        id: "56084",
        Name: "Middle Juba",
        
        FCode: "ADM1",
        CountryCode: "SO",
      },
      {
        id: "51967",
        Name: "Middle Shabele",
        
        FCode: "ADM1",
        CountryCode: "SO",
      }
    ],
  },
  {
    id: "953987",
    Name: "South Africa",
    States: [
      {
        id: "967573",
        Name: "Free State",
        
        FCode: "ADM1",
        CountryCode: "ZA"
      },
      {
        id: "1085594",
        Name: "Gauteng",
        
        FCode: "ADM1",
        CountryCode: "ZA"
      },
      {
        id: "972062",
        Name: "KwaZulu-Natal",
        
        FCode: "ADM1",
        CountryCode: "ZA",
      },
      {
        id: "1085597",
        Name: "Limpopo Province",
        
        FCode: "ADM1",
        CountryCode: "ZA"
      },
      {
        id: "1085595",
        Name: "Mpumalanga",
        
        FCode: "ADM1",
        CountryCode: "ZA"
      },
      {
        id: "1085596",
        Name: "Northern Cape",
        
        FCode: "ADM1",
        CountryCode: "ZA",
      },
      {
        id: "1085593",
        Name: "Province of Eastern Cape",
        
        FCode: "ADM1",
        CountryCode: "ZA"
      },
      {
        id: "1085598",
        Name: "Province of North-West",
        
        FCode: "ADM1",
        CountryCode: "ZA"
      },
      {
        id: "1085599",
        Name: "Province of the Western Cape",
        
        FCode: "ADM1",
        CountryCode: "ZA"
      }
    ],
  },
  {
    id: "7909807",
    Name: "South Sudan",
    States: [
      {
        id: "408655",
        Name: "Central Equatoria",
        
        FCode: "ADM1",
        CountryCode: "SS",
      },
      {
        id: "408668",
        Name: "Eastern Equatoria",
        
        FCode: "ADM1",
        CountryCode: "SS",
      },
      {
        id: "408662",
        Name: "Jonglei",
        
        FCode: "ADM1",
        CountryCode: "SS",
      },
      {
        id: "408647",
        Name: "Lakes",
        
        FCode: "ADM1",
        CountryCode: "SS",
      },
      {
        id: "408665",
        Name: "Northern Bahr el Ghazal State",
        
        FCode: "ADM1",
        CountryCode: "SS",
      },
      {
        id: "408650",
        Name: "Unity State",
        
        FCode: "ADM1",
        CountryCode: "SS",
      },
      {
        id: "381229",
        Name: "Upper Nile",
        
        FCode: "ADM1",
        CountryCode: "SS",
      },
      {
        id: "408670",
        Name: "Warrap",
        
        FCode: "ADM1",
        CountryCode: "SS",
      },
      {
        id: "408657",
        Name: "Western Bahr al Ghazal",
        
        FCode: "ADM1",
        CountryCode: "SS",
      },
      {
        id: "408656",
        Name: "Western Equatoria State",
        
        FCode: "ADM1",
        CountryCode: "SS",
      }
    ],
  },
  {
    id: "366755",
    Name: "Sudan",
    States: [
      {
        id: "408648",
        Name: "Al Jazirah State",
        
        FCode: "ADM1",
        CountryCode: "SD",
      },
      {
        id: "408649",
        Name: "Al Qadarif State",
        
        FCode: "ADM1",
        CountryCode: "SD",
      },
      {
        id: "408654",
        Name: "Blue Nile",
        
        FCode: "ADM1",
        CountryCode: "SD",
      },
      {
        id: "408663",
        Name: "Kassala State",
        
        FCode: "ADM1",
        CountryCode: "SD",
      },
      {
        id: "379253",
        Name: "Khartoum State",
        
        FCode: "ADM1",
        CountryCode: "SD",
      },
      {
        id: "408664",
        Name: "Nile",
        
        FCode: "ADM1",
        CountryCode: "SD",
      },
      {
        id: "408666",
        Name: "Northern Darfur State",
        
        FCode: "ADM1",
        CountryCode: "SD",
      },
      {
        id: "408667",
        Name: "Northern Kordofan State",
        
        FCode: "ADM1",
        CountryCode: "SD",
      },
      {
        id: "378389",
        Name: "Northern State",
        
        FCode: "ADM1",
        CountryCode: "SD",
      },
      {
        id: "408646",
        Name: "Red Sea State",
        
        FCode: "ADM1",
        CountryCode: "SD",
      },
      {
        id: "408669",
        Name: "Sinnar State",
        
        FCode: "ADM1",
        CountryCode: "SD",
      },
      {
        id: "408660",
        Name: "Southern Darfur State",
        
        FCode: "ADM1",
        CountryCode: "SD",
      },
      {
        id: "408661",
        Name: "Southern Kordofan State",
        
        FCode: "ADM1",
        CountryCode: "SD",
      },
      {
        id: "408658",
        Name: "Western Darfur State",
        
        FCode: "ADM1",
        CountryCode: "SD",
      },
      {
        id: "408653",
        Name: "White Nile State",
        
        FCode: "ADM1",
        CountryCode: "SD",
      }
    ],
  },
  {
    id: "934841",
    Name: "Swaziland",
    States: [
      {
        id: "935085",
        Name: "Hhohho District",
        
        FCode: "ADM1",
        CountryCode: "SZ"
      },
      {
        id: "935042",
        Name: "Lubombo District",
        
        FCode: "ADM1",
        CountryCode: "SZ"
      },
      {
        id: "934994",
        Name: "Manzini District",
        
        FCode: "ADM1",
        CountryCode: "SZ"
      },
      {
        id: "934867",
        Name: "Shiselweni District",
        
        FCode: "ADM1",
        CountryCode: "SZ"
      }
    ],
  },
  {
    id: "2410758",
    Name: "São Tomé and Príncipe",
    States: [
      {
        id: "2410878",
        Name: "Príncipe",
        
        FCode: "ADM1",
        CountryCode: "ST"
      },
      {
        id: "2410764",
        Name: "São Tomé",
        
        FCode: "ADM1",
        CountryCode: "ST"
      }
    ],
  },
  {
    id: "149590",
    Name: "Tanzania",
    States: [
      {
        id: "161322",
        Name: "Arusha Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      },
      {
        id: "160260",
        Name: "Dar es Salaam Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      },
      {
        id: "160192",
        Name: "Dodoma Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      },
      {
        id: "159067",
        Name: "Iringa Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      },
      {
        id: "148679",
        Name: "Kagera Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      },
      {
        id: "157732",
        Name: "Kigoma Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      },
      {
        id: "157449",
        Name: "Kilimanjaro Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      },
      {
        id: "155946",
        Name: "Lindi Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      },
      {
        id: "435764",
        Name: "Manyara Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      },
      {
        id: "154775",
        Name: "Mara Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      },
      {
        id: "154375",
        Name: "Mbeya Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      },
      {
        id: "153214",
        Name: "Morogoro Region",
        
        FCode: "ADM1",
        CountryCode: "TZ",
      },
      {
        id: "877744",
        Name: "Mtwara Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      },
      {
        id: "152219",
        Name: "Mwanza Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      },
      {
        id: "150733",
        Name: "Pemba North Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      },
      {
        id: "150732",
        Name: "Pemba South Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      },
      {
        id: "150602",
        Name: "Pwani",
        
        FCode: "ADM1",
        CountryCode: "TZ",
      },
      {
        id: "150442",
        Name: "Rukwa Region",
        
        FCode: "ADM1",
        CountryCode: "TZ",

      },
      {
        id: "877416",
        Name: "Ruvuma Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      },
      {
        id: "150004",
        Name: "Shinyanga Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      },
      {
        id: "149876",
        Name: "Singida Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      },
      {
        id: "149653",
        Name: "Tabora Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      },
      {
        id: "149595",
        Name: "Tanga Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      },
      {
        id: "148728",
        Name: "Zanzibar Central/South Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      },
      {
        id: "148725",
        Name: "Zanzibar North Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      },
      {
        id: "148724",
        Name: "Zanzibar Urban/West Region",
        
        FCode: "ADM1",
        CountryCode: "TZ"
      }
    ],
  },
  {
    id: "2363686",
    Name: "Togo",
    States: [
      {
        id: "2367237",
        Name: "Région Centrale",
        
        FCode: "ADM1",
        CountryCode: "TG"
      },
      {
        id: "2365173",
        Name: "Région Maritime",
        
        FCode: "ADM1",
        CountryCode: "TG"
      },
      {
        id: "2597439",
        Name: "Région de la Kara",
        
        FCode: "ADM1",
        CountryCode: "TG"
      },
      {
        id: "2364370",
        Name: "Région des Plateaux",
        
        FCode: "ADM1",
        CountryCode: "TG"
      },
      {
        id: "2364205",
        Name: "Région des Savanes",
        
        FCode: "ADM1",
        CountryCode: "TG"
      }
    ],
  },
  {
    id: "2464461",
    Name: "Tunisia",
    States: [
      {
        id: "2473245",
        Name: "Gouvernorat de Ariana",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "2472477",
        Name: "Gouvernorat de Ben Arous",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "2472699",
        Name: "Gouvernorat de Bizerte",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "2472770",
        Name: "Gouvernorat de Béja",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "2468365",
        Name: "Gouvernorat de Gabès",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "2468351",
        Name: "Gouvernorat de Gafsa",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "2470085",
        Name: "Gouvernorat de Jendouba",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "2473451",
        Name: "Gouvernorat de Kairouan",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "2473460",
        Name: "Gouvernorat de Kasserine",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "2468014",
        Name: "Gouvernorat de Kebili",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "2473637",
        Name: "Gouvernorat de Kef",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "2473574",
        Name: "Gouvernorat de Mahdia",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "2473495",
        Name: "Gouvernorat de Monastir",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "2469470",
        Name: "Gouvernorat de Médenine",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "2468576",
        Name: "Gouvernorat de Nabeul",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "2467450",
        Name: "Gouvernorat de Sfax",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "2465837",
        Name: "Gouvernorat de Sidi Bou Zid",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "2465027",
        Name: "Gouvernorat de Siliana",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "2464912",
        Name: "Gouvernorat de Sousse",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "2464698",
        Name: "Gouvernorat de Tataouine",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "2464645",
        Name: "Gouvernorat de Tozeur",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "2464464",
        Name: "Gouvernorat de Tunis",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "2464038",
        Name: "Gouvernorat de Zaghouan",
        
        FCode: "ADM1",
        CountryCode: "TN"
      },
      {
        id: "6201192",
        Name: "Gouvernorat de la Manouba",
        
        FCode: "ADM1",
        CountryCode: "TN"
      }
    ],

  },
  {
    id: "226074",
    Name: "Uganda",
    States: [
      {
        id: "7056273",
        Name: "Abim District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443782",
        Name: "Adjumani District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030566",
        Name: "Agago District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030568",
        Name: "Alebtong District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7056275",
        Name: "Amolatar District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030560",
        Name: "Amudat District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7056276",
        Name: "Amuria District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7056278",
        Name: "Amuru District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443327",
        Name: "Apac District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443328",
        Name: "Arua District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7056279",
        Name: "Budaka District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7056280",
        Name: "Bududa District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443783",
        Name: "Bugiri District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030585",
        Name: "Buhweju District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030577",
        Name: "Buikwe District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "234411",
        Name: "Bukedea",
        
        FCode: "ADM1",
        CountryCode: "UG",

      },
      {
        id: "8030579",
        Name: "Bukomansimbi District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7056296",
        Name: "Bukwa District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030573",
        Name: "Bulambuli District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7056281",
        Name: "Bulisa District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443329",
        Name: "Bundibugyo District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443330",
        Name: "Bushenyi District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443784",
        Name: "Busia District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7056282",
        Name: "Butaleja District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7910136",
        Name: "Butambala District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030576",
        Name: "Buvuma District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030571",
        Name: "Buyende District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7056283",
        Name: "Dokolo District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030578",
        Name: "Gomba District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443331",
        Name: "Gulu District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443332",
        Name: "Hoima District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7056284",
        Name: "Ibanda District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443334",
        Name: "Iganga District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7056285",
        Name: "Isingiro District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443335",
        Name: "Jinja District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7056286",
        Name: "Kaabong District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443336",
        Name: "Kabale",
        
        FCode: "ADM1",
        CountryCode: "UG",

      },
      {
        id: "443337",
        Name: "Kabarole District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "448215",
        Name: "Kaberamaido District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443338",
        Name: "Kalangala District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7056287",
        Name: "Kaliro District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7910134",
        Name: "Kalungu District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443339",
        Name: "Kampala District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443340",
        Name: "Kamuli District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "448216",
        Name: "Kamwenge District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "448217",
        Name: "Kanungu District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443341",
        Name: "Kapchorwa District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443342",
        Name: "Kasese District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443785",
        Name: "Katakwi District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "448218",
        Name: "Kayunga District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443343",
        Name: "Kibale District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443344",
        Name: "Kiboga District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030572",
        Name: "Kibuku District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7056288",
        Name: "Kiruhura District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030564",
        Name: "Kiryandongo District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443345",
        Name: "Kisoro District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443346",
        Name: "Kitgum District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7056289",
        Name: "Koboko District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030565",
        Name: "Kole District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443347",
        Name: "Kotido District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443348",
        Name: "Kumi District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030574",
        Name: "Kween District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030582",
        Name: "Kyankwanzi District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030581",
        Name: "Kyegegwa District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "448219",
        Name: "Kyenjojo District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030562",
        Name: "Lamwo District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443349",
        Name: "Lira District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030588",
        Name: "Luuka District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443350",
        Name: "Luwero District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030580",
        Name: "Lwengo District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7056290",
        Name: "Lyantonde District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7056291",
        Name: "Manafwa District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7056292",
        Name: "Maracha District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "226230",
        Name: "Masaka District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443351",
        Name: "Masindi District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "448220",
        Name: "Mayuge District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443353",
        Name: "Mbale District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443355",
        Name: "Mbarara District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030586",
        Name: "Mitoma District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7056293",
        Name: "Mityana District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443356",
        Name: "Moroto District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443357",
        Name: "Moyo District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "233709",
        Name: "Mpigi District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443358",
        Name: "Mubende District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443359",
        Name: "Mukono District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "448221",
        Name: "Nakapiripirit District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7056294",
        Name: "Nakaseke District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443786",
        Name: "Nakasongola District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030575",
        Name: "Namayingo District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "234069",
        Name: "Namutumba District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030561",
        Name: "Napak District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443360",
        Name: "Nebbi District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030570",
        Name: "Ngora District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030583",
        Name: "Ntoroko District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443361",
        Name: "Ntungamo District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7869939",
        Name: "Nwoya District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030567",
        Name: "Otuke District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "7056295",
        Name: "Oyam District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "448222",
        Name: "Pader District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443362",
        Name: "Pallisa District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443363",
        Name: "Rakai District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030584",
        Name: "Rubirizi District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443364",
        Name: "Rukungiri District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443787",
        Name: "Sembabule District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030569",
        Name: "Serere District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030587",
        Name: "Sheema District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "448223",
        Name: "Sironko District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443365",
        Name: "Soroti District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "443366",
        Name: "Tororo District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "448224",
        Name: "Wakiso District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "448225",
        Name: "Yumbe District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      },
      {
        id: "8030563",
        Name: "Zombo District",
        
        FCode: "ADM1",
        CountryCode: "UG"
      }
    ],

  },
  {
    id: "895949",
    Name: "Zambia",
    States: [
      {
        id: "921064",
        Name: "Central Province",
        
        FCode: "ADM1",
        CountryCode: "ZM"
      },
      {
        id: "917524",
        Name: "Copperbelt",
        
        FCode: "ADM1",
        CountryCode: "ZM",

      },
      {
        id: "917388",
        Name: "Eastern Province",
        
        FCode: "ADM1",
        CountryCode: "ZM"
      },
      {
        id: "909845",
        Name: "Luapula Province",
        
        FCode: "ADM1",
        CountryCode: "ZM"
      },
      {
        id: "909129",
        Name: "Lusaka Province",
        
        FCode: "ADM1",
        CountryCode: "ZM"
      },
      {
        id: "900594",
        Name: "North-Western Province",
        
        FCode: "ADM1",
        CountryCode: "ZM"
      },
      {
        id: "900601",
        Name: "Northern Province",
        
        FCode: "ADM1",
        CountryCode: "ZM"
      },
      {
        id: "896972",
        Name: "Southern Province",
        
        FCode: "ADM1",
        CountryCode: "ZM"
      },
      {
        id: "896140",
        Name: "Western Province",
        
        FCode: "ADM1",
        CountryCode: "ZM"
      }
    ],
  },
  {
    id: "878675",
    Name: "Zimbabwe",
    States: [
      {
        id: "1105843",
        Name: "Bulawayo Province",
        
        FCode: "ADM1",
        CountryCode: "ZW"
      },
      {
        id: "1105844",
        Name: "Harare Province",
        
        FCode: "ADM1",
        CountryCode: "ZW",
 
      },
      {
        id: "887358",
        Name: "Manicaland Province",
        
        FCode: "ADM1",
        CountryCode: "ZW"
      },
      {
        id: "886843",
        Name: "Mashonaland Central Province",
        
        FCode: "ADM1",
        CountryCode: "ZW",

      },
      {
        id: "886842",
        Name: "Mashonaland East Province",
        
        FCode: "ADM1",
        CountryCode: "ZW"
      },
      {
        id: "886841",
        Name: "Mashonaland West",
        
        FCode: "ADM1",
        CountryCode: "ZW",
  
      },
      {
        id: "886761",
        Name: "Masvingo Province",
        
        FCode: "ADM1",
        CountryCode: "ZW"
      },
      {
        id: "886748",
        Name: "Matabeleland North Province",
        
        FCode: "ADM1",
        CountryCode: "ZW"
      },
      {
        id: "886747",
        Name: "Matabeleland South Province",
        
        FCode: "ADM1",
        CountryCode: "ZW"
      },
      {
        id: "886119",
        Name: "Midlands Province",
        
        FCode: "ADM1",
        CountryCode: "ZW"
      }
    ],

  },
  {
    id: "1546748",
    Name: "French Southern Territories",
    States: [
      {
        id: "936339",
        Name: "Archipel des Crozet",
        
        FCode: "ADM1",
        CountryCode: "TF"
      },
      {
        id: "1546558",
        Name: "Archipel des Kerguelen",
        
        FCode: "ADM1",
        CountryCode: "TF"
      },
      {
        id: "6690917",
        Name: "La Terre-Adélie",
        
        FCode: "ADM1",
        CountryCode: "TF"
      },
      {
        id: "1547221",
        Name: "Îles Saint-Paul et Nouvelle-Amsterdam",
        
        FCode: "ADM1",
        CountryCode: "TF"
      },
      {
        id: "6690916",
        Name: "Îles Éparses de l'océan Indien",
        
        FCode: "ADM1",
        CountryCode: "TF"
      }
    ],

  },
  {
    id: "3474415",
    Name: "South Georgia and the South Sandwich Islands",
    States: [
      {
        id: "3426466",
        Name: "Grytviken",
        
        FCode: "PPLC",
        CountryCode: "GS",
      },
      {
        id: "3474113",
        Name: "Stromness",
        
        FCode: "PPL",
        CountryCode: "GS"
      }
    ],

  },
  {
    id: "1149361",
    Name: "Afghanistan",
    States: [
      {
        id: "1147745",
        Name: "Badakhshan",
        
        FCode: "ADM1",
        CountryCode: "AF",
      },
      {
        id: "1147707",
        Name: "Badghis",
        
        FCode: "ADM1",
        CountryCode: "AF",
      },
      {
        id: "1142263",
        Name: "Farah",
        
        FCode: "ADM1",
        CountryCode: "AF",
      },
      {
        id: "1142226",
        Name: "Faryab",
        
        FCode: "ADM1",
        CountryCode: "AF",
      },
      {
        id: "1140043",
        Name: "Helmand",
        
        FCode: "ADM1",
        CountryCode: "AF",
      },
      {
        id: "1140025",
        Name: "Herat",
        
        FCode: "ADM1",
        CountryCode: "AF",
      },
      {
        id: "1138957",
        Name: "Kabul",
        
        FCode: "ADM1",
        CountryCode: "AF",
      },
      {
        id: "1135690",
        Name: "Kunduz",
        
        FCode: "ADM1",
        CountryCode: "AF",
      },
      {
        id: "1131461",
        Name: "Orūzgān",
        
        FCode: "ADM1",
        CountryCode: "AF",
      },
      {
        id: "1131257",
        Name: "Paktia",
        
        FCode: "ADM1",
        CountryCode: "AF",
      },
      {
        id: "6957555",
        Name: "Panjshir",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "1444362",
        Name: "Velāyat-e Khowst",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "1444363",
        Name: "Velāyat-e Nūrestān",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "1147537",
        Name: "Wilāyat-e Baghlān",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "1147288",
        Name: "Wilāyat-e Balkh",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "1147239",
        Name: "Wilāyat-e Bāmyān",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "6957553",
        Name: "Wilāyat-e Dāykundī",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "1141268",
        Name: "Wilāyat-e Ghaznī",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "1141103",
        Name: "Wilāyat-e Ghōr",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "1139049",
        Name: "Wilāyat-e Jowzjān",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "1138335",
        Name: "Wilāyat-e Kandahār",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "1135702",
        Name: "Wilāyat-e Kunaṟ",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "1138255",
        Name: "Wilāyat-e Kāpīsā",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "1135022",
        Name: "Wilāyat-e Laghmān",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "1134561",
        Name: "Wilāyat-e Lōgar",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "1132366",
        Name: "Wilāyat-e Nangarhār",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "1131821",
        Name: "Wilāyat-e Nīmrōz",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "1131256",
        Name: "Wilāyat-e Paktīkā",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "1131054",
        Name: "Wilāyat-e Parwān",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "1127766",
        Name: "Wilāyat-e Samangān",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "1127106",
        Name: "Wilāyat-e Sar-e Pul",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "1123230",
        Name: "Wilāyat-e Takhār",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "1121863",
        Name: "Wilāyat-e Wardak",
        
        FCode: "ADM1",
        CountryCode: "AF"
      },
      {
        id: "1121143",
        Name: "Zabul",
        
        FCode: "ADM1",
        CountryCode: "AF",
      }
    ],
  },
  {
    id: "174982",
    Name: "Armenia",
    States: [
      {
        id: "828259",
        Name: "Aragatsotni Marz",
        
        FCode: "ADM1",
        CountryCode: "AM"
      },
      {
        id: "409313",
        Name: "Ararati Marz",
        
        FCode: "ADM1",
        CountryCode: "AM"
      },
      {
        id: "828260",
        Name: "Armaviri Marz",
        
        FCode: "ADM1",
        CountryCode: "AM"
      },
      {
        id: "828261",
        Name: "Geghark’unik’i Marz",
        
        FCode: "ADM1",
        CountryCode: "AM"
      },
      {
        id: "828262",
        Name: "Kotayk’i Marz",
        
        FCode: "ADM1",
        CountryCode: "AM"
      },
      {
        id: "828263",
        Name: "Lorru Marz",
        
        FCode: "ADM1",
        CountryCode: "AM"
      },
      {
        id: "828264",
        Name: "Shiraki Marz",
        
        FCode: "ADM1",
        CountryCode: "AM"
      },
      {
        id: "409314",
        Name: "Syunik’i Marz",
        
        FCode: "ADM1",
        CountryCode: "AM"
      },
      {
        id: "828265",
        Name: "Tavushi Marz",
        
        FCode: "ADM1",
        CountryCode: "AM"
      },
      {
        id: "409315",
        Name: "Vayots’ Dzori Marz",
        
        FCode: "ADM1",
        CountryCode: "AM"
      },
      {
        id: "616051",
        Name: "Yerevan",
        
        FCode: "ADM1",
        CountryCode: "AM",
      }
    ],

  },
  {
    id: "587116",
    Name: "Azerbaijan",
    States: [
      {
        id: "587245",
        Name: "Absheron Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "148617",
        Name: "Aghdam Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "587376",
        Name: "Aghdash Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "148615",
        Name: "Aghjabadi Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "828297",
        Name: "Aghstafa Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "587342",
        Name: "Aghsu Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "409417",
        Name: "Ali Bajramly",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "148442",
        Name: "Astara Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "587081",
        Name: "Baku City",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "587010",
        Name: "Balakan Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "587056",
        Name: "Barda Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "146879",
        Name: "Beylagan Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "147310",
        Name: "Bilasuvar Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "148140",
        Name: "Cəbrayıl Rayonu",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "586771",
        Name: "Dashkasan Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "586725",
        Name: "Davachi Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "148107",
        Name: "Fizuli Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "627535",
        Name: "Gadabay Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "828298",
        Name: "Ganja City",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "828301",
        Name: "Gobustan Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "586112",
        Name: "Goranboy Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "586482",
        Name: "Goychay Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "585967",
        Name: "Goygol Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "828315",
        Name: "Hajigabul Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "147983",
        Name: "Imishli Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "586320",
        Name: "Ismayilli Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "148155",
        Name: "Jalilabad Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "586001",
        Name: "Khachmaz Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "828306",
        Name: "Khizi Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "585686",
        Name: "Kurdamir Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "586047",
        Name: "Kəlbəcər Rayonu",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "147613",
        Name: "Lankaran Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "147626",
        Name: "Laçın Rayonu",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "147610",
        Name: "Lerik Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "409418",
        Name: "Lənkəran Şəhəri",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "147551",
        Name: "Masally Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "828299",
        Name: "Mingacevir City",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "828300",
        Name: "Naftalan City",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "147435",
        Name: "Nakhichevan",
        
        FCode: "ADM1",
        CountryCode: "AZ",
      },
      {
        id: "147422",
        Name: "Neftchala Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "584742",
        Name: "Oghuz Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "585738",
        Name: "Qabala Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "586290",
        Name: "Qakh Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "586087",
        Name: "Qazakh Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "585786",
        Name: "Quba Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "147694",
        Name: "Qubadli Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "585749",
        Name: "Qusar Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "147287",
        Name: "Saatly Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "147284",
        Name: "Sabirabad Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "147269",
        Name: "Salyan Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "828302",
        Name: "Samukh Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "828303",
        Name: "Shaki City",
        
        FCode: "ADM1",
        CountryCode: "AZ",
      },
      {
        id: "585031",
        Name: "Shaki Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "585030",
        Name: "Shamakhi Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "585059",
        Name: "Shamkir Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "828304",
        Name: "Siazan Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "828305",
        Name: "Sumqayit City",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "409420",
        Name: "Tartar Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "584861",
        Name: "Tovuz Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "584783",
        Name: "Ujar Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "409421",
        Name: "Xankəndi Şəhəri",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "148449",
        Name: "Xocalı Rayonu",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "409423",
        Name: "Xocavənd Rayonu",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "146962",
        Name: "Yardymli Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "584650",
        Name: "Yevlakh Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "828307",
        Name: "Yevlax City",
        
        FCode: "ADM1",
        CountryCode: "AZ",
      },
      {
        id: "146900",
        Name: "Zangilan Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "584604",
        Name: "Zaqatala Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "584583",
        Name: "Zardab Rayon",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "147163",
        Name: "Şuşa Rayonu",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      },
      {
        id: "409419",
        Name: "Şuşa Şəhəri",
        
        FCode: "ADM1",
        CountryCode: "AZ"
      }
    ],
  },
  {
    id: "290291",
    Name: "Bahrain",
    States: [
      {
        id: "7090954",
        Name: "Capital Governorate",
        
        FCode: "ADM1",
        CountryCode: "BH"
      },
      {
        id: "7090973",
        Name: "Central Governorate",
        
        FCode: "ADM1",
        CountryCode: "BH"
      },
      {
        id: "290333",
        Name: "Muharraq",
        
        FCode: "ADM1",
        CountryCode: "BH",
      },
      {
        id: "7090974",
        Name: "Northern Governorate",
        
        FCode: "ADM1",
        CountryCode: "BH"
      },
      {
        id: "7090972",
        Name: "Southern Governorate",
        
        FCode: "ADM1",
        CountryCode: "BH"
      }
    ],

  },
  {
    id: "1210997",
    Name: "Bangladesh",
    States: [
      {
        id: "1337229",
        Name: "Borishal",
        
        FCode: "ADM1",
        CountryCode: "BD"
      },
      {
        id: "1337200",
        Name: "Chittagong",
        
        FCode: "ADM1",
        CountryCode: "BD"
      },
      {
        id: "1337179",
        Name: "Dhaka Division",
        
        FCode: "ADM1",
        CountryCode: "BD"
      },
      {
        id: "1337210",
        Name: "Khulna Division",
        
        FCode: "ADM1",
        CountryCode: "BD"
      },
      {
        id: "7671048",
        Name: "Rangpur Division",
        
        FCode: "ADM1",
        CountryCode: "BD"
      },
      {
        id: "1337166",
        Name: "Rājshāhi Division",
        
        FCode: "ADM1",
        CountryCode: "BD"
      },
      {
        id: "1477362",
        Name: "Sylhet Division",
        
        FCode: "ADM1",
        CountryCode: "BD"
      }
    ],

  },
  {
    id: "1252634",
    Name: "Bhutan",
    States: [
      {
        id: "1337278",
        Name: "Bumthang Dzongkhag",
        
        FCode: "ADM1",
        CountryCode: "BT"
      },
      {
        id: "1337279",
        Name: "Chhukha Dzongkhag",
        
        FCode: "ADM1",
        CountryCode: "BT"
      },
      {
        id: "1337280",
        Name: "Dagana Dzongkhag",
        
        FCode: "ADM1",
        CountryCode: "BT"
      },
      {
        id: "7303651",
        Name: "Gasa",
        
        FCode: "ADM1",
        CountryCode: "BT"
      },
      {
        id: "1337283",
        Name: "Haa Dzongkhag",
        
        FCode: "ADM1",
        CountryCode: "BT"
      },
      {
        id: "1337284",
        Name: "Lhuentse Dzongkhag",
        
        FCode: "ADM1",
        CountryCode: "BT"
      },
      {
        id: "1337285",
        Name: "Mongar Dzongkhag",
        
        FCode: "ADM1",
        CountryCode: "BT"
      },
      {
        id: "1337286",
        Name: "Paro",
        
        FCode: "ADM1",
        CountryCode: "BT",
      },
      {
        id: "1337287",
        Name: "Pemagatshel Dzongkhag",
        
        FCode: "ADM1",
        CountryCode: "BT"
      },
      {
        id: "1337288",
        Name: "Punakha Dzongkhag",
        
        FCode: "ADM1",
        CountryCode: "BT"
      },
      {
        id: "1337290",
        Name: "Samdrup Jongkhar",
        
        FCode: "ADM1",
        CountryCode: "BT",
      },
      {
        id: "1337289",
        Name: "Samtse Dzongkhag",
        
        FCode: "ADM1",
        CountryCode: "BT"
      },
      {
        id: "1337282",
        Name: "Sarpang Dzongkhag",
        
        FCode: "ADM1",
        CountryCode: "BT"
      },
      {
        id: "1337293",
        Name: "Thimphu Dzongkhag",
        
        FCode: "ADM1",
        CountryCode: "BT"
      },
      {
        id: "7303653",
        Name: "Trashi Yangste",
        
        FCode: "ADM1",
        CountryCode: "BT"
      },
      {
        id: "1337292",
        Name: "Trashigang Dzongkhag",
        
        FCode: "ADM1",
        CountryCode: "BT"
      },
      {
        id: "1337294",
        Name: "Trongsa Dzongkhag",
        
        FCode: "ADM1",
        CountryCode: "BT"
      },
      {
        id: "1337281",
        Name: "Tsirang Dzongkhag",
        
        FCode: "ADM1",
        CountryCode: "BT"
      },
      {
        id: "1337295",
        Name: "Wangdue Phodrang Dzongkhag",
        
        FCode: "ADM1",
        CountryCode: "BT"
      },
      {
        id: "1337291",
        Name: "Zhemgang Dzongkhag",
        
        FCode: "ADM1",
        CountryCode: "BT"
      }
    ],

  },
  {
    id: "1820814",
    Name: "Brunei",
    States: [
      {
        id: "1820869",
        Name: "Belait District",
        
        FCode: "ADM1",
        CountryCode: "BN"
      },
      {
        id: "1820818",
        Name: "Brunei and Muara District",
        
        FCode: "ADM1",
        CountryCode: "BN"
      },
      {
        id: "1820106",
        Name: "Temburong District",
        
        FCode: "ADM1",
        CountryCode: "BN"
      },
      {
        id: "1820068",
        Name: "Tutong District",
        
        FCode: "ADM1",
        CountryCode: "BN"
      }
    ],

  },
  {
    id: "1831722",
    Name: "Cambodia",
    States: [
      {
        id: "1899273",
        Name: "Khétt Bântéay Méan Choăy",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1821310",
        Name: "Khétt Bătdâmbâng",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1831037",
        Name: "Khétt Kaôh Kŏng",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1830563",
        Name: "Khétt Krâchéh",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1831172",
        Name: "Khétt Kâmpóng Cham",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1831166",
        Name: "Khétt Kâmpóng Chhnăng",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1831132",
        Name: "Khétt Kâmpóng Spœ",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1831124",
        Name: "Khétt Kâmpóng Thum",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1831111",
        Name: "Khétt Kâmpôt",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1831095",
        Name: "Khétt Kândal",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1830937",
        Name: "Khétt Kêb",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1830306",
        Name: "Khétt Môndôl Kiri",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1830206",
        Name: "Khétt Pailĭn",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1821301",
        Name: "Khétt Poŭthĭsăt",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1822609",
        Name: "Khétt Prey Vêng",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1899262",
        Name: "Khétt Preăh Seihânŭ",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1822676",
        Name: "Khétt Preăh Vĭhéar",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1822213",
        Name: "Khétt Siĕm Réab",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1822028",
        Name: "Khétt Stœ̆ng Trêng",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1821992",
        Name: "Khétt Svay Riĕng",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1821939",
        Name: "Khétt Takêv",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1822449",
        Name: "Khêtt Rôtânôkiri",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1830103",
        Name: "Krŏng Phnum Pénh",
        
        FCode: "ADM1",
        CountryCode: "KH"
      },
      {
        id: "1822210",
        Name: "Ŏtâr Méanchey",
        
        FCode: "ADM1",
        CountryCode: "KH"
      }
    ],

  },
  {
    id: "1814991",
    Name: "China",
    States: [
      {
        id: "1818058",
        Name: "Anhui Sheng",
        
        FCode: "ADM1",
        CountryCode: "CN"
      },
      {
        id: "2038349",
        Name: "Beijing Shi",
        
        FCode: "ADM1",
        CountryCode: "CN"
      },
      {
        id: "1814905",
        Name: "Chongqing Shi",
        
        FCode: "ADM1",
        CountryCode: "CN"
      },
      {
        id: "1811017",
        Name: "Fujian",
        
        FCode: "ADM1",
        CountryCode: "CN",
      },
      {
        id: "1810676",
        Name: "Gansu Sheng",
        
        FCode: "ADM1",
        CountryCode: "CN"
      },
      {
        id: "1809935",
        Name: "Guangdong Sheng",
        
        FCode: "ADM1",
        CountryCode: "CN"
      },
      {
        id: "1809867",
        Name: "Guangxi Zhuangzu Zizhiqu",
        
        FCode: "ADM1",
        CountryCode: "CN"
      },
      {
        id: "1809445",
        Name: "Guizhou Sheng",
        
        FCode: "ADM1",
        CountryCode: "CN"
      },
      {
        id: "1809054",
        Name: "Hainan",
        
        FCode: "ADM1",
        CountryCode: "CN",
      },
      {
        id: "1808773",
        Name: "Hebei",
        
        FCode: "ADM1",
        CountryCode: "CN",
      },
      {
        id: "2036965",
        Name: "Heilongjiang Sheng",
        
        FCode: "ADM1",
        CountryCode: "CN"
      },
      {
        id: "1808520",
        Name: "Henan Sheng",
        
        FCode: "ADM1",
        CountryCode: "CN"
      },
      {
        id: "1806949",
        Name: "Hubei",
        
        FCode: "ADM1",
        CountryCode: "CN",
      },
      {
        id: "1806691",
        Name: "Hunan",
        
        FCode: "ADM1",
        CountryCode: "CN",
      },
      {
        id: "2035607",
        Name: "Inner Mongolia",
        
        FCode: "ADM1",
        CountryCode: "CN",
      },
      {
        id: "1806260",
        Name: "Jiangsu Sheng",
        
        FCode: "ADM1",
        CountryCode: "CN"
      },
      {
        id: "1806222",
        Name: "Jiangxi Sheng",
        
        FCode: "ADM1",
        CountryCode: "CN"
      },
      {
        id: "2036500",
        Name: "Jilin Sheng",
        
        FCode: "ADM1",
        CountryCode: "CN"
      },
      {
        id: "2036115",
        Name: "Liaoning",
        
        FCode: "ADM1",
        CountryCode: "CN",
      },
      {
        id: "1799355",
        Name: "Ningxia Huizu Zizhiqu",
        
        FCode: "ADM1",
        CountryCode: "CN"
      },
      {
        id: "1280239",
        Name: "Qinghai Sheng",
        
        FCode: "ADM1",
        CountryCode: "CN"
      },
      {
        id: "1796480",
        Name: "Shaanxi Sheng",
        
        FCode: "ADM1",
        CountryCode: "CN"
      },
      {
        id: "1796328",
        Name: "Shandong Sheng",
        
        FCode: "ADM1",
        CountryCode: "CN"
      },
      {
        id: "1796231",
        Name: "Shanghai Shi",
        
        FCode: "ADM1",
        CountryCode: "CN"
      },
      {
        id: "1795912",
        Name: "Shanxi Sheng",
        
        FCode: "ADM1",
        CountryCode: "CN"
      },
      {
        id: "1794299",
        Name: "Sichuan Sheng",
        
        FCode: "ADM1",
        CountryCode: "CN"
      },
      {
        id: "1792943",
        Name: "Tianjin Shi",
        
        FCode: "ADM1",
        CountryCode: "CN"
      },
      {
        id: "1279685",
        Name: "Tibet Autonomous Region",
        
        FCode: "ADM1",
        CountryCode: "CN",
      },
      {
        id: "1529047",
        Name: "Xinjiang Uygur Zizhiqu",
        
        FCode: "ADM1",
        CountryCode: "CN"
      },
      {
        id: "1785694",
        Name: "Yunnan",
        
        FCode: "ADM1",
        CountryCode: "CN",
      },
      {
        id: "1784764",
        Name: "Zhejiang Sheng",
        
        FCode: "ADM1",
        CountryCode: "CN"
      }
    ],

  },
  {
    id: "2078138",
    Name: "Christmas Island",
    States: [
      {
        id: "2078132",
        Name: "Drumsite",
        
        FCode: "PPL",
        CountryCode: "CX"
      },
      {
        id: "2078091",
        Name: "Settlement",
        
        FCode: "PPL",
        CountryCode: "CX"
      },
      {
        id: "2078087",
        Name: "South Point",
        
        FCode: "PPL",
        CountryCode: "CX"
      },
      {
        id: "2078127",
        Name: "The Settlement",
        
        FCode: "PPLC",
        CountryCode: "CX",
      },
      {
        id: "2078074",
        Name: "Waterfall",
        
        FCode: "PPL",
        CountryCode: "CX"
      }
    ],

  },
  {
    id: "1547376",
    Name: "Cocos [Keeling] Islands",
    States: [
      {
        id: "1547382",
        Name: "Bantam Village",
        
        FCode: "PPL",
        CountryCode: "CC"
      },
      {
        id: "7304591",
        Name: "West Island",
        
        FCode: "PPLC",
        CountryCode: "CC"
      }
    ],

  },
  {
    id: "614540",
    Name: "Georgia",
    States: [
      {
        id: "6643410",
        Name: "Abkhazia",
        
        FCode: "ADM1",
        CountryCode: "GE",
      },
      {
        id: "615929",
        Name: "Ajaria",
        
        FCode: "ADM1",
        CountryCode: "GE"
      },
      {
        id: "865538",
        Name: "Guria",
        
        FCode: "ADM1",
        CountryCode: "GE"
      },
      {
        id: "865539",
        Name: "Imereti",
        
        FCode: "ADM1",
        CountryCode: "GE"
      },
      {
        id: "611716",
        Name: "K'alak'i T'bilisi",
        
        FCode: "ADM1",
        CountryCode: "GE"
      },
      {
        id: "865537",
        Name: "Kakheti",
        
        FCode: "ADM1",
        CountryCode: "GE"
      },
      {
        id: "865536",
        Name: "Kvemo Kartli",
        
        FCode: "ADM1",
        CountryCode: "GE"
      },
      {
        id: "865541",
        Name: "Mtskheta-Mtianeti",
        
        FCode: "ADM1",
        CountryCode: "GE"
      },
      {
        id: "865542",
        Name: "Racha-Lechkhumi and Kvemo Svaneti",
        
        FCode: "ADM1",
        CountryCode: "GE"
      },
      {
        id: "865543",
        Name: "Samegrelo and Zemo Svaneti",
        
        FCode: "ADM1",
        CountryCode: "GE",
      },
      {
        id: "865544",
        Name: "Samtskhe-Javakheti",
        
        FCode: "ADM1",
        CountryCode: "GE"
      },
      {
        id: "865540",
        Name: "Shida Kartli",
        
        FCode: "ADM1",
        CountryCode: "GE"
      }
    ],

  },
  {
    id: "1819730",
    Name: "Hong Kong",
    States: [
      {
        id: "7533598",
        Name: "Central and Western District",
        
        FCode: "ADM1",
        CountryCode: "HK"
      },
      {
        id: "7533608",
        Name: "Eastern",
        
        FCode: "ADM1",
        CountryCode: "HK"
      },
      {
        id: "1819708",
        Name: "Islands District",
        
        FCode: "ADM1",
        CountryCode: "HK"
      },
      {
        id: "7533612",
        Name: "Kowloon City",
        
        FCode: "ADM1",
        CountryCode: "HK"
      },
      {
        id: "7533615",
        Name: "Kwai Tsing",
        
        FCode: "ADM1",
        CountryCode: "HK"
      },
      {
        id: "7533614",
        Name: "Kwon Tong",
        
        FCode: "ADM1",
        CountryCode: "HK"
      },
      {
        id: "7533617",
        Name: "North",
        
        FCode: "ADM1",
        CountryCode: "HK"
      },
      {
        id: "1819049",
        Name: "Sai Kung District",
        
        FCode: "ADM1",
        CountryCode: "HK"
      },
      {
        id: "7533618",
        Name: "Sha Tin",
        
        FCode: "ADM1",
        CountryCode: "HK"
      },
      {
        id: "7533611",
        Name: "Sham Shui Po",
        
        FCode: "ADM1",
        CountryCode: "HK"
      },
      {
        id: "7533609",
        Name: "Southern",
        
        FCode: "ADM1",
        CountryCode: "HK"
      },
      {
        id: "1818672",
        Name: "Tai Po District",
        
        FCode: "ADM1",
        CountryCode: "HK"
      },
      {
        id: "1818458",
        Name: "Tsuen Wan District",
        
        FCode: "ADM1",
        CountryCode: "HK"
      },
      {
        id: "7533616",
        Name: "Tuen Mun",
        
        FCode: "ADM1",
        CountryCode: "HK"
      },
      {
        id: "7533607",
        Name: "Wan Chai",
        
        FCode: "ADM1",
        CountryCode: "HK"
      },
      {
        id: "7533613",
        Name: "Wong Tai Sin",
        
        FCode: "ADM1",
        CountryCode: "HK"
      },
      {
        id: "7533610",
        Name: "Yau Tsim Mong",
        
        FCode: "ADM1",
        CountryCode: "HK"
      },
      {
        id: "1818224",
        Name: "Yuen Long District",
        
        FCode: "ADM1",
        CountryCode: "HK"
      }
    ],

  },
  {
    id: "1269750",
    Name: "India",
    States: [
      {
        id: "1252881",
        Name: "Bengal",
        
        FCode: "ADM1",
        CountryCode: "IN",
      },
      {
        id: "1271155",
        Name: "Daman and Diu",
        
        FCode: "ADM1",
        CountryCode: "IN",
      },
      {
        id: "1271157",
        Name: "Goa",
        
        FCode: "ADM1",
        CountryCode: "IN",
      },
      {
        id: "1270260",
        Name: "Haryana",
        
        FCode: "ADM1",
        CountryCode: "IN",
      },
      {
        id: "1269320",
        Name: "Jammu and Kashmir",
        
        FCode: "ADM1",
        CountryCode: "IN",
      },
      {
        id: "1267254",
        Name: "Kerala",
        
        FCode: "ADM1",
        CountryCode: "IN",
      },
      {
        id: "1265206",
        Name: "Laccadives",
        
        FCode: "ADM1",
        CountryCode: "IN",
      },
      {
        id: "1273293",
        Name: "NCT",
        
        FCode: "ADM1",
        CountryCode: "IN",
      },
      {
        id: "1258899",
        Name: "Rajasthan",
        
        FCode: "ADM1",
        CountryCode: "IN",
      },
      {
        id: "1278629",
        Name: "State of Andhra Pradesh",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1278341",
        Name: "State of Arunāchal Pradesh",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1278253",
        Name: "State of Assam",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1275715",
        Name: "State of Bihār",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1444364",
        Name: "State of Chhattīsgarh",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1270770",
        Name: "State of Gujarāt",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1270101",
        Name: "State of Himāchal Pradesh",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1444365",
        Name: "State of Jharkhand",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1267701",
        Name: "State of Karnātaka",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1264542",
        Name: "State of Madhya Pradesh",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1264418",
        Name: "State of Mahārāshtra",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1263706",
        Name: "State of Manipur",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1263207",
        Name: "State of Meghālaya",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1262963",
        Name: "State of Mizoram",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1262271",
        Name: "State of Nāgāland",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1261029",
        Name: "State of Odisha",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1259223",
        Name: "State of Punjab",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1256312",
        Name: "State of Sikkim",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1255053",
        Name: "State of Tamil Nādu",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1254169",
        Name: "State of Tripura",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1278647",
        Name: "Union Territory of Andaman and Nicobar Islands",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1274744",
        Name: "Union Territory of Chandīgarh",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1273726",
        Name: "Union Territory of Dādra and Nagar Haveli",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1259424",
        Name: "Union Territory of Puducherry",
        
        FCode: "ADM1",
        CountryCode: "IN"
      },
      {
        id: "1253626",
        Name: "Uttar Pradesh",
        
        FCode: "ADM1",
        CountryCode: "IN",
      },
      {
        id: "1444366",
        Name: "Uttarakhand",
        
        FCode: "ADM1",
        CountryCode: "IN",
      }
    ],

  },
  {
    id: "1643084",
    Name: "Indonesia",
    States: [
      {
        id: "1650535",
        Name: "Bali",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1923047",
        Name: "Bangka-Belitung",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1642669",
        Name: "Central Java",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1626231",
        Name: "Central Sulawesi",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1621176",
        Name: "Daerah Istimewa Yogyakarta",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1642907",
        Name: "Daerah Khusus Ibukota Jakarta",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1642668",
        Name: "East Java",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1641897",
        Name: "East Kalimantan",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1633791",
        Name: "East Nusa Tenggara",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1626229",
        Name: "North Sulawesi",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1213642",
        Name: "North Sumatra",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1649147",
        Name: "Propinsi Bengkulu",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1923046",
        Name: "Propinsi Gorontalo",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1633792",
        Name: "Propinsi Nusa Tenggara Barat",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1923045",
        Name: "Provinsi Banten",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1642856",
        Name: "Provinsi Jambi",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1641898",
        Name: "Provinsi Kalimantan Tengah",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1638535",
        Name: "Provinsi Lampung",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1636627",
        Name: "Provinsi Maluku",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1958070",
        Name: "Provinsi Maluku Utara",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1215638",
        Name: "Provinsi Nanggroe Aceh Darussalam",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1643012",
        Name: "Provinsi Papua",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1996549",
        Name: "Provinsi Papua Barat",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1629652",
        Name: "Provinsi Riau",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1996550",
        Name: "Provinsi Sulawesi Barat",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1626230",
        Name: "Provinsi Sulawesi Tenggara",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1996551",
        Name: "Riau Islands",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1641899",
        Name: "South Kalimantan",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1626232",
        Name: "South Sulawesi",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1626196",
        Name: "South Sumatra",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1642672",
        Name: "West Java",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1641900",
        Name: "West Kalimantan",
        
        FCode: "ADM1",
        CountryCode: "id",
      },
      {
        id: "1626197",
        Name: "West Sumatra",
        
        FCode: "ADM1",
        CountryCode: "id",
      }
    ],

  },
  {
    id: "130758",
    Name: "Iran",
    States: [
      {
        id: "139816",
        Name: "Bushehr",
        
        FCode: "ADM1",
        CountryCode: "IR",
      },
      {
        id: "142549",
        Name: "East Azarbaijan",
        
        FCode: "ADM1",
        CountryCode: "IR",
      },
      {
        id: "134766",
        Name: "Fārs",
        
        FCode: "ADM1",
        CountryCode: "IR",
      },
      {
        id: "131222",
        Name: "Hormozgān",
        
        FCode: "ADM1",
        CountryCode: "IR",
      },
      {
        id: "124763",
        Name: "Markazi",
        
        FCode: "ADM1",
        CountryCode: "IR",
      },
      {
        id: "124544",
        Name: "Māzandarān",
        
        FCode: "ADM1",
        CountryCode: "IR",
      },
      {
        id: "7648907",
        Name: "Ostān-e Alborz",
        
        FCode: "ADM1",
        CountryCode: "IR"
      },
      {
        id: "413931",
        Name: "Ostān-e Ardabīl",
        
        FCode: "ADM1",
        CountryCode: "IR"
      },
      {
        id: "139677",
        Name: "Ostān-e Chahār Maḩāl va Bakhtīārī",
        
        FCode: "ADM1",
        CountryCode: "IR"
      },
      {
        id: "418862",
        Name: "Ostān-e Eşfahān",
        
        FCode: "ADM1",
        CountryCode: "IR"
      },
      {
        id: "443792",
        Name: "Ostān-e Golestān",
        
        FCode: "ADM1",
        CountryCode: "IR"
      },
      {
        id: "133349",
        Name: "Ostān-e Gīlān",
        
        FCode: "ADM1",
        CountryCode: "IR"
      },
      {
        id: "132142",
        Name: "Ostān-e Hamadān",
        
        FCode: "ADM1",
        CountryCode: "IR"
      },
      {
        id: "128231",
        Name: "Ostān-e Kermān",
        
        FCode: "ADM1",
        CountryCode: "IR"
      },
      {
        id: "128222",
        Name: "Ostān-e Kermānshāh",
        
        FCode: "ADM1",
        CountryCode: "IR"
      },
      {
        id: "6201374",
        Name: "Ostān-e Khorāsān-e Jonūbī",
        
        FCode: "ADM1",
        CountryCode: "IR"
      },
      {
        id: "6201376",
        Name: "Ostān-e Khorāsān-e Shomālī",
        
        FCode: "ADM1",
        CountryCode: "IR"
      },
      {
        id: "127082",
        Name: "Ostān-e Khūzestān",
        
        FCode: "ADM1",
        CountryCode: "IR",
      },
      {
        id: "126878",
        Name: "Ostān-e Kohgīlūyeh va Bowyer Aḩmad",
        
        FCode: "ADM1",
        CountryCode: "IR"
      },
      {
        id: "126584",
        Name: "Ostān-e Kordestān",
        
        FCode: "ADM1",
        CountryCode: "IR"
      },
      {
        id: "125605",
        Name: "Ostān-e Lorestān",
        
        FCode: "ADM1",
        CountryCode: "IR",
      },
      {
        id: "443793",
        Name: "Ostān-e Qazvīn",
        
        FCode: "ADM1",
        CountryCode: "IR"
      },
      {
        id: "443794",
        Name: "Ostān-e Qom",
        
        FCode: "ADM1",
        CountryCode: "IR"
      },
      {
        id: "1159456",
        Name: "Ostān-e Sīstān va Balūchestān",
        
        FCode: "ADM1",
        CountryCode: "IR"
      },
      {
        id: "110791",
        Name: "Ostān-e Tehrān",
        
        FCode: "ADM1",
        CountryCode: "IR"
      },
      {
        id: "111821",
        Name: "Ostān-e Yazd",
        
        FCode: "ADM1",
        CountryCode: "IR"
      },
      {
        id: "142550",
        Name: "Ostān-e Āz̄arbāyjān-e Gharbī",
        
        FCode: "ADM1",
        CountryCode: "IR"
      },
      {
        id: "130801",
        Name: "Ostān-e Īlām",
        
        FCode: "ADM1",
        CountryCode: "IR"
      },
      {
        id: "6201375",
        Name: "Razavi Khorasan",
        
        FCode: "ADM1",
        CountryCode: "IR",
      },
      {
        id: "116401",
        Name: "Semnān",
        
        FCode: "ADM1",
        CountryCode: "IR",
      },
      {
        id: "111452",
        Name: "Zanjan",
        
        FCode: "ADM1",
        CountryCode: "IR",
      }
    ],

  },
  {
    id: "99237",
    Name: "Iraq",
    States: [
      {
        id: "99592",
        Name: "Anbar",
        
        FCode: "ADM1",
        CountryCode: "IQ",
      },
      {
        id: "97019",
        Name: "Dhi Qar",
        
        FCode: "ADM1",
        CountryCode: "IQ",
      },
      {
        id: "96965",
        Name: "Diyala Province",
        
        FCode: "ADM1",
        CountryCode: "IQ",
      },
      {
        id: "93540",
        Name: "Maysan",
        
        FCode: "ADM1",
        CountryCode: "IQ",
      },
      {
        id: "91695",
        Name: "Muhafazat Salah ad Din",
        
        FCode: "ADM1",
        CountryCode: "IQ"
      },
      {
        id: "89693",
        Name: "Muhafazat Wasit",
        
        FCode: "ADM1",
        CountryCode: "IQ"
      },
      {
        id: "95445",
        Name: "Muḩāfaz̧at Arbīl",
        
        FCode: "ADM1",
        CountryCode: "IQ"
      },
      {
        id: "98180",
        Name: "Muḩāfaz̧at Baghdād",
        
        FCode: "ADM1",
        CountryCode: "IQ"
      },
      {
        id: "98227",
        Name: "Muḩāfaz̧at Bābil",
        
        FCode: "ADM1",
        CountryCode: "IQ"
      },
      {
        id: "97270",
        Name: "Muḩāfaz̧at Dahūk",
        
        FCode: "ADM1",
        CountryCode: "IQ"
      },
      {
        id: "94823",
        Name: "Muḩāfaz̧at Karbalā’",
        
        FCode: "ADM1",
        CountryCode: "IQ"
      },
      {
        id: "98410",
        Name: "Muḩāfaz̧at Kirkūk",
        
        FCode: "ADM1",
        CountryCode: "IQ"
      },
      {
        id: "92877",
        Name: "Muḩāfaz̧at Nīnawá",
        
        FCode: "ADM1",
        CountryCode: "IQ"
      },
      {
        id: "89341",
        Name: "Muḩāfaz̧at al Başrah",
        
        FCode: "ADM1",
        CountryCode: "IQ"
      },
      {
        id: "99032",
        Name: "Muḩāfaz̧at al Muthanná",
        
        FCode: "ADM1",
        CountryCode: "IQ"
      },
      {
        id: "99022",
        Name: "Muḩāfaz̧at al Qādisīyah",
        
        FCode: "ADM1",
        CountryCode: "IQ"
      },
      {
        id: "98862",
        Name: "Muḩāfaz̧at an Najaf",
        
        FCode: "ADM1",
        CountryCode: "IQ"
      },
      {
        id: "98465",
        Name: "Muḩāfaz̧at as Sulaymānīyah",
        
        FCode: "ADM1",
        CountryCode: "IQ"
      }
    ],

  },
  {
    id: "294640",
    Name: "Israel",
    States: [
      {
        id: "294904",
        Name: "Central District",
        
        FCode: "ADM1",
        CountryCode: "IL",
      },
      {
        id: "294800",
        Name: "Haifa District",
        
        FCode: "ADM1",
        CountryCode: "IL"
      },
      {
        id: "293198",
        Name: "Jerusalem District",
        
        FCode: "ADM1",
        CountryCode: "IL",
      },
      {
        id: "294824",
        Name: "Northern District",
        
        FCode: "ADM1",
        CountryCode: "IL",
      },
      {
        id: "294952",
        Name: "Southern District",
        
        FCode: "ADM1",
        CountryCode: "IL",
      },
      {
        id: "293396",
        Name: "Tel Aviv",
        
        FCode: "ADM1",
        CountryCode: "IL",
      }
    ],

  },
  {
    id: "1861060",
    Name: "Japan",
    States: [
      {
        id: "1865694",
        Name: "Aichi-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "2113124",
        Name: "Akita-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "2130656",
        Name: "Aomori-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "2113014",
        Name: "Chiba-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1864226",
        Name: "Ehime",
        
        FCode: "ADM1",
        CountryCode: "JP",
      },
      {
        id: "1863983",
        Name: "Fukui-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1863958",
        Name: "Fukuoka-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "2112922",
        Name: "Fukushima-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1863640",
        Name: "Gifu-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1863501",
        Name: "Gunma-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1862413",
        Name: "Hiroshima-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "2130037",
        Name: "Hokkaidō",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1862047",
        Name: "Hyōgo-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "2112669",
        Name: "Ibaraki-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1861387",
        Name: "Ishikawa-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "2112518",
        Name: "Iwate-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1860834",
        Name: "Kagawa-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1860825",
        Name: "Kagoshima-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1860291",
        Name: "Kanagawa-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1858419",
        Name: "Kumamoto Prefecture",
        
        FCode: "ADM1",
        CountryCode: "JP",
      },
      {
        id: "1857907",
        Name: "Kyōto-fu",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1859133",
        Name: "Kōchi-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1857352",
        Name: "Mie-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "2111888",
        Name: "Miyagi-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1856710",
        Name: "Miyazaki-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1856210",
        Name: "Nagano-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1856156",
        Name: "Nagasaki-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1855608",
        Name: "Nara",
        
        FCode: "ADM1",
        CountryCode: "JP",
      },
      {
        id: "1855429",
        Name: "Niigata-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1854381",
        Name: "Okayama-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1854345",
        Name: "Okinawa-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1853299",
        Name: "Saga-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1853226",
        Name: "Saitama-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1852553",
        Name: "Shiga-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1852442",
        Name: "Shimane-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1851715",
        Name: "Shizuoka-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1850310",
        Name: "Tochigi-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1850157",
        Name: "Tokushima-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1849890",
        Name: "Tottori-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1849872",
        Name: "Toyama-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1850144",
        Name: "Tōkyō-to",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1848938",
        Name: "Wakayama-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "2110554",
        Name: "Yamagata-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1848681",
        Name: "Yamaguchi-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1848649",
        Name: "Yamanashi-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1854484",
        Name: "Ōita-ken",
        
        FCode: "ADM1",
        CountryCode: "JP"
      },
      {
        id: "1853904",
        Name: "Ōsaka-fu",
        
        FCode: "ADM1",
        CountryCode: "JP"
      }
    ],

  },
  {
    id: "248816",
    Name: "Jordan",
    States: [
      {
        id: "443120",
        Name: "Ajlun",
        
        FCode: "ADM1",
        CountryCode: "JO",
      },
      {
        id: "250439",
        Name: "Amman",
        
        FCode: "ADM1",
        CountryCode: "JO",
      },
      {
        id: "443122",
        Name: "Aqaba",
        
        FCode: "ADM1",
        CountryCode: "JO",
      },
      {
        id: "250751",
        Name: "Balqa",
        
        FCode: "ADM1",
        CountryCode: "JO",
      },
      {
        id: "248944",
        Name: "Irbid",
        
        FCode: "ADM1",
        CountryCode: "JO",
      },
      {
        id: "443121",
        Name: "Jerash",
        
        FCode: "ADM1",
        CountryCode: "JO",
      },
      {
        id: "250625",
        Name: "Karak",
        
        FCode: "ADM1",
        CountryCode: "JO",
      },
      {
        id: "443123",
        Name: "Madaba",
        
        FCode: "ADM1",
        CountryCode: "JO",
      },
      {
        id: "250583",
        Name: "Mafraq",
        
        FCode: "ADM1",
        CountryCode: "JO",
      },
      {
        id: "248380",
        Name: "Ma’an",
        
        FCode: "ADM1",
        CountryCode: "JO",
      },
      {
        id: "250199",
        Name: "Tafielah",
        
        FCode: "ADM1",
        CountryCode: "JO",
      },
      {
        id: "250092",
        Name: "Zarqa",
        
        FCode: "ADM1",
        CountryCode: "JO",
      }
    ],

  },
  {
    id: "1522867",
    Name: "Kazakhstan",
    States: [
      {
        id: "610688",
        Name: "Aktyubinskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "KZ"
      },
      {
        id: "1537162",
        Name: "Almaty Oblysy",
        
        FCode: "ADM1",
        CountryCode: "KZ"
      },
      {
        id: "1526395",
        Name: "Almaty Qalasy",
        
        FCode: "ADM1",
        CountryCode: "KZ"
      },
      {
        id: "1518003",
        Name: "Aqmola Oblysy",
        
        FCode: "ADM1",
        CountryCode: "KZ"
      },
      {
        id: "1538317",
        Name: "Astana Qalasy",
        
        FCode: "ADM1",
        CountryCode: "KZ"
      },
      {
        id: "609862",
        Name: "Atyraū Oblysy",
        
        FCode: "ADM1",
        CountryCode: "KZ"
      },
      {
        id: "607847",
        Name: "Batys Qazaqstan Oblysy",
        
        FCode: "ADM1",
        CountryCode: "KZ"
      },
      {
        id: "1538316",
        Name: "Bayqongyr Qalasy",
        
        FCode: "ADM1",
        CountryCode: "KZ"
      },
      {
        id: "1517381",
        Name: "East Kazakhstan",
        
        FCode: "ADM1",
        CountryCode: "KZ",
      },
      {
        id: "608879",
        Name: "Mangistauskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "KZ"
      },
      {
        id: "1520239",
        Name: "Pavlodar Oblysy",
        
        FCode: "ADM1",
        CountryCode: "KZ"
      },
      {
        id: "1523401",
        Name: "Qaraghandy Oblysy",
        
        FCode: "ADM1",
        CountryCode: "KZ"
      },
      {
        id: "1521671",
        Name: "Qostanay Oblysy",
        
        FCode: "ADM1",
        CountryCode: "KZ"
      },
      {
        id: "1521406",
        Name: "Qyzylorda Oblysy",
        
        FCode: "ADM1",
        CountryCode: "KZ"
      },
      {
        id: "1519367",
        Name: "Severo-Kazakhstanskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "KZ"
      },
      {
        id: "1524787",
        Name: "Yuzhno-Kazakhstanskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "KZ"
      },
      {
        id: "1524444",
        Name: "Zhambyl Oblysy",
        
        FCode: "ADM1",
        CountryCode: "KZ"
      }
    ],

  },
  {
    id: "285570",
    Name: "Kuwait",
    States: [
      {
        id: "285816",
        Name: "Al Farwaniyah",
        
        FCode: "ADM1",
        CountryCode: "KW",
      },
      {
        id: "285798",
        Name: "Muḩāfaz̧at Jahrā’",
        
        FCode: "ADM1",
        CountryCode: "KW"
      },
      {
        id: "7733358",
        Name: "Muḩāfaz̧at Mubārak al Kabīr",
        
        FCode: "ADM1",
        CountryCode: "KW"
      },
      {
        id: "285841",
        Name: "Muḩāfaz̧at al Aḩmadī",
        
        FCode: "ADM1",
        CountryCode: "KW"
      },
      {
        id: "285788",
        Name: "Muḩāfaz̧at al ‘Āşimah",
        
        FCode: "ADM1",
        CountryCode: "KW"
      },
      {
        id: "285628",
        Name: "Muḩāfaz̧at Ḩawallī",
        
        FCode: "ADM1",
        CountryCode: "KW"
      }
    ],

  },
  {
    id: "1527747",
    Name: "Kyrgyzstan",
    States: [
      {
        id: "1463580",
        Name: "Batken Oblasty",
        
        FCode: "ADM1",
        CountryCode: "KG"
      },
      {
        id: "1528334",
        Name: "Bishkek",
        
        FCode: "ADM1",
        CountryCode: "KG"
      },
      {
        id: "1538652",
        Name: "Chüy",
        
        FCode: "ADM1",
        CountryCode: "KG"
      },
      {
        id: "1528260",
        Name: "Issyk-Kul’skaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "KG"
      },
      {
        id: "1529778",
        Name: "Jalal-Abad Oblasty",
        
        FCode: "ADM1",
        CountryCode: "KG"
      },
      {
        id: "1527590",
        Name: "Naryn Oblasty",
        
        FCode: "ADM1",
        CountryCode: "KG"
      },
      {
        id: "1346798",
        Name: "Osh Oblasty",
        
        FCode: "ADM1",
        CountryCode: "KG"
      },
      {
        id: "1527297",
        Name: "Talas Oblasty",
        
        FCode: "ADM1",
        CountryCode: "KG"
      }
    ],

  },
  {
    id: "1655842",
    Name: "Laos",
    States: [
      {
        id: "1904618",
        Name: "Kamphèng Nakhon Viangchan",
        
        FCode: "ADM1",
        CountryCode: "LA"
      },
      {
        id: "1665045",
        Name: "Khouèng Attapu",
        
        FCode: "ADM1",
        CountryCode: "LA"
      },
      {
        id: "1904616",
        Name: "Khouèng Bokèo",
        
        FCode: "ADM1",
        CountryCode: "LA"
      },
      {
        id: "1904617",
        Name: "Khouèng Bolikhamxai",
        
        FCode: "ADM1",
        CountryCode: "LA"
      },
      {
        id: "1657818",
        Name: "Khouèng Champasak",
        
        FCode: "ADM1",
        CountryCode: "LA"
      },
      {
        id: "1657114",
        Name: "Khouèng Houaphan",
        
        FCode: "ADM1",
        CountryCode: "LA"
      },
      {
        id: "1656538",
        Name: "Khouèng Khammouan",
        
        FCode: "ADM1",
        CountryCode: "LA"
      },
      {
        id: "1655561",
        Name: "Khouèng Louangnamtha",
        
        FCode: "ADM1",
        CountryCode: "LA"
      },
      {
        id: "1654491",
        Name: "Khouèng Oudômxai",
        
        FCode: "ADM1",
        CountryCode: "LA"
      },
      {
        id: "1653893",
        Name: "Khouèng Phôngsali",
        
        FCode: "ADM1",
        CountryCode: "LA"
      },
      {
        id: "1653333",
        Name: "Khouèng Salavan",
        
        FCode: "ADM1",
        CountryCode: "LA"
      },
      {
        id: "1653315",
        Name: "Khouèng Savannakhét",
        
        FCode: "ADM1",
        CountryCode: "LA"
      },
      {
        id: "1652238",
        Name: "Khouèng Viangchan",
        
        FCode: "ADM1",
        CountryCode: "LA"
      },
      {
        id: "1652210",
        Name: "Khouèng Xaignabouli",
        
        FCode: "ADM1",
        CountryCode: "LA"
      },
      {
        id: "1652077",
        Name: "Khouèng Xiangkhouang",
        
        FCode: "ADM1",
        CountryCode: "LA"
      },
      {
        id: "1904615",
        Name: "Khouèng Xékong",
        
        FCode: "ADM1",
        CountryCode: "LA"
      },
      {
        id: "1655558",
        Name: "Luang Prabang Province",
        
        FCode: "ADM1",
        CountryCode: "LA"
      }
    ],

  },
  {
    id: "272103",
    Name: "Lebanon",
    States: [
      {
        id: "6201370",
        Name: "Mohafazat Aakâr",
        
        FCode: "ADM1",
        CountryCode: "LB"
      },
      {
        id: "6201371",
        Name: "Mohafazat Baalbek-Hermel",
        
        FCode: "ADM1",
        CountryCode: "LB"
      },
      {
        id: "276780",
        Name: "Mohafazat Beyrouth",
        
        FCode: "ADM1",
        CountryCode: "LB"
      },
      {
        id: "280282",
        Name: "Mohafazat Béqaa",
        
        FCode: "ADM1",
        CountryCode: "LB"
      },
      {
        id: "278297",
        Name: "Mohafazat Liban-Nord",
        
        FCode: "ADM1",
        CountryCode: "LB"
      },
      {
        id: "279894",
        Name: "Mohafazat Liban-Sud",
        
        FCode: "ADM1",
        CountryCode: "LB"
      },
      {
        id: "273607",
        Name: "Mohafazat Mont-Liban",
        
        FCode: "ADM1",
        CountryCode: "LB",
      },
      {
        id: "444191",
        Name: "Mohafazat Nabatîyé",
        
        FCode: "ADM1",
        CountryCode: "LB"
      }
    ],

  },
  {
    id: "1821275",
    Name: "Macao",
    States: [
      {
        id: "1821286",
        Name: "Concelho das Ilhas",
        
        FCode: "ADM1",
        CountryCode: "MO"
      },
      {
        id: "1821273",
        Name: "Concelho de Macau",
        
        FCode: "ADM1",
        CountryCode: "MO"
      }
    ],

  },
  {
    id: "1733045",
    Name: "Malaysia",
    States: [
      {
        id: "1733049",
        Name: "Johor",
        
        FCode: "ADM1",
        CountryCode: "MY"
      },
      {
        id: "1733048",
        Name: "Kedah",
        
        FCode: "ADM1",
        CountryCode: "MY"
      },
      {
        id: "1733044",
        Name: "Kelantan",
        
        FCode: "ADM1",
        CountryCode: "MY"
      },
      {
        id: "1733046",
        Name: "Kuala Lumpur",
        
        FCode: "ADM1",
        CountryCode: "MY",
      },
      {
        id: "1734240",
        Name: "Labuan",
        
        FCode: "ADM1",
        CountryCode: "MY",
      },
      {
        id: "1733035",
        Name: "Melaka",
        
        FCode: "ADM1",
        CountryCode: "MY"
      },
      {
        id: "1733043",
        Name: "Negeri Sembilan",
        
        FCode: "ADM1",
        CountryCode: "MY"
      },
      {
        id: "1733042",
        Name: "Pahang",
        
        FCode: "ADM1",
        CountryCode: "MY"
      },
      {
        id: "1733041",
        Name: "Perak",
        
        FCode: "ADM1",
        CountryCode: "MY"
      },
      {
        id: "1733040",
        Name: "Perlis",
        
        FCode: "ADM1",
        CountryCode: "MY"
      },
      {
        id: "1733047",
        Name: "Pulau Pinang",
        
        FCode: "ADM1",
        CountryCode: "MY"
      },
      {
        id: "1996552",
        Name: "Putrajaya",
        
        FCode: "ADM1",
        CountryCode: "MY",
      },
      {
        id: "1733039",
        Name: "Sabah",
        
        FCode: "ADM1",
        CountryCode: "MY"
      },
      {
        id: "1733038",
        Name: "Sarawak",
        
        FCode: "ADM1",
        CountryCode: "MY"
      },
      {
        id: "1733037",
        Name: "Selangor",
        
        FCode: "ADM1",
        CountryCode: "MY"
      },
      {
        id: "1733036",
        Name: "Terengganu",
        
        FCode: "ADM1",
        CountryCode: "MY"
      }
    ],

  },
  {
    id: "1282028",
    Name: "Maldives",
    States: [
      {
        id: "1282478",
        Name: "Baa Atholhu",
        
        FCode: "ADM1",
        CountryCode: "MV"
      },
      {
        id: "8030592",
        Name: "Central Province",
        
        FCode: "ADM1",
        CountryCode: "MV",
      },
      {
        id: "1282447",
        Name: "Dhaalu Atholhu",
        
        FCode: "ADM1",
        CountryCode: "MV"
      },
      {
        id: "1282393",
        Name: "Faafu Atholhu",
        
        FCode: "ADM1",
        CountryCode: "MV"
      },
      {
        id: "1282329",
        Name: "Gaafu Alifu Atholhu",
        
        FCode: "ADM1",
        CountryCode: "MV"
      },
      {
        id: "1282328",
        Name: "Gaafu Dhaalu Atholhu",
        
        FCode: "ADM1",
        CountryCode: "MV"
      },
      {
        id: "1281945",
        Name: "Gnyaviyani Atoll",
        
        FCode: "ADM1",
        CountryCode: "MV",
      },
      {
        id: "1282294",
        Name: "Haa Alifu Atholhu",
        
        FCode: "ADM1",
        CountryCode: "MV"
      },
      {
        id: "1282293",
        Name: "Haa Dhaalu Atholhu",
        
        FCode: "ADM1",
        CountryCode: "MV"
      },
      {
        id: "1282208",
        Name: "Kaafu Atoll",
        
        FCode: "ADM1",
        CountryCode: "MV"
      },
      {
        id: "1282101",
        Name: "Laamu Atholhu",
        
        FCode: "ADM1",
        CountryCode: "MV"
      },
      {
        id: "1282096",
        Name: "Lhaviyani Atholhu",
        
        FCode: "ADM1",
        CountryCode: "MV"
      },
      {
        id: "1337624",
        Name: "Maale",
        
        FCode: "ADM1",
        CountryCode: "MV"
      },
      {
        id: "1281985",
        Name: "Meemu Atholhu",
        
        FCode: "ADM1",
        CountryCode: "MV"
      },
      {
        id: "1281937",
        Name: "Noonu Atoll",
        
        FCode: "ADM1",
        CountryCode: "MV",
      },
      {
        id: "8030594",
        Name: "North Central Province",
        
        FCode: "ADM1",
        CountryCode: "MV",
      },
      {
        id: "8030595",
        Name: "North Province",
        
        FCode: "ADM1",
        CountryCode: "MV",
      },
      {
        id: "1282497",
        Name: "Northern Ari Atoll",
        
        FCode: "ADM1",
        CountryCode: "MV",
      },
      {
        id: "1281918",
        Name: "Raa Atholhu",
        
        FCode: "ADM1",
        CountryCode: "MV"
      },
      {
        id: "1281893",
        Name: "Seenu Atholhu",
        
        FCode: "ADM1",
        CountryCode: "MV"
      },
      {
        id: "1281892",
        Name: "Shaviyani Atholhu",
        
        FCode: "ADM1",
        CountryCode: "MV"
      },
      {
        id: "8030593",
        Name: "South Central Province",
        
        FCode: "ADM1",
        CountryCode: "MV",
      },
      {
        id: "8030589",
        Name: "South Province",
        
        FCode: "ADM1",
        CountryCode: "MV",
      },
      {
        id: "1281881",
        Name: "Thaa Atholhu",
        
        FCode: "ADM1",
        CountryCode: "MV"
      },
      {
        id: "8030591",
        Name: "Upper North Province",
        
        FCode: "ADM1",
        CountryCode: "MV",
      },
      {
        id: "8030590",
        Name: "Upper South Province",
        
        FCode: "ADM1",
        CountryCode: "MV",
      },
      {
        id: "1281843",
        Name: "Vaavu Atholhu",
        
        FCode: "ADM1",
        CountryCode: "MV"
      }
    ],

  },
  {
    id: "2029969",
    Name: "Mongolia",
    States: [
      {
        id: "2032855",
        Name: "Arhangay Aymag",
        
        FCode: "ADM1",
        CountryCode: "MN"
      },
      {
        id: "1516278",
        Name: "Bayan-Ölgiy Aymag",
        
        FCode: "ADM1",
        CountryCode: "MN"
      },
      {
        id: "1516290",
        Name: "Bayanhongor Aymag",
        
        FCode: "ADM1",
        CountryCode: "MN"
      },
      {
        id: "2032199",
        Name: "Bulgan Aymag",
        
        FCode: "ADM1",
        CountryCode: "MN"
      },
      {
        id: "2028849",
        Name: "Central Aimak",
        
        FCode: "ADM1",
        CountryCode: "MN",
      },
      {
        id: "2055111",
        Name: "Darhan-Uul Aymag",
        
        FCode: "ADM1",
        CountryCode: "MN"
      },
      {
        id: "1516012",
        Name: "Dzavhan Aymag",
        
        FCode: "ADM1",
        CountryCode: "MN"
      },
      {
        id: "2031798",
        Name: "East Govĭ",
        
        FCode: "ADM1",
        CountryCode: "MN",
      },
      {
        id: "2031799",
        Name: "Eastern Aymag",
        
        FCode: "ADM1",
        CountryCode: "MN",
      },
      {
        id: "1515917",
        Name: "Govĭ-Altay Aymag",
        
        FCode: "ADM1",
        CountryCode: "MN"
      },
      {
        id: "2055112",
        Name: "Govĭ-Sumber",
        
        FCode: "ADM1",
        CountryCode: "MN"
      },
      {
        id: "2030783",
        Name: "Hentiy Aymag",
        
        FCode: "ADM1",
        CountryCode: "MN"
      },
      {
        id: "1515696",
        Name: "Hovd Aymag",
        
        FCode: "ADM1",
        CountryCode: "MN"
      },
      {
        id: "2030469",
        Name: "Hövsgöl Aymag",
        
        FCode: "ADM1",
        CountryCode: "MN"
      },
      {
        id: "2031740",
        Name: "Middle Govĭ",
        
        FCode: "ADM1",
        CountryCode: "MN",
      },
      {
        id: "2055113",
        Name: "Orhon Aymag",
        
        FCode: "ADM1",
        CountryCode: "MN"
      },
      {
        id: "2029432",
        Name: "Selenge Aymag",
        
        FCode: "ADM1",
        CountryCode: "MN"
      },
      {
        id: "2029669",
        Name: "South Gobi Aimak",
        
        FCode: "ADM1",
        CountryCode: "MN",
      },
      {
        id: "2029155",
        Name: "Sühbaatar Aymag",
        
        FCode: "ADM1",
        CountryCode: "MN"
      },
      {
        id: "2028461",
        Name: "Ulaanbaatar Hot",
        
        FCode: "ADM1",
        CountryCode: "MN"
      },
      {
        id: "1514967",
        Name: "Uvs Aymag",
        
        FCode: "ADM1",
        CountryCode: "MN"
      },
      {
        id: "2029546",
        Name: "Övörhangay",
        
        FCode: "ADM1",
        CountryCode: "MN",
      }
    ],

  },
  {
    id: "1327865",
    Name: "Myanmar [Burma]",
    States: [
      {
        id: "1321850",
        Name: "Ayeyarwady Division",
        
        FCode: "ADM1",
        CountryCode: "MM"
      },
      {
        id: "1300463",
        Name: "Bago Division",
        
        FCode: "ADM1",
        CountryCode: "MM"
      },
      {
        id: "1327132",
        Name: "Chin State",
        
        FCode: "ADM1",
        CountryCode: "MM"
      },
      {
        id: "1321702",
        Name: "Kachin State",
        
        FCode: "ADM1",
        CountryCode: "MM"
      },
      {
        id: "1319539",
        Name: "Kayah State",
        
        FCode: "ADM1",
        CountryCode: "MM"
      },
      {
        id: "1320233",
        Name: "Kayin State",
        
        FCode: "ADM1",
        CountryCode: "MM"
      },
      {
        id: "1312604",
        Name: "Magway Division",
        
        FCode: "ADM1",
        CountryCode: "MM"
      },
      {
        id: "1311871",
        Name: "Mandalay Division",
        
        FCode: "ADM1",
        CountryCode: "MM"
      },
      {
        id: "1308528",
        Name: "Mon State",
        
        FCode: "ADM1",
        CountryCode: "MM"
      },
      {
        id: "1298852",
        Name: "Rakhine State",
        
        FCode: "ADM1",
        CountryCode: "MM"
      },
      {
        id: "1298480",
        Name: "Sagaing Division",
        
        FCode: "ADM1",
        CountryCode: "MM"
      },
      {
        id: "1297099",
        Name: "Shan State",
        
        FCode: "ADM1",
        CountryCode: "MM"
      },
      {
        id: "1293118",
        Name: "Tanintharyi Division",
        
        FCode: "ADM1",
        CountryCode: "MM"
      },
      {
        id: "1298822",
        Name: "Yangon Division",
        
        FCode: "ADM1",
        CountryCode: "MM"
      }
    ],

  },
  {
    id: "1282988",
    Name: "Nepal",
    States: [
      {
        id: "7289707",
        Name: "Central Region",
        
        FCode: "ADM1",
        CountryCode: "NP",
      },
      {
        id: "7289708",
        Name: "Eastern Region",
        
        FCode: "ADM1",
        CountryCode: "NP",
      },
      {
        id: "7289705",
        Name: "Far Western Region",
        
        FCode: "ADM1",
        CountryCode: "NP",
      },
      {
        id: "7289706",
        Name: "Mid Western Region",
        
        FCode: "ADM1",
        CountryCode: "NP",
      },
      {
        id: "7289709",
        Name: "Western Region",
        
        FCode: "ADM1",
        CountryCode: "NP",
      }
    ],

  },
  {
    id: "1873107",
    Name: "North Korea",
    States: [
      {
        id: "2045265",
        Name: "Chagang-do",
        
        FCode: "ADM1",
        CountryCode: "KP"
      },
      {
        id: "1876101",
        Name: "Gangwon",
        
        FCode: "ADM1",
        CountryCode: "KP",
      },
      {
        id: "2044245",
        Name: "Hamgyŏng-bukto",
        
        FCode: "ADM1",
        CountryCode: "KP"
      },
      {
        id: "1877450",
        Name: "Hamgyŏng-namdo",
        
        FCode: "ADM1",
        CountryCode: "KP"
      },
      {
        id: "1876888",
        Name: "Hwanghae-bukto",
        
        FCode: "ADM1",
        CountryCode: "KP"
      },
      {
        id: "1876884",
        Name: "Hwanghae-namdo",
        
        FCode: "ADM1",
        CountryCode: "KP"
      },
      {
        id: "2054927",
        Name: "Nasŏn-si",
        
        FCode: "ADM1",
        CountryCode: "KP"
      },
      {
        id: "1871954",
        Name: "P’yŏngan-bukto",
        
        FCode: "ADM1",
        CountryCode: "KP"
      },
      {
        id: "1871952",
        Name: "P’yŏngan-namdo",
        
        FCode: "ADM1",
        CountryCode: "KP"
      },
      {
        id: "1871856",
        Name: "P’yŏngyang-si",
        
        FCode: "ADM1",
        CountryCode: "KP"
      },
      {
        id: "2039332",
        Name: "Yanggang-do",
        
        FCode: "ADM1",
        CountryCode: "KP"
      }
    ],

  },
  {
    id: "286963",
    Name: "Oman",
    States: [
      {
        id: "411735",
        Name: "Al Minţaqah ad Dākhilīyah",
        
        FCode: "ADM1",
        CountryCode: "OM"
      },
      {
        id: "411737",
        Name: "Al Minţaqah al Wusţá",
        
        FCode: "ADM1",
        CountryCode: "OM"
      },
      {
        id: "411738",
        Name: "Al Minţaqah ash Sharqīyah",
        
        FCode: "ADM1",
        CountryCode: "OM"
      },
      {
        id: "411736",
        Name: "Minţaqat al Bāţinah",
        
        FCode: "ADM1",
        CountryCode: "OM"
      },
      {
        id: "411739",
        Name: "Minţaqat az̧ Z̧āhirah",
        
        FCode: "ADM1",
        CountryCode: "OM"
      },
      {
        id: "411740",
        Name: "Muḩāfaz̧at Masqaţ",
        
        FCode: "ADM1",
        CountryCode: "OM"
      },
      {
        id: "411741",
        Name: "Muḩāfaz̧at Musandam",
        
        FCode: "ADM1",
        CountryCode: "OM"
      },
      {
        id: "411742",
        Name: "Muḩāfaz̧at Z̧ufār",
        
        FCode: "ADM1",
        CountryCode: "OM"
      },
      {
        id: "7110710",
        Name: "Muḩāfaz̧at al Buraymī",
        
        FCode: "ADM1",
        CountryCode: "OM"
      }
    ],

  },
  {
    id: "1168579",
    Name: "Pakistan",
    States: [
      {
        id: "1184196",
        Name: "Azad Kashmir",
        
        FCode: "ADM1",
        CountryCode: "PK"
      },
      {
        id: "1183606",
        Name: "Balochistān",
        
        FCode: "ADM1",
        CountryCode: "PK"
      },
      {
        id: "1179245",
        Name: "Federally Administered Tribal Areas",
        
        FCode: "ADM1",
        CountryCode: "PK"
      },
      {
        id: "1168878",
        Name: "Gilgit-Baltistan",
        
        FCode: "ADM1",
        CountryCode: "PK",
      },
      {
        id: "1162015",
        Name: "Islāmābād Capital Territory",
        
        FCode: "ADM1",
        CountryCode: "PK"
      },
      {
        id: "1168873",
        Name: "North West Frontier Province",
        
        FCode: "ADM1",
        CountryCode: "PK",
      },
      {
        id: "1167710",
        Name: "Punjab",
        
        FCode: "ADM1",
        CountryCode: "PK",
      },
      {
        id: "1164807",
        Name: "Sindh",
        
        FCode: "ADM1",
        CountryCode: "PK"
      }
    ],

  },
  {
    id: "6254930",
    Name: "Palestine",
    States: [
      {
        id: "281132",
        Name: "Gaza Strip",
        
        FCode: "ADM1",
        CountryCode: "PS",
      },
      {
        id: "285153",
        Name: "West Bank",
        
        FCode: "ADM1",
        CountryCode: "PS"
      }
    ],

  },
  {
    id: "1694008",
    Name: "Philippines",
    States: [
      {
        id: "7115989",
        Name: "Autonomous Region in Muslim Mindanao",
        
        FCode: "ADM1",
        CountryCode: "PH"
      },
      {
        id: "7521310",
        Name: "Bicol",
        
        FCode: "ADM1",
        CountryCode: "PH"
      },
      {
        id: "7521297",
        Name: "Cagayan Valley",
        
        FCode: "ADM1",
        CountryCode: "PH"
      },
      {
        id: "7521303",
        Name: "Calabarzon",
        
        FCode: "ADM1",
        CountryCode: "PH"
      },
      {
        id: "7521299",
        Name: "Caraga",
        
        FCode: "ADM1",
        CountryCode: "PH"
      },
      {
        id: "7521305",
        Name: "Central Luzon",
        
        FCode: "ADM1",
        CountryCode: "PH"
      },
      {
        id: "7521306",
        Name: "Central Visayas",
        
        FCode: "ADM1",
        CountryCode: "PH"
      },
      {
        id: "7521300",
        Name: "Cordillera Administrative Region",
        
        FCode: "ADM1",
        CountryCode: "PH"
      },
      {
        id: "7521309",
        Name: "Davao",
        
        FCode: "ADM1",
        CountryCode: "PH"
      },
      {
        id: "7521307",
        Name: "Eastern Visayas",
        
        FCode: "ADM1",
        CountryCode: "PH"
      },
      {
        id: "7521301",
        Name: "Ilocos",
        
        FCode: "ADM1",
        CountryCode: "PH"
      },
      {
        id: "7521296",
        Name: "Mimaropa",
        
        FCode: "ADM1",
        CountryCode: "PH"
      },
      {
        id: "7521311",
        Name: "National Capital Region",
        
        FCode: "ADM1",
        CountryCode: "PH"
      },
      {
        id: "7521295",
        Name: "Northern Mindanao",
        
        FCode: "ADM1",
        CountryCode: "PH"
      },
      {
        id: "7521298",
        Name: "Soccsksargen",
        
        FCode: "ADM1",
        CountryCode: "PH"
      },
      {
        id: "7521304",
        Name: "Western Visayas",
        
        FCode: "ADM1",
        CountryCode: "PH"
      },
      {
        id: "7521308",
        Name: "Zamboanga Peninsula",
        
        FCode: "ADM1",
        CountryCode: "PH"
      }
    ],

  },
  {
    id: "289688",
    Name: "Qatar",
    States: [
      {
        id: "389473",
        Name: "Baladīyat Jarayān al Bāţinah",
        
        FCode: "ADM1",
        CountryCode: "QA"
      },
      {
        id: "6201190",
        Name: "Baladīyat Umm Sa‘īd",
        
        FCode: "ADM1",
        CountryCode: "QA"
      },
      {
        id: "389467",
        Name: "Baladīyat Umm Şalāl",
        
        FCode: "ADM1",
        CountryCode: "QA"
      },
      {
        id: "389470",
        Name: "Baladīyat ad Dawḩah",
        
        FCode: "ADM1",
        CountryCode: "QA"
      },
      {
        id: "389463",
        Name: "Baladīyat al Ghuwayrīyah",
        
        FCode: "ADM1",
        CountryCode: "QA"
      },
      {
        id: "389468",
        Name: "Baladīyat al Jumaylīyah",
        
        FCode: "ADM1",
        CountryCode: "QA"
      },
      {
        id: "389465",
        Name: "Baladīyat al Khawr wa adh Dhakhīrah",
        
        FCode: "ADM1",
        CountryCode: "QA"
      },
      {
        id: "389472",
        Name: "Baladīyat al Wakrah",
        
        FCode: "ADM1",
        CountryCode: "QA"
      },
      {
        id: "389469",
        Name: "Baladīyat ar Rayyān",
        
        FCode: "ADM1",
        CountryCode: "QA"
      },
      {
        id: "389462",
        Name: "Baladīyat ash Shamāl",
        
        FCode: "ADM1",
        CountryCode: "QA"
      },
      {
        id: "8030540",
        Name: "Baladīyat az̧ Z̧a‘āyin",
        
        FCode: "ADM1",
        CountryCode: "QA"
      }
    ],

  },
  {
    id: "102358",
    Name: "Saudi Arabia",
    States: [
      {
        id: "108241",
        Name: "Al Minţaqah ash Sharqīyah",
        
        FCode: "ADM1",
        CountryCode: "SA"
      },
      {
        id: "105298",
        Name: "Minţaqat Jīzān",
        
        FCode: "ADM1",
        CountryCode: "SA"
      },
      {
        id: "104514",
        Name: "Minţaqat Makkah",
        
        FCode: "ADM1",
        CountryCode: "SA"
      },
      {
        id: "103628",
        Name: "Minţaqat Najrān",
        
        FCode: "ADM1",
        CountryCode: "SA"
      },
      {
        id: "101627",
        Name: "Minţaqat Tabūk",
        
        FCode: "ADM1",
        CountryCode: "SA"
      },
      {
        id: "109954",
        Name: "Minţaqat al Bāḩah",
        
        FCode: "ADM1",
        CountryCode: "SA"
      },
      {
        id: "109470",
        Name: "Minţaqat al Jawf",
        
        FCode: "ADM1",
        CountryCode: "SA"
      },
      {
        id: "109224",
        Name: "Minţaqat al Madīnah",
        
        FCode: "ADM1",
        CountryCode: "SA"
      },
      {
        id: "108933",
        Name: "Minţaqat al Qaşīm",
        
        FCode: "ADM1",
        CountryCode: "SA"
      },
      {
        id: "108411",
        Name: "Minţaqat ar Riyāḑ",
        
        FCode: "ADM1",
        CountryCode: "SA"
      },
      {
        id: "106280",
        Name: "Minţaqat Ḩā’il",
        
        FCode: "ADM1",
        CountryCode: "SA"
      },
      {
        id: "108179",
        Name: "Minţaqat ‘Asīr",
        
        FCode: "ADM1",
        CountryCode: "SA"
      },
      {
        id: "109579",
        Name: "Northern Borders Region",
        
        FCode: "ADM1",
        CountryCode: "SA",
      }
    ],

  },
  {
    id: "1880251",
    Name: "Singapore",
    States: [
      {
        id: "7535954",
        Name: "Central Singapore Community Development Council",
        
        FCode: "ADM1",
        CountryCode: "SG"
      },
      {
        id: "7535955",
        Name: "North East Community Development Region",
        
        FCode: "ADM1",
        CountryCode: "SG"
      },
      {
        id: "7535958",
        Name: "North West Community Development Council",
        
        FCode: "ADM1",
        CountryCode: "SG"
      },
      {
        id: "7535956",
        Name: "South East Community Development Council",
        
        FCode: "ADM1",
        CountryCode: "SG"
      },
      {
        id: "7535957",
        Name: "South West Community Development Council",
        
        FCode: "ADM1",
        CountryCode: "SG"
      }
    ],

  },
  {
    id: "1835841",
    Name: "South Korea",
    States: [
      {
        id: "1838519",
        Name: "Busan",
        
        FCode: "ADM1",
        CountryCode: "KR",
      },
      {
        id: "1835327",
        Name: "Daegu",
        
        FCode: "ADM1",
        CountryCode: "KR",
      },
      {
        id: "1835224",
        Name: "Daejeon",
        
        FCode: "ADM1",
        CountryCode: "KR",
      },
      {
        id: "1843125",
        Name: "Gangwon",
        
        FCode: "ADM1",
        CountryCode: "KR",
      },
      {
        id: "1841808",
        Name: "Gwangju",
        
        FCode: "ADM1",
        CountryCode: "KR",
      },
      {
        id: "1841610",
        Name: "Gyeonggi",
        
        FCode: "ADM1",
        CountryCode: "KR",
      },
      {
        id: "1843561",
        Name: "Incheon",
        
        FCode: "ADM1",
        CountryCode: "KR",
      },
      {
        id: "1846265",
        Name: "Jeju",
        
        FCode: "ADM1",
        CountryCode: "KR",
      },
      {
        id: "1845106",
        Name: "North Chungcheong",
        
        FCode: "ADM1",
        CountryCode: "KR",
      },
      {
        id: "1841597",
        Name: "North Gyeongsang",
        
        FCode: "ADM1",
        CountryCode: "KR",
      },
      {
        id: "1845789",
        Name: "North Jeolla",
        
        FCode: "ADM1",
        CountryCode: "KR",
      },
      {
        id: "1835847",
        Name: "Seoul",
        
        FCode: "ADM1",
        CountryCode: "KR",
      },
      {
        id: "1845105",
        Name: "South Chungcheong",
        
        FCode: "ADM1",
        CountryCode: "KR",
      },
      {
        id: "1902028",
        Name: "South Gyeongsang",
        
        FCode: "ADM1",
        CountryCode: "KR",
      },
      {
        id: "1845788",
        Name: "South Jeolla",
        
        FCode: "ADM1",
        CountryCode: "KR",
      },
      {
        id: "1833742",
        Name: "Ulsan",
        
        FCode: "ADM1",
        CountryCode: "KR",
      }
    ],

  },
  {
    id: "1227603",
    Name: "Sri Lanka",
    States: [
      {
        id: "1249296",
        Name: "Central Province",
        
        FCode: "ADM1",
        CountryCode: "LK"
      },
      {
        id: "8133521",
        Name: "Eastern Province",
        
        FCode: "ADM1",
        CountryCode: "LK"
      },
      {
        id: "1232870",
        Name: "North Central Province",
        
        FCode: "ADM1",
        CountryCode: "LK"
      },
      {
        id: "1232860",
        Name: "North Western Province",
        
        FCode: "ADM1",
        CountryCode: "LK"
      },
      {
        id: "7671049",
        Name: "Northern Province",
        
        FCode: "ADM1",
        CountryCode: "LK"
      },
      {
        id: "1228435",
        Name: "Province of Sabaragamuwa",
        
        FCode: "ADM1",
        CountryCode: "LK"
      },
      {
        id: "1225265",
        Name: "Province of Uva",
        
        FCode: "ADM1",
        CountryCode: "LK"
      },
      {
        id: "1227618",
        Name: "Southern Province",
        
        FCode: "ADM1",
        CountryCode: "LK"
      },
      {
        id: "1223421",
        Name: "Western Province",
        
        FCode: "ADM1",
        CountryCode: "LK"
      }
    ],

  },
  {
    id: "163843",
    Name: "Syria",
    States: [
      {
        id: "173813",
        Name: "Al-Hasakah",
        
        FCode: "ADM1",
        CountryCode: "SY",
      },
      {
        id: "170062",
        Name: "Aleppo",
        
        FCode: "ADM1",
        CountryCode: "SY",
      },
      {
        id: "172957",
        Name: "Ar-Raqqah",
        
        FCode: "ADM1",
        CountryCode: "SY",
      },
      {
        id: "172410",
        Name: "As-Suwayda",
        
        FCode: "ADM1",
        CountryCode: "SY",
      },
      {
        id: "167541",
        Name: "Damascus City",
        
        FCode: "ADM1",
        CountryCode: "SY",
      },
      {
        id: "170903",
        Name: "Daraa",
        
        FCode: "ADM1",
        CountryCode: "SY",
      },
      {
        id: "170792",
        Name: "Deir ez-Zor",
        
        FCode: "ADM1",
        CountryCode: "SY",
      },
      {
        id: "170015",
        Name: "Hama",
        
        FCode: "ADM1",
        CountryCode: "SY",
      },
      {
        id: "169575",
        Name: "Homs",
        
        FCode: "ADM1",
        CountryCode: "SY",
      },
      {
        id: "169387",
        Name: "Idlib",
        
        FCode: "ADM1",
        CountryCode: "SY",
      },
      {
        id: "173578",
        Name: "Latakia",
        
        FCode: "ADM1",
        CountryCode: "SY",
      },
      {
        id: "173336",
        Name: "Quneitra",
        
        FCode: "ADM1",
        CountryCode: "SY",
      },
      {
        id: "170652",
        Name: "Rif-dimashq",
        
        FCode: "ADM1",
        CountryCode: "SY",
      },
      {
        id: "163342",
        Name: "Tartus",
        
        FCode: "ADM1",
        CountryCode: "SY",
      }
    ],
 
  },
  {
    id: "1668284",
    Name: "Taiwan",
    States: [
      {
        id: "7280288",
        Name: "Fukien",
        
        FCode: "ADM1",
        CountryCode: "TW"
      },
      {
        id: "7280289",
        Name: "Kaohsiung",
        
        FCode: "ADM1",
        CountryCode: "TW"
      },
      {
        id: "7280290",
        Name: "Taipei",
        
        FCode: "ADM1",
        CountryCode: "TW"
      },
      {
        id: "7280291",
        Name: "Taiwan",
        
        FCode: "ADM1",
        CountryCode: "TW"
      }
    ],

  },
  {
    id: "1220409",
    Name: "Tajikistan",
    States: [
      {
        id: "7280679",
        Name: "Dushanbe",
        
        FCode: "ADM1",
        CountryCode: "TJ"
      },
      {
        id: "1221692",
        Name: "Gorno-Badakhshan",
        
        FCode: "ADM1",
        CountryCode: "TJ",
      },
      {
        id: "6452615",
        Name: "Region of Republican Subordination",
        
        FCode: "ADM1",
        CountryCode: "TJ",
      },
      {
        id: "1347488",
        Name: "Viloyati Khatlon",
        
        FCode: "ADM1",
        CountryCode: "TJ"
      },
      {
        id: "1221092",
        Name: "Viloyati Sughd",
        
        FCode: "ADM1",
        CountryCode: "TJ"
      }
    ],

  },
  {
    id: "1605651",
    Name: "Thailand",
    States: [
      {
        id: "1609348",
        Name: "Bangkok",
        
        FCode: "ADM1",
        CountryCode: "TH",
      },
      {
        id: "1611268",
        Name: "Changawat Chanthaburi",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1906689",
        Name: "Changwat Amnat Charoen",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1621034",
        Name: "Changwat Ang Thong",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "8133594",
        Name: "Changwat Bueng Kan",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1611452",
        Name: "Changwat Buriram",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1611438",
        Name: "Changwat Chachoengsao",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1611415",
        Name: "Changwat Chai Nat",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1611406",
        Name: "Changwat Chaiyaphum",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1153668",
        Name: "Changwat Chiang Rai",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1611108",
        Name: "Changwat Chon Buri",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1153555",
        Name: "Changwat Chumphon",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1610468",
        Name: "Changwat Kalasin",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1153089",
        Name: "Changwat Kamphaeng Phet",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1153080",
        Name: "Changwat Kanchanaburi",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1609775",
        Name: "Changwat Khon Kaen",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1152631",
        Name: "Changwat Krabi",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1152472",
        Name: "Changwat Lampang",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1152467",
        Name: "Changwat Lamphun",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1609070",
        Name: "Changwat Loei",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1609031",
        Name: "Changwat Lop Buri",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1152221",
        Name: "Changwat Mae Hong Son",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1608899",
        Name: "Changwat Maha Sarakham",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1608595",
        Name: "Changwat Mukdahan",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1608538",
        Name: "Changwat Nakhon Nayok",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1608533",
        Name: "Changwat Nakhon Pathom",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1608530",
        Name: "Changwat Nakhon Phanom",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1608528",
        Name: "Changwat Nakhon Ratchasima",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1608526",
        Name: "Changwat Nakhon Sawan",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1608525",
        Name: "Changwat Nakhon Si Thammarat",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1608451",
        Name: "Changwat Nan",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1608408",
        Name: "Changwat Narathiwat",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1906690",
        Name: "Changwat Nong Bua Lamphu",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1608231",
        Name: "Changwat Nong Khai",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1608132",
        Name: "Changwat Nonthaburi",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1607982",
        Name: "Changwat Pathum Thani",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1607976",
        Name: "Changwat Pattani",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1151462",
        Name: "Changwat Phangnga",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1607778",
        Name: "Changwat Phatthalung",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1607758",
        Name: "Changwat Phayao",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1607736",
        Name: "Changwat Phetchabun",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1151416",
        Name: "Changwat Phetchaburi",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1607724",
        Name: "Changwat Phichit",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1607707",
        Name: "Changwat Phitsanulok",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1607530",
        Name: "Changwat Phra Nakhon Si Ayutthaya",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1607551",
        Name: "Changwat Phrae",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1906687",
        Name: "Changwat Prachin Buri",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1151073",
        Name: "Changwat Prachuap Khiri Khan",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1150964",
        Name: "Changwat Ranong",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1150953",
        Name: "Changwat Ratchaburi",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1607016",
        Name: "Changwat Rayong",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1607000",
        Name: "Changwat Roi Et",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1906691",
        Name: "Changwat Sa Kaeo",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1606789",
        Name: "Changwat Sakon Nakhon",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1606589",
        Name: "Changwat Samut Prakan",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1606587",
        Name: "Changwat Samut Sakhon",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1606585",
        Name: "Changwat Samut Songkhram",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1606417",
        Name: "Changwat Sara Buri",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1606375",
        Name: "Changwat Satun",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1606269",
        Name: "Changwat Sing Buri",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1606238",
        Name: "Changwat Sisaket",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1606146",
        Name: "Changwat Songkhla",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1150532",
        Name: "Changwat Sukhothai",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1606032",
        Name: "Changwat Suphan Buri",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1150514",
        Name: "Changwat Surat Thani",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1606029",
        Name: "Changwat Surin",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1150489",
        Name: "Changwat Tak",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1150006",
        Name: "Changwat Trang",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1605277",
        Name: "Changwat Trat",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1906688",
        Name: "Changwat Ubon Ratchathani",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1906686",
        Name: "Changwat Udon Thani",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1149965",
        Name: "Changwat Uthai Thani",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1605214",
        Name: "Changwat Uttaradit",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1604869",
        Name: "Changwat Yala",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1604767",
        Name: "Changwat Yasothon",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1153670",
        Name: "Chiang Mai Province",
        
        FCode: "ADM1",
        CountryCode: "TH"
      },
      {
        id: "1151253",
        Name: "Phuket Province",
        
        FCode: "ADM1",
        CountryCode: "TH",
      }
    ],

  },
  {
    id: "298795",
    Name: "Turkey",
    States: [
      {
        id: "325361",
        Name: "Adana",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "325329",
        Name: "Adıyaman",
        
        FCode: "ADM1",
        CountryCode: "TR"
      },
      {
        id: "325302",
        Name: "Afyonkarahisar",
        
        FCode: "ADM1",
        CountryCode: "TR"
      },
      {
        id: "443185",
        Name: "Aksaray",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "752014",
        Name: "Amasya",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "323784",
        Name: "Ankara",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "323776",
        Name: "Antalya",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "862470",
        Name: "Ardahan",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "751816",
        Name: "Artvin",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "322819",
        Name: "Aydın",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "325163",
        Name: "Ağrı",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "322164",
        Name: "Balıkesir",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "862467",
        Name: "Bartın",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "443186",
        Name: "Batman",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "862471",
        Name: "Bayburt",
        
        FCode: "ADM1",
        CountryCode: "TR"
      },
      {
        id: "321122",
        Name: "Bilecik",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "321079",
        Name: "Bingöl",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "321022",
        Name: "Bitlis",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "750510",
        Name: "Bolu",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "320390",
        Name: "Burdur",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "750268",
        Name: "Bursa",
        
        FCode: "ADM1",
        CountryCode: "TR"
      },
      {
        id: "317106",
        Name: "Denizli",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "316540",
        Name: "Diyarbakır",
        
        FCode: "ADM1",
        CountryCode: "TR"
      },
      {
        id: "865521",
        Name: "Düzce",
        
        FCode: "ADM1",
        CountryCode: "TR"
      },
      {
        id: "747711",
        Name: "Edirne",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "315807",
        Name: "Elazığ",
        
        FCode: "ADM1",
        CountryCode: "TR"
      },
      {
        id: "315372",
        Name: "Erzincan",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "315367",
        Name: "Erzurum",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "315201",
        Name: "Eskişehir",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "314829",
        Name: "Gaziantep",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "746878",
        Name: "Giresun",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "746423",
        Name: "Gümüşhane",
        
        FCode: "ADM1",
        CountryCode: "TR"
      },
      {
        id: "312888",
        Name: "Hakkâri",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "312394",
        Name: "Hatay",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "311071",
        Name: "Isparta",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "745042",
        Name: "Istanbul",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "443184",
        Name: "Iğdır",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "310858",
        Name: "Kahramanmaraş",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "862468",
        Name: "Karabük",
        
        FCode: "ADM1",
        CountryCode: "TR"
      },
      {
        id: "443187",
        Name: "Karaman",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "743942",
        Name: "Kars",
        
        FCode: "ADM1",
        CountryCode: "TR"
      },
      {
        id: "743881",
        Name: "Kastamonu",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "308463",
        Name: "Kayseri",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "443213",
        Name: "Kilis",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "742865",
        Name: "Kocaeli",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "306569",
        Name: "Konya",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "305267",
        Name: "Kütahya",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "743165",
        Name: "Kırklareli",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "443188",
        Name: "Kırıkkale",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "307513",
        Name: "Kırşehir",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "304919",
        Name: "Malatya",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "304825",
        Name: "Manisa",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "304794",
        Name: "Mardin",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "311728",
        Name: "Mersin",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "304183",
        Name: "Muğla",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "304041",
        Name: "Muş",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "303830",
        Name: "Nevşehir",
        
        FCode: "ADM1",
        CountryCode: "TR"
      },
      {
        id: "303826",
        Name: "Niğde",
        
        FCode: "ADM1",
        CountryCode: "TR"
      },
      {
        id: "741098",
        Name: "Ordu",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "443183",
        Name: "Osmaniye",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "740481",
        Name: "Rize",
        
        FCode: "ADM1",
        CountryCode: "TR"
      },
      {
        id: "740352",
        Name: "Sakarya",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "740263",
        Name: "Samsun",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "300821",
        Name: "Siirt",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "739598",
        Name: "Sinop",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "300617",
        Name: "Sivas",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "738926",
        Name: "Tekirdağ",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "738742",
        Name: "Tokat",
        
        FCode: "ADM1",
        CountryCode: "TR"
      },
      {
        id: "738647",
        Name: "Trabzon",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "298845",
        Name: "Tunceli",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "298298",
        Name: "Uşak",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "298113",
        Name: "Van",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "862469",
        Name: "Yalova",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "296560",
        Name: "Yozgat",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "737021",
        Name: "Zonguldak",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "749778",
        Name: "Çanakkale",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "749747",
        Name: "Çankırı",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "748877",
        Name: "Çorum",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "311044",
        Name: "İzmir",
        
        FCode: "ADM1",
        CountryCode: "TR"
      },
      {
        id: "298332",
        Name: "Şanlıurfa",
        
        FCode: "ADM1",
        CountryCode: "TR",
      },
      {
        id: "443189",
        Name: "Şırnak",
        
        FCode: "ADM1",
        CountryCode: "TR",
      }
    ],

  },
  {
    id: "1218197",
    Name: "Turkmenistan",
    States: [
      {
        id: "162181",
        Name: "Ahal Welaýaty",
        
        FCode: "ADM1",
        CountryCode: "TM"
      },
      {
        id: "162152",
        Name: "Balkan Welaýaty",
        
        FCode: "ADM1",
        CountryCode: "TM"
      },
      {
        id: "601465",
        Name: "Daşoguz Welaýaty",
        
        FCode: "ADM1",
        CountryCode: "TM"
      },
      {
        id: "1219651",
        Name: "Lebap Welaýaty",
        
        FCode: "ADM1",
        CountryCode: "TM"
      },
      {
        id: "1218666",
        Name: "Mary Welaýaty",
        
        FCode: "ADM1",
        CountryCode: "TM"
      }
    ],

  },
  {
    id: "290557",
    Name: "United Arab Emirates",
    States: [
      {
        id: "292969",
        Name: "Abū Z̧aby",
        
        FCode: "ADM1",
        CountryCode: "AE",
      },
      {
        id: "292933",
        Name: "Ajman",
        
        FCode: "ADM1",
        CountryCode: "AE",
      },
      {
        id: "292879",
        Name: "Al Fujayrah",
        
        FCode: "ADM1",
        CountryCode: "AE"
      },
      {
        id: "292673",
        Name: "Ash Shāriqah",
        
        FCode: "ADM1",
        CountryCode: "AE"
      },
      {
        id: "292224",
        Name: "Dubayy",
        
        FCode: "ADM1",
        CountryCode: "AE",
      },
      {
        id: "291075",
        Name: "Ra’s al Khaymah",
        
        FCode: "ADM1",
        CountryCode: "AE"
      },
      {
        id: "290595",
        Name: "Umm al Qaywayn",
        
        FCode: "ADM1",
        CountryCode: "AE"
      }
    ],

  },
  {
    id: "1512440",
    Name: "Uzbekistan",
    States: [
      {
        id: "1484846",
        Name: "Andijan",
        
        FCode: "ADM1",
        CountryCode: "UZ"
      },
      {
        id: "1114929",
        Name: "Bukhara",
        
        FCode: "ADM1",
        CountryCode: "UZ",
      },
      {
        id: "1484845",
        Name: "Fergana",
        
        FCode: "ADM1",
        CountryCode: "UZ",
      },
      {
        id: "1484844",
        Name: "Jizzakh Province",
        
        FCode: "ADM1",
        CountryCode: "UZ"
      },
      {
        id: "453752",
        Name: "Karakalpakstan",
        
        FCode: "ADM1",
        CountryCode: "UZ",
      },
      {
        id: "1114928",
        Name: "Kashkadarya Province",
        
        FCode: "ADM1",
        CountryCode: "UZ",
      },
      {
        id: "1484842",
        Name: "Namangan Province",
        
        FCode: "ADM1",
        CountryCode: "UZ"
      },
      {
        id: "1484841",
        Name: "Navoiy Province",
        
        FCode: "ADM1",
        CountryCode: "UZ"
      },
      {
        id: "1114927",
        Name: "Samarqand Viloyati",
        
        FCode: "ADM1",
        CountryCode: "UZ"
      },
      {
        id: "1484840",
        Name: "Sirdaryo Viloyati",
        
        FCode: "ADM1",
        CountryCode: "UZ"
      },
      {
        id: "1114926",
        Name: "Surxondaryo Viloyati",
        
        FCode: "ADM1",
        CountryCode: "UZ"
      },
      {
        id: "1484839",
        Name: "Toshkent Shahri",
        
        FCode: "ADM1",
        CountryCode: "UZ"
      },
      {
        id: "1484838",
        Name: "Toshkent Viloyati",
        
        FCode: "ADM1",
        CountryCode: "UZ"
      },
      {
        id: "1484843",
        Name: "Xorazm Viloyati",
        
        FCode: "ADM1",
        CountryCode: "UZ"
      }
    ],

  },
  {
    id: "1562822",
    Name: "Vietnam",
    States: [
      {
        id: "7506719",
        Name: "Hau Giang",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1905099",
        Name: "Huyện Ðiện Biên",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1581297",
        Name: "Thành Phố Hải Phòng",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1580578",
        Name: "Thành phố Hồ Chí Minh",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1581129",
        Name: "Thủ Ðô Hà Nội",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1594446",
        Name: "Tỉnh An Giang",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1584534",
        Name: "Tỉnh Bà Rịa-Vũng Tàu",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1905475",
        Name: "Tỉnh Bình Dương",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1905480",
        Name: "Tỉnh Bình Phước",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1581882",
        Name: "Tỉnh Bình Thuận",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1587871",
        Name: "Tỉnh Bình Ðịnh",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1905675",
        Name: "Tỉnh Bạc Liêu",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1905419",
        Name: "Tỉnh Bắc Giang",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1905669",
        Name: "Tỉnh Bắc Kạn",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1905412",
        Name: "Tỉnh Bắc Ninh",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1587974",
        Name: "Tỉnh Bến Tre",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1586182",
        Name: "Tỉnh Cao Bằng",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1905678",
        Name: "Tỉnh Cà Mau",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1581188",
        Name: "Tỉnh Cần Thơ",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1581088",
        Name: "Tỉnh Gia Lai",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1581030",
        Name: "Tỉnh Hà Giang",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1905637",
        Name: "Tỉnh Hà Nam",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1581019",
        Name: "Tỉnh Hà Tây",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1580700",
        Name: "Tỉnh Hà Tĩnh",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1572594",
        Name: "Tỉnh Hòa Bình",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1905699",
        Name: "Tỉnh Hưng Yên",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1905686",
        Name: "Tỉnh Hải Dương",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1579634",
        Name: "Tỉnh Khánh Hòa",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1579008",
        Name: "Tỉnh Kiến Giang",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1565088",
        Name: "Tỉnh Kon Tum",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1577954",
        Name: "Tỉnh Lai Châu",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1575788",
        Name: "Tỉnh Long An",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1562412",
        Name: "Tỉnh Lào Cai",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1577882",
        Name: "Tỉnh Lâm Ðồng",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1576632",
        Name: "Tỉnh Lạng Sơn",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1905626",
        Name: "Tỉnh Nam Ðịnh",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1559969",
        Name: "Tỉnh Nghệ An",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1559970",
        Name: "Tỉnh Ninh Bình",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1559971",
        Name: "Tỉnh Ninh Thuận",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1905577",
        Name: "Tỉnh Phú Thọ",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1569805",
        Name: "Tỉnh Phú Yên",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1568839",
        Name: "Tỉnh Quảng Bình",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1905516",
        Name: "Tỉnh Quảng Nam",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1568769",
        Name: "Tỉnh Quảng Ngãi",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1568758",
        Name: "Tỉnh Quảng Ninh",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1568733",
        Name: "Tỉnh Quảng Trị",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1559972",
        Name: "Tỉnh Sóc Trăng",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1567643",
        Name: "Tỉnh Sơn La",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1566165",
        Name: "Tỉnh Thanh Hóa",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1566338",
        Name: "Tỉnh Thái Bình",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1905497",
        Name: "Tỉnh Thái Nguyên",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1565033",
        Name: "Tỉnh Thừa Thiên-Huế",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1564676",
        Name: "Tỉnh Tiền Giang",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1559975",
        Name: "Tỉnh Trà Vinh",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1559976",
        Name: "Tỉnh Tuyên Quang",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1566557",
        Name: "Tỉnh Tây Ninh",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1559977",
        Name: "Tỉnh Vĩnh Long",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1905856",
        Name: "Tỉnh Vĩnh Phúc",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1559978",
        Name: "Tỉnh Yên Bái",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1905468",
        Name: "Tỉnh Ðà Nẵng",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1584169",
        Name: "Tỉnh Ðắc Lắk",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1582720",
        Name: "Tỉnh Ðồng Nai",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1582562",
        Name: "Tỉnh Ðồng Tháp",
        
        FCode: "ADM1",
        CountryCode: "VN"
      },
      {
        id: "1904987",
        Name: "Ðắk Nông",
        
        FCode: "ADM1",
        CountryCode: "VN"
      }
    ],
  },
  {
    id: "69543",
    Name: "Yemen",
    States: [
      {
        id: "80412",
        Name: "Aden",
        
        FCode: "ADM1",
        CountryCode: "YE",
      },
      {
        id: "6940571",
        Name: "Amanat Al Asimah",
        
        FCode: "ADM1",
        CountryCode: "YE"
      },
      {
        id: "80425",
        Name: "Muḩāfaz̧at Abyan",
        
        FCode: "ADM1",
        CountryCode: "YE"
      },
      {
        id: "76183",
        Name: "Muḩāfaz̧at Dhamār",
        
        FCode: "ADM1",
        CountryCode: "YE"
      },
      {
        id: "6201196",
        Name: "Muḩāfaz̧at Ibb",
        
        FCode: "ADM1",
        CountryCode: "YE"
      },
      {
        id: "6201197",
        Name: "Muḩāfaz̧at Laḩij",
        
        FCode: "ADM1",
        CountryCode: "YE"
      },
      {
        id: "72966",
        Name: "Muḩāfaz̧at Ma’rib",
        
        FCode: "ADM1",
        CountryCode: "YE"
      },
      {
        id: "71532",
        Name: "Muḩāfaz̧at Raymah",
        
        FCode: "ADM1",
        CountryCode: "YE"
      },
      {
        id: "70935",
        Name: "Muḩāfaz̧at Shabwah",
        
        FCode: "ADM1",
        CountryCode: "YE"
      },
      {
        id: "70222",
        Name: "Muḩāfaz̧at Ta‘izz",
        
        FCode: "ADM1",
        CountryCode: "YE"
      },
      {
        id: "79838",
        Name: "Muḩāfaz̧at al Bayḑā’",
        
        FCode: "ADM1",
        CountryCode: "YE"
      },
      {
        id: "74222",
        Name: "Muḩāfaz̧at al Jawf",
        
        FCode: "ADM1",
        CountryCode: "YE"
      },
      {
        id: "78985",
        Name: "Muḩāfaz̧at al Mahrah",
        
        FCode: "ADM1",
        CountryCode: "YE"
      },
      {
        id: "73200",
        Name: "Muḩāfaz̧at al Maḩwīt",
        
        FCode: "ADM1",
        CountryCode: "YE"
      },
      {
        id: "79416",
        Name: "Muḩāfaz̧at al Ḩudaydah",
        
        FCode: "ADM1",
        CountryCode: "YE"
      },
      {
        id: "6201193",
        Name: "Muḩāfaz̧at aḑ Ḑāli‘",
        
        FCode: "ADM1",
        CountryCode: "YE"
      },
      {
        id: "71333",
        Name: "Muḩāfaz̧at Şa‘dah",
        
        FCode: "ADM1",
        CountryCode: "YE"
      },
      {
        id: "6201195",
        Name: "Muḩāfaz̧at Ḩajjah",
        
        FCode: "ADM1",
        CountryCode: "YE"
      },
      {
        id: "75411",
        Name: "Muḩāfaz̧at Ḩaḑramawt",
        
        FCode: "ADM1",
        CountryCode: "YE"
      },
      {
        id: "6201194",
        Name: "Omran",
        
        FCode: "ADM1",
        CountryCode: "YE",
      },
      {
        id: "71132",
        Name: "Sanaa",
        
        FCode: "ADM1",
        CountryCode: "YE"
      }
    ],
  },
  {
    id: "783754",
    Name: "Albania",
    States: [
      {
        id: "865730",
        Name: "Qarku i Beratit",
        
        FCode: "ADM1",
        CountryCode: "AL"
      },
      {
        id: "865731",
        Name: "Qarku i Dibrës",
        
        FCode: "ADM1",
        CountryCode: "AL"
      },
      {
        id: "3344947",
        Name: "Qarku i Durrësit",
        
        FCode: "ADM1",
        CountryCode: "AL"
      },
      {
        id: "865732",
        Name: "Qarku i Elbasanit",
        
        FCode: "ADM1",
        CountryCode: "AL"
      },
      {
        id: "3344948",
        Name: "Qarku i Fierit",
        
        FCode: "ADM1",
        CountryCode: "AL"
      },
      {
        id: "865733",
        Name: "Qarku i Gjirokastrës",
        
        FCode: "ADM1",
        CountryCode: "AL"
      },
      {
        id: "865734",
        Name: "Qarku i Korçës",
        
        FCode: "ADM1",
        CountryCode: "AL"
      },
      {
        id: "865735",
        Name: "Qarku i Kukësit",
        
        FCode: "ADM1",
        CountryCode: "AL"
      },
      {
        id: "3344949",
        Name: "Qarku i Lezhës",
        
        FCode: "ADM1",
        CountryCode: "AL"
      },
      {
        id: "3344950",
        Name: "Qarku i Shkodrës",
        
        FCode: "ADM1",
        CountryCode: "AL"
      },
      {
        id: "3344951",
        Name: "Qarku i Tiranës",
        
        FCode: "ADM1",
        CountryCode: "AL"
      },
      {
        id: "3344952",
        Name: "Qarku i Vlorës",
        
        FCode: "ADM1",
        CountryCode: "AL"
      }
    ],
  },
  {
    id: "3041565",
    Name: "Andorra",
    States: [
      {
        id: "3041566",
        Name: "Parròquia d'Andorra la Vella",
        
        FCode: "ADM1",
        CountryCode: "AD",

      },
      {
        id: "3040684",
        Name: "Parròquia d'Encamp",
        
        FCode: "ADM1",
        CountryCode: "AD",

      },
      {
        id: "3338529",
        Name: "Parròquia d'Escaldes-Engordany",
        
        FCode: "ADM1",
        CountryCode: "AD",
      },
      {
        id: "3039676",
        Name: "Parròquia d'Ordino",
        
        FCode: "ADM1",
        CountryCode: "AD",
      },
      {
        id: "3041203",
        Name: "Parròquia de Canillo",
        
        FCode: "ADM1",
        CountryCode: "AD",
      },
      {
        id: "3039162",
        Name: "Parròquia de Sant Julià de Lòria",
        
        FCode: "ADM1",
        CountryCode: "AD",
      },
      {
        id: "3040131",
        Name: "Parròquia de la Massana",
        
        FCode: "ADM1",
        CountryCode: "AD",
      }
    ],
  },
  {
    id: "2782113",
    Name: "Austria",
    States: [
      {
        id: "2781194",
        Name: "Burgenland",
        
        FCode: "ADM1",
        CountryCode: "AT",
      },
      {
        id: "2774686",
        Name: "Carinthia",
        
        FCode: "ADM1",
        CountryCode: "AT",
      },
      {
        id: "2770542",
        Name: "Lower Austria",
        
        FCode: "ADM1",
        CountryCode: "AT",
      },
      {
        id: "2766823",
        Name: "Salzburg",
        
        FCode: "ADM1",
        CountryCode: "AT"
      },
      {
        id: "2764581",
        Name: "Styria",
        
        FCode: "ADM1",
        CountryCode: "AT",
      },
      {
        id: "2763586",
        Name: "Tyrol",
        
        FCode: "ADM1",
        CountryCode: "AT",
      },
      {
        id: "2769848",
        Name: "Upper Austria",
        
        FCode: "ADM1",
        CountryCode: "AT",
      },
      {
        id: "2761367",
        Name: "Vienna",
        
        FCode: "ADM1",
        CountryCode: "AT",
      },
      {
        id: "2762300",
        Name: "Vorarlberg",
        
        FCode: "ADM1",
        CountryCode: "AT",
      }
    ],
  },
  {
    id: "630336",
    Name: "Belarus",
    States: [
      {
        id: "629631",
        Name: "Brestskaya Voblasts’",
        
        FCode: "ADM1",
        CountryCode: "BY"
      },
      {
        id: "628281",
        Name: "Homyel’skaya Voblasts’",
        
        FCode: "ADM1",
        CountryCode: "BY"
      },
      {
        id: "625143",
        Name: "Horad Minsk",
        
        FCode: "ADM1",
        CountryCode: "BY"
      },
      {
        id: "628035",
        Name: "Hrodzyenskaya Voblasts’",
        
        FCode: "ADM1",
        CountryCode: "BY"
      },
      {
        id: "625073",
        Name: "Mahilyowskaya Voblasts’",
        
        FCode: "ADM1",
        CountryCode: "BY"
      },
      {
        id: "625142",
        Name: "Minskaya Voblasts’",
        
        FCode: "ADM1",
        CountryCode: "BY"
      },
      {
        id: "620134",
        Name: "Vitsyebskaya Voblasts’",
        
        FCode: "ADM1",
        CountryCode: "BY"
      }
    ],
  },
  {
    id: "2802361",
    Name: "Belgium",
    States: [
      {
        id: "2800867",
        Name: "Brussels Capital Region",
        
        FCode: "ADM1",
        CountryCode: "BE",
      },
      {
        id: "3337388",
        Name: "Flanders",
        
        FCode: "ADM1",
        CountryCode: "BE",
      },
      {
        id: "3337387",
        Name: "Walloon Region",
        
        FCode: "ADM1",
        CountryCode: "BE",
      }
    ],
  },
  {
    id: "3277605",
    Name: "Bosnia and Herzegovina",
    States: [
      {
        id: "3294903",
        Name: "Brčko",
        
        FCode: "ADM1",
        CountryCode: "BA",
      },
      {
        id: "3229999",
        Name: "Federation of Bosnia and Herzegovina",
        
        FCode: "ADM1",
        CountryCode: "BA",
      },
      {
        id: "3230000",
        Name: "Republika Srpska",
        
        FCode: "ADM1",
        CountryCode: "BA",
      }
    ],
  },
  {
    id: "732800",
    Name: "Bulgaria",
    States: [
      {
        id: "733192",
        Name: "Oblast Blagoevgrad",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "732771",
        Name: "Oblast Burgas",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "726419",
        Name: "Oblast Dobrich",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "864552",
        Name: "Oblast Gabrovo",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "730436",
        Name: "Oblast Khaskovo",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "864554",
        Name: "Oblast Kyustendil",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "864553",
        Name: "Oblast Kŭrdzhali",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "729560",
        Name: "Oblast Lovech",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "453753",
        Name: "Oblast Montana",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "728379",
        Name: "Oblast Pazardzhik",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "728331",
        Name: "Oblast Pernik",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "728204",
        Name: "Oblast Pleven",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "728194",
        Name: "Oblast Plovdiv",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "453751",
        Name: "Oblast Razgrad",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "727524",
        Name: "Oblast Ruse",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "864555",
        Name: "Oblast Shumen",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "864556",
        Name: "Oblast Silistra",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "864557",
        Name: "Oblast Sliven",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "864558",
        Name: "Oblast Smolyan",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "727012",
        Name: "Oblast Sofiya",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "864559",
        Name: "Oblast Stara Zagora",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "864560",
        Name: "Oblast Tŭrgovishte",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "726051",
        Name: "Oblast Varna",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "864561",
        Name: "Oblast Veliko Tŭrnovo",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "864562",
        Name: "Oblast Vidin",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "725713",
        Name: "Oblast Vratsa",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "864563",
        Name: "Oblast Yambol",
        
        FCode: "ADM1",
        CountryCode: "BG"
      },
      {
        id: "731061",
        Name: "Sofia-Capital",
        
        FCode: "ADM1",
        CountryCode: "BG",
      }
    ],
  },
  {
    id: "3202326",
    Name: "Croatia",
    States: [
      {
        id: "3337511",
        Name: "Bjelovarsko-Bilogorska Županija",
        
        FCode: "ADM1",
        CountryCode: "HR"
      },
      {
        id: "3337512",
        Name: "Brodsko-Posavska Županija",
        
        FCode: "ADM1",
        CountryCode: "HR",
      },
      {
        id: "3337513",
        Name: "Dubrovačko-Neretvanska Županija",
        
        FCode: "ADM1",
        CountryCode: "HR",
      },
      {
        id: "3337532",
        Name: "Grad Zagreb",
        
        FCode: "ADM1",
        CountryCode: "HR"
      },
      {
        id: "3337514",
        Name: "Istarska Županija",
        
        FCode: "ADM1",
        CountryCode: "HR",
      },
      {
        id: "3337515",
        Name: "Karlovačka Županija",
        
        FCode: "ADM1",
        CountryCode: "HR"
      },
      {
        id: "3337518",
        Name: "Koprivničko-Križevačka Županija",
        
        FCode: "ADM1",
        CountryCode: "HR"
      },
      {
        id: "3337519",
        Name: "Krapinsko-Zagorska Županija",
        
        FCode: "ADM1",
        CountryCode: "HR",
      },
      {
        id: "3337520",
        Name: "Ličko-Senjska Županija",
        
        FCode: "ADM1",
        CountryCode: "HR"
      },
      {
        id: "3337521",
        Name: "Međimurska Županija",
        
        FCode: "ADM1",
        CountryCode: "HR"
      },
      {
        id: "3337522",
        Name: "Osječko-Baranjska Županija",
        
        FCode: "ADM1",
        CountryCode: "HR",
      },
      {
        id: "3337523",
        Name: "Požeško-Slavonska Županija",
        
        FCode: "ADM1",
        CountryCode: "HR",
      },
      {
        id: "3337524",
        Name: "Primorsko-Goranska Županija",
        
        FCode: "ADM1",
        CountryCode: "HR",
      },
      {
        id: "3337526",
        Name: "Sisačko-Moslavačka Županija",
        
        FCode: "ADM1",
        CountryCode: "HR",

      },
      {
        id: "3337527",
        Name: "Splitsko-Dalmatinska Županija",
        
        FCode: "ADM1",
        CountryCode: "HR",
      },
      {
        id: "3337528",
        Name: "Varaždinska Županija",
        
        FCode: "ADM1",
        CountryCode: "HR"
      },
      {
        id: "3337533",
        Name: "Virovitičko-Podravska Županija",
        
        FCode: "ADM1",
        CountryCode: "HR"
      },
      {
        id: "3337529",
        Name: "Vukovarsko-Srijemska Županija",
        
        FCode: "ADM1",
        CountryCode: "HR",
      },
      {
        id: "3337530",
        Name: "Zadarska Županija",
        
        FCode: "ADM1",
        CountryCode: "HR"
      },
      {
        id: "3337531",
        Name: "Zagrebačka Županija",
        
        FCode: "ADM1",
        CountryCode: "HR"
      },
      {
        id: "3337525",
        Name: "Šibensko-Kninska Županija",
        
        FCode: "ADM1",
        CountryCode: "HR",
      }
    ],
  },
  {
    id: "146669",
    Name: "Cyprus",
    States: [
      {
        id: "146615",
        Name: "Famagusta District",
        
        FCode: "ADM1",
        CountryCode: "CY"
      },
      {
        id: "146411",
        Name: "Kyrenia District",
        
        FCode: "ADM1",
        CountryCode: "CY"
      },
      {
        id: "146398",
        Name: "Larnaca District",
        
        FCode: "ADM1",
        CountryCode: "CY"
      },
      {
        id: "146383",
        Name: "Limassol District",
        
        FCode: "ADM1",
        CountryCode: "CY"
      },
      {
        id: "146267",
        Name: "Nicosia District",
        
        FCode: "ADM1",
        CountryCode: "CY"
      },
      {
        id: "146213",
        Name: "Paphos District",
        
        FCode: "ADM1",
        CountryCode: "CY"
      }
    ],
  },
  {
    id: "3077311",
    Name: "Czech Republic",
    States: [
      {
        id: "3067695",
        Name: "Hlavní město Praha",
        
        FCode: "ADM1",
        CountryCode: "CZ",
      },
      {
        id: "3339537",
        Name: "Jihočeský Kraj",
        
        FCode: "ADM1",
        CountryCode: "CZ"
      },
      {
        id: "3339539",
        Name: "Karlovarský kraj",
        
        FCode: "ADM1",
        CountryCode: "CZ"
      },
      {
        id: "3339538",
        Name: "Kraj Vysočina",
        
        FCode: "ADM1",
        CountryCode: "CZ"
      },
      {
        id: "3339540",
        Name: "Královéhradecký kraj",
        
        FCode: "ADM1",
        CountryCode: "CZ"
      },
      {
        id: "3339541",
        Name: "Liberecký kraj",
        
        FCode: "ADM1",
        CountryCode: "CZ"
      },
      {
        id: "3339573",
        Name: "Moravskoslezský kraj",
        
        FCode: "ADM1",
        CountryCode: "CZ"
      },
      {
        id: "3339542",
        Name: "Olomoucký kraj",
        
        FCode: "ADM1",
        CountryCode: "CZ"
      },
      {
        id: "3339574",
        Name: "Pardubický kraj",
        
        FCode: "ADM1",
        CountryCode: "CZ"
      },
      {
        id: "3339575",
        Name: "Plzeňský kraj",
        
        FCode: "ADM1",
        CountryCode: "CZ"
      },
      {
        id: "3339536",
        Name: "South Moravian Region",
        
        FCode: "ADM1",
        CountryCode: "CZ",
      },
      {
        id: "3339576",
        Name: "Středočeský kraj",
        
        FCode: "ADM1",
        CountryCode: "CZ"
      },
      {
        id: "3339578",
        Name: "Zlínský kraj",
        
        FCode: "ADM1",
        CountryCode: "CZ"
      },
      {
        id: "3339577",
        Name: "Ústecký kraj",
        
        FCode: "ADM1",
        CountryCode: "CZ"
      }
    ],
  },
  {
    id: "2623032",
    Name: "Denmark",
    States: [
      {
        id: "6418538",
        Name: "Capital Region",
        
        FCode: "ADM1",
        CountryCode: "DK",
      },
      {
        id: "6418539",
        Name: "Central Jutland",
        
        FCode: "ADM1",
        CountryCode: "DK",
      },
      {
        id: "6418540",
        Name: "North Jutland",
        
        FCode: "ADM1",
        CountryCode: "DK",
      },
      {
        id: "6418542",
        Name: "South Denmark",
        
        FCode: "ADM1",
        CountryCode: "DK",
      },
      {
        id: "6418541",
        Name: "Zealand",
        
        FCode: "ADM1",
        CountryCode: "DK",

      }
    ],

  },
  {
    id: "453733",
    Name: "Estonia",
    States: [
      {
        id: "592170",
        Name: "Harjumaa",
        
        FCode: "ADM1",
        CountryCode: "EE"
      },
      {
        id: "592133",
        Name: "Hiiumaa",
        
        FCode: "ADM1",
        CountryCode: "EE"
      },
      {
        id: "592075",
        Name: "Ida-Virumaa",
        
        FCode: "ADM1",
        CountryCode: "EE"
      },
      {
        id: "591961",
        Name: "Järvamaa",
        
        FCode: "ADM1",
        CountryCode: "EE"
      },
      {
        id: "591901",
        Name: "Jõgevamaa",
        
        FCode: "ADM1",
        CountryCode: "EE"
      },
      {
        id: "590854",
        Name: "Lääne-Virumaa",
        
        FCode: "ADM1",
        CountryCode: "EE"
      },
      {
        id: "590856",
        Name: "Läänemaa",
        
        FCode: "ADM1",
        CountryCode: "EE"
      },
      {
        id: "589576",
        Name: "Pärnumaa",
        
        FCode: "ADM1",
        CountryCode: "EE"
      },
      {
        id: "589373",
        Name: "Põlva",
        
        FCode: "ADM1",
        CountryCode: "EE"
      },
      {
        id: "589115",
        Name: "Raplamaa",
        
        FCode: "ADM1",
        CountryCode: "EE"
      },
      {
        id: "588879",
        Name: "Saaremaa",
        
        FCode: "ADM1",
        CountryCode: "EE"
      },
      {
        id: "588334",
        Name: "Tartumaa",
        
        FCode: "ADM1",
        CountryCode: "EE"
      },
      {
        id: "587875",
        Name: "Valgamaa",
        
        FCode: "ADM1",
        CountryCode: "EE"
      },
      {
        id: "587590",
        Name: "Viljandimaa",
        
        FCode: "ADM1",
        CountryCode: "EE"
      },
      {
        id: "587448",
        Name: "Võrumaa",
        
        FCode: "ADM1",
        CountryCode: "EE"
      }
    ],

  },
  {
    id: "2622320",
    Name: "Faroe Islands",
    States: [
      {
        id: "2622387",
        Name: "Eysturoy",
        
        FCode: "ADM1",
        CountryCode: "FO",

      },
      {
        id: "2616145",
        Name: "Norðoyar",
        
        FCode: "ADM1",
        CountryCode: "FO",

      },
      {
        id: "2614219",
        Name: "Sandoy",
        
        FCode: "ADM1",
        CountryCode: "FO",

      },
      {
        id: "2612225",
        Name: "Streymoy",
        
        FCode: "ADM1",
        CountryCode: "FO",

      },
      {
        id: "2612137",
        Name: "Suðuroy",
        
        FCode: "ADM1",
        CountryCode: "FO",

      },
      {
        id: "2610816",
        Name: "Vágar",
        
        FCode: "ADM1",
        CountryCode: "FO",

      }
    ],
  },
  {
    id: "660013",
    Name: "Finland",
    States: [
      {
        id: "660528",
        Name: "Brändö",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "3041809",
        Name: "Eckerö",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "3041799",
        Name: "Finström",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "659951",
        Name: "Föglö",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "3041793",
        Name: "Geta",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "3041777",
        Name: "Hammarland",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "3041761",
        Name: "Jomala",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "650397",
        Name: "Kumlinge",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "651989",
        Name: "Kökar",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "648958",
        Name: "Lapponia",
        
        FCode: "ADM1",
        CountryCode: "FI",

      },
      {
        id: "648384",
        Name: "Lemland",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "647457",
        Name: "Lumparland",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "3041733",
        Name: "Mariehamn",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "643485",
        Name: "Oulu",
        
        FCode: "ADM1",
        CountryCode: "FI",

      },
      {
        id: "828988",
        Name: "Province of Eastern Finland",
        
        FCode: "ADM1",
        CountryCode: "FI",

      },
      {
        id: "828987",
        Name: "Province of Southern Finland",
        
        FCode: "ADM1",
        CountryCode: "FI",

      },
      {
        id: "828989",
        Name: "Province of Western Finland",
        
        FCode: "ADM1",
        CountryCode: "FI",

      },
      {
        id: "637880",
        Name: "Saltvik",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "636159",
        Name: "Sottunga",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "635817",
        Name: "Sund",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "632425",
        Name: "Vårdö",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "6620378",
        Name: "Åland (general)",
        
        FCode: "ADM1",
        CountryCode: "AX"
      }
    ],

  },
  {
    id: "3017382",
    Name: "France",
    States: [
      {
        id: "3038033",
        Name: "Alsace",
        
        FCode: "ADM1",
        CountryCode: "FR",

      },
      {
        id: "3037350",
        Name: "Aquitaine",
        
        FCode: "ADM1",
        CountryCode: "FR",

      },
      {
        id: "3035876",
        Name: "Auvergne",
        
        FCode: "ADM1",
        CountryCode: "FR",
      },
      {
        id: "3034693",
        Name: "Basse-Normandie",
        
        FCode: "ADM1",
        CountryCode: "FR",
      },
      {
        id: "3030967",
        Name: "Bourgogne",
        
        FCode: "ADM1",
        CountryCode: "FR",
      },
      {
        id: "3030293",
        Name: "Brittany",
        
        FCode: "ADM1",
        CountryCode: "FR",
      },
      {
        id: "3027939",
        Name: "Centre",
        
        FCode: "ADM1",
        CountryCode: "FR",
      },
      {
        id: "3027257",
        Name: "Champagne-Ardenne",
        
        FCode: "ADM1",
        CountryCode: "FR",
      },
      {
        id: "3023519",
        Name: "Corsica",
        
        FCode: "ADM1",
        CountryCode: "FR",
      },
      {
        id: "3017372",
        Name: "Franche-Comté",
        
        FCode: "ADM1",
        CountryCode: "FR",
      },
      {
        id: "6690363",
        Name: "Guadeloupe",
        
        FCode: "ADM1",
        CountryCode: "GP",
      },
      {
        id: "6690605",
        Name: "Guyane",
        
        FCode: "ADM1",
        CountryCode: "GF",
      },
      {
        id: "3013756",
        Name: "Haute-Normandie",
        
        FCode: "ADM1",
        CountryCode: "FR",
      },
      {
        id: "3007670",
        Name: "Languedoc-Roussillon",
        
        FCode: "ADM1",
        CountryCode: "FR",
      },
      {
        id: "2998268",
        Name: "Limousin",
        
        FCode: "ADM1",
        CountryCode: "FR",
      },
      {
        id: "2997551",
        Name: "Lorraine",
        
        FCode: "ADM1",
        CountryCode: "FR",
      },
      {
        id: "6690603",
        Name: "Martinique",
        
        FCode: "ADM1",
        CountryCode: "MQ"
      },
      {
        id: "2993955",
        Name: "Midi-Pyrénées",
        
        FCode: "ADM1",
        CountryCode: "FR",
      },
      {
        id: "2990119",
        Name: "Nord-Pas-de-Calais",
        
        FCode: "ADM1",
        CountryCode: "FR",
      },
      {
        id: "2988289",
        Name: "Pays de la Loire",
        
        FCode: "ADM1",
        CountryCode: "FR",
      },
      {
        id: "2987375",
        Name: "Picardie",
        
        FCode: "ADM1",
        CountryCode: "FR",
      },
      {
        id: "2986492",
        Name: "Poitou-Charentes",
        
        FCode: "ADM1",
        CountryCode: "FR",
      },
      {
        id: "2985244",
        Name: "Provence-Alpes-Côte d'Azur",
        
        FCode: "ADM1",
        CountryCode: "FR",
      },
      {
        id: "2983751",
        Name: "Rhône-Alpes",
        
        FCode: "ADM1",
        CountryCode: "FR",
      },
      {
        id: "6690283",
        Name: "Réunion",
        
        FCode: "ADM1",
        CountryCode: "RE"
      },
      {
        id: "3012874",
        Name: "Île-de-France",
        
        FCode: "ADM1",
        CountryCode: "FR",
      }
    ],
  },
  {
    id: "2921044",
    Name: "Germany",
    States: [
      {
        id: "2953481",
        Name: "Baden-Württemberg",
        
        FCode: "ADM1",
        CountryCode: "DE",
      },
      {
        id: "2951839",
        Name: "Bavaria",
        
        FCode: "ADM1",
        CountryCode: "DE",
      },
      {
        id: "2945356",
        Name: "Brandenburg",
        
        FCode: "ADM1",
        CountryCode: "DE",
      },
      {
        id: "2944387",
        Name: "Bremen",
        
        FCode: "ADM1",
        CountryCode: "DE",
      },
      {
        id: "2911297",
        Name: "Hamburg",
        
        FCode: "ADM1",
        CountryCode: "DE",
      },
      {
        id: "2905330",
        Name: "Hesse",
        
        FCode: "ADM1",
        CountryCode: "DE",
      },
      {
        id: "2950157",
        Name: "Land Berlin",
        
        FCode: "ADM1",
        CountryCode: "DE",
      },
      {
        id: "2862926",
        Name: "Lower Saxony",
        
        FCode: "ADM1",
        CountryCode: "DE",
      },
      {
        id: "2872567",
        Name: "Mecklenburg-Vorpommern",
        
        FCode: "ADM1",
        CountryCode: "DE",
      },
      {
        id: "2861876",
        Name: "North Rhine-Westphalia",
        
        FCode: "ADM1",
        CountryCode: "DE",
      },
      {
        id: "2847618",
        Name: "Rheinland-Pfalz",
        
        FCode: "ADM1",
        CountryCode: "DE",
      },
      {
        id: "2842635",
        Name: "Saarland",
        
        FCode: "ADM1",
        CountryCode: "DE",
      },
      {
        id: "2842566",
        Name: "Saxony",
        
        FCode: "ADM1",
        CountryCode: "DE",
      },
      {
        id: "2842565",
        Name: "Saxony-Anhalt",
        
        FCode: "ADM1",
        CountryCode: "DE",
      },
      {
        id: "2838632",
        Name: "Schleswig-Holstein",
        
        FCode: "ADM1",
        CountryCode: "DE",
      },
      {
        id: "2822542",
        Name: "Thuringia",
        
        FCode: "ADM1",
        CountryCode: "DE",
      }
    ],
  },
  {
    id: "2411586",
    Name: "Gibraltar",
    States: [
      {
        id: "2411619",
        Name: "Catalan Bay",
        
        FCode: "PPL",
        CountryCode: "GI"
      },
      {
        id: "2411585",
        Name: "Gibraltar",
        
        FCode: "PPLC",
        CountryCode: "GI",
      }
    ],
  },
  {
    id: "390903",
    Name: "Greece",
    States: [
      {
        id: "6692632",
        Name: "Attica",
        
        FCode: "ADM1",
        CountryCode: "GR",
      },
      {
        id: "6697800",
        Name: "Central Greece",
        
        FCode: "ADM1",
        CountryCode: "GR",
      },
      {
        id: "6697801",
        Name: "Central Macedonia",
        
        FCode: "ADM1",
        CountryCode: "GR",
      },
      {
        id: "6697802",
        Name: "Crete",
        
        FCode: "ADM1",
        CountryCode: "GR",
      },
      {
        id: "6697803",
        Name: "East Macedonia and Thrace",
        
        FCode: "ADM1",
        CountryCode: "GR",
      },
      {
        id: "6697804",
        Name: "Epirus",
        
        FCode: "ADM1",
        CountryCode: "GR",
      },
      {
        id: "6697805",
        Name: "Ionian Islands",
        
        FCode: "ADM1",
        CountryCode: "GR",
      },
      {
        id: "736572",
        Name: "Mount Athos",
        
        FCode: "ADM1",
        CountryCode: "GR",
      },
      {
        id: "6697806",
        Name: "North Aegean",
        
        FCode: "ADM1",
        CountryCode: "GR",
      },
      {
        id: "6697807",
        Name: "Peloponnese",
        
        FCode: "ADM1",
        CountryCode: "GR",
      },
      {
        id: "6697808",
        Name: "South Aegean",
        
        FCode: "ADM1",
        CountryCode: "GR",
      },
      {
        id: "6697809",
        Name: "Thessaly",
        
        FCode: "ADM1",
        CountryCode: "GR",
      },
      {
        id: "6697810",
        Name: "West Greece",
        
        FCode: "ADM1",
        CountryCode: "GR",
      },
      {
        id: "6697811",
        Name: "West Macedonia",
        
        FCode: "ADM1",
        CountryCode: "GR",
      }
    ],
  },
  {
    id: "719819",
    Name: "Hungary",
    States: [
      {
        id: "3055399",
        Name: "Baranya megye",
        
        FCode: "ADM1",
        CountryCode: "HU"
      },
      {
        id: "722064",
        Name: "Borsod-Abaúj-Zemplén",
        
        FCode: "ADM1",
        CountryCode: "HU",
      },
      {
        id: "3054638",
        Name: "Budapest főváros",
        
        FCode: "ADM1",
        CountryCode: "HU"
      },
      {
        id: "3055744",
        Name: "Bács-Kiskun",
        
        FCode: "ADM1",
        CountryCode: "HU",
      },
      {
        id: "722433",
        Name: "Békés megye",
        
        FCode: "ADM1",
        CountryCode: "HU"
      },
      {
        id: "721589",
        Name: "Csongrád megye",
        
        FCode: "ADM1",
        CountryCode: "HU"
      },
      {
        id: "3053028",
        Name: "Fejér",
        
        FCode: "ADM1",
        CountryCode: "HU",
      },
      {
        id: "3051977",
        Name: "Győr-Moson-Sopron",
        
        FCode: "ADM1",
        CountryCode: "HU",
      },
      {
        id: "720293",
        Name: "Hajdú-Bihar",
        
        FCode: "ADM1",
        CountryCode: "HU",
      },
      {
        id: "720002",
        Name: "Heves megye",
        
        FCode: "ADM1",
        CountryCode: "HU"
      },
      {
        id: "719637",
        Name: "Jász-Nagykun-Szolnok",
        
        FCode: "ADM1",
        CountryCode: "HU",
      },
      {
        id: "3049518",
        Name: "Komárom-Esztergom",
        
        FCode: "ADM1",
        CountryCode: "HU",
      },
      {
        id: "3047348",
        Name: "Nógrád megye",
        
        FCode: "ADM1",
        CountryCode: "HU"
      },
      {
        id: "3046431",
        Name: "Pest megye",
        
        FCode: "ADM1",
        CountryCode: "HU"
      },
      {
        id: "3045226",
        Name: "Somogy megye",
        
        FCode: "ADM1",
        CountryCode: "HU"
      },
      {
        id: "715593",
        Name: "Szabolcs-Szatmár-Bereg",
        
        FCode: "ADM1",
        CountryCode: "HU",
      },
      {
        id: "3043845",
        Name: "Tolna megye",
        
        FCode: "ADM1",
        CountryCode: "HU"
      },
      {
        id: "3043047",
        Name: "Vas",
        
        FCode: "ADM1",
        CountryCode: "HU",
      },
      {
        id: "3042925",
        Name: "Veszprém megye",
        
        FCode: "ADM1",
        CountryCode: "HU"
      },
      {
        id: "3042613",
        Name: "Zala",
        
        FCode: "ADM1",
        CountryCode: "HU",
      }
    ],
  },
  {
    id: "2629691",
    Name: "Iceland",
    States: [
      {
        id: "3426182",
        Name: "Capital Region",
        
        FCode: "ADM1",
        CountryCode: "IS",
      },
      {
        id: "3337405",
        Name: "East",
        
        FCode: "ADM1",
        CountryCode: "IS",
      },
      {
        id: "3337404",
        Name: "Northeast",
        
        FCode: "ADM1",
        CountryCode: "IS",
      },
      {
        id: "3337403",
        Name: "Northwest",
        
        FCode: "ADM1",
        CountryCode: "IS",
      },
      {
        id: "3337406",
        Name: "South",
        
        FCode: "ADM1",
        CountryCode: "IS",
      },
      {
        id: "3426183",
        Name: "Southern Peninsula",
        
        FCode: "ADM1",
        CountryCode: "IS",
      },
      {
        id: "3426184",
        Name: "West",
        
        FCode: "ADM1",
        CountryCode: "IS",
      },
      {
        id: "3426185",
        Name: "Westfjords",
        
        FCode: "ADM1",
        CountryCode: "IS",
      }
    ],
  },
  {
    id: "2963597",
    Name: "Ireland",
    States: [
      {
        id: "7521313",
        Name: "Connaught",
        
        FCode: "ADM1",
        CountryCode: "IE"
      },
      {
        id: "7521314",
        Name: "Leinster",
        
        FCode: "ADM1",
        CountryCode: "IE"
      },
      {
        id: "7521315",
        Name: "Munster",
        
        FCode: "ADM1",
        CountryCode: "IE"
      },
      {
        id: "7521316",
        Name: "Ulster",
        
        FCode: "ADM1",
        CountryCode: "IE"
      }
    ],
  },
  {
    id: "3175395",
    Name: "Italy",
    States: [
      {
        id: "3183560",
        Name: "Abruzzo",
        
        FCode: "ADM1",
        CountryCode: "IT",
      },
      {
        id: "3164857",
        Name: "Aosta Valley",
        
        FCode: "ADM1",
        CountryCode: "IT",
      },
      {
        id: "3169778",
        Name: "Apulia",
        
        FCode: "ADM1",
        CountryCode: "IT",
      },
      {
        id: "3182306",
        Name: "Basilicate",
        
        FCode: "ADM1",
        CountryCode: "IT",
      },
      {
        id: "2525468",
        Name: "Calabria",
        
        FCode: "ADM1",
        CountryCode: "IT",
      },
      {
        id: "3181042",
        Name: "Campania",
        
        FCode: "ADM1",
        CountryCode: "IT",
      },
      {
        id: "3177401",
        Name: "Emilia-Romagna",
        
        FCode: "ADM1",
        CountryCode: "IT",
      },
      {
        id: "3176525",
        Name: "Friuli Venezia Giulia",
        
        FCode: "ADM1",
        CountryCode: "IT",
      },
      {
        id: "3174976",
        Name: "Latium",
        
        FCode: "ADM1",
        CountryCode: "IT",
      },
      {
        id: "3174725",
        Name: "Liguria",
        
        FCode: "ADM1",
        CountryCode: "IT",
      },
      {
        id: "3174618",
        Name: "Lombardy",
        
        FCode: "ADM1",
        CountryCode: "IT",
      },
      {
        id: "3173222",
        Name: "Molise",
        
        FCode: "ADM1",
        CountryCode: "IT",
      },
      {
        id: "3170831",
        Name: "Piedmont",
        
        FCode: "ADM1",
        CountryCode: "IT",
      },
      {
        id: "2523228",
        Name: "Sardinia",
        
        FCode: "ADM1",
        CountryCode: "IT",
      },
      {
        id: "2523119",
        Name: "Sicily",
        
        FCode: "ADM1",
        CountryCode: "IT",
      },
      {
        id: "3174004",
        Name: "The Marches",
        
        FCode: "ADM1",
        CountryCode: "IT",
      },
      {
        id: "3165244",
        Name: "Trentino-Alto Adige",
        
        FCode: "ADM1",
        CountryCode: "IT",
      },
      {
        id: "3165361",
        Name: "Tuscany",
        
        FCode: "ADM1",
        CountryCode: "IT",
      },
      {
        id: "3165048",
        Name: "Umbria",
        
        FCode: "ADM1",
        CountryCode: "IT",
      },
      {
        id: "3164604",
        Name: "Veneto",
        
        FCode: "ADM1",
        CountryCode: "IT",
      }
    ],
  },
  {
    id: "831053",
    Name: "Kosovo",
    States: [
      {
        id: "791579",
        Name: "Komuna e Deçanit",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "791121",
        Name: "Komuna e Dragashit",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "790697",
        Name: "Komuna e Drenasit",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "784758",
        Name: "Komuna e Ferizajt",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "791645",
        Name: "Komuna e Gjakovës",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "790673",
        Name: "Komuna e Gjilanit",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "789995",
        Name: "Komuna e Istogut",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "789720",
        Name: "Komuna e Kaçanikut",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "788730",
        Name: "Komuna e Leposaviqit",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "788651",
        Name: "Komuna e Lipjanit",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "831104",
        Name: "Komuna e Malisheves",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "785059",
        Name: "Komuna e Mitrovicës",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "831103",
        Name: "Komuna e Obiliqit",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "787156",
        Name: "Komuna e Pejës",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "786713",
        Name: "Komuna e Prishtinës",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "786711",
        Name: "Komuna e Prizrenit",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "787455",
        Name: "Komuna e Rahovecit",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "831101",
        Name: "Komuna e Shtimes",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "785641",
        Name: "Komuna e Skenderajt",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "785234",
        Name: "Komuna e Thërandës",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "784371",
        Name: "Komuna e Vitisë",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "831105",
        Name: "Komuna e Zubin Potokut",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "789226",
        Name: "Opština Kamenica",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "789453",
        Name: "Opština Klina",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "831099",
        Name: "Opština Kosovo Polje",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "831102",
        Name: "Opština Novo Brdo",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "786949",
        Name: "Opština Podujevo",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "784096",
        Name: "Opština Vučitrn",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "831106",
        Name: "Opština Zvečan",
        
        FCode: "ADM1",
        CountryCode: "XK"
      },
      {
        id: "831100",
        Name: "Opština Štrpce",
        
        FCode: "ADM1",
        CountryCode: "XK"
      }
    ],
  },
  {
    id: "458258",
    Name: "Latvia",
    States: [
      {
        id: "7628345",
        Name: "Aglonas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "461613",
        Name: "Aizkraukles Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628305",
        Name: "Aizputes Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628338",
        Name: "Aknīstes Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628368",
        Name: "Alojas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628299",
        Name: "Alsungas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "461525",
        Name: "Alūksnes Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628375",
        Name: "Amatas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628384",
        Name: "Apes Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628312",
        Name: "Auces Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628318",
        Name: "Babītes Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628324",
        Name: "Baldones Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628349",
        Name: "Baltinavas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "461160",
        Name: "Balvu Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "461112",
        Name: "Bauskas Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628379",
        Name: "Beverīnas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628309",
        Name: "Brocēnu Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628372",
        Name: "Burtnieku Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628326",
        Name: "Carnikavas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628353",
        Name: "Cesvaines Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628346",
        Name: "Ciblas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "460569",
        Name: "Cēsu Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628350",
        Name: "Dagdas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "460414",
        Name: "Daugavpils",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "460410",
        Name: "Daugavpils Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "460311",
        Name: "Dobeles Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628298",
        Name: "Dundagas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628304",
        Name: "Durbes Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628314",
        Name: "Engures Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628328",
        Name: "Garkalnes Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628303",
        Name: "Grobiņas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "459664",
        Name: "Gulbenes Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628321",
        Name: "Iecavas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628358",
        Name: "Ikšķiles Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628339",
        Name: "Ilūkstes Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628360",
        Name: "Inčukalna Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628333",
        Name: "Jaunjelgavas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628381",
        Name: "Jaunpiebalgas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628313",
        Name: "Jaunpils Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "459281",
        Name: "Jelgava",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "459278",
        Name: "Jelgavas Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628337",
        Name: "Jēkabpils",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "459282",
        Name: "Jēkabpils Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "459202",
        Name: "Jūrmala",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628311",
        Name: "Kandavas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628374",
        Name: "Kocēnu Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628357",
        Name: "Kokneses Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628361",
        Name: "Krimuldas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628355",
        Name: "Krustpils Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "458621",
        Name: "Krāslavas Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "458459",
        Name: "Kuldīgas Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628351",
        Name: "Kārsavas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628331",
        Name: "Lielvārdes Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "457955",
        Name: "Liepāja",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "457951",
        Name: "Liepājas Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "457889",
        Name: "Limbažu Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628354",
        Name: "Lubānas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "457773",
        Name: "Ludzas Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628363",
        Name: "Līgatnes Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628341",
        Name: "Līvānu Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "457712",
        Name: "Madonas Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628371",
        Name: "Mazsalacas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628364",
        Name: "Mālpils Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628319",
        Name: "Mārupes Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628369",
        Name: "Naukšēnu Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628334",
        Name: "Neretas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628301",
        Name: "Nīcas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "457061",
        Name: "Ogres Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628320",
        Name: "Olaines Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628316",
        Name: "Ozolnieku Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "456528",
        Name: "Preiļu Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628306",
        Name: "Priekules Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628376",
        Name: "Priekuļu Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628373",
        Name: "Pārgaujas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628300",
        Name: "Pāvilostas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628356",
        Name: "Pļaviņu Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628377",
        Name: "Raunas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628344",
        Name: "Riebiņu Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628310",
        Name: "Rojas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628359",
        Name: "Ropažu Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628302",
        Name: "Rucavas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628352",
        Name: "Rugāju Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628317",
        Name: "Rundāles Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "456203",
        Name: "Rēzekne",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "456197",
        Name: "Rēzeknes Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "456173",
        Name: "Rīga",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "456169",
        Name: "Rīgas Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628370",
        Name: "Rūjienas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628367",
        Name: "Salacgrīvas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628336",
        Name: "Salas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628323",
        Name: "Salaspils Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "455888",
        Name: "Saldus Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628366",
        Name: "Saulkrastu Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628362",
        Name: "Siguldas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628308",
        Name: "Skrundas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628332",
        Name: "Skrīveru Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628380",
        Name: "Smiltenes Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628325",
        Name: "Stopiņu Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628378",
        Name: "Strenču Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628365",
        Name: "Sējas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "454968",
        Name: "Talsu Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "454771",
        Name: "Tukuma Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628315",
        Name: "Tērvetes Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628307",
        Name: "Vaiņodes Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "454571",
        Name: "Valkas Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "454564",
        Name: "Valmieras Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628342",
        Name: "Varakļānu Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628383",
        Name: "Vecpiebalgas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628329",
        Name: "Vecumnieku Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "454311",
        Name: "Ventspils",
        
        FCode: "ADM1",
        CountryCode: "LV",
      },
      {
        id: "454307",
        Name: "Ventspils Rajons",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628335",
        Name: "Viesītes Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628348",
        Name: "Viļakas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628343",
        Name: "Viļānu Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628340",
        Name: "Vārkavas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628347",
        Name: "Zilupes Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628327",
        Name: "Ādažu Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628382",
        Name: "Ērgļu Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628330",
        Name: "Ķeguma Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      },
      {
        id: "7628322",
        Name: "Ķekavas Novads",
        
        FCode: "ADM1",
        CountryCode: "LV"
      }
    ],
  },
  {
    id: "3042058",
    Name: "Liechtenstein",
    States: [
      {
        id: "3042074",
        Name: "Gemeinde Balzers",
        
        FCode: "ADM1",
        CountryCode: "LI"
      },
      {
        id: "3042069",
        Name: "Gemeinde Eschen",
        
        FCode: "ADM1",
        CountryCode: "LI"
      },
      {
        id: "3042063",
        Name: "Gemeinde Gamprin",
        
        FCode: "ADM1",
        CountryCode: "LI"
      },
      {
        id: "3042056",
        Name: "Gemeinde Mauren",
        
        FCode: "ADM1",
        CountryCode: "LI"
      },
      {
        id: "3042050",
        Name: "Gemeinde Planken",
        
        FCode: "ADM1",
        CountryCode: "LI"
      },
      {
        id: "3042047",
        Name: "Gemeinde Ruggell",
        
        FCode: "ADM1",
        CountryCode: "LI"
      },
      {
        id: "3042042",
        Name: "Gemeinde Schaan",
        
        FCode: "ADM1",
        CountryCode: "LI"
      },
      {
        id: "3042038",
        Name: "Gemeinde Schellenberg",
        
        FCode: "ADM1",
        CountryCode: "LI"
      },
      {
        id: "3042036",
        Name: "Gemeinde Triesen",
        
        FCode: "ADM1",
        CountryCode: "LI"
      },
      {
        id: "3042034",
        Name: "Gemeinde Triesenberg",
        
        FCode: "ADM1",
        CountryCode: "LI"
      },
      {
        id: "3042031",
        Name: "Gemeinde Vaduz",
        
        FCode: "ADM1",
        CountryCode: "LI"
      }
    ],
  },
  {
    id: "597427",
    Name: "Lithuania",
    States: [
      {
        id: "864389",
        Name: "Alytaus Apskritis",
        
        FCode: "ADM1",
        CountryCode: "LT"
      },
      {
        id: "864477",
        Name: "Kauno Apskritis",
        
        FCode: "ADM1",
        CountryCode: "LT"
      },
      {
        id: "864478",
        Name: "Klaipėdos Apskritis",
        
        FCode: "ADM1",
        CountryCode: "LT"
      },
      {
        id: "864479",
        Name: "Marijampolės Apskritis",
        
        FCode: "ADM1",
        CountryCode: "LT"
      },
      {
        id: "864480",
        Name: "Panevėžio Apskritis",
        
        FCode: "ADM1",
        CountryCode: "LT"
      },
      {
        id: "864482",
        Name: "Tauragės Apskritis",
        
        FCode: "ADM1",
        CountryCode: "LT"
      },
      {
        id: "864483",
        Name: "Telšių Apskritis",
        
        FCode: "ADM1",
        CountryCode: "LT"
      },
      {
        id: "864484",
        Name: "Utenos Apskritis",
        
        FCode: "ADM1",
        CountryCode: "LT"
      },
      {
        id: "864485",
        Name: "Vilniaus Apskritis",
        
        FCode: "ADM1",
        CountryCode: "LT"
      },
      {
        id: "864481",
        Name: "Šiaulių Apskritis",
        
        FCode: "ADM1",
        CountryCode: "LT"
      }
    ],
  },
  {
    id: "2960313",
    Name: "Luxembourg",
    States: [
      {
        id: "2960655",
        Name: "District de Diekirch",
        
        FCode: "ADM1",
        CountryCode: "LU"
      },
      {
        id: "2960513",
        Name: "District de Grevenmacher",
        
        FCode: "ADM1",
        CountryCode: "LU"
      },
      {
        id: "2960314",
        Name: "District de Luxembourg",
        
        FCode: "ADM1",
        CountryCode: "LU"
      }
    ],
  },
  {
    id: "718075",
    Name: "Macedonia",
    States: [
      {
        id: "863850",
        Name: "Opstina Gjorce Petrov",
        
        FCode: "ADM1",
        CountryCode: "MK",
      },
      {
        id: "863875",
        Name: "Opstina Lipkovo",
        
        FCode: "ADM1",
        CountryCode: "MK",
      },
      {
        id: "863891",
        Name: "Opstina Rankovce",
        
        FCode: "ADM1",
        CountryCode: "MK",
      },
      {
        id: "7056266",
        Name: "Opština Aerodrom",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863831",
        Name: "Opština Aračinovo",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863485",
        Name: "Opština Berovo",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863486",
        Name: "Opština Bitola",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "862950",
        Name: "Opština Bogdanci",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863834",
        Name: "Opština Bogovinje",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "862946",
        Name: "Opština Bosilovo",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863835",
        Name: "Opština Brvenica",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "7056269",
        Name: "Opština Butel",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863840",
        Name: "Opština Centar",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863841",
        Name: "Opština Centar Župa",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863843",
        Name: "Opština Debar",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "7056271",
        Name: "Opština Debarca",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863844",
        Name: "Opština Delčevo",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863846",
        Name: "Opština Demir Hisar",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "862961",
        Name: "Opština Demir Kapija",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "862949",
        Name: "Opština Dojran",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863849",
        Name: "Opština Dolneni",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863851",
        Name: "Opština Drugovo",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863853",
        Name: "Opština Gazi Baba",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863854",
        Name: "Opština Gevgelija",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863855",
        Name: "Opština Gostivar",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "862974",
        Name: "Opština Gradsko",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863856",
        Name: "Opština Ilinden",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863858",
        Name: "Opština Jegunovce",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "862960",
        Name: "Opština Karbinci",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863860",
        Name: "Opština Karpoš",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863861",
        Name: "Opština Kavadarci",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863863",
        Name: "Opština Kisela Voda",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863862",
        Name: "Opština Kičevo",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "862953",
        Name: "Opština Konče",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863865",
        Name: "Opština Kočani",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "789090",
        Name: "Opština Kratovo",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863869",
        Name: "Opština Kriva Palanka",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863870",
        Name: "Opština Krivogaštani",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863871",
        Name: "Opština Kruševo",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863873",
        Name: "Opština Kumanovo",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "862975",
        Name: "Opština Lozovo",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "862956",
        Name: "Opština Makedonska Kamenica",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863877",
        Name: "Opština Makedonski Brod",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863892",
        Name: "Opština Mavrovo i Rostuša",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863488",
        Name: "Opština Mogila",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863881",
        Name: "Opština Negotino",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863468",
        Name: "Opština Novaci",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "862945",
        Name: "Opština Novo Selo",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863883",
        Name: "Opština Ohrid",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863885",
        Name: "Opština Oslomej",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "862938",
        Name: "Opština Pehčevo",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863886",
        Name: "Opština Petrovec",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863887",
        Name: "Opština Plasnica",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863888",
        Name: "Opština Prilep",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863889",
        Name: "Opština Probištip",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863890",
        Name: "Opština Radoviš",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "786339",
        Name: "Opština Resen",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "862973",
        Name: "Opština Rosoman",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863894",
        Name: "Opština Saraj",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863896",
        Name: "Opština Sopište",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863899",
        Name: "Opština Staro Nagoričane",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863901",
        Name: "Opština Struga",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863902",
        Name: "Opština Strumica",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863903",
        Name: "Opština Studeničani",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863905",
        Name: "Opština Sveti Nikole",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863906",
        Name: "Opština Tearce",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863907",
        Name: "Opština Tetovo",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "784732",
        Name: "Opština Valandovo",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "862947",
        Name: "Opština Vasilevo",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863909",
        Name: "Opština Veles",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863911",
        Name: "Opština Vevčani",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863912",
        Name: "Opština Vinica",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863913",
        Name: "Opština Vraneštica",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863914",
        Name: "Opština Vrapčište",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863917",
        Name: "Opština Zajas",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863918",
        Name: "Opština Zelenikovo",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "862958",
        Name: "Opština Zrnovci",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863836",
        Name: "Opština Čair",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863838",
        Name: "Opština Čaška",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "862977",
        Name: "Opština Češinovo",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863842",
        Name: "Opština Čučer-Sandevo",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863900",
        Name: "Opština Štip",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863904",
        Name: "Opština Šuto Orizari",
        
        FCode: "ADM1",
        CountryCode: "MK"
      },
      {
        id: "863919",
        Name: "Opština Želino",
        
        FCode: "ADM1",
        CountryCode: "MK"
      }
    ],
  },
  {
    id: "2562770",
    Name: "Malta",
    States: [
      {
        id: "2563232",
        Name: "Attard",
        
        FCode: "PPL",
        CountryCode: "MT",
      },
      {
        id: "2563217",
        Name: "Balzan",
        
        FCode: "PPL",
        CountryCode: "MT",
      },
      {
        id: "2563230",
        Name: "Baħar iċ-Ċagħaq",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563205",
        Name: "Beżbeżija",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2564765",
        Name: "Bighi",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563197",
        Name: "Binġemma",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563193",
        Name: "Birbuba",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562966",
        Name: "Birgu",
        
        FCode: "PPL",
        CountryCode: "MT",
      },
      {
        id: "2563191",
        Name: "Birkirkara",
        
        FCode: "PPL",
        CountryCode: "MT",
      },
      {
        id: "2563189",
        Name: "Birżebbuġa",
        
        FCode: "PPL",
        CountryCode: "MT",
      },
      {
        id: "2563186",
        Name: "Biskra",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563182",
        Name: "Borġ in-Nadur",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563180",
        Name: "Bubaqra",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563173",
        Name: "Bur Magħtab",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563172",
        Name: "Bur Marrad",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563178",
        Name: "Buġibba",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "7522265",
        Name: "Comino",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563181",
        Name: "Cospicua",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563150",
        Name: "Delimara",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563140",
        Name: "Dingli",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563129",
        Name: "Dwejra",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562955",
        Name: "Floriana",
        
        FCode: "PPL",
        CountryCode: "MT",
      },
      {
        id: "2563020",
        Name: "Gudja",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563088",
        Name: "Għajn Klieb",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563085",
        Name: "Għajn Qajjied",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563079",
        Name: "Għajn Tuffieħa",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563090",
        Name: "Għajn il-Kbira",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563075",
        Name: "Għajn Żejtuna",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563081",
        Name: "Għajnsielem",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563066",
        Name: "Għammar",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563056",
        Name: "Għar Mundu",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563055",
        Name: "Għar Ram",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563063",
        Name: "Għarb",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563062",
        Name: "Għargħur",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563052",
        Name: "Għasri",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563046",
        Name: "Għaxaq",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563044",
        Name: "Għemieri",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562971",
        Name: "Id-Daħar",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562947",
        Name: "Il- Gżira",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562968",
        Name: "Il-Bidni",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562961",
        Name: "Il-Brolli",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562959",
        Name: "Il-Fawwara",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562946",
        Name: "Il-Gżira",
        
        FCode: "PPL",
        CountryCode: "MT",
      },
      {
        id: "2562781",
        Name: "Il-Madliena",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562906",
        Name: "Il-Miżieb",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562904",
        Name: "Il-Palma",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562902",
        Name: "Il-Pergla",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562897",
        Name: "Il-Qajjenza",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562892",
        Name: "Il-Qattara",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563074",
        Name: "Il-Qortin ta’ Għajn Żejtuna",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562881",
        Name: "Il-Wilġa",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562943",
        Name: "Il-Ħammieri",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562941",
        Name: "Il-Ħamrija",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562933",
        Name: "Il-Ħofra",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562877",
        Name: "In-Naħħalija",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562860",
        Name: "Is-Sellum",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562842",
        Name: "Ix-Xagħra ta’ l-Isqof",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562840",
        Name: "Ix-Xgħajriet",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562837",
        Name: "Ix-Xlejli",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562262",
        Name: "Iż-Żebbiegħ",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562831",
        Name: "Kalafrana",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562830",
        Name: "Kalkara",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562816",
        Name: "Kerċem",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562815",
        Name: "Kirkop",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562809",
        Name: "L-Andrijiet",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2565295",
        Name: "L-Aħrax tal-Għajn",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562800",
        Name: "L-Iklin",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562798",
        Name: "L-Imbordin",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562793",
        Name: "L-Iskorvit",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562801",
        Name: "Lija",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562788",
        Name: "Luqa",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562774",
        Name: "Magħtab",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562766",
        Name: "Manikata",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562755",
        Name: "Marsa",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562753",
        Name: "Marsalforn",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562750",
        Name: "Marsaskala",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562247",
        Name: "Marsaxlokk",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562746",
        Name: "Mdina",
        
        FCode: "PPL",
        CountryCode: "MT",
      },
      {
        id: "2562744",
        Name: "Mellieħa",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562713",
        Name: "Misraħ Strejnu",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562712",
        Name: "Misraħ Suffara",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562717",
        Name: "Misraħ Ħlantun",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562707",
        Name: "Miżieb",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562704",
        Name: "Mosta",
        
        FCode: "PPL",
        CountryCode: "MT",
      },
      {
        id: "2562701",
        Name: "Mqabba",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562698",
        Name: "Msida",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562696",
        Name: "Msieraħ",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562694",
        Name: "Mtarfa",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562693",
        Name: "Munxar",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562734",
        Name: "Mġarr",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562735",
        Name: "Mġarr",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562687",
        Name: "Nadur",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562683",
        Name: "Naxxar",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562679",
        Name: "Nigred",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562617",
        Name: "Paola",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562655",
        Name: "Qala",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562641",
        Name: "Qawra",
        
        FCode: "PPLL",
        CountryCode: "MT"
      },
      {
        id: "2562634",
        Name: "Qbajjar",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562629",
        Name: "Qormi",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562622",
        Name: "Qrendi",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562620",
        Name: "Rabat",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562598",
        Name: "Safi",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562553",
        Name: "San Katald",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562552",
        Name: "San Lawrenz",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562551",
        Name: "San Leonardo",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562541",
        Name: "San Pawl il-Baħar",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2567539",
        Name: "San Ġwann",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562545",
        Name: "Sannat",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562528",
        Name: "Santa Luċija",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562515",
        Name: "Santu Pietru",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562514",
        Name: "Santu Rokku",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562792",
        Name: "Senglea",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562504",
        Name: "Siġġiewi",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562501",
        Name: "Sliema",
        
        FCode: "PPL",
        CountryCode: "MT",
      },
      {
        id: "2562557",
        Name: "St. Julian's",
        
        FCode: "PPL",
        CountryCode: "MT",
      },
      {
        id: "2562463",
        Name: "Tad-Dawl",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562429",
        Name: "Tal-Bajjada",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562424",
        Name: "Tal-Barrani",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562421",
        Name: "Tal-Blata",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562420",
        Name: "Tal-Borġ",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562391",
        Name: "Tal-Kittienija",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562388",
        Name: "Tal-Liebru",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562384",
        Name: "Tal-Mejda",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562381",
        Name: "Tal-Merħla",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562380",
        Name: "Tal-Milord",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562378",
        Name: "Tal-Munxar",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562374",
        Name: "Tal-Papa",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562373",
        Name: "Tal-Pitkal",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562369",
        Name: "Tal-Veċċa",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562406",
        Name: "Tal-Ħandaq",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562404",
        Name: "Tal-Ħlas",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562349",
        Name: "Tarxien",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562334",
        Name: "Tas-Salvatur",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562332",
        Name: "Tas-Santi",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562486",
        Name: "Ta’ Bir Miftuħ",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562483",
        Name: "Ta’ Brared",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562362",
        Name: "Ta’ Qali",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562342",
        Name: "Ta’ San Niklaw",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562343",
        Name: "Ta’ San Ġwakkin",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562433",
        Name: "Ta’ l-Abatija",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562398",
        Name: "Ta’ l-Ibraġ",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562474",
        Name: "Ta’ Ċantar",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562447",
        Name: "Ta’ Ħamet",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562443",
        Name: "Ta’ Ħaxxluq",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562305",
        Name: "Valletta",
        
        FCode: "PPLC",
        CountryCode: "MT",
      },
      {
        id: "2562619",
        Name: "Victoria",
        
        FCode: "PPL",
        CountryCode: "MT",
      },
      {
        id: "2562290",
        Name: "Wardija Crossroads",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562288",
        Name: "Wied Fulija",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562287",
        Name: "Wied Għammieq",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562284",
        Name: "Wied l-Arkata",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562280",
        Name: "Xagħra",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562274",
        Name: "Xewkija",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562273",
        Name: "Xgħajra",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "6692380",
        Name: "Xlendi",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562268",
        Name: "Xrobb il-Għaġin",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563031",
        Name: "Ġnien il-Kbir",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2567540",
        Name: "Ħal Far",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563009",
        Name: "Ħal Ġinwi",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2563004",
        Name: "Ħalq Dieri",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562998",
        Name: "Ħamrun",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562989",
        Name: "Ħas-Sajd",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562980",
        Name: "Ħofret ir-Rizz",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562266",
        Name: "Żabbar",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562261",
        Name: "Żebbuġ",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562260",
        Name: "Żebbuġ",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562258",
        Name: "Żejtun",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562254",
        Name: "Żonqor",
        
        FCode: "PPL",
        CountryCode: "MT"
      },
      {
        id: "2562250",
        Name: "Żurrieq",
        
        FCode: "PPL",
        CountryCode: "MT"
      }
    ],
  },
  {
    id: "617790",
    Name: "Moldova",
    States: [
      {
        id: "861487",
        Name: "Municipiul Bender",
        
        FCode: "ADM1",
        CountryCode: "MD"
      },
      {
        id: "873909",
        Name: "Municipiul Bălţi",
        
        FCode: "ADM1",
        CountryCode: "MD"
      },
      {
        id: "618069",
        Name: "Municipiul Chişinău",
        
        FCode: "ADM1",
        CountryCode: "MD"
      },
      {
        id: "617715",
        Name: "Raionul Anenii Noi",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "618565",
        Name: "Raionul Basarabeasca",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "618511",
        Name: "Raionul Briceni",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "618164",
        Name: "Raionul Cahul",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "618142",
        Name: "Raionul Cantemir",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "618430",
        Name: "Raionul Cimişlia",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "617962",
        Name: "Raionul Criuleni",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "618162",
        Name: "Raionul Călăraşi",
        
        FCode: "ADM1",
        CountryCode: "MD"
      },
      {
        id: "618119",
        Name: "Raionul Căuşeni",
        
        FCode: "ADM1",
        CountryCode: "MD"
      },
      {
        id: "618381",
        Name: "Raionul Donduşeni",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "618369",
        Name: "Raionul Drochia",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "618363",
        Name: "Raionul Dubăsari",
        
        FCode: "ADM1",
        CountryCode: "MD"
      },
      {
        id: "617077",
        Name: "Raionul Edineţ",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "618331",
        Name: "Raionul Floreşti",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "618345",
        Name: "Raionul Făleşti",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "618260",
        Name: "Raionul Glodeni",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "858803",
        Name: "Raionul Hînceşti",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "617991",
        Name: "Raionul Ialoveni",
        
        FCode: "ADM1",
        CountryCode: "MD",
        
      },
      {
        id: "617903",
        Name: "Raionul Leova",
        
        FCode: "ADM1",
        CountryCode: "MD",
    
      },
      {
        id: "617754",
        Name: "Raionul Nisporeni",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "617656",
        Name: "Raionul Ocniţa",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "617639",
        Name: "Raionul Orhei",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "617501",
        Name: "Raionul Rezina",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "617483",
        Name: "Raionul Rîşcani",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "617366",
        Name: "Raionul Soroca",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "617301",
        Name: "Raionul Străşeni",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "617913",
        Name: "Raionul Sîngerei",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "617264",
        Name: "Raionul Taraclia",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "617255",
        Name: "Raionul Teleneşti",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "617181",
        Name: "Raionul Ungheni",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "858808",
        Name: "Raionul Şoldăneşti",
        
        FCode: "ADM1",
        CountryCode: "MD",
      },
      {
        id: "617283",
        Name: "Raionul Ştefan Vodă",
        
        FCode: "ADM1",
        CountryCode: "MD"
      },
      {
        id: "858895",
        Name: "Unitate Teritorială Autonomă Găgăuzia",
        
        FCode: "ADM1",
        CountryCode: "MD"
      },
      {
        id: "858889",
        Name: "Unitatea Teritorială din Stînga Nistrului",
        
        FCode: "ADM1",
        CountryCode: "MD"
      }
    ],
  },
  {
    id: "3194884",
    Name: "Montenegro",
    States: [
      {
        id: "3343959",
        Name: "Opština Andrijevica",
        
        FCode: "ADM1",
        CountryCode: "ME"
      },
      {
        id: "3204508",
        Name: "Opština Bar",
        
        FCode: "ADM1",
        CountryCode: "ME"
      },
      {
        id: "3199070",
        Name: "Opština Berane",
        
        FCode: "ADM1",
        CountryCode: "ME"
      },
      {
        id: "3204173",
        Name: "Opština Bijelo Polje",
        
        FCode: "ADM1",
        CountryCode: "ME"
      },
      {
        id: "3203104",
        Name: "Opština Budva",
        
        FCode: "ADM1",
        CountryCode: "ME"
      },
      {
        id: "3202640",
        Name: "Opština Cetinje",
        
        FCode: "ADM1",
        CountryCode: "ME"
      },
      {
        id: "3202193",
        Name: "Opština Danilovgrad",
        
        FCode: "ADM1",
        CountryCode: "ME"
      },
      {
        id: "3199393",
        Name: "Opština Herceg Novi",
        
        FCode: "ADM1",
        CountryCode: "ME"
      },
      {
        id: "3197895",
        Name: "Opština Kolašin",
        
        FCode: "ADM1",
        CountryCode: "ME"
      },
      {
        id: "3197537",
        Name: "Opština Kotor",
        
        FCode: "ADM1",
        CountryCode: "ME"
      },
      {
        id: "3194925",
        Name: "Opština Mojkovac",
        
        FCode: "ADM1",
        CountryCode: "ME"
      },
      {
        id: "3194493",
        Name: "Opština Nikšić",
        
        FCode: "ADM1",
        CountryCode: "ME"
      },
      {
        id: "3193227",
        Name: "Opština Plav",
        
        FCode: "ADM1",
        CountryCode: "ME"
      },
      {
        id: "3193160",
        Name: "Opština Pljevlja",
        
        FCode: "ADM1",
        CountryCode: "ME"
      },
      {
        id: "3193129",
        Name: "Opština Plužine",
        
        FCode: "ADM1",
        CountryCode: "ME"
      },
      {
        id: "3189077",
        Name: "Opština Podgorica",
        
        FCode: "ADM1",
        CountryCode: "ME"
      },
      {
        id: "786233",
        Name: "Opština Rožaje",
        
        FCode: "ADM1",
        CountryCode: "ME"
      },
      {
        id: "3189071",
        Name: "Opština Tivat",
        
        FCode: "ADM1",
        CountryCode: "ME"
      },
      {
        id: "3188514",
        Name: "Opština Ulcinj",
        
        FCode: "ADM1",
        CountryCode: "ME"
      },
      {
        id: "3191221",
        Name: "Opština Šavnik",
        
        FCode: "ADM1",
        CountryCode: "ME"
      },
      {
        id: "3186995",
        Name: "Opština Žabljak",
        
        FCode: "ADM1",
        CountryCode: "ME"
      }
    ],
  },
  {
    id: "2750405",
    Name: "Netherlands",
    States: [
      {
        id: "2755812",
        Name: "Friesland",
        
        FCode: "ADM1",
        CountryCode: "NL",
      },
      {
        id: "2755249",
        Name: "Groningen",
        
        FCode: "ADM1",
        CountryCode: "NL",
      },
      {
        id: "2749990",
        Name: "North Brabant",
        
        FCode: "ADM1",
        CountryCode: "NL",
      },
      {
        id: "2749879",
        Name: "North Holland",
        
        FCode: "ADM1",
        CountryCode: "NL",
      },
      {
        id: "2756631",
        Name: "Provincie Drenthe",
        
        FCode: "ADM1",
        CountryCode: "NL",
      },
      {
        id: "3319179",
        Name: "Provincie Flevoland",
        
        FCode: "ADM1",
        CountryCode: "NL",
      },
      {
        id: "2755634",
        Name: "Provincie Gelderland",
        
        FCode: "ADM1",
        CountryCode: "NL",
      },
      {
        id: "2751596",
        Name: "Provincie Limburg",
        
        FCode: "ADM1",
        CountryCode: "NL",
      },
      {
        id: "2748838",
        Name: "Provincie Overijssel",
        
        FCode: "ADM1",
        CountryCode: "NL"
      },
      {
        id: "2745909",
        Name: "Provincie Utrecht",
        
        FCode: "ADM1",
        CountryCode: "NL"
      },
      {
        id: "2744011",
        Name: "Provincie Zeeland",
        
        FCode: "ADM1",
        CountryCode: "NL",
      },
      {
        id: "2743698",
        Name: "South Holland",
        
        FCode: "ADM1",
        CountryCode: "NL",
      }
    ],

  },
  {
    id: "3144096",
    Name: "Norway",
    States: [
      {
        id: "3163480",
        Name: "Akershus county",
        
        FCode: "ADM1",
        CountryCode: "NO",
      },
      {
        id: "3162354",
        Name: "Aust-Agder county",
        
        FCode: "ADM1",
        CountryCode: "NO",
      },
      {
        id: "3159665",
        Name: "Buskerud county",
        
        FCode: "ADM1",
        CountryCode: "NO",
      },
      {
        id: "780166",
        Name: "Finnmark Fylke",
        
        FCode: "ADM1",
        CountryCode: "NO"
      },
      {
        id: "3153403",
        Name: "Hedmark county",
        
        FCode: "ADM1",
        CountryCode: "NO",
      },
      {
        id: "3151864",
        Name: "Hordaland Fylke",
        
        FCode: "ADM1",
        CountryCode: "NO"
      },
      {
        id: "3145495",
        Name: "Møre og Romsdal fylke",
        
        FCode: "ADM1",
        CountryCode: "NO"
      },
      {
        id: "3144148",
        Name: "Nord-Trøndelag Fylke",
        
        FCode: "ADM1",
        CountryCode: "NO"
      },
      {
        id: "3144301",
        Name: "Nordland Fylke",
        
        FCode: "ADM1",
        CountryCode: "NO"
      },
      {
        id: "3143487",
        Name: "Oppland county",
        
        FCode: "ADM1",
        CountryCode: "NO",
      },
      {
        id: "3143242",
        Name: "Oslo",
        
        FCode: "ADM1",
        CountryCode: "NO",
      },
      {
        id: "3141558",
        Name: "Rogaland Fylke",
        
        FCode: "ADM1",
        CountryCode: "NO"
      },
      {
        id: "3137966",
        Name: "Sogn og Fjordane Fylke",
        
        FCode: "ADM1",
        CountryCode: "NO"
      },
      {
        id: "3137400",
        Name: "Sør-Trøndelag Fylke",
        
        FCode: "ADM1",
        CountryCode: "NO"
      },
      {
        id: "3134723",
        Name: "Telemark county",
        
        FCode: "ADM1",
        CountryCode: "NO",
      },
      {
        id: "3133897",
        Name: "Troms Fylke",
        
        FCode: "ADM1",
        CountryCode: "NO"
      },
      {
        id: "3132064",
        Name: "Vest-Agder Fylke",
        
        FCode: "ADM1",
        CountryCode: "NO"
      },
      {
        id: "3132015",
        Name: "Vestfold county",
        
        FCode: "ADM1",
        CountryCode: "NO",
      },
      {
        id: "3143188",
        Name: "Østfold county",
        
        FCode: "ADM1",
        CountryCode: "NO",
      }
    ],

  },
  {
    id: "798544",
    Name: "Poland",
    States: [
      {
        id: "3337498",
        Name: "Greater Poland Voivodeship",
        
        FCode: "ADM1",
        CountryCode: "PL",
      },
      {
        id: "3337500",
        Name: "Kujawsko-Pomorskie",
        
        FCode: "ADM1",
        CountryCode: "PL",
      },
      {
        id: "858786",
        Name: "Lesser Poland Voivodeship",
        
        FCode: "ADM1",
        CountryCode: "PL",
      },
      {
        id: "3337492",
        Name: "Lower Silesian Voivodeship",
        
        FCode: "ADM1",
        CountryCode: "PL",
      },
      {
        id: "858785",
        Name: "Lublin Voivodeship",
        
        FCode: "ADM1",
        CountryCode: "PL",
      },
      {
        id: "3337494",
        Name: "Lubusz",
        
        FCode: "ADM1",
        CountryCode: "PL",
      },
      {
        id: "858787",
        Name: "Masovian Voivodeship",
        
        FCode: "ADM1",
        CountryCode: "PL",
      },
      {
        id: "3337495",
        Name: "Opole Voivodeship",
        
        FCode: "ADM1",
        CountryCode: "PL",
      },
      {
        id: "858789",
        Name: "Podlasie",
        
        FCode: "ADM1",
        CountryCode: "PL",
      },
      {
        id: "3337496",
        Name: "Pomeranian Voivodeship",
        
        FCode: "ADM1",
        CountryCode: "PL",
      },
      {
        id: "3337497",
        Name: "Silesian Voivodeship",
        
        FCode: "ADM1",
        CountryCode: "PL",
      },
      {
        id: "858788",
        Name: "Subcarpathian Voivodeship",
        
        FCode: "ADM1",
        CountryCode: "PL",
      },
      {
        id: "858791",
        Name: "Warmian-Masurian Voivodeship",
        
        FCode: "ADM1",
        CountryCode: "PL",
      },
      {
        id: "3337499",
        Name: "West Pomeranian Voivodeship",
        
        FCode: "ADM1",
        CountryCode: "PL",
      },
      {
        id: "3337493",
        Name: "Łódź Voivodeship",
        
        FCode: "ADM1",
        CountryCode: "PL",
      },
      {
        id: "858790",
        Name: "Świętokrzyskie",
        
        FCode: "ADM1",
        CountryCode: "PL",
      }
    ],
  },
  {
    id: "2264397",
    Name: "Portugal",
    States: [
      {
        id: "2742610",
        Name: "Aveiro",
        
        FCode: "ADM1",
        CountryCode: "PT",
      },
      {
        id: "2742026",
        Name: "Bragança",
        
        FCode: "ADM1",
        CountryCode: "PT",
      },
      {
        id: "2738782",
        Name: "Distrito da Guarda",
        
        FCode: "ADM1",
        CountryCode: "PT",
      },
      {
        id: "2270984",
        Name: "Distrito de Beja",
        
        FCode: "ADM1",
        CountryCode: "PT",
      },
      {
        id: "2742031",
        Name: "Distrito de Braga",
        
        FCode: "ADM1",
        CountryCode: "PT",
      },
      {
        id: "2269513",
        Name: "Distrito de Castelo Branco",
        
        FCode: "ADM1",
        CountryCode: "PT",
      },
      {
        id: "2740636",
        Name: "Distrito de Coimbra",
        
        FCode: "ADM1",
        CountryCode: "PT",
      },
      {
        id: "2268337",
        Name: "Distrito de Faro",
        
        FCode: "ADM1",
        CountryCode: "PT",
      },
      {
        id: "2267094",
        Name: "Distrito de Leiria",
        
        FCode: "ADM1",
        CountryCode: "PT",
      },
      {
        id: "2264507",
        Name: "Distrito de Portalegre",
        
        FCode: "ADM1",
        CountryCode: "PT",
      },
      {
        id: "2263478",
        Name: "Distrito de Santarém",
        
        FCode: "ADM1",
        CountryCode: "PT",
      },
      {
        id: "2262961",
        Name: "Distrito de Setúbal",
        
        FCode: "ADM1",
        CountryCode: "PT",
      },
      {
        id: "2732772",
        Name: "Distrito de Viana do Castelo",
        
        FCode: "ADM1",
        CountryCode: "PT",
      },
      {
        id: "2732437",
        Name: "Distrito de Vila Real",
        
        FCode: "ADM1",
        CountryCode: "PT",
      },
      {
        id: "2732264",
        Name: "Distrito de Viseu",
        
        FCode: "ADM1",
        CountryCode: "PT",
      },
      {
        id: "2268404",
        Name: "Distrito de Évora",
        
        FCode: "ADM1",
        CountryCode: "PT",
      },
      {
        id: "2735941",
        Name: "Distrito do Porto",
        
        FCode: "ADM1",
        CountryCode: "PT",
      },
      {
        id: "2267056",
        Name: "Lisbon",
        
        FCode: "ADM1",
        CountryCode: "PT",
      },
      {
        id: "2593105",
        Name: "Região Autónoma da Madeira",
        
        FCode: "ADM1",
        CountryCode: "PT",
      },
      {
        id: "3411865",
        Name: "Região Autónoma dos Açores",
        
        FCode: "ADM1",
        CountryCode: "PT",
      }
    ],
  },
  {
    id: "798549",
    Name: "Romania",
    States: [
      {
        id: "683504",
        Name: "Bucureşti",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "686581",
        Name: "Judeţul Alba",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "686253",
        Name: "Judeţul Arad",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "686192",
        Name: "Judeţul Argeş",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "685947",
        Name: "Judeţul Bacău",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "684878",
        Name: "Judeţul Bihor",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "684647",
        Name: "Judeţul Bistriţa-Năsăud",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "684038",
        Name: "Judeţul Botoşani",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "683843",
        Name: "Judeţul Braşov",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "683901",
        Name: "Judeţul Brăila",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "683121",
        Name: "Judeţul Buzău",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "682714",
        Name: "Judeţul Caraş-Severin",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "681291",
        Name: "Judeţul Cluj",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "680962",
        Name: "Judeţul Constanţa",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "680428",
        Name: "Judeţul Covasna",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "683016",
        Name: "Judeţul Călăraşi",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "679134",
        Name: "Judeţul Dolj",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "679385",
        Name: "Judeţul Dâmboviţa",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "677692",
        Name: "Judeţul Galaţi",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "677104",
        Name: "Judeţul Giurgiu",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "676898",
        Name: "Judeţul Gorj",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "676309",
        Name: "Judeţul Harghita",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "675917",
        Name: "Judeţul Hunedoara",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "675848",
        Name: "Judeţul Ialomiţa",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "675809",
        Name: "Judeţul Iaşi",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "865518",
        Name: "Judeţul Ilfov",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "673612",
        Name: "Judeţul Mehedinţi",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "672628",
        Name: "Judeţul Mureş",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "672460",
        Name: "Judeţul Neamţ",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "671857",
        Name: "Judeţul Olt",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "669737",
        Name: "Judeţul Prahova",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "667869",
        Name: "Judeţul Satu Mare",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "667267",
        Name: "Judeţul Sibiu",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "668248",
        Name: "Judeţul Sălaj",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "665283",
        Name: "Judeţul Teleorman",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "665091",
        Name: "Judeţul Timiş",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "664517",
        Name: "Judeţul Tulcea",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "663116",
        Name: "Judeţul Vaslui",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "662447",
        Name: "Judeţul Vrancea",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "662892",
        Name: "Judeţul Vâlcea",
        
        FCode: "ADM1",
        CountryCode: "RO"
      },
      {
        id: "673887",
        Name: "Maramureş",
        
        FCode: "ADM1",
        CountryCode: "RO",
      },
      {
        id: "665849",
        Name: "Suceava",
        
        FCode: "ADM1",
        CountryCode: "RO",
      }
    ],
  },
  {
    id: "2017370",
    Name: "Russia",
    States: [
      {
        id: "1511732",
        Name: "Altayskiy Kray",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "2027748",
        Name: "Amurskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "581043",
        Name: "Arkhangelskaya",
        
        FCode: "ADM1",
        CountryCode: "RU",
      },
      {
        id: "580491",
        Name: "Astrakhanskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "578071",
        Name: "Belgorodskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "571473",
        Name: "Bryanskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "569665",
        Name: "Chechnya",
        
        FCode: "ADM1",
        CountryCode: "RU",
      },
      {
        id: "1508290",
        Name: "Chelyabinsk Oblast",
        
        FCode: "ADM1",
        CountryCode: "RU",
      },
      {
        id: "2126099",
        Name: "Chukotskiy Avtonomnyy Okrug",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "567395",
        Name: "Chuvashia",
        
        FCode: "ADM1",
        CountryCode: "RU",
      },
      {
        id: "567293",
        Name: "Dagestan",
        
        FCode: "ADM1",
        CountryCode: "RU",
      },
      {
        id: "2023468",
        Name: "Irkutskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "555235",
        Name: "Ivanovskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "2026639",
        Name: "Jewish Autonomous Oblast",
        
        FCode: "ADM1",
        CountryCode: "RU",
      },
      {
        id: "554667",
        Name: "Kabardino-Balkarskaya Respublika",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "554230",
        Name: "Kaliningradskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "553899",
        Name: "Kaluzhskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "2125072",
        Name: "Kamtchatski Kray",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "552927",
        Name: "Karachayevo-Cherkesskaya Respublika",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "1503900",
        Name: "Kemerovskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "2022888",
        Name: "Khabarovsk Krai",
        
        FCode: "ADM1",
        CountryCode: "RU",
      },
      {
        id: "1503773",
        Name: "Khanty-Mansiyskiy Avtonomnyy Okrug",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "548389",
        Name: "Kirovskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "543871",
        Name: "Kostromskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "542415",
        Name: "Krasnodarskiy Kray",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "1502020",
        Name: "Krasnoyarskiy Kray",
        
        FCode: "ADM1",
        CountryCode: "RU",
      },
      {
        id: "1501312",
        Name: "Kurganskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "538555",
        Name: "Kurskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "536199",
        Name: "Leningrad",
        
        FCode: "ADM1",
        CountryCode: "RU",
      },
      {
        id: "535120",
        Name: "Lipetskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "2123627",
        Name: "Magadanskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "524894",
        Name: "Moscow",
        
        FCode: "ADM1",
        CountryCode: "RU",
      },
      {
        id: "524925",
        Name: "Moskovskaya",
        
        FCode: "ADM1",
        CountryCode: "RU",
      },
      {
        id: "524304",
        Name: "Murmansk",
        
        FCode: "ADM1",
        CountryCode: "RU",
      },
      {
        id: "522652",
        Name: "Nenetskiy Avtonomnyy Okrug",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "559838",
        Name: "Nizhegorodskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "519969",
        Name: "North Ossetia",
        
        FCode: "ADM1",
        CountryCode: "RU",
      },
      {
        id: "519324",
        Name: "Novgorodskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "1496745",
        Name: "Novosibirskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "1496152",
        Name: "Omskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "515001",
        Name: "Orenburgskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "514801",
        Name: "Orlovskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "511555",
        Name: "Penzenskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "511180",
        Name: "Perm Krai",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "2017623",
        Name: "Primorskiy Kray",
        
        FCode: "ADM1",
        CountryCode: "RU",
      },
      {
        id: "504338",
        Name: "Pskovskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "584222",
        Name: "Respublika Adygeya",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "1506272",
        Name: "Respublika Altay",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "578853",
        Name: "Respublika Bashkortostan",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "2050915",
        Name: "Respublika Buryatiya",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "556349",
        Name: "Respublika Ingushetiya",
        
        FCode: "ADM1",
        CountryCode: "RU",
      },
      {
        id: "553972",
        Name: "Respublika Kalmykiya",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "552548",
        Name: "Respublika Kareliya",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "1503834",
        Name: "Respublika Khakasiya",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "545854",
        Name: "Respublika Komi",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "529352",
        Name: "Respublika Mariy-El",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "525369",
        Name: "Respublika Mordoviya",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "2013162",
        Name: "Respublika Sakha (Yakutiya)",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "484048",
        Name: "Respublika Tatarstan",
        
        FCode: "ADM1",
        CountryCode: "RU",
      },
      {
        id: "1488873",
        Name: "Respublika Tyva",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "501165",
        Name: "Rostovskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "500059",
        Name: "Ryazanskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "2121529",
        Name: "Sakhalinskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU",
      },
      {
        id: "499068",
        Name: "Samarskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "536203",
        Name: "Sankt-Peterburg",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "498671",
        Name: "Saratovskaya Oblast'",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "491684",
        Name: "Smolenskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "487839",
        Name: "Stavropol’skiy Kray",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "1490542",
        Name: "Sverdlovskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "484638",
        Name: "Tambovskaya Oblast'",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "1489421",
        Name: "Tomskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "480508",
        Name: "Tul'skaya Oblast'",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "480041",
        Name: "Tverskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "1488747",
        Name: "Tyumenskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU",
      },
      {
        id: "479613",
        Name: "Udmurtskaya Respublika",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "479119",
        Name: "Ul’yanovskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "826294",
        Name: "Vladimirskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "472755",
        Name: "Volgogradskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "472454",
        Name: "Vologodskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "472039",
        Name: "Voronezhskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "1486462",
        Name: "Yamalo-Nenetskiy Avtonomnyy Okrug",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "468898",
        Name: "Yaroslavskaya Oblast’",
        
        FCode: "ADM1",
        CountryCode: "RU"
      },
      {
        id: "7779061",
        Name: "Zabaykal’skiy Kray",
        
        FCode: "ADM1",
        CountryCode: "RU"
      }
    ],
  },
  {
    id: "3168068",
    Name: "San Marino",
    States: [
      {
        id: "3345303",
        Name: "Castello di Acquaviva",
        
        FCode: "ADM1",
        CountryCode: "SM"
      },
      {
        id: "3345304",
        Name: "Castello di Borgo Maggiore",
        
        FCode: "ADM1",
        CountryCode: "SM"
      },
      {
        id: "3345305",
        Name: "Castello di Domagnano",
        
        FCode: "ADM1",
        CountryCode: "SM"
      },
      {
        id: "3345306",
        Name: "Castello di Faetano",
        
        FCode: "ADM1",
        CountryCode: "SM"
      },
      {
        id: "3345307",
        Name: "Castello di Fiorentino",
        
        FCode: "ADM1",
        CountryCode: "SM"
      },
      {
        id: "3345308",
        Name: "Castello di Montegiardino",
        
        FCode: "ADM1",
        CountryCode: "SM"
      },
      {
        id: "3345302",
        Name: "Castello di San Marino Città",
        
        FCode: "ADM1",
        CountryCode: "SM"
      },
      {
        id: "3166650",
        Name: "Castello di Serravalle",
        
        FCode: "ADM1",
        CountryCode: "SM"
      },
      {
        id: "3178807",
        Name: "Chiesanuova",
        
        FCode: "ADM1",
        CountryCode: "SM",
      }
    ],
  },
  {
    id: "6290252",
    Name: "Serbia",
    States: [
      {
        id: "784272",
        Name: "Autonomna Pokrajina Vojvodina",
        
        FCode: "ADM1",
        CountryCode: "RS"
      },
      {
        id: "785958",
        Name: "Central Serbia",
        
        FCode: "ADM1",
        CountryCode: "RS"
      }
    ],
  },
  {
    id: "3057568",
    Name: "Slovakia",
    States: [
      {
        id: "3343954",
        Name: "Banskobystrický Kraj",
        
        FCode: "ADM1",
        CountryCode: "SK"
      },
      {
        id: "3343955",
        Name: "Bratislavský Kraj",
        
        FCode: "ADM1",
        CountryCode: "SK"
      },
      {
        id: "865084",
        Name: "Košický Kraj",
        
        FCode: "ADM1",
        CountryCode: "SK"
      },
      {
        id: "3343956",
        Name: "Nitriansky Kraj",
        
        FCode: "ADM1",
        CountryCode: "SK"
      },
      {
        id: "865085",
        Name: "Prešovský Kraj",
        
        FCode: "ADM1",
        CountryCode: "SK"
      },
      {
        id: "3343957",
        Name: "Trenčiansky Kraj",
        
        FCode: "ADM1",
        CountryCode: "SK"
      },
      {
        id: "3343958",
        Name: "Trnavský Kraj",
        
        FCode: "ADM1",
        CountryCode: "SK"
      },
      {
        id: "3056506",
        Name: "Žilinský Kraj",
        
        FCode: "ADM1",
        CountryCode: "SK"
      }
    ],
  },
  {
    id: "3190538",
    Name: "Slovenia",
    States: [
      {
        id: "3239101",
        Name: "Bohinj",
        
        FCode: "ADM1",
        CountryCode: "SI",
      },
      {
        id: "3199016",
        Name: "Comune di Isola",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3193340",
        Name: "Comune di Pirano",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239318",
        Name: "Ljubljana",
        
        FCode: "ADM1",
        CountryCode: "SI",
      },
      {
        id: "3202780",
        Name: "Mestna Občina Celje",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3197752",
        Name: "Mestna Občina Koper",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3197377",
        Name: "Mestna Občina Kranj",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3195505",
        Name: "Mestna Občina Maribor",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3194647",
        Name: "Mestna Občina Murska Sobota",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3194451",
        Name: "Mestna Občina Nova Gorica",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3194350",
        Name: "Mestna Občina Novo mesto",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3192240",
        Name: "Mestna Občina Ptuj",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3190535",
        Name: "Mestna Občina Slovenj Gradec",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3189074",
        Name: "Mestna Občina Velenje",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3204853",
        Name: "Občina Ajdovščina",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "8133579",
        Name: "Občina Apače",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239282",
        Name: "Občina Beltinci",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344930",
        Name: "Občina Benedikt",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344912",
        Name: "Občina Bistrica ob Sotli",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239103",
        Name: "Občina Bled",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344899",
        Name: "Občina Bloke",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239073",
        Name: "Občina Borovnica",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239100",
        Name: "Občina Bovec",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344905",
        Name: "Občina Braslovče",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239083",
        Name: "Občina Brda",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239071",
        Name: "Občina Brezovica",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3203411",
        Name: "Občina Brežice",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344938",
        Name: "Občina Cankova",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239110",
        Name: "Občina Cerklje na Gorenjskem",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3202707",
        Name: "Občina Cerknica",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239091",
        Name: "Občina Cerkno",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344929",
        Name: "Občina Cerkvenjak",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "8133580",
        Name: "Občina Cirkulane",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344926",
        Name: "Občina Destrnik",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239051",
        Name: "Občina Divača",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344913",
        Name: "Občina Dobje",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239193",
        Name: "Občina Dobrepolje",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344914",
        Name: "Občina Dobrna",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239096",
        Name: "Občina Dobrova-Polhov Gradec",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344936",
        Name: "Občina Dobrovnik",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239115",
        Name: "Občina Dol pri Ljubljani",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344910",
        Name: "Občina Dolenjske Toplice",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3201729",
        Name: "Občina Domžale",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239248",
        Name: "Občina Dornava",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3201252",
        Name: "Občina Dravograd",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239216",
        Name: "Občina Duplek",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239095",
        Name: "Občina Gorenja Vas-Poljane",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239245",
        Name: "Občina Gorišnica",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3200196",
        Name: "Občina Gornja Radgona",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239133",
        Name: "Občina Gornji Grad",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239275",
        Name: "Občina Gornji Petrovci",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344939",
        Name: "Občina Grad",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3199522",
        Name: "Občina Grosuplje",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344922",
        Name: "Občina Hajdina",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344940",
        Name: "Občina Hodoš",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344897",
        Name: "Občina Horjul",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344920",
        Name: "Občina Hoče-Slivnica",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3199296",
        Name: "Občina Hrastnik",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239050",
        Name: "Občina Hrpelje-Kozina",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3199169",
        Name: "Občina Idrija",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239069",
        Name: "Občina Ig",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3199130",
        Name: "Občina Ilirska Bistrica",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239191",
        Name: "Občina Ivančna Gorica",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3198646",
        Name: "Občina Jesenice",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344894",
        Name: "Občina Jezersko",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239251",
        Name: "Občina Juršinci",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3198364",
        Name: "Občina Kamnik",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239086",
        Name: "Občina Kanal",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239227",
        Name: "Občina Kidričevo",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239098",
        Name: "Občina Kobarid",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239280",
        Name: "Občina Kobilje",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239078",
        Name: "Občina Komen",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344896",
        Name: "Občina Komenda",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "8133581",
        Name: "Občina Kostanjevica na Krki",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344908",
        Name: "Občina Kostel",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239243",
        Name: "Občina Kozje",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3197942",
        Name: "Občina Kočevje",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239105",
        Name: "Občina Kranjska Gora",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344932",
        Name: "Občina Križevci",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3197146",
        Name: "Občina Krško",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239213",
        Name: "Občina Kungota",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239272",
        Name: "Občina Kuzma",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3196759",
        Name: "Občina Laško",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3196684",
        Name: "Občina Lenart",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344935",
        Name: "Občina Lendava",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3196424",
        Name: "Občina Litija",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239184",
        Name: "Občina Ljubno",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3196306",
        Name: "Občina Ljutomer",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "8133582",
        Name: "Občina Log-Dragomer",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3196288",
        Name: "Občina Logatec",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344918",
        Name: "Občina Lovrenc na Pohorju",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239056",
        Name: "Občina Loška Dolina",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239059",
        Name: "Občina Loški Potok",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239188",
        Name: "Občina Lukovica",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239134",
        Name: "Občina Luče",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239229",
        Name: "Občina Majšperk",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "8133583",
        Name: "Občina Makole",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344925",
        Name: "Občina Markovci",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239113",
        Name: "Občina Medvode",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239114",
        Name: "Občina Mengeš",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3195213",
        Name: "Občina Metlika",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239177",
        Name: "Občina Mežica",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344921",
        Name: "Občina Miklavž na Dravskem Polju",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239080",
        Name: "Občina Miren-Kostanjevica",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344911",
        Name: "Občina Mirna Peč",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239207",
        Name: "Občina Mislinja",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "8133584",
        Name: "Občina Mokronog-Trebelno",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239279",
        Name: "Občina Moravske Toplice",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239132",
        Name: "Občina Moravče",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3194791",
        Name: "Občina Mozirje",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239179",
        Name: "Občina Muta",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239104",
        Name: "Občina Naklo",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239294",
        Name: "Občina Nazarje",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239285",
        Name: "Občina Odranci",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344915",
        Name: "Občina Oplotnica",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3193964",
        Name: "Občina Ormož",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239061",
        Name: "Občina Osilnica",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239215",
        Name: "Občina Pesnica",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239054",
        Name: "Občina Pivka",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344924",
        Name: "Občina Podlehnik",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344916",
        Name: "Občina Podvelka",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239241",
        Name: "Občina Podčetrtek",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "8133585",
        Name: "Občina Poljčane",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344906",
        Name: "Občina Polzela",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3192672",
        Name: "Občina Postojna",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344907",
        Name: "Občina Prebold",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239107",
        Name: "Občina Preddvor",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344902",
        Name: "Občina Prevalje",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239268",
        Name: "Občina Puconci",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239262",
        Name: "Občina Radenci",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239189",
        Name: "Občina Radeče",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3192120",
        Name: "Občina Radlje ob Dravi",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3192062",
        Name: "Občina Radovljica",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239175",
        Name: "Občina Ravne na Koroškem",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344941",
        Name: "Občina Razkrižje",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239224",
        Name: "Občina Rače-Fram",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3191679",
        Name: "Občina Ribnica",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344917",
        Name: "Občina Ribnica na Pohorju",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239237",
        Name: "Občina Rogatec",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239234",
        Name: "Občina Rogaška Slatina",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239270",
        Name: "Občina Rogašovci",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239211",
        Name: "Občina Ruše",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344919",
        Name: "Občina Selnica ob Dravi",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239195",
        Name: "Občina Semič",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3190949",
        Name: "Občina Sevnica",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3190944",
        Name: "Občina Sežana",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3190533",
        Name: "Občina Slovenska Bistrica",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3190529",
        Name: "Občina Slovenske Konjice",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344900",
        Name: "Občina Sodražica",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344895",
        Name: "Občina Solčava",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239226",
        Name: "Občina Starše",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344931",
        Name: "Občina Sveta Ana",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344928",
        Name: "Občina Sveti Andraž v Slovenskih Goricah",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239259",
        Name: "Občina Sveti Jurij ob Ščavnici",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344904",
        Name: "Občina Tabor",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344937",
        Name: "Občina Tišina",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3189037",
        Name: "Občina Tolmin",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3188914",
        Name: "Občina Trbovlje",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3188885",
        Name: "Občina Trebnje",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344927",
        Name: "Občina Trnovska vas",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344901",
        Name: "Občina Trzin",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3188687",
        Name: "Občina Tržič",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239283",
        Name: "Občina Turnišče",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344934",
        Name: "Občina Velika Polana",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239062",
        Name: "Občina Velike Lašče",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344933",
        Name: "Občina Veržej",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239231",
        Name: "Občina Videm",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239075",
        Name: "Občina Vipava",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239204",
        Name: "Občina Vitanje",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239112",
        Name: "Občina Vodice",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239202",
        Name: "Občina Vojnik",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344903",
        Name: "Občina Vransko",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3187213",
        Name: "Občina Vrhnika",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239180",
        Name: "Občina Vuzenica",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3186905",
        Name: "Občina Zagorje ob Savi",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239247",
        Name: "Občina Zavrč",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239205",
        Name: "Občina Zreče",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239286",
        Name: "Občina Črenšovci",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239181",
        Name: "Občina Črna na Koroškem",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3202332",
        Name: "Občina Črnomelj",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344943",
        Name: "Občina Šalovci",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344898",
        Name: "Občina Šempeter-Vrtojba",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239214",
        Name: "Občina Šentilj",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239197",
        Name: "Občina Šentjernej",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3191028",
        Name: "Občina Šentjur",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239111",
        Name: "Občina Šenčur",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239199",
        Name: "Občina Škocjan",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3190716",
        Name: "Občina Škofja Loka",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239066",
        Name: "Občina Škofljica",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3190509",
        Name: "Občina Šmarje pri Jelšah",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239187",
        Name: "Občina Šmartno ob Paki",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344942",
        Name: "Občina Šmartno pri Litiji",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239185",
        Name: "Občina Šoštanj",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239200",
        Name: "Občina Štore",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3186843",
        Name: "Občina Žalec",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239093",
        Name: "Občina Železniki",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344923",
        Name: "Občina Žetale",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3239087",
        Name: "Občina Žiri",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344893",
        Name: "Občina Žirovnica",
        
        FCode: "ADM1",
        CountryCode: "SI"
      },
      {
        id: "3344909",
        Name: "Občina Žužemberk",
        
        FCode: "ADM1",
        CountryCode: "SI"
      }
    ],
  },
  {
    id: "2510769",
    Name: "Spain",
    States: [
      {
        id: "2593109",
        Name: "Andalusia",
        
        FCode: "ADM1",
        CountryCode: "ES",
      },
      {
        id: "3336899",
        Name: "Aragon",
        
        FCode: "ADM1",
        CountryCode: "ES",
      },
      {
        id: "3114710",
        Name: "Asturias",
        
        FCode: "ADM1",
        CountryCode: "ES",
      },
      {
        id: "3115609",
        Name: "Autonomous Region of Navarre",
        
        FCode: "ADM1",
        CountryCode: "ES",
      },
      {
        id: "2521383",
        Name: "Balearic Islands",
        
        FCode: "ADM1",
        CountryCode: "ES",
      },
      {
        id: "3336903",
        Name: "Basque Country",
        
        FCode: "ADM1",
        CountryCode: "ES",
      },
      {
        id: "2593110",
        Name: "Canary Islands",
        
        FCode: "ADM1",
        CountryCode: "ES",
      },
      {
        id: "3336898",
        Name: "Cantabria",
        
        FCode: "ADM1",
        CountryCode: "ES",
      },
      {
        id: "3336900",
        Name: "Castille and León",
        
        FCode: "ADM1",
        CountryCode: "ES",
      },
      {
        id: "2593111",
        Name: "Castille-La Mancha",
        
        FCode: "ADM1",
        CountryCode: "ES",
      },
      {
        id: "3336901",
        Name: "Catalonia",
        
        FCode: "ADM1",
        CountryCode: "ES",
      },
      {
        id: "2519582",
        Name: "Ceuta",
        
        FCode: "ADM1",
        CountryCode: "ES",
      },
      {
        id: "2593112",
        Name: "Extremadura",
        
        FCode: "ADM1",
        CountryCode: "ES",
      },
      {
        id: "3336902",
        Name: "Galicia",
        
        FCode: "ADM1",
        CountryCode: "ES",
      },
      {
        id: "3336897",
        Name: "La Rioja",
        
        FCode: "ADM1",
        CountryCode: "ES",
      },
      {
        id: "3117732",
        Name: "Madrid",
        
        FCode: "ADM1",
        CountryCode: "ES",
      },
      {
        id: "6362988",
        Name: "Melilla",
        
        FCode: "ADM1",
        CountryCode: "ES",
      },
      {
        id: "2513413",
        Name: "Murcia",
        
        FCode: "ADM1",
        CountryCode: "ES",
      },
      {
        id: "2593113",
        Name: "Valencia",
        
        FCode: "ADM1",
        CountryCode: "ES",
      }
    ],
  },
  {
    id: "2661886",
    Name: "Sweden",
    States: [
      {
        id: "2721357",
        Name: "Blekinge",
        
        FCode: "ADM1",
        CountryCode: "SE",
      },
      {
        id: "2699767",
        Name: "Dalarna",
        
        FCode: "ADM1",
        CountryCode: "SE",
      },
      {
        id: "2711508",
        Name: "Gotland",
        
        FCode: "ADM1",
        CountryCode: "SE",
      },
      {
        id: "2712411",
        Name: "Gävleborg",
        
        FCode: "ADM1",
        CountryCode: "SE",
      },
      {
        id: "2708794",
        Name: "Halland",
        
        FCode: "ADM1",
        CountryCode: "SE",
      },
      {
        id: "2703330",
        Name: "Jämtland",
        
        FCode: "ADM1",
        CountryCode: "SE",
      },
      {
        id: "2702976",
        Name: "Jönköping",
        
        FCode: "ADM1",
        CountryCode: "SE",
      },
      {
        id: "2702259",
        Name: "Kalmar",
        
        FCode: "ADM1",
        CountryCode: "SE",
      },
      {
        id: "2699050",
        Name: "Kronoberg",
        
        FCode: "ADM1",
        CountryCode: "SE",
      },
      {
        id: "604010",
        Name: "Norrbotten",
        
        FCode: "ADM1",
        CountryCode: "SE",
      },
      {
        id: "3337385",
        Name: "Skåne",
        
        FCode: "ADM1",
        CountryCode: "SE",
      },
      {
        id: "2673722",
        Name: "Stockholm",
        
        FCode: "ADM1",
        CountryCode: "SE",
      },
      {
        id: "2676207",
        Name: "Södermanland",
        
        FCode: "ADM1",
        CountryCode: "SE",
      },
      {
        id: "2666218",
        Name: "Uppsala",
        
        FCode: "ADM1",
        CountryCode: "SE",
      },
      {
        id: "2664870",
        Name: "Värmland",
        
        FCode: "ADM1",
        CountryCode: "SE",
      },
      {
        id: "2664415",
        Name: "Västerbotten",
        
        FCode: "ADM1",
        CountryCode: "SE",
      },
      {
        id: "2664292",
        Name: "Västernorrland",
        
        FCode: "ADM1",
        CountryCode: "SE",
      },
      {
        id: "2664179",
        Name: "Västmanland",
        
        FCode: "ADM1",
        CountryCode: "SE",
      },
      {
        id: "3337386",
        Name: "Västra Götaland",
        
        FCode: "ADM1",
        CountryCode: "SE",
      },
      {
        id: "2686655",
        Name: "Örebro",
        
        FCode: "ADM1",
        CountryCode: "SE",
      },
      {
        id: "2685867",
        Name: "Östergötland",
        
        FCode: "ADM1",
        CountryCode: "SE",
      }
    ],
  },
  {
    id: "2658434",
    Name: "Switzerland",
    States: [
      {
        id: "2661876",
        Name: "Aargau",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2661739",
        Name: "Appenzell Ausserrhoden",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2661603",
        Name: "Basel-Country",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2661602",
        Name: "Basle-Ville",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2661551",
        Name: "Bern",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2660717",
        Name: "Fribourg",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2660645",
        Name: "Geneva",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2660593",
        Name: "Glarus",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2660522",
        Name: "Grisons",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2660207",
        Name: "Jura",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2661741",
        Name: "Kanton Appenzell Innerrhoden",
        
        FCode: "ADM1",
        CountryCode: "CH"
      },
      {
        id: "2659810",
        Name: "Lucerne",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2659495",
        Name: "Neuchâtel",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2659471",
        Name: "Nidwalden",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2659315",
        Name: "Obwalden",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2658821",
        Name: "Saint Gallen",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2658760",
        Name: "Schaffhausen",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2658664",
        Name: "Schwyz",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2658563",
        Name: "Solothurn",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2658372",
        Name: "Thurgau",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2658370",
        Name: "Ticino",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2658226",
        Name: "Uri",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2658205",
        Name: "Valais",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2658182",
        Name: "Vaud",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2657907",
        Name: "Zug",
        
        FCode: "ADM1",
        CountryCode: "CH",
      },
      {
        id: "2657895",
        Name: "Zurich",
        
        FCode: "ADM1",
        CountryCode: "CH",
      }
    ],
  },
  {
    id: "690791",
    Name: "Ukraine",
    States: [
      {
        id: "703883",
        Name: "Avtonomna Respublika Krym",
        
        FCode: "ADM1",
        CountryCode: "UA"
      },
      {
        id: "710802",
        Name: "Cherkas’ka Oblast’",
        
        FCode: "ADM1",
        CountryCode: "UA"
      },
      {
        id: "710734",
        Name: "Chernihivs’ka Oblast’",
        
        FCode: "ADM1",
        CountryCode: "UA"
      },
      {
        id: "710720",
        Name: "Chernivets’ka Oblast’",
        
        FCode: "ADM1",
        CountryCode: "UA"
      },
      {
        id: "709929",
        Name: "Dnipropetrovska Oblast'",
        
        FCode: "ADM1",
        CountryCode: "UA"
      },
      {
        id: "709716",
        Name: "Donets’ka Oblast’",
        
        FCode: "ADM1",
        CountryCode: "UA"
      },
      {
        id: "707470",
        Name: "Ivano-Frankivs’ka Oblast’",
        
        FCode: "ADM1",
        CountryCode: "UA"
      },
      {
        id: "706482",
        Name: "Kharkivs’ka Oblast’",
        
        FCode: "ADM1",
        CountryCode: "UA"
      },
      {
        id: "706442",
        Name: "Kherson",
        
        FCode: "ADM1",
        CountryCode: "UA",
      },
      {
        id: "706370",
        Name: "Khmel’nyts’ka Oblast’",
        
        FCode: "ADM1",
        CountryCode: "UA"
      },
      {
        id: "703446",
        Name: "Kiev",
        
        FCode: "ADM1",
        CountryCode: "UA",
      },
      {
        id: "705811",
        Name: "Kirovohrads’ka Oblast’",
        
        FCode: "ADM1",
        CountryCode: "UA"
      },
      {
        id: "702657",
        Name: "Luhans’ka Oblast’",
        
        FCode: "ADM1",
        CountryCode: "UA"
      },
      {
        id: "702549",
        Name: "L’vivs’ka Oblast’",
        
        FCode: "ADM1",
        CountryCode: "UA"
      },
      {
        id: "703447",
        Name: "Misto Kyyiv",
        
        FCode: "ADM1",
        CountryCode: "UA"
      },
      {
        id: "694422",
        Name: "Misto Sevastopol’",
        
        FCode: "ADM1",
        CountryCode: "UA"
      },
      {
        id: "700567",
        Name: "Mykolayivs’ka Oblast’",
        
        FCode: "ADM1",
        CountryCode: "UA"
      },
      {
        id: "698738",
        Name: "Odessa",
        
        FCode: "ADM1",
        CountryCode: "UA",
      },
      {
        id: "696634",
        Name: "Poltava",
        
        FCode: "ADM1",
        CountryCode: "UA",
      },
      {
        id: "695592",
        Name: "Rivnens’ka Oblast’",
        
        FCode: "ADM1",
        CountryCode: "UA"
      },
      {
        id: "692196",
        Name: "Sumy",
        
        FCode: "ADM1",
        CountryCode: "UA",
      },
      {
        id: "691649",
        Name: "Ternopil’s’ka Oblast’",
        
        FCode: "ADM1",
        CountryCode: "UA"
      },
      {
        id: "689559",
        Name: "Vinnyts’ka Oblast’",
        
        FCode: "ADM1",
        CountryCode: "UA"
      },
      {
        id: "689064",
        Name: "Volyns’ka Oblast’",
        
        FCode: "ADM1",
        CountryCode: "UA"
      },
      {
        id: "687869",
        Name: "Zakarpats’ka Oblast’",
        
        FCode: "ADM1",
        CountryCode: "UA"
      },
      {
        id: "687699",
        Name: "Zaporiz’ka Oblast’",
        
        FCode: "ADM1",
        CountryCode: "UA"
      },
      {
        id: "686966",
        Name: "Zhytomyrs’ka Oblast’",
        
        FCode: "ADM1",
        CountryCode: "UA"
      }
    ],
  },
  {
    id: "2635167",
    Name: "United Kingdom",
    States: [
      {
        id: "6269131",
        Name: "England",
        
        FCode: "ADM1",
        CountryCode: "GB",
      },
      {
        id: "6620380",
        Name: "Guernsey (general)",
        
        FCode: "ADM1",
        CountryCode: "GG"
      },
      {
        id: "6620382",
        Name: "Isle of Man",
        
        FCode: "ADM1",
        CountryCode: "IM"
      },
      {
        id: "6620384",
        Name: "Jersey (general)",
        
        FCode: "ADM1",
        CountryCode: "JE"
      },
      {
        id: "2641364",
        Name: "N Ireland",
        
        FCode: "ADM1",
        CountryCode: "GB",
      },
      {
        id: "2638360",
        Name: "Scotland",
        
        FCode: "ADM1",
        CountryCode: "GB",
      },
      {
        id: "2634895",
        Name: "Wales",
        
        FCode: "ADM1",
        CountryCode: "GB",
      }
    ],
  },
  {
    id: "661882",
    Name: "Åland",
    States: [
      {
        id: "660528",
        Name: "Brändö",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "3041809",
        Name: "Eckerö",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "3041799",
        Name: "Finström",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "659951",
        Name: "Föglö",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "3041793",
        Name: "Geta",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "3041777",
        Name: "Hammarland",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "3041761",
        Name: "Jomala",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "650397",
        Name: "Kumlinge",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "651989",
        Name: "Kökar",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "648384",
        Name: "Lemland",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "647457",
        Name: "Lumparland",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "3041733",
        Name: "Mariehamn",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "637880",
        Name: "Saltvik",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "636159",
        Name: "Sottunga",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "635817",
        Name: "Sund",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "632425",
        Name: "Vårdö",
        
        FCode: "ADM1",
        CountryCode: "AX"
      },
      {
        id: "6620378",
        Name: "Åland (general)",
        
        FCode: "ADM1",
        CountryCode: "AX"
      }
    ],
  },
  {
    id: "3573511",
    Name: "Anguilla",
    States: [
      {
        id: "3573503",
        Name: "Bethel",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573502",
        Name: "Betty Hill",
        
        FCode: "PPLL",
        CountryCode: "AI"
      },
      {
        id: "3573496",
        Name: "Blowing Point Village",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573491",
        Name: "Cannifist",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573489",
        Name: "Cauls Bottom",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573487",
        Name: "Chalvilles",
        
        FCode: "PPLL",
        CountryCode: "AI"
      },
      {
        id: "3573480",
        Name: "Crocus Hill",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573477",
        Name: "Deep Waters",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573473",
        Name: "East End Village",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573472",
        Name: "Ebenezer",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573466",
        Name: "George Hill",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573456",
        Name: "Island Harbour",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573454",
        Name: "Junks Hole",
        
        FCode: "PPLL",
        CountryCode: "AI"
      },
      {
        id: "3573447",
        Name: "Little Dix",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573440",
        Name: "Long Bay Village",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573439",
        Name: "Long Ground",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573438",
        Name: "Long Path",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573432",
        Name: "Lower South Hill",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573430",
        Name: "Mahogany Tree",
        
        FCode: "PPLL",
        CountryCode: "AI"
      },
      {
        id: "3573421",
        Name: "Mount Fortune",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573420",
        Name: "North Hill Village",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573418",
        Name: "North Side",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573412",
        Name: "Rey Hill",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573407",
        Name: "Sandy Ground Village",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573390",
        Name: "Shoal Bay Village",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573385",
        Name: "South Hill Village",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573380",
        Name: "Stoney Ground",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573379",
        Name: "The Copse",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573378",
        Name: "The Farrington",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573377",
        Name: "The Forest",
        
        FCode: "PPLL",
        CountryCode: "AI"
      },
      {
        id: "3573375",
        Name: "The Quarter",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573374",
        Name: "The Valley",
        
        FCode: "PPLC",
        CountryCode: "AI",
      },
      {
        id: "3573369",
        Name: "Wattices",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573368",
        Name: "Welches Hill",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573364",
        Name: "West End Village",
        
        FCode: "PPL",
        CountryCode: "AI"
      },
      {
        id: "3573362",
        Name: "White Hill",
        
        FCode: "PPL",
        CountryCode: "AI"
      }
    ],
  },
  {
    id: "3576396",
    Name: "Antigua and Barbuda",
    States: [
      {
        id: "3576390",
        Name: "Barbuda",
        
        FCode: "ADM1",
        CountryCode: "AG"
      },
      {
        id: "3576024",
        Name: "Parish of Saint George",
        
        FCode: "ADM1",
        CountryCode: "AG"
      },
      {
        id: "3576023",
        Name: "Parish of Saint John",
        
        FCode: "ADM1",
        CountryCode: "AG",
      },
      {
        id: "3576018",
        Name: "Parish of Saint Mary",
        
        FCode: "ADM1",
        CountryCode: "AG"
      },
      {
        id: "3576017",
        Name: "Parish of Saint Paul",
        
        FCode: "ADM1",
        CountryCode: "AG"
      },
      {
        id: "3576016",
        Name: "Parish of Saint Peter",
        
        FCode: "ADM1",
        CountryCode: "AG"
      },
      {
        id: "3576015",
        Name: "Parish of Saint Philip",
        
        FCode: "ADM1",
        CountryCode: "AG"
      },
      {
        id: "3576037",
        Name: "Redonda",
        
        FCode: "ADM1",
        CountryCode: "AG",
      }
    ],
  },
  {
    id: "3577279",
    Name: "Aruba",
    States: [
      {
        id: "3577284",
        Name: "Angochi",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577282",
        Name: "Arasji",
        
        FCode: "PPL",
        CountryCode: "AW"
      },
      {
        id: "3577277",
        Name: "Babijn",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577276",
        Name: "Balashi",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577268",
        Name: "Blumond",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "6692446",
        Name: "Boegoeroei",
        
        FCode: "PPL",
        CountryCode: "AW"
      },
      {
        id: "3577265",
        Name: "Boton",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577263",
        Name: "Brasil",
        
        FCode: "PPL",
        CountryCode: "AW"
      },
      {
        id: "3577262",
        Name: "Bringamosa",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577261",
        Name: "Bubali",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577257",
        Name: "Bushiribana",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577256",
        Name: "Butucu",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577253",
        Name: "Calabas",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577251",
        Name: "Camacuri",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577250",
        Name: "Canashito",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577248",
        Name: "Cas Ariba",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577246",
        Name: "Cas di Paloma",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577245",
        Name: "Cashero",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577244",
        Name: "Casibari",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577242",
        Name: "Catashi",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577241",
        Name: "Catiri",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577096",
        Name: "Ceru Colorado",
        
        FCode: "PPL",
        CountryCode: "AW"
      },
      {
        id: "3577239",
        Name: "Coba Lodo",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577227",
        Name: "Cunucu Abao",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577225",
        Name: "Cura Cabai",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577219",
        Name: "Druif",
        
        FCode: "PPL",
        CountryCode: "AW"
      },
      {
        id: "3577214",
        Name: "Eagle Beach",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577213",
        Name: "Falcon",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577209",
        Name: "Fontein",
        
        FCode: "PPL",
        CountryCode: "AW"
      },
      {
        id: "3577207",
        Name: "Gasparito",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577193",
        Name: "Jamanota",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577191",
        Name: "Jan Flemming",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577189",
        Name: "Juwana Morto",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577254",
        Name: "Largo Cadushi",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577180",
        Name: "Mabon",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577179",
        Name: "Macuarima",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577178",
        Name: "Madiki",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577176",
        Name: "Mahuma",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577172",
        Name: "Marawiel",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577171",
        Name: "Maria Mài",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577166",
        Name: "Meiveld",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577164",
        Name: "Moco",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577163",
        Name: "Modansa",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577162",
        Name: "Mon Pos",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577161",
        Name: "Morgenster",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577159",
        Name: "Noord",
        
        FCode: "PPL",
        CountryCode: "AW"
      },
      {
        id: "3577158",
        Name: "Noord Cura Cabai",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577156",
        Name: "Nuñe",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577154",
        Name: "Oranjestad",
        
        FCode: "PPLC",
        CountryCode: "AW",
      },
      {
        id: "3577152",
        Name: "Palm Beach",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577150",
        Name: "Paradera",
        
        FCode: "PPL",
        CountryCode: "AW"
      },
      {
        id: "3577149",
        Name: "Paradijs",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577148",
        Name: "Paraguaná",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577147",
        Name: "Parkietenbos",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577145",
        Name: "Pavía",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577144",
        Name: "Picaron",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577142",
        Name: "Piedra Plat",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577140",
        Name: "Plantersrust",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577138",
        Name: "Ponton",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577137",
        Name: "Pos Abao",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577136",
        Name: "Pos Chikito",
        
        FCode: "PPL",
        CountryCode: "AW"
      },
      {
        id: "3577129",
        Name: "Primavera",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577121",
        Name: "Roncado",
        
        FCode: "PPL",
        CountryCode: "AW"
      },
      {
        id: "3577120",
        Name: "Rooi Afó",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577119",
        Name: "Rooi Bosal",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577118",
        Name: "Rooi Cochi",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577117",
        Name: "Rooi Congo",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577116",
        Name: "Rooi Hundo",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577115",
        Name: "Rooi Master",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577114",
        Name: "Rooi Prikichi",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577113",
        Name: "Sabana Basora",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577112",
        Name: "Sabana Berde",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577111",
        Name: "Sabana Blanco",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577110",
        Name: "Sabana Grandi",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577108",
        Name: "Sabana Liber",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577107",
        Name: "Sabaneta",
        
        FCode: "PPL",
        CountryCode: "AW"
      },
      {
        id: "3577106",
        Name: "Sabanía Abao",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577105",
        Name: "Saliña Cerca",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577104",
        Name: "San Barbola",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577103",
        Name: "San Fuego",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577102",
        Name: "Santa Cruz",
        
        FCode: "PPL",
        CountryCode: "AW"
      },
      {
        id: "3577101",
        Name: "Santa Helena",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577099",
        Name: "Santa Martha",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577097",
        Name: "Sero Blanco",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577095",
        Name: "Shaba",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577094",
        Name: "Shabiruri",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577093",
        Name: "Shete",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577092",
        Name: "Shiribana",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577091",
        Name: "Simeon Antonio",
        
        FCode: "PPL",
        CountryCode: "AW"
      },
      {
        id: "3577090",
        Name: "Sint Anna",
        
        FCode: "PPL",
        CountryCode: "AW"
      },
      {
        id: "3577089",
        Name: "Sint Nicolaas",
        
        FCode: "PPL",
        CountryCode: "AW"
      },
      {
        id: "3577086",
        Name: "Siribana",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577084",
        Name: "Soledad",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577083",
        Name: "Solito",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577075",
        Name: "Tamarijn",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577073",
        Name: "Tanki Flip",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577072",
        Name: "Tanki Lender",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577071",
        Name: "Tarabana",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577061",
        Name: "Washington",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577060",
        Name: "Wayaca",
        
        FCode: "PPLL",
        CountryCode: "AW"
      },
      {
        id: "3577058",
        Name: "Westpunt",
        
        FCode: "PPLL",
        CountryCode: "AW"
      }
    ],
  },
  {
    id: "3572887",
    Name: "Bahamas",
    States: [
      {
        id: "3572937",
        Name: "Acklins Island District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "3571809",
        Name: "Berry Islands District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "3572807",
        Name: "Bimini District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "8030541",
        Name: "Black Point District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "3572678",
        Name: "Cat Island District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "8030542",
        Name: "Central Abaco District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "8030543",
        Name: "Central Andros District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "8030544",
        Name: "Central Eleuthera District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "3572374",
        Name: "City of Freeport District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "8030545",
        Name: "Crooked Island and Long Cay District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "8030546",
        Name: "East Grand Bahama District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "3572427",
        Name: "Exuma District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "3572363",
        Name: "Fresh Creek District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "3572312",
        Name: "Governor's Harbour District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "8030547",
        Name: "Grand Cay District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "3572271",
        Name: "Green Turtle Cay District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "3572238",
        Name: "Harbour Island District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "3572188",
        Name: "High Rock District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "8030548",
        Name: "Hope Town District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "3572154",
        Name: "Inagua District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "3572109",
        Name: "Kemps Bay District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "3572005",
        Name: "Long Island District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "8030549",
        Name: "Mangrove Cay District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "3571912",
        Name: "Marsh Harbour District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "3571894",
        Name: "Mayaguana District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "8030550",
        Name: "Moore’s Island District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "3571815",
        Name: "New Providence District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "8030551",
        Name: "North Abaco District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "8030552",
        Name: "North Andros District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "8030553",
        Name: "North Eleuthera District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "3571629",
        Name: "Ragged Island District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "3571591",
        Name: "Rock Sound District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "8030554",
        Name: "Rum Cay District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "3571493",
        Name: "San Salvador District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "3571495",
        Name: "Sandy Point District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "8030555",
        Name: "South Abaco District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "8030556",
        Name: "South Andros District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "8030557",
        Name: "South Eleuthera District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "8030558",
        Name: "Spanish Wells District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      },
      {
        id: "8030559",
        Name: "West Grand Bahama District",
        
        FCode: "ADM1",
        CountryCode: "BS"
      }
    ],
  },
  {
    id: "3374084",
    Name: "Barbados",
    States: [
      {
        id: "3373988",
        Name: "Christ Church",
        
        FCode: "ADM1",
        CountryCode: "BB"
      },
      {
        id: "3373580",
        Name: "Saint Andrew",
        
        FCode: "ADM1",
        CountryCode: "BB"
      },
      {
        id: "3373572",
        Name: "Saint George",
        
        FCode: "ADM1",
        CountryCode: "BB"
      },
      {
        id: "3373570",
        Name: "Saint James",
        
        FCode: "ADM1",
        CountryCode: "BB"
      },
      {
        id: "3373569",
        Name: "Saint John",
        
        FCode: "ADM1",
        CountryCode: "BB"
      },
      {
        id: "3373568",
        Name: "Saint Joseph",
        
        FCode: "ADM1",
        CountryCode: "BB"
      },
      {
        id: "3373565",
        Name: "Saint Lucy",
        
        FCode: "ADM1",
        CountryCode: "BB"
      },
      {
        id: "3373557",
        Name: "Saint Michael",
        
        FCode: "ADM1",
        CountryCode: "BB"
      },
      {
        id: "3373554",
        Name: "Saint Peter",
        
        FCode: "ADM1",
        CountryCode: "BB"
      },
      {
        id: "3373553",
        Name: "Saint Philip",
        
        FCode: "ADM1",
        CountryCode: "BB"
      },
      {
        id: "3373551",
        Name: "Saint Thomas",
        
        FCode: "ADM1",
        CountryCode: "BB"
      }
    ],
  },
  {
    id: "3582678",
    Name: "Belize",
    States: [
      {
        id: "3582676",
        Name: "Belize District",
        
        FCode: "ADM1",
        CountryCode: "BZ"
      },
      {
        id: "3582429",
        Name: "Cayo District",
        
        FCode: "ADM1",
        CountryCode: "BZ"
      },
      {
        id: "3582302",
        Name: "Corozal District",
        
        FCode: "ADM1",
        CountryCode: "BZ"
      },
      {
        id: "3581511",
        Name: "Orange Walk District",
        
        FCode: "ADM1",
        CountryCode: "BZ"
      },
      {
        id: "3580975",
        Name: "Stann Creek District",
        
        FCode: "ADM1",
        CountryCode: "BZ"
      },
      {
        id: "3580913",
        Name: "Toledo District",
        
        FCode: "ADM1",
        CountryCode: "BZ"
      }
    ],
  },
  {
    id: "3573345",
    Name: "Bermuda",
    States: [
      {
        id: "3573251",
        Name: "Devonshire Parish",
        
        FCode: "ADM1",
        CountryCode: "BM"
      },
      {
        id: "3573195",
        Name: "Hamilton Parish",
        
        FCode: "ADM1",
        CountryCode: "BM",
      },
      {
        id: "3573198",
        Name: "Hamilton city",
        
        FCode: "ADM1",
        CountryCode: "BM",
      },
      {
        id: "3573103",
        Name: "Paget",
        
        FCode: "ADM1",
        CountryCode: "BM",
      },
      {
        id: "3573095",
        Name: "Pembroke Parish",
        
        FCode: "ADM1",
        CountryCode: "BM"
      },
      {
        id: "3573062",
        Name: "Saint George",
        
        FCode: "ADM1",
        CountryCode: "BM"
      },
      {
        id: "3573057",
        Name: "Saint George’s Parish",
        
        FCode: "ADM1",
        CountryCode: "BM"
      },
      {
        id: "3573050",
        Name: "Sandys Parish",
        
        FCode: "ADM1",
        CountryCode: "BM"
      },
      {
        id: "3573031",
        Name: "Smith’s Parish",
        
        FCode: "ADM1",
        CountryCode: "BM"
      },
      {
        id: "3573026",
        Name: "Southampton Parish",
        
        FCode: "ADM1",
        CountryCode: "BM"
      },
      {
        id: "3572972",
        Name: "Warwick Parish",
        
        FCode: "ADM1",
        CountryCode: "BM"
      }
    ],
  },
  {
    id: "7626844",
    Name: "Bonaire",
    States: [
      {
        id: "7609816",
        Name: "Bonaire",
        
        FCode: "ADM1",
        CountryCode: "BQ"
      },
      {
        id: "7610358",
        Name: "Saba",
        
        FCode: "ADM1",
        CountryCode: "BQ"
      },
      {
        id: "7610359",
        Name: "Sint Eustatius",
        
        FCode: "ADM1",
        CountryCode: "BQ"
      }
    ],
  },
  {
    id: "3577718",
    Name: "British Virgin Islands",
    States: [
      {
        id: "3577781",
        Name: "Anderson",
        
        FCode: "PPLL",
        CountryCode: "VG"
      },
      {
        id: "3577753",
        Name: "Belle Vue",
        
        FCode: "PPL",
        CountryCode: "VG"
      },
      {
        id: "3577706",
        Name: "Cane Garden Bay",
        
        FCode: "PPL",
        CountryCode: "VG"
      },
      {
        id: "3740110",
        Name: "Creek Village",
        
        FCode: "PPLL",
        CountryCode: "VG"
      },
      {
        id: "3577636",
        Name: "Freshwater Pond",
        
        FCode: "PPL",
        CountryCode: "VG"
      },
      {
        id: "3577619",
        Name: "Great Carrot Bay",
        
        FCode: "PPLL",
        CountryCode: "VG"
      },
      {
        id: "3577612",
        Name: "Great Mountain",
        
        FCode: "PPLL",
        CountryCode: "VG"
      },
      {
        id: "3577596",
        Name: "Hannah",
        
        FCode: "PPLL",
        CountryCode: "VG"
      },
      {
        id: "3577561",
        Name: "Kingstown",
        
        FCode: "PPL",
        CountryCode: "VG"
      },
      {
        id: "3577556",
        Name: "Leonards",
        
        FCode: "PPL",
        CountryCode: "VG"
      },
      {
        id: "3577555",
        Name: "Lettsome Settlement",
        
        FCode: "PPL",
        CountryCode: "VG"
      },
      {
        id: "3577545",
        Name: "Little Carrot Bay",
        
        FCode: "PPLL",
        CountryCode: "VG"
      },
      {
        id: "3577541",
        Name: "Little Harbour",
        
        FCode: "PPL",
        CountryCode: "VG"
      },
      {
        id: "3577522",
        Name: "Long Swamp",
        
        FCode: "PPL",
        CountryCode: "VG"
      },
      {
        id: "3577498",
        Name: "Maya Cove",
        
        FCode: "PPL",
        CountryCode: "VG"
      },
      {
        id: "3577430",
        Name: "Road Town",
        
        FCode: "PPLC",
        CountryCode: "VG",
      },
      {
        id: "3577371",
        Name: "South Sound",
        
        FCode: "PPLL",
        CountryCode: "VG"
      },
      {
        id: "3577369",
        Name: "Spanish Town",
        
        FCode: "PPL",
        CountryCode: "VG"
      },
      {
        id: "3577352",
        Name: "The Mill",
        
        FCode: "PPLL",
        CountryCode: "VG"
      },
      {
        id: "3577351",
        Name: "The Settlement",
        
        FCode: "PPL",
        CountryCode: "VG"
      },
      {
        id: "3577349",
        Name: "Threllfall",
        
        FCode: "PPLL",
        CountryCode: "VG"
      },
      {
        id: "3577311",
        Name: "Wesley Will",
        
        FCode: "PPL",
        CountryCode: "VG"
      }
    ],
  },
  {
    id: "6251999",
    Name: "Canada",
    States: [
      {
        id: "5883102",
        Name: "Alberta",
        
        FCode: "ADM1",
        CountryCode: "CA"
      },
      {
        id: "5909050",
        Name: "British Columbia",
        
        FCode: "ADM1",
        CountryCode: "CA",
      },
      {
        id: "6065171",
        Name: "Manitoba",
        
        FCode: "ADM1",
        CountryCode: "CA"
      },
      {
        id: "6087430",
        Name: "New Brunswick",
        
        FCode: "ADM1",
        CountryCode: "CA",
      },
      {
        id: "6354959",
        Name: "Newfoundland and Labrador",
        
        FCode: "ADM1",
        CountryCode: "CA",
      },
      {
        id: "6091069",
        Name: "Northwest Territories",
        
        FCode: "ADM1",
        CountryCode: "CA",
      },
      {
        id: "6091530",
        Name: "Nova Scotia",
        
        FCode: "ADM1",
        CountryCode: "CA",
      },
      {
        id: "6091732",
        Name: "Nunavut",
        
        FCode: "ADM1",
        CountryCode: "CA"
      },
      {
        id: "6093943",
        Name: "Ontario",
        
        FCode: "ADM1",
        CountryCode: "CA"
      },
      {
        id: "6113358",
        Name: "Prince Edward Island",
        
        FCode: "ADM1",
        CountryCode: "CA",
      },
      {
        id: "6115047",
        Name: "Quebec",
        
        FCode: "ADM1",
        CountryCode: "CA",
      },
      {
        id: "6141242",
        Name: "Saskatchewan",
        
        FCode: "ADM1",
        CountryCode: "CA"
      },
      {
        id: "6185811",
        Name: "Yukon",
        
        FCode: "ADM1",
        CountryCode: "CA",
      }
    ],
  },
  {
    id: "3580718",
    Name: "Cayman Islands",
    States: [
      {
        id: "3580758",
        Name: "Banksville",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580754",
        Name: "Battle Ground",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580751",
        Name: "Belford Estates",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580743",
        Name: "Birch Tree Hill",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580742",
        Name: "Blakes",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580739",
        Name: "Blossom Point",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580733",
        Name: "Bodden Town",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580729",
        Name: "Botabano",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580725",
        Name: "Breakers",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580724",
        Name: "Breezy Castle",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580723",
        Name: "Brinkleys",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580717",
        Name: "Cayman Palms",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580701",
        Name: "Coral Gables",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580692",
        Name: "Creek",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580682",
        Name: "Driftwood Village",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580679",
        Name: "Dusty Place",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580678",
        Name: "East End",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580663",
        Name: "Frenchman’s Fort",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580661",
        Name: "George Town",
        
        FCode: "PPLC",
        CountryCode: "KY",
      },
      {
        id: "3580650",
        Name: "Gun Bay",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580647",
        Name: "Half Moon Bay",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580645",
        Name: "Half Way Pond",
        
        FCode: "PPLL",
        CountryCode: "KY"
      },
      {
        id: "3580641",
        Name: "Head of Bay",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580639",
        Name: "Hell",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580636",
        Name: "High Rock Estates",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580633",
        Name: "Hutland",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580620",
        Name: "Knob Hill",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580619",
        Name: "Lambert House",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580601",
        Name: "Lower Valley",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580590",
        Name: "Midland Acres",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580587",
        Name: "Molusca Heights",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580583",
        Name: "Mount Pleasant",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580580",
        Name: "Newlands",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580575",
        Name: "North Side",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580572",
        Name: "North Sound Estates",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580571",
        Name: "North Ward",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580566",
        Name: "Old Man Bay",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580563",
        Name: "Old Stores",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580562",
        Name: "Omega Gardens",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580557",
        Name: "Pease Bay",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580556",
        Name: "Pedro",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580553",
        Name: "Prospect",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580551",
        Name: "Prospect Park",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580547",
        Name: "Red Bay Estate",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580540",
        Name: "Saint James",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580533",
        Name: "Sand Bluff",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580529",
        Name: "Savannah",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580528",
        Name: "Savannah Acres",
        
        FCode: "PPLL",
        CountryCode: "KY"
      },
      {
        id: "3580518",
        Name: "South Town",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580510",
        Name: "Spot Bay",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580506",
        Name: "Spotts",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580498",
        Name: "The Common",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580496",
        Name: "The Moorings",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580497",
        Name: "The Moorings",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580494",
        Name: "Tibbetts Turn",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580491",
        Name: "Town Hall Crescent",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580490",
        Name: "Tropical Gardens",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580489",
        Name: "Upper Land",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580488",
        Name: "Vicksville",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580484",
        Name: "Water Ground",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580477",
        Name: "West Bay",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580475",
        Name: "West End",
        
        FCode: "PPL",
        CountryCode: "KY"
      },
      {
        id: "3580471",
        Name: "Whitehall Estate",
        
        FCode: "PPL",
        CountryCode: "KY"
      }
    ],
  },
  {
    id: "3624060",
    Name: "Costa Rica",
    States: [
      {
        id: "3624953",
        Name: "Provincia de Alajuela",
        
        FCode: "ADM1",
        CountryCode: "CR"
      },
      {
        id: "3624368",
        Name: "Provincia de Cartago",
        
        FCode: "ADM1",
        CountryCode: "CR"
      },
      {
        id: "3623582",
        Name: "Provincia de Guanacaste",
        
        FCode: "ADM1",
        CountryCode: "CR"
      },
      {
        id: "3623484",
        Name: "Provincia de Heredia",
        
        FCode: "ADM1",
        CountryCode: "CR"
      },
      {
        id: "3623064",
        Name: "Provincia de Limón",
        
        FCode: "ADM1",
        CountryCode: "CR"
      },
      {
        id: "3622226",
        Name: "Provincia de Puntarenas",
        
        FCode: "ADM1",
        CountryCode: "CR"
      },
      {
        id: "3621837",
        Name: "Provincia de San José",
        
        FCode: "ADM1",
        CountryCode: "CR"
      }
    ],
  },
  {
    id: "3562981",
    Name: "Cuba",
    States: [
      {
        id: "3550595",
        Name: "Las Tunas",
        
        FCode: "ADM1",
        CountryCode: "CU"
      },
      {
        id: "3556608",
        Name: "Municipio Especial Isla de la Juventud",
        
        FCode: "ADM1",
        CountryCode: "CU"
      },
      {
        id: "7668824",
        Name: "Provincia Artemisa",
        
        FCode: "ADM1",
        CountryCode: "CU"
      },
      {
        id: "3558052",
        Name: "Provincia Granma",
        
        FCode: "ADM1",
        CountryCode: "CU"
      },
      {
        id: "7668827",
        Name: "Provincia Mayabeque",
        
        FCode: "ADM1",
        CountryCode: "CU"
      },
      {
        id: "3566062",
        Name: "Provincia de Camagüey",
        
        FCode: "ADM1",
        CountryCode: "CU"
      },
      {
        id: "3564175",
        Name: "Provincia de Ciego de Ávila",
        
        FCode: "ADM1",
        CountryCode: "CU"
      },
      {
        id: "3564120",
        Name: "Provincia de Cienfuegos",
        
        FCode: "ADM1",
        CountryCode: "CU"
      },
      {
        id: "3557685",
        Name: "Provincia de Guantánamo",
        
        FCode: "ADM1",
        CountryCode: "CU"
      },
      {
        id: "3556965",
        Name: "Provincia de Holguín",
        
        FCode: "ADM1",
        CountryCode: "CU"
      },
      {
        id: "3564073",
        Name: "Provincia de La Habana",
        
        FCode: "ADM1",
        CountryCode: "CU"
      },
      {
        id: "3547394",
        Name: "Provincia de Matanzas",
        
        FCode: "ADM1",
        CountryCode: "CU"
      },
      {
        id: "3544088",
        Name: "Provincia de Pinar del Río",
        
        FCode: "ADM1",
        CountryCode: "CU"
      },
      {
        id: "3540665",
        Name: "Provincia de Sancti Spíritus",
        
        FCode: "ADM1",
        CountryCode: "CU"
      },
      {
        id: "3536725",
        Name: "Provincia de Santiago de Cuba",
        
        FCode: "ADM1",
        CountryCode: "CU"
      },
      {
        id: "3534168",
        Name: "Provincia de Villa Clara",
        
        FCode: "ADM1",
        CountryCode: "CU"
      }
    ],
  },
  {
    id: "7626836",
    Name: "Curacao",
    States: [
      {
        id: "3513946",
        Name: "Australie",
        
        FCode: "PPLL",
        CountryCode: "CW"
      },
      {
        id: "3513936",
        Name: "Barber",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513888",
        Name: "Blomonte",
        
        FCode: "PPLL",
        CountryCode: "CW"
      },
      {
        id: "6692389",
        Name: "Boca St. Michiel",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513885",
        Name: "Boka Samí",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513880",
        Name: "Bona Vista",
        
        FCode: "PPLL",
        CountryCode: "CW"
      },
      {
        id: "3513879",
        Name: "Bonavista",
        
        FCode: "PPLL",
        CountryCode: "CW"
      },
      {
        id: "3513871",
        Name: "Bou’i Seru",
        
        FCode: "PPLL",
        CountryCode: "CW"
      },
      {
        id: "3513861",
        Name: "Brievengat",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513856",
        Name: "Buena Vista",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513853",
        Name: "Bullenbaai",
        
        FCode: "PPLL",
        CountryCode: "CW"
      },
      {
        id: "7302257",
        Name: "Coral Estate Rif St. Marie",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513781",
        Name: "De Hoop",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513763",
        Name: "Dorp Sint Michiel",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513762",
        Name: "Dorp Sint Willebrordus",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513761",
        Name: "Dorp Soto",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513759",
        Name: "Dorp Westpunt",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513753",
        Name: "Emmastad",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513740",
        Name: "Fontein",
        
        FCode: "PPLL",
        CountryCode: "CW"
      },
      {
        id: "3513736",
        Name: "Fortuna Abou",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513722",
        Name: "Gato",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513692",
        Name: "Groot Kwartier",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513643",
        Name: "Jan Doret",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513640",
        Name: "Jan Thiel",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513636",
        Name: "Janwé",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513627",
        Name: "Juan Domingo",
        
        FCode: "PPLL",
        CountryCode: "CW"
      },
      {
        id: "3513625",
        Name: "Julianadorp",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513608",
        Name: "Kas Chikitu",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513574",
        Name: "Kolontjie",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513564",
        Name: "Krakeel",
        
        FCode: "PPLL",
        CountryCode: "CW"
      },
      {
        id: "3513560",
        Name: "Kunuku Abou",
        
        FCode: "PPLL",
        CountryCode: "CW"
      },
      {
        id: "3513558",
        Name: "Kura Juri",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513548",
        Name: "Lagún",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513536",
        Name: "Libie",
        
        FCode: "PPLL",
        CountryCode: "CW"
      },
      {
        id: "3513466",
        Name: "Montan’i Rei",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513464",
        Name: "Morgenster",
        
        FCode: "PPLL",
        CountryCode: "CW"
      },
      {
        id: "3513445",
        Name: "Newport",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513405",
        Name: "Parera",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513351",
        Name: "Rancho",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513322",
        Name: "Roosendaal",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513315",
        Name: "Rust en Vrede",
        
        FCode: "PPLL",
        CountryCode: "CW"
      },
      {
        id: "3513312",
        Name: "Sabana Westpunt",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513300",
        Name: "Saliña Abou",
        
        FCode: "PPLL",
        CountryCode: "CW"
      },
      {
        id: "3513285",
        Name: "San Pedro",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513286",
        Name: "San Pedro",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "7302156",
        Name: "Santa Catharina",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513273",
        Name: "Santa Krus",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513269",
        Name: "Santa Maria",
        
        FCode: "PPLL",
        CountryCode: "CW"
      },
      {
        id: "3513264",
        Name: "Santa Rosa",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513248",
        Name: "Seritu",
        
        FCode: "PPLL",
        CountryCode: "CW"
      },
      {
        id: "3513250",
        Name: "Ser’i Bientu",
        
        FCode: "PPLL",
        CountryCode: "CW"
      },
      {
        id: "3513226",
        Name: "Sint Jozefsdal",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513221",
        Name: "Sint Michiel Liber",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513214",
        Name: "Slangenbaai",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513190",
        Name: "Su Casa",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513187",
        Name: "Suffisant Dorp",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513184",
        Name: "Suriname Dorp",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513104",
        Name: "Weis",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513103",
        Name: "Weitje",
        
        FCode: "PPL",
        CountryCode: "CW"
      },
      {
        id: "3513090",
        Name: "Willemstad",
        
        FCode: "PPLC",
        CountryCode: "CW",
      },
      {
        id: "3513074",
        Name: "Zeelandia",
        
        FCode: "PPL",
        CountryCode: "CW"
      }
    ],
  },
  {
    id: "3575830",
    Name: "Dominica",
    States: [
      {
        id: "3575632",
        Name: "Saint Andrew",
        
        FCode: "ADM1",
        CountryCode: "DM"
      },
      {
        id: "3575630",
        Name: "Saint David",
        
        FCode: "ADM1",
        CountryCode: "DM"
      },
      {
        id: "3575628",
        Name: "Saint George",
        
        FCode: "ADM1",
        CountryCode: "DM"
      },
      {
        id: "3575626",
        Name: "Saint John",
        
        FCode: "ADM1",
        CountryCode: "DM"
      },
      {
        id: "3575625",
        Name: "Saint Joseph",
        
        FCode: "ADM1",
        CountryCode: "DM"
      },
      {
        id: "3575622",
        Name: "Saint Luke",
        
        FCode: "ADM1",
        CountryCode: "DM"
      },
      {
        id: "3575621",
        Name: "Saint Mark",
        
        FCode: "ADM1",
        CountryCode: "DM"
      },
      {
        id: "3575620",
        Name: "Saint Patrick",
        
        FCode: "ADM1",
        CountryCode: "DM"
      },
      {
        id: "3575619",
        Name: "Saint Paul",
        
        FCode: "ADM1",
        CountryCode: "DM"
      },
      {
        id: "3575618",
        Name: "Saint Peter",
        
        FCode: "ADM1",
        CountryCode: "DM"
      }
    ],
  },
  {
    id: "3508796",
    Name: "Dominican Republic",
    States: [
      {
        id: "3496024",
        Name: "Distrito Nacional",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3508718",
        Name: "Provincia Duarte",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3505867",
        Name: "Provincia Espaillat",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3496772",
        Name: "Provincia María Trinidad Sánchez",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3493192",
        Name: "Provincia Sánchez Ramírez",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3512209",
        Name: "Provincia de Azua",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3512050",
        Name: "Provincia de Baoruco",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3512042",
        Name: "Provincia de Barahona",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3508951",
        Name: "Provincia de Dajabón",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3506189",
        Name: "Provincia de El Seíbo",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3507269",
        Name: "Provincia de Elías Piña",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3504766",
        Name: "Provincia de Hato Mayor",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3493282",
        Name: "Provincia de Hermanas Mirabal",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3504326",
        Name: "Provincia de Independencia",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3503706",
        Name: "Provincia de La Altagracia",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3500955",
        Name: "Provincia de La Romana",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3499977",
        Name: "Provincia de La Vega",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3496274",
        Name: "Provincia de Monseñor Nouel",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3496200",
        Name: "Provincia de Monte Cristi",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3496132",
        Name: "Provincia de Monte Plata",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3495136",
        Name: "Provincia de Pedernales",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3495015",
        Name: "Provincia de Peravia",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3493232",
        Name: "Provincia de Samaná",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3493186",
        Name: "Provincia de San Cristóbal",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "6201372",
        Name: "Provincia de San José de Ocoa",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3493091",
        Name: "Provincia de San Juan",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3493031",
        Name: "Provincia de San Pedro de Macorís",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3492918",
        Name: "Provincia de Santiago",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3492912",
        Name: "Provincia de Santiago Rodríguez",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "6201373",
        Name: "Provincia de Santo Domingo",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3492112",
        Name: "Provincia de Valverde",
        
        FCode: "ADM1",
        CountryCode: "DO"
      },
      {
        id: "3494267",
        Name: "Puerto Plata",
        
        FCode: "ADM1",
        CountryCode: "DO",
      }
    ],
  },
  {
    id: "3585968",
    Name: "El Salvador",
    States: [
      {
        id: "3587425",
        Name: "Departamento de Ahuachapán",
        
        FCode: "ADM1",
        CountryCode: "SV"
      },
      {
        id: "3587217",
        Name: "Departamento de Cabañas",
        
        FCode: "ADM1",
        CountryCode: "SV"
      },
      {
        id: "3587090",
        Name: "Departamento de Chalatenango",
        
        FCode: "ADM1",
        CountryCode: "SV"
      },
      {
        id: "3586831",
        Name: "Departamento de Cuscatlán",
        
        FCode: "ADM1",
        CountryCode: "SV"
      },
      {
        id: "3585155",
        Name: "Departamento de La Libertad",
        
        FCode: "ADM1",
        CountryCode: "SV"
      },
      {
        id: "3585087",
        Name: "Departamento de La Paz",
        
        FCode: "ADM1",
        CountryCode: "SV"
      },
      {
        id: "3584767",
        Name: "Departamento de La Unión",
        
        FCode: "ADM1",
        CountryCode: "SV"
      },
      {
        id: "3584317",
        Name: "Departamento de Morazán",
        
        FCode: "ADM1",
        CountryCode: "SV"
      },
      {
        id: "3583462",
        Name: "Departamento de San Miguel",
        
        FCode: "ADM1",
        CountryCode: "SV"
      },
      {
        id: "3583360",
        Name: "Departamento de San Salvador",
        
        FCode: "ADM1",
        CountryCode: "SV"
      },
      {
        id: "3583176",
        Name: "Departamento de San Vicente",
        
        FCode: "ADM1",
        CountryCode: "SV"
      },
      {
        id: "3583332",
        Name: "Departamento de Santa Ana",
        
        FCode: "ADM1",
        CountryCode: "SV"
      },
      {
        id: "3583101",
        Name: "Departamento de Sonsonate",
        
        FCode: "ADM1",
        CountryCode: "SV"
      },
      {
        id: "3582882",
        Name: "Departamento de Usulután",
        
        FCode: "ADM1",
        CountryCode: "SV"
      }
    ],
  },
  {
    id: "3425505",
    Name: "Greenland",
    States: [
      {
        id: "7602005",
        Name: "Kujalleq",
        
        FCode: "ADM1",
        CountryCode: "GL"
      },
      {
        id: "7602003",
        Name: "Qaasuitsup",
        
        FCode: "ADM1",
        CountryCode: "GL"
      },
      {
        id: "7602006",
        Name: "Qeqqata",
        
        FCode: "ADM1",
        CountryCode: "GL"
      },
      {
        id: "7602007",
        Name: "Sermersooq",
        
        FCode: "ADM1",
        CountryCode: "GL"
      }
    ],
  },
  {
    id: "3580239",
    Name: "Grenada",
    States: [
      {
        id: "7303836",
        Name: "Carriacou and Petite Martinique",
        
        FCode: "ADM1",
        CountryCode: "GD"
      },
      {
        id: "3579938",
        Name: "Saint Andrew",
        
        FCode: "ADM1",
        CountryCode: "GD"
      },
      {
        id: "3579932",
        Name: "Saint David",
        
        FCode: "ADM1",
        CountryCode: "GD"
      },
      {
        id: "3579926",
        Name: "Saint George",
        
        FCode: "ADM1",
        CountryCode: "GD"
      },
      {
        id: "3579919",
        Name: "Saint John",
        
        FCode: "ADM1",
        CountryCode: "GD"
      },
      {
        id: "3579913",
        Name: "Saint Mark",
        
        FCode: "ADM1",
        CountryCode: "GD"
      },
      {
        id: "3579907",
        Name: "Saint Patrick",
        
        FCode: "ADM1",
        CountryCode: "GD"
      }
    ],

  },
  {
    id: "3595528",
    Name: "Guatemala",
    States: [
      {
        id: "3599773",
        Name: "Departamento de Alta Verapaz",
        
        FCode: "ADM1",
        CountryCode: "GT"
      },
      {
        id: "3599602",
        Name: "Departamento de Baja Verapaz",
        
        FCode: "ADM1",
        CountryCode: "GT"
      },
      {
        id: "3598571",
        Name: "Departamento de Chimaltenango",
        
        FCode: "ADM1",
        CountryCode: "GT"
      },
      {
        id: "3598464",
        Name: "Departamento de Chiquimula",
        
        FCode: "ADM1",
        CountryCode: "GT"
      },
      {
        id: "3596416",
        Name: "Departamento de El Progreso",
        
        FCode: "ADM1",
        CountryCode: "GT"
      },
      {
        id: "3595802",
        Name: "Departamento de Escuintla",
        
        FCode: "ADM1",
        CountryCode: "GT"
      },
      {
        id: "3595530",
        Name: "Departamento de Guatemala",
        
        FCode: "ADM1",
        CountryCode: "GT"
      },
      {
        id: "3595415",
        Name: "Departamento de Huehuetenango",
        
        FCode: "ADM1",
        CountryCode: "GT"
      },
      {
        id: "3595259",
        Name: "Departamento de Izabal",
        
        FCode: "ADM1",
        CountryCode: "GT"
      },
      {
        id: "3595236",
        Name: "Departamento de Jalapa",
        
        FCode: "ADM1",
        CountryCode: "GT"
      },
      {
        id: "3595067",
        Name: "Departamento de Jutiapa",
        
        FCode: "ADM1",
        CountryCode: "GT"
      },
      {
        id: "3590978",
        Name: "Departamento de Quetzaltenango",
        
        FCode: "ADM1",
        CountryCode: "GT"
      },
      {
        id: "3590857",
        Name: "Departamento de Retalhuleu",
        
        FCode: "ADM1",
        CountryCode: "GT"
      },
      {
        id: "3590686",
        Name: "Departamento de Sacatepéquez",
        
        FCode: "ADM1",
        CountryCode: "GT"
      },
      {
        id: "3589801",
        Name: "Departamento de San Marcos",
        
        FCode: "ADM1",
        CountryCode: "GT"
      },
      {
        id: "3589172",
        Name: "Departamento de Santa Rosa",
        
        FCode: "ADM1",
        CountryCode: "GT"
      },
      {
        id: "3588697",
        Name: "Departamento de Sololá",
        
        FCode: "ADM1",
        CountryCode: "GT"
      },
      {
        id: "3588668",
        Name: "Departamento de Suchitepéquez",
        
        FCode: "ADM1",
        CountryCode: "GT"
      },
      {
        id: "3588257",
        Name: "Departamento de Totonicapán",
        
        FCode: "ADM1",
        CountryCode: "GT"
      },
      {
        id: "3587586",
        Name: "Departamento de Zacapa",
        
        FCode: "ADM1",
        CountryCode: "GT"
      },
      {
        id: "3591410",
        Name: "Departamento del Petén",
        
        FCode: "ADM1",
        CountryCode: "GT"
      },
      {
        id: "3590964",
        Name: "Departamento del Quiché",
        
        FCode: "ADM1",
        CountryCode: "GT"
      }
    ],
  },
  {
    id: "3723988",
    Name: "Haiti",
    States: [
      {
        id: "7115999",
        Name: "Département de Nippes",
        
        FCode: "ADM1",
        CountryCode: "HT"
      },
      {
        id: "3731053",
        Name: "Département de l'Artibonite",
        
        FCode: "ADM1",
        CountryCode: "HT"
      },
      {
        id: "3719432",
        Name: "Département de l'Ouest",
        
        FCode: "ADM1",
        CountryCode: "HT"
      },
      {
        id: "3724613",
        Name: "Département de la Grand'Anse",
        
        FCode: "ADM1",
        CountryCode: "HT"
      },
      {
        id: "3728069",
        Name: "Département du Centre",
        
        FCode: "ADM1",
        CountryCode: "HT"
      },
      {
        id: "3719543",
        Name: "Département du Nord",
        
        FCode: "ADM1",
        CountryCode: "HT"
      },
      {
        id: "3719540",
        Name: "Département du Nord-Est",
        
        FCode: "ADM1",
        CountryCode: "HT"
      },
      {
        id: "3719536",
        Name: "Département du Nord-Ouest",
        
        FCode: "ADM1",
        CountryCode: "HT"
      },
      {
        id: "3716952",
        Name: "Département du Sud",
        
        FCode: "ADM1",
        CountryCode: "HT"
      },
      {
        id: "3716950",
        Name: "Département du Sud-Est",
        
        FCode: "ADM1",
        CountryCode: "HT"
      }
    ],
  },
  {
    id: "3608932",
    Name: "Honduras",
    States: [
      {
        id: "3608814",
        Name: "Bay Islands",
        
        FCode: "ADM1",
        CountryCode: "HN",
      },
      {
        id: "3615027",
        Name: "Departamento de Atlántida",
        
        FCode: "ADM1",
        CountryCode: "HN"
      },
      {
        id: "3613527",
        Name: "Departamento de Choluteca",
        
        FCode: "ADM1",
        CountryCode: "HN"
      },
      {
        id: "3613358",
        Name: "Departamento de Colón",
        
        FCode: "ADM1",
        CountryCode: "HN"
      },
      {
        id: "3613319",
        Name: "Departamento de Comayagua",
        
        FCode: "ADM1",
        CountryCode: "HN"
      },
      {
        id: "3613229",
        Name: "Departamento de Copán",
        
        FCode: "ADM1",
        CountryCode: "HN"
      },
      {
        id: "3613140",
        Name: "Departamento de Cortés",
        
        FCode: "ADM1",
        CountryCode: "HN"
      },
      {
        id: "3610942",
        Name: "Departamento de El Paraíso",
        
        FCode: "ADM1",
        CountryCode: "HN"
      },
      {
        id: "3609583",
        Name: "Departamento de Gracias a Dios",
        
        FCode: "ADM1",
        CountryCode: "HN"
      },
      {
        id: "3608833",
        Name: "Departamento de Intibucá",
        
        FCode: "ADM1",
        CountryCode: "HN"
      },
      {
        id: "3606066",
        Name: "Departamento de Lempira",
        
        FCode: "ADM1",
        CountryCode: "HN"
      },
      {
        id: "3604318",
        Name: "Departamento de Ocotepeque",
        
        FCode: "ADM1",
        CountryCode: "HN"
      },
      {
        id: "3604249",
        Name: "Departamento de Olancho",
        
        FCode: "ADM1",
        CountryCode: "HN"
      },
      {
        id: "3601689",
        Name: "Departamento de Santa Bárbara",
        
        FCode: "ADM1",
        CountryCode: "HN"
      },
      {
        id: "3600456",
        Name: "Departamento de Valle",
        
        FCode: "ADM1",
        CountryCode: "HN"
      },
      {
        id: "3600193",
        Name: "Departamento de Yoro",
        
        FCode: "ADM1",
        CountryCode: "HN"
      },
      {
        id: "3609672",
        Name: "Departmento de Francisco Morazán",
        
        FCode: "ADM1",
        CountryCode: "HN"
      },
      {
        id: "3607251",
        Name: "Departmento de La Paz",
        
        FCode: "ADM1",
        CountryCode: "HN"
      }
    ],
  },
  {
    id: "3489940",
    Name: "Jamaica",
    States: [
      {
        id: "3490145",
        Name: "Hanover Parish",
        
        FCode: "ADM1",
        CountryCode: "JM",
      },
      {
        id: "3489853",
        Name: "Kingston",
        
        FCode: "ADM1",
        CountryCode: "JM",
      },
      {
        id: "3490952",
        Name: "Parish of Clarendon",
        
        FCode: "ADM1",
        CountryCode: "JM"
      },
      {
        id: "3489586",
        Name: "Parish of Manchester",
        
        FCode: "ADM1",
        CountryCode: "JM"
      },
      {
        id: "3488997",
        Name: "Parish of Portland",
        
        FCode: "ADM1",
        CountryCode: "JM"
      },
      {
        id: "3488716",
        Name: "Parish of Saint Andrew",
        
        FCode: "ADM1",
        CountryCode: "JM"
      },
      {
        id: "3488715",
        Name: "Parish of Saint Ann",
        
        FCode: "ADM1",
        CountryCode: "JM"
      },
      {
        id: "3488711",
        Name: "Parish of Saint Catherine",
        
        FCode: "ADM1",
        CountryCode: "JM"
      },
      {
        id: "3488700",
        Name: "Parish of Saint James",
        
        FCode: "ADM1",
        CountryCode: "JM"
      },
      {
        id: "3488693",
        Name: "Parish of Saint Mary",
        
        FCode: "ADM1",
        CountryCode: "JM"
      },
      {
        id: "3488688",
        Name: "Parish of Saint Thomas",
        
        FCode: "ADM1",
        CountryCode: "JM"
      },
      {
        id: "3488222",
        Name: "Parish of Trelawny",
        
        FCode: "ADM1",
        CountryCode: "JM"
      },
      {
        id: "3488081",
        Name: "Parish of Westmoreland",
        
        FCode: "ADM1",
        CountryCode: "JM"
      },
      {
        id: "3488708",
        Name: "St. Elizabeth",
        
        FCode: "ADM1",
        CountryCode: "JM",
      }
    ],
  },
  {
    id: "3996063",
    Name: "Mexico",
    States: [
      {
        id: "4019231",
        Name: "Aguascalientes",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "4017698",
        Name: "Baja California Sur",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "3531730",
        Name: "Campeche",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "3531011",
        Name: "Chiapas",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "4014336",
        Name: "Chihuahua",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "4013674",
        Name: "Coahuila",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "4013513",
        Name: "Colima",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "4011741",
        Name: "Durango",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "4017700",
        Name: "Estado de Baja California",
        
        FCode: "ADM1",
        CountryCode: "MX"
      },
      {
        id: "3523272",
        Name: "Estado de México",
        
        FCode: "ADM1",
        CountryCode: "MX"
      },
      {
        id: "3514780",
        Name: "Estado de Veracruz-Llave",
        
        FCode: "ADM1",
        CountryCode: "MX"
      },
      {
        id: "4005267",
        Name: "Guanajuato",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "3527213",
        Name: "Guerrero",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "3527115",
        Name: "Hidalgo",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "4004156",
        Name: "Jalisco",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "3995955",
        Name: "Michoacán",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "3522961",
        Name: "Morelos",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "3995012",
        Name: "Nayarit",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "3522542",
        Name: "Nuevo León",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "3522509",
        Name: "Oaxaca",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "3521082",
        Name: "Puebla",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "3520914",
        Name: "Querétaro",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "3520887",
        Name: "Quintana Roo",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "3985605",
        Name: "San Luis Potosí",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "3983035",
        Name: "Sinaloa",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "3982846",
        Name: "Sonora",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "3516458",
        Name: "Tabasco",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "3516391",
        Name: "Tamaulipas",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "3527646",
        Name: "The Federal District",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "3515359",
        Name: "Tlaxcala",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "3514211",
        Name: "Yucatán",
        
        FCode: "ADM1",
        CountryCode: "MX",
      },
      {
        id: "3979840",
        Name: "Zacatecas",
        
        FCode: "ADM1",
        CountryCode: "MX",
      }
    ],
  },
  {
    id: "3578097",
    Name: "Montserrat",
    States: [
      {
        id: "3578045",
        Name: "Parish of Saint Anthony",
        
        FCode: "ADM1",
        CountryCode: "MS"
      },
      {
        id: "3578044",
        Name: "Parish of Saint Georges",
        
        FCode: "ADM1",
        CountryCode: "MS"
      },
      {
        id: "3578039",
        Name: "Parish of Saint Peter",
        
        FCode: "ADM1",
        CountryCode: "MS"
      }
    ],
  },
  {
    id: "3617476",
    Name: "Nicaragua",
    States: [
      {
        id: "3620673",
        Name: "Departamento de Boaco",
        
        FCode: "ADM1",
        CountryCode: "NI"
      },
      {
        id: "3620481",
        Name: "Departamento de Carazo",
        
        FCode: "ADM1",
        CountryCode: "NI"
      },
      {
        id: "3620380",
        Name: "Departamento de Chinandega",
        
        FCode: "ADM1",
        CountryCode: "NI"
      },
      {
        id: "3620368",
        Name: "Departamento de Chontales",
        
        FCode: "ADM1",
        CountryCode: "NI"
      },
      {
        id: "3619193",
        Name: "Departamento de Estelí",
        
        FCode: "ADM1",
        CountryCode: "NI"
      },
      {
        id: "3619135",
        Name: "Departamento de Granada",
        
        FCode: "ADM1",
        CountryCode: "NI"
      },
      {
        id: "3618928",
        Name: "Departamento de Jinotega",
        
        FCode: "ADM1",
        CountryCode: "NI"
      },
      {
        id: "3618029",
        Name: "Departamento de León",
        
        FCode: "ADM1",
        CountryCode: "NI"
      },
      {
        id: "3617796",
        Name: "Departamento de Madriz",
        
        FCode: "ADM1",
        CountryCode: "NI"
      },
      {
        id: "3617762",
        Name: "Departamento de Managua",
        
        FCode: "ADM1",
        CountryCode: "NI"
      },
      {
        id: "3617722",
        Name: "Departamento de Masaya",
        
        FCode: "ADM1",
        CountryCode: "NI"
      },
      {
        id: "3617707",
        Name: "Departamento de Matagalpa",
        
        FCode: "ADM1",
        CountryCode: "NI"
      },
      {
        id: "3617458",
        Name: "Departamento de Nueva Segovia",
        
        FCode: "ADM1",
        CountryCode: "NI"
      },
      {
        id: "3617051",
        Name: "Departamento de Rivas",
        
        FCode: "ADM1",
        CountryCode: "NI"
      },
      {
        id: "3617056",
        Name: "Departamento de Río San Juan",
        
        FCode: "ADM1",
        CountryCode: "NI"
      },
      {
        id: "3830307",
        Name: "Región Autónoma Atlántico Norte",
        
        FCode: "ADM1",
        CountryCode: "NI"
      },
      {
        id: "3830308",
        Name: "Región Autónoma Atlántico Sur",
        
        FCode: "ADM1",
        CountryCode: "NI"
      }
    ],
  },
  {
    id: "3703430",
    Name: "Panama",
    States: [
      {
        id: "7303686",
        Name: "Emberá-Wounaan",
        
        FCode: "ADM1",
        CountryCode: "PA"
      },
      {
        id: "3701537",
        Name: "Kuna Yala",
        
        FCode: "ADM1",
        CountryCode: "PA",
      },
      {
        id: "7303688",
        Name: "Ngöbe-Buglé",
        
        FCode: "ADM1",
        CountryCode: "PA"
      },
      {
        id: "3713954",
        Name: "Provincia de Bocas del Toro",
        
        FCode: "ADM1",
        CountryCode: "PA"
      },
      {
        id: "3712410",
        Name: "Provincia de Chiriquí",
        
        FCode: "ADM1",
        CountryCode: "PA"
      },
      {
        id: "3712162",
        Name: "Provincia de Coclé",
        
        FCode: "ADM1",
        CountryCode: "PA"
      },
      {
        id: "3712073",
        Name: "Provincia de Colón",
        
        FCode: "ADM1",
        CountryCode: "PA"
      },
      {
        id: "3708710",
        Name: "Provincia de Herrera",
        
        FCode: "ADM1",
        CountryCode: "PA"
      },
      {
        id: "3704961",
        Name: "Provincia de Los Santos",
        
        FCode: "ADM1",
        CountryCode: "PA"
      },
      {
        id: "3703433",
        Name: "Provincia de Panamá",
        
        FCode: "ADM1",
        CountryCode: "PA"
      },
      {
        id: "3700159",
        Name: "Provincia de Veraguas",
        
        FCode: "ADM1",
        CountryCode: "PA"
      },
      {
        id: "3711671",
        Name: "Provincia del Darién",
        
        FCode: "ADM1",
        CountryCode: "PA"
      }
    ],
  },
  {
    id: "4566966",
    Name: "Puerto Rico",
    States: [
      {
        id: "4562487",
        Name: "Adjuntas",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4562503",
        Name: "Aguada",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4562512",
        Name: "Aguadilla",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4562516",
        Name: "Aguas Buenas",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4562531",
        Name: "Aibonito",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4562640",
        Name: "Arecibo",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4562682",
        Name: "Arroyo",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4562605",
        Name: "Añasco",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4562771",
        Name: "Barceloneta",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4562779",
        Name: "Barranquitas",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4562837",
        Name: "Bayamón Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4562997",
        Name: "Cabo Rojo Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4563011",
        Name: "Caguas Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4563065",
        Name: "Camuy Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4563169",
        Name: "Canóvanas Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4563244",
        Name: "Carolina Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4563299",
        Name: "Cataño Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4563309",
        Name: "Cayey Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4563380",
        Name: "Ceiba Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4563774",
        Name: "Ciales Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4563778",
        Name: "Cidra Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4563812",
        Name: "Coamo Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4563921",
        Name: "Comerío Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4564004",
        Name: "Corozal Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4564071",
        Name: "Culebra Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4564134",
        Name: "Dorado Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4564949",
        Name: "Fajardo Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4564993",
        Name: "Florida Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4565107",
        Name: "Guayama Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4565112",
        Name: "Guayanilla Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4565120",
        Name: "Guaynabo Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4565126",
        Name: "Gurabo Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4565091",
        Name: "Guánica Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4565348",
        Name: "Hatillo Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4565381",
        Name: "Hormigueros Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4565449",
        Name: "Humacao Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4565713",
        Name: "Juana Díaz Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4565900",
        Name: "Lajas Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4565910",
        Name: "Lares Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4565961",
        Name: "Las Marías Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4565981",
        Name: "Las Piedras Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4566025",
        Name: "Loíza Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4566106",
        Name: "Luquillo Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4566138",
        Name: "Manatí Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4566180",
        Name: "Maricao Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4566209",
        Name: "Maunabo Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4566217",
        Name: "Mayagüez Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4566272",
        Name: "Moca Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4566334",
        Name: "Morovis Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4565581",
        Name: "Municipio de Isabela",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4565684",
        Name: "Municipio de Jayuya",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4565720",
        Name: "Municipio de Juncos",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4566397",
        Name: "Naguabo Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4566403",
        Name: "Naranjito Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4566456",
        Name: "Orocovis Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4566654",
        Name: "Patillas Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4566689",
        Name: "Peñuelas Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4566886",
        Name: "Ponce Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4567734",
        Name: "Quebradillas Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4567727",
        Name: "Rincón Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4567823",
        Name: "Río Grande Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4568015",
        Name: "Sabana Grande Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4568043",
        Name: "Salinas Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4568105",
        Name: "San Germán Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4568138",
        Name: "San Juan",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4568150",
        Name: "San Lorenzo Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4568177",
        Name: "San Sebastián Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4568213",
        Name: "Santa Isabel Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4568404",
        Name: "Toa Alta Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4568408",
        Name: "Toa Baja Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4568452",
        Name: "Trujillo Alto Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4568491",
        Name: "Utuado Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4568529",
        Name: "Vega Alta Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4568534",
        Name: "Vega Baja Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4568924",
        Name: "Vieques Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4568684",
        Name: "Villalba Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4568909",
        Name: "Yabucoa Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      },
      {
        id: "4568918",
        Name: "Yauco Municipio",
        
        FCode: "ADM1",
        CountryCode: "PR"
      }
    ],
  },
  {
    id: "3578476",
    Name: "Saint Barthélemy",
    States: [
      {
        id: "3579787",
        Name: "Anse des Cayes",
        
        FCode: "PPLL",
        CountryCode: "BL"
      },
      {
        id: "3579785",
        Name: "Anse des Flamands",
        
        FCode: "PPL",
        CountryCode: "BL"
      },
      {
        id: "3579485",
        Name: "Colombier",
        
        FCode: "PPL",
        CountryCode: "BL"
      },
      {
        id: "3579470",
        Name: "Corossol",
        
        FCode: "PPL",
        CountryCode: "BL"
      },
      {
        id: "3579243",
        Name: "Grand Cul-de-Sac",
        
        FCode: "PPL",
        CountryCode: "BL"
      },
      {
        id: "3579199",
        Name: "Grand Fond",
        
        FCode: "PPL",
        CountryCode: "BL"
      },
      {
        id: "3579132",
        Name: "Gustavia",
        
        FCode: "PPLC",
        CountryCode: "BL"
      },
      {
        id: "3579000",
        Name: "La Saline",
        
        FCode: "PPL",
        CountryCode: "BL"
      },
      {
        id: "3578974",
        Name: "Le Gouverneur",
        
        FCode: "PPL",
        CountryCode: "BL"
      },
      {
        id: "3578903",
        Name: "Lurin",
        
        FCode: "PPLL",
        CountryCode: "BL"
      },
      {
        id: "3578852",
        Name: "Marigot",
        
        FCode: "PPL",
        CountryCode: "BL"
      },
      {
        id: "3578678",
        Name: "Petit Cul de Sac",
        
        FCode: "PPLL",
        CountryCode: "BL"
      },
      {
        id: "3578562",
        Name: "Public",
        
        FCode: "PPL",
        CountryCode: "BL"
      },
      {
        id: "3578558",
        Name: "Quartier de Lorient",
        
        FCode: "PPL",
        CountryCode: "BL"
      },
      {
        id: "3578555",
        Name: "Quartier du Roi",
        
        FCode: "PPL",
        CountryCode: "BL"
      },
      {
        id: "3578433",
        Name: "Saint-Jean",
        
        FCode: "PPL",
        CountryCode: "BL"
      },
      {
        id: "3578337",
        Name: "Toiny",
        
        FCode: "PPL",
        CountryCode: "BL"
      }
    ],
  },
  {
    id: "3575174",
    Name: "Saint Kitts and Nevis",
    States: [
      {
        id: "3575476",
        Name: "Christ Church Nichola Town",
        
        FCode: "ADM1",
        CountryCode: "KN"
      },
      {
        id: "3575183",
        Name: "Saint Anne Sandy Point",
        
        FCode: "ADM1",
        CountryCode: "KN"
      },
      {
        id: "3575180",
        Name: "Saint George Basseterre",
        
        FCode: "ADM1",
        CountryCode: "KN"
      },
      {
        id: "3575179",
        Name: "Saint George Gingerland",
        
        FCode: "ADM1",
        CountryCode: "KN"
      },
      {
        id: "3575177",
        Name: "Saint James Windward",
        
        FCode: "ADM1",
        CountryCode: "KN"
      },
      {
        id: "3575176",
        Name: "Saint John Capesterre",
        
        FCode: "ADM1",
        CountryCode: "KN"
      },
      {
        id: "3575175",
        Name: "Saint John Figtree",
        
        FCode: "ADM1",
        CountryCode: "KN"
      },
      {
        id: "3575173",
        Name: "Saint Mary Cayon",
        
        FCode: "ADM1",
        CountryCode: "KN"
      },
      {
        id: "3575172",
        Name: "Saint Paul Capesterre",
        
        FCode: "ADM1",
        CountryCode: "KN"
      },
      {
        id: "3575171",
        Name: "Saint Paul Charlestown",
        
        FCode: "ADM1",
        CountryCode: "KN"
      },
      {
        id: "3575168",
        Name: "Saint Peter Basseterre",
        
        FCode: "ADM1",
        CountryCode: "KN"
      },
      {
        id: "3575165",
        Name: "Saint Thomas Lowland",
        
        FCode: "ADM1",
        CountryCode: "KN"
      },
      {
        id: "3575164",
        Name: "Saint Thomas Middle Island",
        
        FCode: "ADM1",
        CountryCode: "KN"
      },
      {
        id: "3575114",
        Name: "Trinity Palmetto Point",
        
        FCode: "ADM1",
        CountryCode: "KN"
      }
    ],
  },
  {
    id: "3576468",
    Name: "Saint Lucia",
    States: [
      {
        id: "3576891",
        Name: "Quarter of Anse-la-Raye",
        
        FCode: "ADM1",
        CountryCode: "LC"
      },
      {
        id: "3576810",
        Name: "Quarter of Castries",
        
        FCode: "ADM1",
        CountryCode: "LC"
      },
      {
        id: "3576794",
        Name: "Quarter of Choiseul",
        
        FCode: "ADM1",
        CountryCode: "LC"
      },
      {
        id: "3576771",
        Name: "Quarter of Dauphin",
        
        FCode: "ADM1",
        CountryCode: "LC"
      },
      {
        id: "3576764",
        Name: "Quarter of Dennery",
        
        FCode: "ADM1",
        CountryCode: "LC"
      },
      {
        id: "3576685",
        Name: "Quarter of Gros-Islet",
        
        FCode: "ADM1",
        CountryCode: "LC"
      },
      {
        id: "3576662",
        Name: "Quarter of Laborie",
        
        FCode: "ADM1",
        CountryCode: "LC"
      },
      {
        id: "3576567",
        Name: "Quarter of Micoud",
        
        FCode: "ADM1",
        CountryCode: "LC"
      },
      {
        id: "3576507",
        Name: "Quarter of Praslin",
        
        FCode: "ADM1",
        CountryCode: "LC"
      },
      {
        id: "3576441",
        Name: "Quarter of Soufrière",
        
        FCode: "ADM1",
        CountryCode: "LC"
      },
      {
        id: "3576413",
        Name: "Quarter of Vieux-Fort",
        
        FCode: "ADM1",
        CountryCode: "LC"
      }
    ],
  },
  {
    id: "3578421",
    Name: "Saint Martin",
    States: [
      {
        id: "6984581",
        Name: "Agrement",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6985363",
        Name: "Anse Marcel",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6984544",
        Name: "Baie Nettle",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6984598",
        Name: "Belle Hill",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6985389",
        Name: "Belle Plaine",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6984546",
        Name: "Bellevue",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6984586",
        Name: "Bienvenue",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6985386",
        Name: "Bloomingdale",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6985366",
        Name: "Cocksies",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "3578556",
        Name: "Colombier",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "3579484",
        Name: "Colombier",
        
        FCode: "PPL",
        CountryCode: "MF"
      },
      {
        id: "6984577",
        Name: "Concordia",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6984585",
        Name: "Cripple Gate",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "3579446",
        Name: "Cul de Sac",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6985388",
        Name: "Embouchure",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6985367",
        Name: "Espérance",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6985390",
        Name: "Flagstaff",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6985383",
        Name: "Fond Mahaut",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6984590",
        Name: "Friar's Bay",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6984580",
        Name: "Galisbay",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6985385",
        Name: "Grand Fond",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6985384",
        Name: "Grand Fond Nord",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "3579247",
        Name: "Grand-Case",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6985371",
        Name: "Griselle",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "3579123",
        Name: "Hameau du Pont",
        
        FCode: "PPL",
        CountryCode: "MF"
      },
      {
        id: "6984584",
        Name: "Helligard",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6985369",
        Name: "Hope Hill",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6984603",
        Name: "Industrie",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6984592",
        Name: "Jardin des Dains",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6984588",
        Name: "La Batterie",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6984576",
        Name: "La Colombe",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6984595",
        Name: "La Savane",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6985370",
        Name: "Les Jardins D’Orient Bay",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6984578",
        Name: "Les Village de St. Martin",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "3578851",
        Name: "Marigot",
        
        FCode: "PPLC",
        CountryCode: "MF",
      },
      {
        id: "6985387",
        Name: "Mont Saline",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6985368",
        Name: "Mont Vernon",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6984591",
        Name: "Morne Emile",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6984583",
        Name: "Morne Valois",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6692392",
        Name: "Orient Bay",
        
        FCode: "PPL",
        CountryCode: "MF"
      },
      {
        id: "6984597",
        Name: "Paradis",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6985372",
        Name: "Parc de la Baie Orientale",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6985379",
        Name: "Quartier D’Orleans Est",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6985377",
        Name: "Quartier D’Orleans Ouest",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6985378",
        Name: "Quartier D’Orleans Sud",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "3578559",
        Name: "Quartier de Grand’ Case",
        
        FCode: "PPL",
        CountryCode: "MF"
      },
      {
        id: "3578557",
        Name: "Quartier d’Orléans",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "3578544",
        Name: "Rambaud",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6984573",
        Name: "Saint Jean",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6984589",
        Name: "Saint Louis",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "3578434",
        Name: "Saint-James",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6984545",
        Name: "Sandy Ground",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6985380",
        Name: "Spring",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6984526",
        Name: "Terres Basses",
        
        FCode: "PPLL",
        CountryCode: "MF"
      },
      {
        id: "6984582",
        Name: "Valois",
        
        FCode: "PPLL",
        CountryCode: "MF"
      }
    ],
  },
  {
    id: "3424932",
    Name: "Saint Pierre and Miquelon",
    States: [
      {
        id: "3424938",
        Name: "Commune de Miquelon-Langlade",
        
        FCode: "ADM1",
        CountryCode: "PM"
      },
      {
        id: "3424935",
        Name: "Commune de Saint-Pierre",
        
        FCode: "ADM1",
        CountryCode: "PM"
      }
    ],
  },
  {
    id: "3577815",
    Name: "Saint Vincent and the Grenadines",
    States: [
      {
        id: "3577892",
        Name: "Grenadines",
        
        FCode: "ADM1",
        CountryCode: "VC"
      },
      {
        id: "3577934",
        Name: "Parish of Charlotte",
        
        FCode: "ADM1",
        CountryCode: "VC"
      },
      {
        id: "3577822",
        Name: "Parish of Saint Andrew",
        
        FCode: "ADM1",
        CountryCode: "VC"
      },
      {
        id: "3577821",
        Name: "Parish of Saint David",
        
        FCode: "ADM1",
        CountryCode: "VC"
      },
      {
        id: "3577819",
        Name: "Parish of Saint George",
        
        FCode: "ADM1",
        CountryCode: "VC"
      },
      {
        id: "3577818",
        Name: "Parish of Saint Patrick",
        
        FCode: "ADM1",
        CountryCode: "VC"
      }
    ],
  },
  {
    id: "7609695",
    Name: "Sint Maarten",
    States: [
      {
        id: "6985409",
        Name: "Almond Grove Estate",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "6985421",
        Name: "Beacon Hill",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513921",
        Name: "Belvédère",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513887",
        Name: "Bloomingdale",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "6985429",
        Name: "Cay Bay",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "6985406",
        Name: "Claude Estate",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "6985411",
        Name: "Cole Bay",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513794",
        Name: "Cul de Sac",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513792",
        Name: "Cupe Coy",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "6985398",
        Name: "Dawn Beach",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513782",
        Name: "Defiance",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513778",
        Name: "Diamond",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "6985404",
        Name: "Dutch Quarter",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513754",
        Name: "Ebenezer",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513750",
        Name: "Experiment",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513651",
        Name: "Industrie",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513572",
        Name: "Koolbaai",
        
        FCode: "PPL",
        CountryCode: "SX"
      },
      {
        id: "3513522",
        Name: "Lower Prince’s Quarter",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513514",
        Name: "Madame’s Estate",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "6985422",
        Name: "Maho Reef",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513490",
        Name: "Mary’s Fancy",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513473",
        Name: "Middle Region",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "6985405",
        Name: "Mont William Hill",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "6985423",
        Name: "Mullet Bay",
        
        FCode: "PPL",
        CountryCode: "SX"
      },
      {
        id: "3513450",
        Name: "Nazareth",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513438",
        Name: "One Hoe",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513431",
        Name: "Orange Grove",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513421",
        Name: "Over the Pond",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "7504626",
        Name: "Oyster Pond",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513392",
        Name: "Philipsburg",
        
        FCode: "PPLC",
        CountryCode: "SX",
      },
      {
        id: "3513384",
        Name: "Pine Garden",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "6985443",
        Name: "Pointe Blanche",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513354",
        Name: "Prospect Farm",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "6985431",
        Name: "Rabbit Hill",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "6985446",
        Name: "Red Pond",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513343",
        Name: "Retreat Estate",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513342",
        Name: "Reward",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "6985401",
        Name: "Rice Hill",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513332",
        Name: "Rockland",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "6985403",
        Name: "Saint James",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513261",
        Name: "Saunders",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "6957290",
        Name: "Simpson Bay",
        
        FCode: "PPL",
        CountryCode: "SX"
      },
      {
        id: "3513236",
        Name: "Simson Bay Village",
        
        FCode: "PPL",
        CountryCode: "SX"
      },
      {
        id: "3513195",
        Name: "Spring Garden",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513306",
        Name: "St. Peters",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513189",
        Name: "Sucker Garden",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "6985399",
        Name: "Tamarind Hill",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513172",
        Name: "The Corner",
        
        FCode: "PPL",
        CountryCode: "SX"
      },
      {
        id: "3513168",
        Name: "The Hope",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513166",
        Name: "The Villa",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513156",
        Name: "Trial",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513147",
        Name: "Union Farm",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513144",
        Name: "Upper Prince’s Quarter",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513130",
        Name: "Vineyard",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "6985407",
        Name: "Waymouth Hills Mildrum",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513101",
        Name: "Welgeleden",
        
        FCode: "PPLL",
        CountryCode: "SX"
      },
      {
        id: "3513085",
        Name: "Windsor",
        
        FCode: "PPL",
        CountryCode: "SX"
      },
      {
        id: "3513067",
        Name: "Zorg en Rust",
        
        FCode: "PPLL",
        CountryCode: "SX"
      }
    ],
  },
  {
    id: "3573591",
    Name: "Trinidad and Tobago",
    States: [
      {
        id: "3575052",
        Name: "Arima",
        
        FCode: "ADM1",
        CountryCode: "TT"
      },
      {
        id: "7521937",
        Name: "Chaguanas",
        
        FCode: "ADM1",
        CountryCode: "TT"
      },
      {
        id: "7521938",
        Name: "Couva-Tabaquite-Talparo",
        
        FCode: "ADM1",
        CountryCode: "TT"
      },
      {
        id: "7521939",
        Name: "Diego Martin",
        
        FCode: "ADM1",
        CountryCode: "TT"
      },
      {
        id: "7521940",
        Name: "Eastern Tobago",
        
        FCode: "ADM1",
        CountryCode: "TT"
      },
      {
        id: "3574155",
        Name: "Mayaro",
        
        FCode: "ADM1",
        CountryCode: "TT"
      },
      {
        id: "7521941",
        Name: "Penal/Debe",
        
        FCode: "ADM1",
        CountryCode: "TT"
      },
      {
        id: "7521943",
        Name: "Point Fortin",
        
        FCode: "ADM1",
        CountryCode: "TT"
      },
      {
        id: "3573891",
        Name: "Port-of-Spain",
        
        FCode: "ADM1",
        CountryCode: "TT"
      },
      {
        id: "7521942",
        Name: "Princes Town",
        
        FCode: "ADM1",
        CountryCode: "TT"
      },
      {
        id: "3573739",
        Name: "San Fernando",
        
        FCode: "ADM1",
        CountryCode: "TT"
      },
      {
        id: "7521946",
        Name: "San Juan/Laventille",
        
        FCode: "ADM1",
        CountryCode: "TT"
      },
      {
        id: "7521944",
        Name: "Sangre Grande",
        
        FCode: "ADM1",
        CountryCode: "TT"
      },
      {
        id: "7521945",
        Name: "Siparia",
        
        FCode: "ADM1",
        CountryCode: "TT"
      },
      {
        id: "3573606",
        Name: "Tobago",
        
        FCode: "ADM1",
        CountryCode: "TT"
      },
      {
        id: "7521947",
        Name: "Tunapuna/Piarco",
        
        FCode: "ADM1",
        CountryCode: "TT"
      }
    ],
  },
  {
    id: "3576916",
    Name: "Turks and Caicos Islands",
    States: [
      {
        id: "3577054",
        Name: "Balfour Town",
        
        FCode: "PPL",
        CountryCode: "TC"
      },
      {
        id: "3577053",
        Name: "Bambarra",
        
        FCode: "PPL",
        CountryCode: "TC"
      },
      {
        id: "3577027",
        Name: "Cockburn Harbour",
        
        FCode: "PPL",
        CountryCode: "TC"
      },
      {
        id: "3576994",
        Name: "Cockburn Town",
        
        FCode: "PPLC",
        CountryCode: "TC",
      },
      {
        id: "3577025",
        Name: "Conch Bar",
        
        FCode: "PPL",
        CountryCode: "TC"
      },
      {
        id: "3577004",
        Name: "Five Cays Settlement",
        
        FCode: "PPL",
        CountryCode: "TC"
      },
      {
        id: "8131575",
        Name: "Grace Bay",
        
        FCode: "PPL",
        CountryCode: "TC"
      },
      {
        id: "3576991",
        Name: "Greenwich",
        
        FCode: "PPL",
        CountryCode: "TC"
      },
      {
        id: "3576979",
        Name: "Kew",
        
        FCode: "PPL",
        CountryCode: "TC"
      },
      {
        id: "3576968",
        Name: "Lorimers",
        
        FCode: "PPL",
        CountryCode: "TC"
      },
      {
        id: "3576938",
        Name: "Sandy Point",
        
        FCode: "PPL",
        CountryCode: "TC"
      },
      {
        id: "3576905",
        Name: "Whitby",
        
        FCode: "PPL",
        CountryCode: "TC"
      }
    ],
  },
  {
    id: "4796775",
    Name: "U.S. Virgin Islands",
    States: [
      {
        id: "7267902",
        Name: "Saint Croix Island",
        
        FCode: "ADM1",
        CountryCode: "VI"
      },
      {
        id: "7267903",
        Name: "Saint John Island",
        
        FCode: "ADM1",
        CountryCode: "VI"
      },
      {
        id: "7267904",
        Name: "Saint Thomas Island",
        
        FCode: "ADM1",
        CountryCode: "VI"
      }
    ],
  },
  {
    id: "6252001",
    Name: "United States",
    States: [
      {
        id: "4829764",
        Name: "Alabama",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5879092",
        Name: "Alaska",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5551752",
        Name: "Arizona",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "4099753",
        Name: "Arkansas",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5332921",
        Name: "California",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5417618",
        Name: "Colorado",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "4831725",
        Name: "Connecticut",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "4142224",
        Name: "Delaware",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "4155751",
        Name: "Florida",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "4197000",
        Name: "Georgia",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5855797",
        Name: "Hawaii",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5596512",
        Name: "Idaho",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "4896861",
        Name: "Illinois",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "4921868",
        Name: "Indiana",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "4862182",
        Name: "Iowa",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "4273857",
        Name: "Kansas",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "6254925",
        Name: "Kentucky",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "4331987",
        Name: "Louisiana",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "4971068",
        Name: "Maine",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "4361885",
        Name: "Maryland",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "6254926",
        Name: "Massachusetts",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5001836",
        Name: "Michigan",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5037779",
        Name: "Minnesota",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "4436296",
        Name: "Mississippi",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "4398678",
        Name: "Missouri",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5667009",
        Name: "Montana",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5073708",
        Name: "Nebraska",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5509151",
        Name: "Nevada",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5090174",
        Name: "New Hampshire",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5101760",
        Name: "New Jersey",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5481136",
        Name: "New Mexico",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5128638",
        Name: "New York",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "4482348",
        Name: "North Carolina",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5690763",
        Name: "North Dakota",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5165418",
        Name: "Ohio",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "4544379",
        Name: "Oklahoma",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5744337",
        Name: "Oregon",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "6254927",
        Name: "Pennsylvania",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5224323",
        Name: "Rhode Island",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "4597040",
        Name: "South Carolina",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5769223",
        Name: "South Dakota",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "4662168",
        Name: "Tennessee",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "4736286",
        Name: "Texas",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5549030",
        Name: "Utah",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5242283",
        Name: "Vermont",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "6254928",
        Name: "Virginia",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5815135",
        Name: "Washington",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "4138106",
        Name: "Washington, D.C.",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "4826850",
        Name: "West Virginia",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5279468",
        Name: "Wisconsin",
        
        FCode: "ADM1",
        CountryCode: "US",
      },
      {
        id: "5843591",
        Name: "Wyoming",
        
        FCode: "ADM1",
        CountryCode: "US",
      }
    ],
  },
  {
    id: "2077456",
    Name: "Australia",
    States: [
      {
        id: "2177478",
        Name: "Australian Capital Territory",
        
        FCode: "ADM1",
        CountryCode: "AU"
      },
      {
        id: "2155400",
        Name: "New South Wales",
        
        FCode: "ADM1",
        CountryCode: "AU",
      },
      {
        id: "2064513",
        Name: "Northern Territory",
        
        FCode: "ADM1",
        CountryCode: "AU",
      },
      {
        id: "2152274",
        Name: "Queensland",
        
        FCode: "ADM1",
        CountryCode: "AU",
      },
      {
        id: "2061327",
        Name: "South Australia",
        
        FCode: "ADM1",
        CountryCode: "AU",
      },
      {
        id: "2147291",
        Name: "Tasmania",
        
        FCode: "ADM1",
        CountryCode: "AU",
      },
      {
        id: "2145234",
        Name: "Victoria",
        
        FCode: "ADM1",
        CountryCode: "AU",
      },
      {
        id: "2058645",
        Name: "Western Australia",
        
        FCode: "ADM1",
        CountryCode: "AU",
      }
    ],
  },
  {
    id: "1899402",
    Name: "Cook Islands",
    States: [
      {
        id: "4035755",
        Name: "Amuri",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035729",
        Name: "Areora",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035730",
        Name: "Areora",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035726",
        Name: "Arorangi",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035725",
        Name: "Arutanga",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035715",
        Name: "Avarua",
        
        FCode: "PPLC",
        CountryCode: "CK",
      },
      {
        id: "4035712",
        Name: "Avatiu",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035694",
        Name: "Ivirua",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4036480",
        Name: "Karanga Village",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4036467",
        Name: "Kimiangatau Village",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4036465",
        Name: "Mangarei Village",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035655",
        Name: "Mapumai",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4036498",
        Name: "Matavera",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035637",
        Name: "Muri",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035632",
        Name: "Natikitea",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035626",
        Name: "Ngatangiia",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035622",
        Name: "Ngatiarua",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035623",
        Name: "Ngatiarua",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4036495",
        Name: "Nikao",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4036522",
        Name: "Nikaupara",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035613",
        Name: "Nukatere",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035612",
        Name: "Nukuao",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4031141",
        Name: "Omoka",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035601",
        Name: "Oneroa",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4036432",
        Name: "Palmerston",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035585",
        Name: "Papaolematuu",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035584",
        Name: "Papapapaitai",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035583",
        Name: "Papapapaiuta",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4036496",
        Name: "Pue",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4036528",
        Name: "Reureu",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035549",
        Name: "Roto",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035530",
        Name: "Tamarua",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035523",
        Name: "Tauhunu",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4036511",
        Name: "Tautu",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035509",
        Name: "Te Enui",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4031126",
        Name: "Te Tautua",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035494",
        Name: "Tengatangi",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035481",
        Name: "Titikaveka",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035463",
        Name: "Tukao",
        
        FCode: "PPL",
        CountryCode: "CK"
      },
      {
        id: "4035447",
        Name: "Vaipae",
        
        FCode: "PPL",
        CountryCode: "CK"
      }
    ],
  },
  {
    id: "1966436",
    Name: "East Timor",
    States: [
      {
        id: "1648513",
        Name: "Bobonaro",
        
        FCode: "ADM1",
        CountryCode: "TL",
      },
      {
        id: "1651815",
        Name: "Distrito Aileu",
        
        FCode: "ADM1",
        CountryCode: "TL"
      },
      {
        id: "1651809",
        Name: "Distrito Ainaro",
        
        FCode: "ADM1",
        CountryCode: "TL"
      },
      {
        id: "1649538",
        Name: "Distrito Bacau",
        
        FCode: "ADM1",
        CountryCode: "TL"
      },
      {
        id: "1639462",
        Name: "Distrito Cova Lima",
        
        FCode: "ADM1",
        CountryCode: "TL"
      },
      {
        id: "1645456",
        Name: "Distrito Díli",
        
        FCode: "ADM1",
        CountryCode: "TL"
      },
      {
        id: "1638294",
        Name: "Distrito Lautém",
        
        FCode: "ADM1",
        CountryCode: "TL"
      },
      {
        id: "1637729",
        Name: "Distrito Liquiçá",
        
        FCode: "ADM1",
        CountryCode: "TL"
      },
      {
        id: "1636525",
        Name: "Distrito Manatuto",
        
        FCode: "ADM1",
        CountryCode: "TL"
      },
      {
        id: "1651539",
        Name: "Distrito Oecussi-Ambeno",
        
        FCode: "ADM1",
        CountryCode: "TL"
      },
      {
        id: "1622470",
        Name: "Distrito Viqueque",
        
        FCode: "ADM1",
        CountryCode: "TL"
      },
      {
        id: "1644865",
        Name: "Ermera",
        
        FCode: "ADM1",
        CountryCode: "TL",
      },
      {
        id: "1636309",
        Name: "Manufahi",
        
        FCode: "ADM1",
        CountryCode: "TL",
      }
    ],
  },
  {
    id: "2205218",
    Name: "Fiji",
    States: [
      {
        id: "2205272",
        Name: "Central",
        
        FCode: "ADM1",
        CountryCode: "FJ",
      },
      {
        id: "4036647",
        Name: "Eastern",
        
        FCode: "ADM1",
        CountryCode: "FJ",
      },
      {
        id: "2199295",
        Name: "Northern",
        
        FCode: "ADM1",
        CountryCode: "FJ",
      },
      {
        id: "6324593",
        Name: "Rotuma",
        
        FCode: "ADM1",
        CountryCode: "FJ"
      },
      {
        id: "2194371",
        Name: "Western",
        
        FCode: "ADM1",
        CountryCode: "FJ",
      }
    ],
  },
  {
    id: "4030656",
    Name: "French Polynesia",
    States: [
      {
        id: "4034366",
        Name: "Îles Australes",
        
        FCode: "ADM1",
        CountryCode: "PF"
      },
      {
        id: "4019991",
        Name: "Îles Marquises",
        
        FCode: "ADM1",
        CountryCode: "PF"
      },
      {
        id: "4034364",
        Name: "Îles Sous-le-Vent",
        
        FCode: "ADM1",
        CountryCode: "PF"
      },
      {
        id: "4030621",
        Name: "Îles Tuamotu-Gambier",
        
        FCode: "ADM1",
        CountryCode: "PF"
      },
      {
        id: "4034365",
        Name: "Îles du Vent",
        
        FCode: "ADM1",
        CountryCode: "PF"
      }
    ],
  },
  {
    id: "4043988",
    Name: "Guam",
    States: [
      {
        id: "4043524",
        Name: "Agana Heights Municipality",
        
        FCode: "ADM1",
        CountryCode: "GU"
      },
      {
        id: "4043725",
        Name: "Agat Municipality",
        
        FCode: "ADM1",
        CountryCode: "GU"
      },
      {
        id: "4043691",
        Name: "Asan-Maina Municipality",
        
        FCode: "ADM1",
        CountryCode: "GU"
      },
      {
        id: "4043885",
        Name: "Barrigada Municipality",
        
        FCode: "ADM1",
        CountryCode: "GU"
      },
      {
        id: "4043614",
        Name: "Chalan Pago-Ordot Municipality",
        
        FCode: "ADM1",
        CountryCode: "GU"
      },
      {
        id: "4043877",
        Name: "Dededo Municipality",
        
        FCode: "ADM1",
        CountryCode: "GU"
      },
      {
        id: "4044019",
        Name: "Hagåtña Municipality",
        
        FCode: "ADM1",
        CountryCode: "GU"
      },
      {
        id: "4044041",
        Name: "Inarajan Municipality",
        
        FCode: "ADM1",
        CountryCode: "GU"
      },
      {
        id: "4043416",
        Name: "Mangilao Municipality",
        
        FCode: "ADM1",
        CountryCode: "GU"
      },
      {
        id: "4043396",
        Name: "Merizo Municipality",
        
        FCode: "ADM1",
        CountryCode: "GU"
      },
      {
        id: "4044148",
        Name: "Mongmong-Toto-Maite Municipality",
        
        FCode: "ADM1",
        CountryCode: "GU"
      },
      {
        id: "4038478",
        Name: "Piti Municipality",
        
        FCode: "ADM1",
        CountryCode: "GU"
      },
      {
        id: "4038555",
        Name: "Santa Rita Municipality",
        
        FCode: "ADM1",
        CountryCode: "GU"
      },
      {
        id: "4038590",
        Name: "Sinajana Municipality",
        
        FCode: "ADM1",
        CountryCode: "GU"
      },
      {
        id: "4038652",
        Name: "Talofofo Municipality",
        
        FCode: "ADM1",
        CountryCode: "GU"
      },
      {
        id: "4038661",
        Name: "Tamuning-Tumon-Harmon Municipality",
        
        FCode: "ADM1",
        CountryCode: "GU"
      },
      {
        id: "4038739",
        Name: "Umatac Municipality",
        
        FCode: "ADM1",
        CountryCode: "GU"
      },
      {
        id: "4038796",
        Name: "Yigo Municipality",
        
        FCode: "ADM1",
        CountryCode: "GU"
      },
      {
        id: "4038811",
        Name: "Yona Municipality",
        
        FCode: "ADM1",
        CountryCode: "GU"
      }
    ],
  },
  {
    id: "4030945",
    Name: "Kiribati",
    States: [
      {
        id: "2110215",
        Name: "Gilbert Islands",
        
        FCode: "ADM1",
        CountryCode: "KI",
      },
      {
        id: "4030940",
        Name: "Line Islands",
        
        FCode: "ADM1",
        CountryCode: "KI",
      },
      {
        id: "7521379",
        Name: "Phoenix Islands",
        
        FCode: "ADM1",
        CountryCode: "KI"
      }
    ],
  },
  {
    id: "2080185",
    Name: "Marshall Islands",
    States: [
      {
        id: "7303491",
        Name: "Ailinginae Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303492",
        Name: "Ailinglaplap Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303493",
        Name: "Ailuk Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303494",
        Name: "Arno Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303495",
        Name: "Aur Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303496",
        Name: "Bikar Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303497",
        Name: "Bikini Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303513",
        Name: "Bokak Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303498",
        Name: "Ebon Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303499",
        Name: "Enewetak Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303500",
        Name: "Erikub Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303519",
        Name: "Jabat Island",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303501",
        Name: "Jaluit Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303520",
        Name: "Jemo Island",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303521",
        Name: "Kili Island",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303502",
        Name: "Kwajalein Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303503",
        Name: "Lae Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303522",
        Name: "Lib Island",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303504",
        Name: "Likiep Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303505",
        Name: "Majuro Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303506",
        Name: "Maloelap Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303523",
        Name: "Mejit Island",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303507",
        Name: "Mili Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303508",
        Name: "Namdrik Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303509",
        Name: "Namu Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303510",
        Name: "Rongelap Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303511",
        Name: "Rongrik Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303512",
        Name: "Taka Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303514",
        Name: "Ujae Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303515",
        Name: "Ujelang Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303516",
        Name: "Utrik Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303517",
        Name: "Wotho Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      },
      {
        id: "7303518",
        Name: "Wotje Atoll",
        
        FCode: "ADM1",
        CountryCode: "MH"
      }
    ],
  },
  {
    id: "2081918",
    Name: "Micronesia",
    States: [
      {
        id: "2082282",
        Name: "State of Chuuk",
        
        FCode: "ADM1",
        CountryCode: "FM"
      },
      {
        id: "2082036",
        Name: "State of Kosrae",
        
        FCode: "ADM1",
        CountryCode: "FM"
      },
      {
        id: "2081550",
        Name: "State of Pohnpei",
        
        FCode: "ADM1",
        CountryCode: "FM"
      },
      {
        id: "2081175",
        Name: "State of Yap",
        
        FCode: "ADM1",
        CountryCode: "FM"
      }
    ],
  },
  {
    id: "2110425",
    Name: "Nauru",
    States: [
      {
        id: "2110451",
        Name: "Aiwo",
        
        FCode: "ADM1",
        CountryCode: "NR",
      },
      {
        id: "2110449",
        Name: "Anabar",
        
        FCode: "ADM1",
        CountryCode: "NR",
      },
      {
        id: "2110448",
        Name: "Anetan",
        
        FCode: "ADM1",
        CountryCode: "NR",
      },
      {
        id: "2110445",
        Name: "Anibare",
        
        FCode: "ADM1",
        CountryCode: "NR",
      },
      {
        id: "2110442",
        Name: "Baiti",
        
        FCode: "ADM1",
        CountryCode: "NR",
      },
      {
        id: "2110441",
        Name: "Boe",
        
        FCode: "ADM1",
        CountryCode: "NR",
      },
      {
        id: "2110440",
        Name: "Buada",
        
        FCode: "ADM1",
        CountryCode: "NR",
      },
      {
        id: "2110437",
        Name: "Denigomodu",
        
        FCode: "ADM1",
        CountryCode: "NR",
      },
      {
        id: "2110435",
        Name: "Ewa",
        
        FCode: "ADM1",
        CountryCode: "NR",
      },
      {
        id: "2110432",
        Name: "Ijuw",
        
        FCode: "ADM1",
        CountryCode: "NR",
      },
      {
        id: "2110431",
        Name: "Meneng",
        
        FCode: "ADM1",
        CountryCode: "NR",
      },
      {
        id: "2110423",
        Name: "Nibok",
        
        FCode: "ADM1",
        CountryCode: "NR",
      },
      {
        id: "2110420",
        Name: "Uaboe",
        
        FCode: "ADM1",
        CountryCode: "NR",
      },
      {
        id: "2110418",
        Name: "Yaren",
        
        FCode: "ADM1",
        CountryCode: "NR",
      }
    ],
  },
  {
    id: "2139685",
    Name: "New Caledonia",
    States: [
      {
        id: "2140685",
        Name: "Province Nord",
        
        FCode: "ADM1",
        CountryCode: "NC"
      },
      {
        id: "2140464",
        Name: "Province Sud",
        
        FCode: "ADM1",
        CountryCode: "NC"
      },
      {
        id: "7521415",
        Name: "Province des îles Loyauté",
        
        FCode: "ADM1",
        CountryCode: "NC"
      }
    ],
  },
  {
    id: "2186224",
    Name: "New Zealand",
    States: [
      {
        id: "2193734",
        Name: "Auckland",
        
        FCode: "ADM1",
        CountryCode: "NZ",
      },
      {
        id: "2182560",
        Name: "Bay of Plenty",
        
        FCode: "ADM1",
        CountryCode: "NZ"
      },
      {
        id: "2192628",
        Name: "Canterbury",
        
        FCode: "ADM1",
        CountryCode: "NZ"
      },
      {
        id: "4033013",
        Name: "Chatham Islands",
        
        FCode: "ADM1",
        CountryCode: "NZ",
      },
      {
        id: "2190767",
        Name: "Gisborne",
        
        FCode: "ADM1",
        CountryCode: "NZ"
      },
      {
        id: "2190146",
        Name: "Hawke's Bay",
        
        FCode: "ADM1",
        CountryCode: "NZ"
      },
      {
        id: "2179671",
        Name: "Manawatu-Wanganui",
        
        FCode: "ADM1",
        CountryCode: "NZ"
      },
      {
        id: "2187304",
        Name: "Marlborough",
        
        FCode: "ADM1",
        CountryCode: "NZ"
      },
      {
        id: "6612108",
        Name: "Nelson",
        
        FCode: "ADM1",
        CountryCode: "NZ"
      },
      {
        id: "2185978",
        Name: "Northland",
        
        FCode: "ADM1",
        CountryCode: "NZ"
      },
      {
        id: "6612109",
        Name: "Otago",
        
        FCode: "ADM1",
        CountryCode: "NZ"
      },
      {
        id: "2182501",
        Name: "Southland",
        
        FCode: "ADM1",
        CountryCode: "NZ"
      },
      {
        id: "2181872",
        Name: "Taranaki",
        
        FCode: "ADM1",
        CountryCode: "NZ"
      },
      {
        id: "2181818",
        Name: "Tasman",
        
        FCode: "ADM1",
        CountryCode: "NZ"
      },
      {
        id: "2180293",
        Name: "Waikato",
        
        FCode: "ADM1",
        CountryCode: "NZ"
      },
      {
        id: "2179538",
        Name: "Wellington",
        
        FCode: "ADM1",
        CountryCode: "NZ",
      },
      {
        id: "6612113",
        Name: "West Coast",
        
        FCode: "ADM1",
        CountryCode: "NZ"
      }
    ],
  },
  {
    id: "4036232",
    Name: "Niue",
    States: [
      {
        id: "4036284",
        Name: "Alofi",
        
        FCode: "PPLC",
        CountryCode: "NU",
      },
      {
        id: "4036279",
        Name: "Avatele",
        
        FCode: "PPL",
        CountryCode: "NU"
      },
      {
        id: "4036274",
        Name: "Fatiau",
        
        FCode: "PPL",
        CountryCode: "NU"
      },
      {
        id: "4036268",
        Name: "Hakupu",
        
        FCode: "PPL",
        CountryCode: "NU"
      },
      {
        id: "4036267",
        Name: "Hikutivake",
        
        FCode: "PPL",
        CountryCode: "NU"
      },
      {
        id: "4036265",
        Name: "Huvalu",
        
        FCode: "PPL",
        CountryCode: "NU"
      },
      {
        id: "4036261",
        Name: "Lakepa",
        
        FCode: "PPL",
        CountryCode: "NU"
      },
      {
        id: "4036256",
        Name: "Liha",
        
        FCode: "PPL",
        CountryCode: "NU"
      },
      {
        id: "4036255",
        Name: "Liku",
        
        FCode: "PPL",
        CountryCode: "NU"
      },
      {
        id: "4036247",
        Name: "Makefu",
        
        FCode: "PPL",
        CountryCode: "NU"
      },
      {
        id: "4036246",
        Name: "Mamakula",
        
        FCode: "PPL",
        CountryCode: "NU"
      },
      {
        id: "4036242",
        Name: "Matalave",
        
        FCode: "PPL",
        CountryCode: "NU"
      },
      {
        id: "4036234",
        Name: "Mutalau",
        
        FCode: "PPL",
        CountryCode: "NU"
      },
      {
        id: "4036222",
        Name: "Taoli",
        
        FCode: "PPL",
        CountryCode: "NU"
      },
      {
        id: "4036212",
        Name: "Tuapa",
        
        FCode: "PPL",
        CountryCode: "NU"
      }
    ],
  },
  {
    id: "2155115",
    Name: "Norfolk Island",
    States: [
      {
        id: "2172160",
        Name: "Cascade Station",
        
        FCode: "PPL",
        CountryCode: "NF"
      },
      {
        id: "2161314",
        Name: "Kingston",
        
        FCode: "PPLC",
        CountryCode: "NF",
      },
      {
        id: "2159622",
        Name: "Longridge Station",
        
        FCode: "PPL",
        CountryCode: "NF"
      }
    ],
  },
  {
    id: "4041468",
    Name: "Northern Mariana Islands",
    States: [
      {
        id: "7733156",
        Name: "Northern Islands Municipality",
        
        FCode: "ADM1",
        CountryCode: "MP"
      },
      {
        id: "4041530",
        Name: "Rota Municipality",
        
        FCode: "ADM1",
        CountryCode: "MP"
      },
      {
        id: "4041552",
        Name: "Saipan Municipality",
        
        FCode: "ADM1",
        CountryCode: "MP"
      },
      {
        id: "4041650",
        Name: "Tinian Municipality",
        
        FCode: "ADM1",
        CountryCode: "MP"
      }
    ],
  },
  {
    id: "1559582",
    Name: "Palau",
    States: [
      {
        id: "1559964",
        Name: "State of Aimeliik",
        
        FCode: "ADM1",
        CountryCode: "PW"
      },
      {
        id: "4037645",
        Name: "State of Airai",
        
        FCode: "ADM1",
        CountryCode: "PW"
      },
      {
        id: "4037653",
        Name: "State of Angaur",
        
        FCode: "ADM1",
        CountryCode: "PW"
      },
      {
        id: "1559776",
        Name: "State of Hatohobei",
        
        FCode: "ADM1",
        CountryCode: "PW"
      },
      {
        id: "1559774",
        Name: "State of Kayangel",
        
        FCode: "ADM1",
        CountryCode: "PW"
      },
      {
        id: "4037892",
        Name: "State of Koror",
        
        FCode: "ADM1",
        CountryCode: "PW"
      },
      {
        id: "4037930",
        Name: "State of Melekeok",
        
        FCode: "ADM1",
        CountryCode: "PW"
      },
      {
        id: "4037962",
        Name: "State of Ngaraard",
        
        FCode: "ADM1",
        CountryCode: "PW"
      },
      {
        id: "4038037",
        Name: "State of Ngarchelong",
        
        FCode: "ADM1",
        CountryCode: "PW"
      },
      {
        id: "4038043",
        Name: "State of Ngardmau",
        
        FCode: "ADM1",
        CountryCode: "PW"
      },
      {
        id: "1559532",
        Name: "State of Ngatpang",
        
        FCode: "ADM1",
        CountryCode: "PW"
      },
      {
        id: "4037976",
        Name: "State of Ngchesar",
        
        FCode: "ADM1",
        CountryCode: "PW"
      },
      {
        id: "4038068",
        Name: "State of Ngeremlengui",
        
        FCode: "ADM1",
        CountryCode: "PW"
      },
      {
        id: "4038179",
        Name: "State of Ngiwal",
        
        FCode: "ADM1",
        CountryCode: "PW"
      },
      {
        id: "4038261",
        Name: "State of Peleliu",
        
        FCode: "ADM1",
        CountryCode: "PW"
      },
      {
        id: "1559630",
        Name: "State of Sonsorol",
        
        FCode: "ADM1",
        CountryCode: "PW"
      }
    ],
  },
  {
    id: "2088628",
    Name: "Papua New Guinea",
    States: [
      {
        id: "2089470",
        Name: "Bougainville",
        
        FCode: "ADM1",
        CountryCode: "PG"
      },
      {
        id: "2133763",
        Name: "Central Province",
        
        FCode: "ADM1",
        CountryCode: "PG"
      },
      {
        id: "2098593",
        Name: "Chimbu Province",
        
        FCode: "ADM1",
        CountryCode: "PG"
      },
      {
        id: "2097853",
        Name: "East New Britain Province",
        
        FCode: "ADM1",
        CountryCode: "PG"
      },
      {
        id: "2097846",
        Name: "East Sepik Province",
        
        FCode: "ADM1",
        CountryCode: "PG"
      },
      {
        id: "2097855",
        Name: "Eastern Highlands Province",
        
        FCode: "ADM1",
        CountryCode: "PG"
      },
      {
        id: "2097655",
        Name: "Enga Province",
        
        FCode: "ADM1",
        CountryCode: "PG"
      },
      {
        id: "2096633",
        Name: "Gulf Province",
        
        FCode: "ADM1",
        CountryCode: "PG"
      },
      {
        id: "2091993",
        Name: "Madang Province",
        
        FCode: "ADM1",
        CountryCode: "PG"
      },
      {
        id: "2091495",
        Name: "Manus Province",
        
        FCode: "ADM1",
        CountryCode: "PG"
      },
      {
        id: "2132895",
        Name: "Milne Bay Province",
        
        FCode: "ADM1",
        CountryCode: "PG"
      },
      {
        id: "2090468",
        Name: "Morobe Province",
        
        FCode: "ADM1",
        CountryCode: "PG"
      },
      {
        id: "2089856",
        Name: "National Capital District",
        
        FCode: "ADM1",
        CountryCode: "PG"
      },
      {
        id: "2089693",
        Name: "New Ireland",
        
        FCode: "ADM1",
        CountryCode: "PG",
      },
      {
        id: "2089478",
        Name: "Northern Province",
        
        FCode: "ADM1",
        CountryCode: "PG"
      },
      {
        id: "2087246",
        Name: "Sandaun Province",
        
        FCode: "ADM1",
        CountryCode: "PG"
      },
      {
        id: "2086331",
        Name: "Southern Highlands Province",
        
        FCode: "ADM1",
        CountryCode: "PG"
      },
      {
        id: "2083546",
        Name: "West New Britain Province",
        
        FCode: "ADM1",
        CountryCode: "PG"
      },
      {
        id: "2083551",
        Name: "Western Highlands Province",
        
        FCode: "ADM1",
        CountryCode: "PG"
      },
      {
        id: "2083549",
        Name: "Western Province",
        
        FCode: "ADM1",
        CountryCode: "PG"
      }
    ],
  },
  {
    id: "4030699",
    Name: "Pitcairn Islands",
    States: [
      {
        id: "4030723",
        Name: "Adams Town",
        
        FCode: "PPLC",
        CountryCode: "PN",
      },
      {
        id: "8063825",
        Name: "Kundur marqa",
        
        FCode: "PPL",
        CountryCode: "PN"
      },
      {
        id: "7576192",
        Name: "place",
        
        FCode: "PPL",
        CountryCode: "PN"
      }
    ],
  },
  {
    id: "4034894",
    Name: "Samoa",
    States: [
      {
        id: "4035434",
        Name: "A`ana",
        
        FCode: "ADM1",
        CountryCode: "WS"
      },
      {
        id: "4035425",
        Name: "Aiga-i-le-Tai",
        
        FCode: "ADM1",
        CountryCode: "WS"
      },
      {
        id: "4035402",
        Name: "Atua",
        
        FCode: "ADM1",
        CountryCode: "WS"
      },
      {
        id: "4035383",
        Name: "Fa`asaleleaga",
        
        FCode: "ADM1",
        CountryCode: "WS"
      },
      {
        id: "4035314",
        Name: "Gaga`emauga",
        
        FCode: "ADM1",
        CountryCode: "WS"
      },
      {
        id: "4035313",
        Name: "Gagaifomauga",
        
        FCode: "ADM1",
        CountryCode: "WS"
      },
      {
        id: "4035154",
        Name: "Palauli",
        
        FCode: "ADM1",
        CountryCode: "WS"
      },
      {
        id: "4035046",
        Name: "Satupa`itea",
        
        FCode: "ADM1",
        CountryCode: "WS"
      },
      {
        id: "4034977",
        Name: "Tuamasaga",
        
        FCode: "ADM1",
        CountryCode: "WS"
      },
      {
        id: "4034943",
        Name: "Va`a-o-Fonoti",
        
        FCode: "ADM1",
        CountryCode: "WS"
      },
      {
        id: "4034910",
        Name: "Vaisigano",
        
        FCode: "ADM1",
        CountryCode: "WS"
      }
    ],
  },
  {
    id: "2103350",
    Name: "Solomon Islands",
    States: [
      {
        id: "2109495",
        Name: "Central Province",
        
        FCode: "ADM1",
        CountryCode: "SB"
      },
      {
        id: "7280292",
        Name: "Choiseul",
        
        FCode: "ADM1",
        CountryCode: "SB"
      },
      {
        id: "2108831",
        Name: "Guadalcanal Province",
        
        FCode: "ADM1",
        CountryCode: "SB"
      },
      {
        id: "2108262",
        Name: "Isabel Province",
        
        FCode: "ADM1",
        CountryCode: "SB"
      },
      {
        id: "2178730",
        Name: "Makira-Ulawa Province",
        
        FCode: "ADM1",
        CountryCode: "SB"
      },
      {
        id: "2106552",
        Name: "Malaita Province",
        
        FCode: "ADM1",
        CountryCode: "SB"
      },
      {
        id: "7280293",
        Name: "Rennell and Bellona",
        
        FCode: "ADM1",
        CountryCode: "SB"
      },
      {
        id: "2178472",
        Name: "Temotu Province",
        
        FCode: "ADM1",
        CountryCode: "SB"
      },
      {
        id: "2101556",
        Name: "Western Province",
        
        FCode: "ADM1",
        CountryCode: "SB"
      }
    ],
  },
  {
    id: "4031074",
    Name: "Tokelau",
    States: [
      {
        id: "4031116",
        Name: "Atafu",
        
        FCode: "ADM1",
        CountryCode: "TK"
      },
      {
        id: "4031112",
        Name: "Fakaofo",
        
        FCode: "ADM1",
        CountryCode: "TK",
      },
      {
        id: "4031091",
        Name: "Nukunonu",
        
        FCode: "ADM1",
        CountryCode: "TK"
      }
    ],
  },
  {
    id: "4032283",
    Name: "Tonga",
    States: [
      {
        id: "7668021",
        Name: "Eua",
        
        FCode: "ADM1",
        CountryCode: "TO"
      },
      {
        id: "4032637",
        Name: "Ha`apai",
        
        FCode: "ADM1",
        CountryCode: "TO"
      },
      {
        id: "7668055",
        Name: "Niuas",
        
        FCode: "ADM1",
        CountryCode: "TO"
      },
      {
        id: "4032279",
        Name: "Tongatapu",
        
        FCode: "ADM1",
        CountryCode: "TO"
      },
      {
        id: "4032231",
        Name: "Vava`u",
        
        FCode: "ADM1",
        CountryCode: "TO"
      }
    ],
  },
  {
    id: "2110297",
    Name: "Tuvalu",
    States: [
      {
        id: "2110384",
        Name: "Funafuti",
        
        FCode: "ADM1",
        CountryCode: "TV"
      },
      {
        id: "7601980",
        Name: "Nanumanga",
        
        FCode: "ADM1",
        CountryCode: "TV"
      },
      {
        id: "2110345",
        Name: "Nanumea",
        
        FCode: "ADM1",
        CountryCode: "TV",
      },
      {
        id: "7601979",
        Name: "Niutao",
        
        FCode: "ADM1",
        CountryCode: "TV"
      },
      {
        id: "2110341",
        Name: "Nui",
        
        FCode: "ADM1",
        CountryCode: "TV",
      },
      {
        id: "7601982",
        Name: "Nukufetau",
        
        FCode: "ADM1",
        CountryCode: "TV"
      },
      {
        id: "7601983",
        Name: "Nukulaelae",
        
        FCode: "ADM1",
        CountryCode: "TV"
      },
      {
        id: "7601981",
        Name: "Vaitupu",
        
        FCode: "ADM1",
        CountryCode: "TV"
      }
    ],
  },
  {
    id: "5854968",
    Name: "U.S. Minor Outlying Islands",
    States: [
      {
        id: "5854907",
        Name: "Baker Island",
        
        FCode: "ADM1",
        CountryCode: "UM"
      },
      {
        id: "5854922",
        Name: "Howland Island",
        
        FCode: "ADM1",
        CountryCode: "UM"
      },
      {
        id: "5854926",
        Name: "Jarvis Island",
        
        FCode: "ADM1",
        CountryCode: "UM"
      },
      {
        id: "5854929",
        Name: "Johnston Atoll",
        
        FCode: "ADM1",
        CountryCode: "UM"
      },
      {
        id: "5854936",
        Name: "Kingman Reef",
        
        FCode: "ADM1",
        CountryCode: "UM"
      },
      {
        id: "5854943",
        Name: "Midway Islands",
        
        FCode: "ADM1",
        CountryCode: "UM"
      },
      {
        id: "4743755",
        Name: "Navassa Island",
        
        FCode: "ADM1",
        CountryCode: "UM",
      },
      {
        id: "5854952",
        Name: "Palmyra Atoll",
        
        FCode: "ADM1",
        CountryCode: "UM"
      },
      {
        id: "4041685",
        Name: "Wake Island",
        
        FCode: "ADM1",
        CountryCode: "UM",
      }
    ],
  },
  {
    id: "2134431",
    Name: "Vanuatu",
    States: [
      {
        id: "2208265",
        Name: "Malampa Province",
        
        FCode: "ADM1",
        CountryCode: "VU"
      },
      {
        id: "2208266",
        Name: "Penama Province",
        
        FCode: "ADM1",
        CountryCode: "VU"
      },
      {
        id: "2134898",
        Name: "Sanma Province",
        
        FCode: "ADM1",
        CountryCode: "VU"
      },
      {
        id: "2208267",
        Name: "Shefa Province",
        
        FCode: "ADM1",
        CountryCode: "VU"
      },
      {
        id: "2134739",
        Name: "Tafea Province",
        
        FCode: "ADM1",
        CountryCode: "VU"
      },
      {
        id: "2137421",
        Name: "Torba Province",
        
        FCode: "ADM1",
        CountryCode: "VU"
      }
    ],
  },
  {
    id: "4034749",
    Name: "Wallis and Futuna",
    States: [
      {
        id: "4034884",
        Name: "Circonscription d'Alo",
        
        FCode: "ADM1",
        CountryCode: "WF"
      },
      {
        id: "4034759",
        Name: "Circonscription d'Uvéa",
        
        FCode: "ADM1",
        CountryCode: "WF"
      },
      {
        id: "4034776",
        Name: "Circonscription de Sigavé",
        
        FCode: "ADM1",
        CountryCode: "WF"
      }
    ],
  },
  {
    id: "3865483",
    Name: "Argentina",
    States: [
      {
        id: "3433955",
        Name: "Buenos Aires F.D.",
        
        FCode: "ADM1",
        CountryCode: "AR",
      },
      {
        id: "3435907",
        Name: "Provincia de Buenos Aires",
        
        FCode: "ADM1",
        CountryCode: "AR",
      },
      {
        id: "3862286",
        Name: "Provincia de Catamarca",
        
        FCode: "ADM1",
        CountryCode: "AR"
      },
      {
        id: "3435214",
        Name: "Provincia de Corrientes",
        
        FCode: "ADM1",
        CountryCode: "AR"
      },
      {
        id: "3860255",
        Name: "Provincia de Córdoba",
        
        FCode: "ADM1",
        CountryCode: "AR"
      },
      {
        id: "3434137",
        Name: "Provincia de Entre Ríos",
        
        FCode: "ADM1",
        CountryCode: "AR"
      },
      {
        id: "3433896",
        Name: "Provincia de Formosa",
        
        FCode: "ADM1",
        CountryCode: "AR"
      },
      {
        id: "3853404",
        Name: "Provincia de Jujuy",
        
        FCode: "ADM1",
        CountryCode: "AR"
      },
      {
        id: "3849574",
        Name: "Provincia de La Pampa",
        
        FCode: "ADM1",
        CountryCode: "AR"
      },
      {
        id: "3848949",
        Name: "Provincia de La Rioja",
        
        FCode: "ADM1",
        CountryCode: "AR"
      },
      {
        id: "3844419",
        Name: "Provincia de Mendoza",
        
        FCode: "ADM1",
        CountryCode: "AR"
      },
      {
        id: "3430657",
        Name: "Provincia de Misiones",
        
        FCode: "ADM1",
        CountryCode: "AR",
      },
      {
        id: "3838830",
        Name: "Provincia de Río Negro",
        
        FCode: "ADM1",
        CountryCode: "AR"
      },
      {
        id: "3837152",
        Name: "Provincia de San Juan",
        
        FCode: "ADM1",
        CountryCode: "AR"
      },
      {
        id: "3837029",
        Name: "Provincia de San Luis",
        
        FCode: "ADM1",
        CountryCode: "AR"
      },
      {
        id: "3836350",
        Name: "Provincia de Santa Cruz",
        
        FCode: "ADM1",
        CountryCode: "AR"
      },
      {
        id: "3835868",
        Name: "Provincia de Santiago del Estero",
        
        FCode: "ADM1",
        CountryCode: "AR"
      },
      {
        id: "3834450",
        Name: "Provincia de Tierra del Fuego, Antártida e Islas del Atlántico Sur",
        
        FCode: "ADM1",
        CountryCode: "AR",
      },
      {
        id: "3833578",
        Name: "Provincia de Tucumán",
        
        FCode: "ADM1",
        CountryCode: "AR"
      },
      {
        id: "3861887",
        Name: "Provincia del Chaco",
        
        FCode: "ADM1",
        CountryCode: "AR"
      },
      {
        id: "3861244",
        Name: "Provincia del Chubut",
        
        FCode: "ADM1",
        CountryCode: "AR",
      },
      {
        id: "3843122",
        Name: "Provincia del Neuquén",
        
        FCode: "ADM1",
        CountryCode: "AR"
      },
      {
        id: "3838231",
        Name: "Salta",
        
        FCode: "ADM1",
        CountryCode: "AR",
      },
      {
        id: "3836276",
        Name: "Santa Fe Province",
        
        FCode: "ADM1",
        CountryCode: "AR",
      }
    ],
  },
  {
    id: "3923057",
    Name: "Bolivia",
    States: [
      {
        id: "3920177",
        Name: "Departamento de Chuquisaca",
        
        FCode: "ADM1",
        CountryCode: "BO"
      },
      {
        id: "3919966",
        Name: "Departamento de Cochabamba",
        
        FCode: "ADM1",
        CountryCode: "BO"
      },
      {
        id: "3911924",
        Name: "Departamento de La Paz",
        
        FCode: "ADM1",
        CountryCode: "BO"
      },
      {
        id: "3908600",
        Name: "Departamento de Pando",
        
        FCode: "ADM1",
        CountryCode: "BO"
      },
      {
        id: "3907580",
        Name: "Departamento de Potosí",
        
        FCode: "ADM1",
        CountryCode: "BO"
      },
      {
        id: "3904907",
        Name: "Departamento de Santa Cruz",
        
        FCode: "ADM1",
        CountryCode: "BO"
      },
      {
        id: "3903319",
        Name: "Departamento de Tarija",
        
        FCode: "ADM1",
        CountryCode: "BO"
      },
      {
        id: "3923172",
        Name: "Departamento del Beni",
        
        FCode: "ADM1",
        CountryCode: "BO"
      },
      {
        id: "3909233",
        Name: "Oruro",
        
        FCode: "ADM1",
        CountryCode: "BO",
      }
    ],
  },
  {
    id: "3469034",
    Name: "Brazil",
    States: [
      {
        id: "3665361",
        Name: "Amazonas",
        
        FCode: "ADM1",
        CountryCode: "BR",
      },
      {
        id: "3471168",
        Name: "Estado da Bahia",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3393098",
        Name: "Estado da Paraíba",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3408096",
        Name: "Estado de Alagoas",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3462372",
        Name: "Estado de Goiás",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3457419",
        Name: "Estado de Mato Grosso",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3457415",
        Name: "Estado de Mato Grosso do Sul",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3457153",
        Name: "Estado de Minas Gerais",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3392268",
        Name: "Estado de Pernambuco",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3924825",
        Name: "Estado de Rondônia",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3662560",
        Name: "Estado de Roraima",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3450387",
        Name: "Estado de Santa Catarina",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3447799",
        Name: "Estado de Sergipe",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3448433",
        Name: "Estado de São Paulo",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3474575",
        Name: "Estado de Tocantins",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3665474",
        Name: "Estado do Acre",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3407762",
        Name: "Estado do Amapá",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3402362",
        Name: "Estado do Ceará",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3463930",
        Name: "Estado do Espírito Santo",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3395443",
        Name: "Estado do Maranhão",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3455077",
        Name: "Estado do Parana",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3393129",
        Name: "Estado do Pará",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3392213",
        Name: "Estado do Piauí",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3390290",
        Name: "Estado do Rio Grande do Norte",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3451133",
        Name: "Estado do Rio Grande do Sul",
        
        FCode: "ADM1",
        CountryCode: "BR"
      },
      {
        id: "3463504",
        Name: "Federal District",
        
        FCode: "ADM1",
        CountryCode: "BR",
      },
      {
        id: "3451189",
        Name: "Rio de Janeiro",
        
        FCode: "ADM1",
        CountryCode: "BR",
      }
    ],
  },
  {
    id: "3895114",
    Name: "Chile",
    States: [
      {
        id: "3900333",
        Name: "Región Aisén del General Carlos Ibáñez del Campo",
        
        FCode: "ADM1",
        CountryCode: "CL"
      },
      {
        id: "3873544",
        Name: "Región Metropolitana de Santiago",
        
        FCode: "ADM1",
        CountryCode: "CL"
      },
      {
        id: "3899537",
        Name: "Región de Antofagasta",
        
        FCode: "ADM1",
        CountryCode: "CL"
      },
      {
        id: "6693562",
        Name: "Región de Arica y Parinacota",
        
        FCode: "ADM1",
        CountryCode: "CL"
      },
      {
        id: "3899191",
        Name: "Región de Atacama",
        
        FCode: "ADM1",
        CountryCode: "CL"
      },
      {
        id: "3893623",
        Name: "Región de Coquimbo",
        
        FCode: "ADM1",
        CountryCode: "CL"
      },
      {
        id: "3881974",
        Name: "Región de Los Lagos",
        
        FCode: "ADM1",
        CountryCode: "CL"
      },
      {
        id: "6693563",
        Name: "Región de Los Ríos",
        
        FCode: "ADM1",
        CountryCode: "CL"
      },
      {
        id: "4036650",
        Name: "Región de Magallanes y de la Antártica Chilena",
        
        FCode: "ADM1",
        CountryCode: "CL"
      },
      {
        id: "3870116",
        Name: "Región de Tarapacá",
        
        FCode: "ADM1",
        CountryCode: "CL"
      },
      {
        id: "3868621",
        Name: "Región de Valparaíso",
        
        FCode: "ADM1",
        CountryCode: "CL"
      },
      {
        id: "3899463",
        Name: "Región de la Araucanía",
        
        FCode: "ADM1",
        CountryCode: "CL"
      },
      {
        id: "3898380",
        Name: "Región del Biobío",
        
        FCode: "ADM1",
        CountryCode: "CL"
      },
      {
        id: "3883281",
        Name: "Región del Libertador General Bernardo O’Higgins",
        
        FCode: "ADM1",
        CountryCode: "CL"
      },
      {
        id: "3880306",
        Name: "Región del Maule",
        
        FCode: "ADM1",
        CountryCode: "CL"
      }
    ],
  },
  {
    id: "3686110",
    Name: "Colombia",
    States: [
      {
        id: "3689436",
        Name: "Atlántico",
        
        FCode: "ADM1",
        CountryCode: "CO",
      },
      {
        id: "3688685",
        Name: "Bogota D.C.",
        
        FCode: "ADM1",
        CountryCode: "CO",
      },
      {
        id: "3685413",
        Name: "Cundinamarca",
        
        FCode: "ADM1",
        CountryCode: "CO",
      },
      {
        id: "3689815",
        Name: "Departamento de Antioquia",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3689717",
        Name: "Departamento de Arauca",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3688650",
        Name: "Departamento de Bolívar",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3688536",
        Name: "Departamento de Boyacá",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3687951",
        Name: "Departamento de Caldas",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3687173",
        Name: "Departamento de Casanare",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3685889",
        Name: "Departamento de Córdoba",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3678847",
        Name: "Departamento de La Guajira",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3674021",
        Name: "Departamento de Nariño",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3673798",
        Name: "Departamento de Norte de Santander",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3670698",
        Name: "Departamento de Risaralda",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3668578",
        Name: "Departamento de Santander",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3667725",
        Name: "Departamento de Sucre",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3666951",
        Name: "Departamento de Tolima",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3689982",
        Name: "Departamento del Amazonas",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3687479",
        Name: "Departamento del Caquetá",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3687029",
        Name: "Departamento del Cauca",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3686880",
        Name: "Departamento del Cesar",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3686431",
        Name: "Departamento del Chocó",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3681652",
        Name: "Departamento del Guainía",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3681344",
        Name: "Departamento del Guaviare",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3680692",
        Name: "Departamento del Huila",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3675686",
        Name: "Departamento del Magdalena",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3674810",
        Name: "Departamento del Meta",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3671178",
        Name: "Departamento del Putumayo",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3671087",
        Name: "Departamento del Quindío",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3666313",
        Name: "Departamento del Valle del Cauca",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3666254",
        Name: "Departamento del Vaupés",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3666082",
        Name: "Departamento del Vichada",
        
        FCode: "ADM1",
        CountryCode: "CO"
      },
      {
        id: "3670205",
        Name: "Providencia y Santa Catalina, Departamento de Archipiélago de San Andrés",
        
        FCode: "ADM1",
        CountryCode: "CO"
      }
    ],
  },
  {
    id: "3658394",
    Name: "Ecuador",
    States: [
      {
        id: "3660130",
        Name: "Provincia de Bolívar",
        
        FCode: "ADM1",
        CountryCode: "EC"
      },
      {
        id: "3658766",
        Name: "Provincia de Cotopaxi",
        
        FCode: "ADM1",
        CountryCode: "EC"
      },
      {
        id: "3658195",
        Name: "Provincia de El Oro",
        
        FCode: "ADM1",
        CountryCode: "EC"
      },
      {
        id: "3657986",
        Name: "Provincia de Esmeraldas",
        
        FCode: "ADM1",
        CountryCode: "EC"
      },
      {
        id: "3830306",
        Name: "Provincia de Francisco de Orellana",
        
        FCode: "ADM1",
        CountryCode: "EC"
      },
      {
        id: "3657879",
        Name: "Provincia de Galápagos",
        
        FCode: "ADM1",
        CountryCode: "EC"
      },
      {
        id: "3655635",
        Name: "Provincia de Imbabura",
        
        FCode: "ADM1",
        CountryCode: "EC"
      },
      {
        id: "3654665",
        Name: "Provincia de Loja",
        
        FCode: "ADM1",
        CountryCode: "EC"
      },
      {
        id: "3654592",
        Name: "Provincia de Los Ríos",
        
        FCode: "ADM1",
        CountryCode: "EC"
      },
      {
        id: "3654451",
        Name: "Provincia de Manabí",
        
        FCode: "ADM1",
        CountryCode: "EC"
      },
      {
        id: "3654005",
        Name: "Provincia de Morona Santiago",
        
        FCode: "ADM1",
        CountryCode: "EC"
      },
      {
        id: "3653890",
        Name: "Provincia de Napo",
        
        FCode: "ADM1",
        CountryCode: "EC"
      },
      {
        id: "3653224",
        Name: "Provincia de Pichincha",
        
        FCode: "ADM1",
        CountryCode: "EC"
      },
      {
        id: "7062138",
        Name: "Provincia de Santa Elena",
        
        FCode: "ADM1",
        CountryCode: "EC",
      },
      {
        id: "7062136",
        Name: "Provincia de Santo Domingo de los Tsáchilas",
        
        FCode: "ADM1",
        CountryCode: "EC"
      },
      {
        id: "3830305",
        Name: "Provincia de Sucumbíos",
        
        FCode: "ADM1",
        CountryCode: "EC"
      },
      {
        id: "3649953",
        Name: "Provincia de Zamora Chinchipe",
        
        FCode: "ADM1",
        CountryCode: "EC"
      },
      {
        id: "3660431",
        Name: "Provincia del Azuay",
        
        FCode: "ADM1",
        CountryCode: "EC"
      },
      {
        id: "3659718",
        Name: "Provincia del Carchi",
        
        FCode: "ADM1",
        CountryCode: "EC"
      },
      {
        id: "3659849",
        Name: "Provincia del Cañar",
        
        FCode: "ADM1",
        CountryCode: "EC"
      },
      {
        id: "3659237",
        Name: "Provincia del Chimborazo",
        
        FCode: "ADM1",
        CountryCode: "EC"
      },
      {
        id: "3657505",
        Name: "Provincia del Guayas",
        
        FCode: "ADM1",
        CountryCode: "EC",
      },
      {
        id: "3653392",
        Name: "Provincia del Pastaza",
        
        FCode: "ADM1",
        CountryCode: "EC"
      },
      {
        id: "3650445",
        Name: "Provincia del Tungurahua",
        
        FCode: "ADM1",
        CountryCode: "EC"
      }
    ],
  },
  {
    id: "3474414",
    Name: "Falkland Islands",
    States: [
      {
        id: "3965420",
        Name: "Beaver Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3427167",
        Name: "Bluff Cove",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3473344",
        Name: "Bluff Cove Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3427153",
        Name: "Bombilia House",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3427139",
        Name: "Burnside House",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3427129",
        Name: "Camp Verde",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3965571",
        Name: "Carcass Island Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3427113",
        Name: "Ceritos",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3831995",
        Name: "Chartres",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3427091",
        Name: "Cranmer",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3427086",
        Name: "Darwin Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3427076",
        Name: "Dos Lomas",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3427074",
        Name: "Douglas Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3831968",
        Name: "Dunnose Head Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3427042",
        Name: "Estancia House",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3427019",
        Name: "Fitzroy North",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3427023",
        Name: "Fitzroy Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3473351",
        Name: "Foam Creek House",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3831938",
        Name: "Fox Bay East Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3831937",
        Name: "Fox Bay West Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3426996",
        Name: "Goose Green Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3473349",
        Name: "Green Patch Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3831908",
        Name: "Hill Cove",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3426965",
        Name: "Hope Cottage",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3426961",
        Name: "Horseshoe Bay",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3426945",
        Name: "Johnson Harbour Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3473350",
        Name: "Johnson Harbour Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3473358",
        Name: "Keppel Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3473341",
        Name: "Lively Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3426886",
        Name: "Mare Harbour Rancho",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3426883",
        Name: "Mariquita",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3426871",
        Name: "Mid Rancho",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3949791",
        Name: "New Island Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3426842",
        Name: "North Arm Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3426825",
        Name: "Orqueta",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3426816",
        Name: "Pebble Island Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3426806",
        Name: "Piedra Sola",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3426792",
        Name: "Port Howard",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3426791",
        Name: "Port Louis Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3426789",
        Name: "Port Louis South",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3426788",
        Name: "Port San Carlos Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3831828",
        Name: "Port Stephens Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3426768",
        Name: "Rincon Grande Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3831800",
        Name: "Roy Cove Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3426731",
        Name: "Salvador Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3426741",
        Name: "San Carlos Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3426736",
        Name: "Sand Fountain",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3949792",
        Name: "Saunders Island Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3473338",
        Name: "Speedwell Island Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3831765",
        Name: "Spring Point Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3426691",
        Name: "Stanley",
        
        FCode: "PPLC",
        CountryCode: "FK",
      },
      {
        id: "3426674",
        Name: "Teal Inlet Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3426672",
        Name: "Tranquilidad",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3426645",
        Name: "Walker Creek",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3949790",
        Name: "Weddell Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      },
      {
        id: "3965555",
        Name: "Westpoint Island Settlement",
        
        FCode: "PPL",
        CountryCode: "FK"
      }
    ],
  },
  {
    id: "3378535",
    Name: "Guyana",
    States: [
      {
        id: "3379515",
        Name: "Barima-Waini Region",
        
        FCode: "ADM1",
        CountryCode: "GY"
      },
      {
        id: "3379023",
        Name: "Cuyuni-Mazaruni Region",
        
        FCode: "ADM1",
        CountryCode: "GY"
      },
      {
        id: "3378950",
        Name: "Demerara-Mahaica Region",
        
        FCode: "ADM1",
        CountryCode: "GY"
      },
      {
        id: "3378840",
        Name: "East Berbice-Corentyne Region",
        
        FCode: "ADM1",
        CountryCode: "GY"
      },
      {
        id: "3378741",
        Name: "Essequibo Islands-West Demerara Region",
        
        FCode: "ADM1",
        CountryCode: "GY"
      },
      {
        id: "3377274",
        Name: "Mahaica-Berbice Region",
        
        FCode: "ADM1",
        CountryCode: "GY"
      },
      {
        id: "3376407",
        Name: "Pomeroon-Supenaam Region",
        
        FCode: "ADM1",
        CountryCode: "GY"
      },
      {
        id: "3376386",
        Name: "Potaro-Siparuni Region",
        
        FCode: "ADM1",
        CountryCode: "GY"
      },
      {
        id: "3375469",
        Name: "Upper Demerara-Berbice Region",
        
        FCode: "ADM1",
        CountryCode: "GY"
      },
      {
        id: "3375463",
        Name: "Upper Takutu-Upper Essequibo Region",
        
        FCode: "ADM1",
        CountryCode: "GY"
      }
    ],
  },
  {
    id: "3437598",
    Name: "Paraguay",
    States: [
      {
        id: "3474570",
        Name: "Asunción",
        
        FCode: "ADM1",
        CountryCode: "PY"
      },
      {
        id: "3439137",
        Name: "Departamento Central",
        
        FCode: "ADM1",
        CountryCode: "PY"
      },
      {
        id: "3439441",
        Name: "Departamento de Alto Paraguay",
        
        FCode: "ADM1",
        CountryCode: "PY"
      },
      {
        id: "3867442",
        Name: "Departamento de Boquerón",
        
        FCode: "ADM1",
        CountryCode: "PY"
      },
      {
        id: "3439312",
        Name: "Departamento de Caaguazú",
        
        FCode: "ADM1",
        CountryCode: "PY"
      },
      {
        id: "3439296",
        Name: "Departamento de Caazapá",
        
        FCode: "ADM1",
        CountryCode: "PY"
      },
      {
        id: "3439216",
        Name: "Departamento de Canindeyú",
        
        FCode: "ADM1",
        CountryCode: "PY"
      },
      {
        id: "3438833",
        Name: "Departamento de Concepción",
        
        FCode: "ADM1",
        CountryCode: "PY"
      },
      {
        id: "3437923",
        Name: "Departamento de Itapúa",
        
        FCode: "ADM1",
        CountryCode: "PY"
      },
      {
        id: "3437727",
        Name: "Departamento de Misiones",
        
        FCode: "ADM1",
        CountryCode: "PY"
      },
      {
        id: "3437599",
        Name: "Departamento de Paraguarí",
        
        FCode: "ADM1",
        CountryCode: "PY"
      },
      {
        id: "3437443",
        Name: "Departamento de Presidente Hayes",
        
        FCode: "ADM1",
        CountryCode: "PY"
      },
      {
        id: "3437027",
        Name: "Departamento de San Pedro",
        
        FCode: "ADM1",
        CountryCode: "PY"
      },
      {
        id: "3438827",
        Name: "Departamento de la Cordillera",
        
        FCode: "ADM1",
        CountryCode: "PY"
      },
      {
        id: "3437677",
        Name: "Departamento de Ñeembucú",
        
        FCode: "ADM1",
        CountryCode: "PY"
      },
      {
        id: "3439440",
        Name: "Departamento del Alto Paraná",
        
        FCode: "ADM1",
        CountryCode: "PY"
      },
      {
        id: "3439433",
        Name: "Departamento del Amambay",
        
        FCode: "ADM1",
        CountryCode: "PY"
      },
      {
        id: "3438049",
        Name: "Departamento del Guairá",
        
        FCode: "ADM1",
        CountryCode: "PY"
      }
    ],
  },
  {
    id: "3932488",
    Name: "Peru",
    States: [
      {
        id: "3699699",
        Name: "Departamento de Amazonas",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3699674",
        Name: "Departamento de Ancash",
        
        FCode: "ADM1",
        CountryCode: "PE",
      },
      {
        id: "3947421",
        Name: "Departamento de Apurímac",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3947319",
        Name: "Departamento de Arequipa",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3947018",
        Name: "Departamento de Ayacucho",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3699087",
        Name: "Departamento de Cajamarca",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3941583",
        Name: "Departamento de Cusco",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3939467",
        Name: "Departamento de Huancavelica",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3696416",
        Name: "Departamento de Huánuco",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3938526",
        Name: "Departamento de Ica",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3937485",
        Name: "Departamento de Junín",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3695781",
        Name: "Departamento de La Libertad",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3695753",
        Name: "Departamento de Lambayeque",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3936452",
        Name: "Departamento de Lima",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3695238",
        Name: "Departamento de Loreto",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3935619",
        Name: "Departamento de Madre de Dios",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3934607",
        Name: "Departamento de Moquegua",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3932834",
        Name: "Departamento de Pasco",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3693525",
        Name: "Departamento de Piura",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3931275",
        Name: "Departamento de Puno",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3692385",
        Name: "Departamento de San Martín",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3928127",
        Name: "Departamento de Tacna",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3691146",
        Name: "Departamento de Tumbes",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3691099",
        Name: "Departamento de Ucayali",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3946080",
        Name: "Provincia Constitucional del Callao",
        
        FCode: "ADM1",
        CountryCode: "PE"
      },
      {
        id: "3936451",
        Name: "Provincia de Lima",
        
        FCode: "ADM1",
        CountryCode: "PE"
      }
    ],
  },
  {
    id: "3382998",
    Name: "Suriname",
    States: [
      {
        id: "3384481",
        Name: "Distrikt Brokopondo",
        
        FCode: "ADM1",
        CountryCode: "SR"
      },
      {
        id: "3384418",
        Name: "Distrikt Commewijne",
        
        FCode: "ADM1",
        CountryCode: "SR"
      },
      {
        id: "3384397",
        Name: "Distrikt Coronie",
        
        FCode: "ADM1",
        CountryCode: "SR"
      },
      {
        id: "3383560",
        Name: "Distrikt Marowijne",
        
        FCode: "ADM1",
        CountryCode: "SR"
      },
      {
        id: "3383438",
        Name: "Distrikt Nickerie",
        
        FCode: "ADM1",
        CountryCode: "SR"
      },
      {
        id: "3383337",
        Name: "Distrikt Para",
        
        FCode: "ADM1",
        CountryCode: "SR"
      },
      {
        id: "3383329",
        Name: "Distrikt Paramaribo",
        
        FCode: "ADM1",
        CountryCode: "SR"
      },
      {
        id: "3383110",
        Name: "Distrikt Saramacca",
        
        FCode: "ADM1",
        CountryCode: "SR"
      },
      {
        id: "3383062",
        Name: "Distrikt Sipaliwini",
        
        FCode: "ADM1",
        CountryCode: "SR"
      },
      {
        id: "3382761",
        Name: "Distrikt Wanica",
        
        FCode: "ADM1",
        CountryCode: "SR"
      }
    ],
  },
  {
    id: "3439705",
    Name: "Uruguay",
    States: [
      {
        id: "3443756",
        Name: "Artigas",
        
        FCode: "ADM1",
        CountryCode: "UY",
      },
      {
        id: "3443411",
        Name: "Canelones",
        
        FCode: "ADM1",
        CountryCode: "UY",
      },
      {
        id: "3443173",
        Name: "Cerro Largo",
        
        FCode: "ADM1",
        CountryCode: "UY",
      },
      {
        id: "3443025",
        Name: "Colonia",
        
        FCode: "ADM1",
        CountryCode: "UY",
      },
      {
        id: "3442720",
        Name: "Departamento de Durazno",
        
        FCode: "ADM1",
        CountryCode: "UY"
      },
      {
        id: "3442587",
        Name: "Departamento de Flores",
        
        FCode: "ADM1",
        CountryCode: "UY"
      },
      {
        id: "3441572",
        Name: "Departamento de Montevideo",
        
        FCode: "ADM1",
        CountryCode: "UY"
      },
      {
        id: "3441242",
        Name: "Departamento de Paysandú",
        
        FCode: "ADM1",
        CountryCode: "UY"
      },
      {
        id: "3440780",
        Name: "Departamento de Rivera",
        
        FCode: "ADM1",
        CountryCode: "UY"
      },
      {
        id: "3440771",
        Name: "Departamento de Rocha",
        
        FCode: "ADM1",
        CountryCode: "UY"
      },
      {
        id: "3440789",
        Name: "Departamento de Río Negro",
        
        FCode: "ADM1",
        CountryCode: "UY"
      },
      {
        id: "3440711",
        Name: "Departamento de Salto",
        
        FCode: "ADM1",
        CountryCode: "UY"
      },
      {
        id: "3440645",
        Name: "Departamento de San José",
        
        FCode: "ADM1",
        CountryCode: "UY"
      },
      {
        id: "3440033",
        Name: "Departamento de Tacuarembó",
        
        FCode: "ADM1",
        CountryCode: "UY"
      },
      {
        id: "3439780",
        Name: "Departamento de Treinta y Tres",
        
        FCode: "ADM1",
        CountryCode: "UY"
      },
      {
        id: "3442584",
        Name: "Florida",
        
        FCode: "ADM1",
        CountryCode: "UY",
      },
      {
        id: "3442007",
        Name: "Lavalleja",
        
        FCode: "ADM1",
        CountryCode: "UY",
      },
      {
        id: "3441890",
        Name: "Maldonado",
        
        FCode: "ADM1",
        CountryCode: "UY",
      },
      {
        id: "3440054",
        Name: "Soriano",
        
        FCode: "ADM1",
        CountryCode: "UY",
      }
    ],
  },
  {
    id: "3625428",
    Name: "Venezuela",
    States: [
      {
        id: "3640846",
        Name: "Dependencias Federales",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3640847",
        Name: "Distrito Capital",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3649302",
        Name: "Estado Amazonas",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3649198",
        Name: "Estado Anzoátegui",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3649151",
        Name: "Estado Apure",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3649110",
        Name: "Estado Aragua",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3648544",
        Name: "Estado Barinas",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3648106",
        Name: "Estado Bolívar",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3646751",
        Name: "Estado Carabobo",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3645386",
        Name: "Estado Cojedes",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3640873",
        Name: "Estado Falcón",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3640017",
        Name: "Estado Guárico",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3636539",
        Name: "Estado Lara",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3632191",
        Name: "Estado Miranda",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3632100",
        Name: "Estado Monagas",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3632306",
        Name: "Estado Mérida",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3631462",
        Name: "Estado Nueva Esparta",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3629941",
        Name: "Estado Portuguesa",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3626655",
        Name: "Estado Sucre",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3625974",
        Name: "Estado Trujillo",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3626553",
        Name: "Estado Táchira",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3830309",
        Name: "Estado Vargas",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3625210",
        Name: "Estado Yaracuy",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3625035",
        Name: "Estado Zulia",
        
        FCode: "ADM1",
        CountryCode: "VE"
      },
      {
        id: "3644541",
        Name: "Territorio Federal Delta Amacuro",
        
        FCode: "ADM1",
        CountryCode: "VE"
      }
    ],
  }
];